export const MoCandPFCharData = [
  {
    char: 'dan-heng',
    app_rate_moc: 0.0,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.0,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 0,
    sample_size_players_moc: 0,
    app_rate_pf: 0.0,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.0,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 0,
    sample_size_players_pf: 0,
    app_rate_as: 0.05,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.03,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 7,
    sample_size_players_as: 2,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 14.29,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 3016,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 14.29,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 3269,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 71.43,
    round_6_moc: 99.99,
    round_6_pf: 0,
    round_6_as: 3383,
    cons_avg: 5.0,
    weapons_1: 'Cruising in the Stellar Sea',
    weapons_1_app: 100.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0.0,
    weapons_1_round_as: 3251,
    weapons_2: '',
    weapons_2_app: 0.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Scholar Lost in Erudition',
    artifacts_1_1: 'Scholar Lost in Erudition',
    artifacts_1_2: '',
    artifacts_1_app: 50.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0.0,
    artifacts_1_round_as: 0,
    artifacts_2: 'Pioneer Diver of Dead Waters',
    artifacts_2_1: 'Pioneer Diver of Dead Waters',
    artifacts_2_2: '',
    artifacts_2_app: 50.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 3251,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Rutilant Arena',
    planars_1_app: 50.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0.0,
    planars_1_round_as: 0,
    planars_2: 'Firmament Frontline: Glamoth',
    planars_2_app: 50.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 3251,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 50.0,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 50.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 100.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Wind DMG Boost',
    sphere_stats_1_app: 100.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 50.0,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 50.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 6.5,
    skill_lvl: 11.0,
    ultimate_lvl: 11.0,
    talent_lvl: 11.0,
    max_hp: 2791.98,
    atk: 2622.14,
    dfns: 1152.88,
    speed: 115.05,
    crate: 79.76,
    cdmg: 156.27,
    dmg_boost: 61.28,
    heal_boost: 1,
    energy_regen: 9.72,
    effect_res: 7.99,
    effect_rate: 9.07,
    break_effect: 11.02,
    spd_sub: 5.05,
    hp_sub: 11.88,
    atk_sub: 18.36,
    def_sub: 17.01,
    crate_sub: 32.56,
    cdmg_sub: 73.87,
    res_sub: 7.99,
    ehr_sub: 9.07,
    break_sub: 11.02
  },
  {
    char: 'himeko',
    app_rate_moc: 0.15,
    app_rate_moc_e0s1: 0.01,
    app_rate_moc_e1: 0.09,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 7.43,
    avg_round_moc_s0: 99.99,
    sample_moc: 22,
    sample_size_players_moc: 9,
    app_rate_pf: 2.96,
    app_rate_pf_e0s1: 0.78,
    app_rate_pf_e1: 1.92,
    app_rate_pf_s0: 0.32,
    avg_round_pf: 26204,
    avg_round_pf_e1: 31735,
    avg_round_pf_s0: 25071,
    sample_pf: 415,
    sample_size_players_pf: 62,
    app_rate_as: 0.24,
    app_rate_as_e0s1: 0.06,
    app_rate_as_e1: 0.14,
    app_rate_as_s0: 0.01,
    avg_round_as: 3287,
    avg_round_as_e1: 3367,
    avg_round_as_s0: 0,
    sample_as: 37,
    sample_size_players_as: 8,
    app_0: 16.92,
    round_0_moc: 6.5,
    round_0_pf: 30084,
    round_0_as: 3363,
    app_1: 29.84,
    round_1_moc: 6.14,
    round_1_pf: 30874,
    round_1_as: 3428,
    app_2: 20.29,
    round_2_moc: 10.0,
    round_2_pf: 30301,
    round_2_as: 3262,
    app_3: 14.78,
    round_3_moc: 6.33,
    round_3_pf: 31626,
    round_3_as: 3473,
    app_4: 9.26,
    round_4_moc: 4.5,
    round_4_pf: 33364,
    round_4_as: 3399,
    app_5: 4.4,
    round_5_moc: 5.0,
    round_5_pf: 32672,
    round_5_as: 3476,
    app_6: 4.52,
    round_6_moc: 7.8,
    round_6_pf: 34978,
    round_6_as: 3249,
    cons_avg: 2.01,
    weapons_1: 'Night on the Milky Way',
    weapons_1_app: 47.18,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 27573,
    weapons_1_round_as: 2992,
    weapons_2: 'Before Dawn',
    weapons_2_app: 18.51,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 29267,
    weapons_2_round_as: 0,
    weapons_3: "Geniuses' Repose",
    weapons_3_app: 11.46,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 26920,
    weapons_3_round_as: 3226,
    weapons_4: 'Eternal Calculus',
    weapons_4_app: 8.96,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 26573,
    weapons_4_round_as: 0.0,
    weapons_5: 'After the Charmony Fall',
    weapons_5_app: 7.05,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 26120,
    weapons_5_round_as: 0,
    weapons_6: 'The Day The Cosmos Fell',
    weapons_6_app: 2.56,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 24040,
    weapons_6_round_as: 0.0,
    weapons_7: 'Into the Unreachable Veil',
    weapons_7_app: 1.28,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0,
    weapons_7_round_as: 0.0,
    weapons_8: 'The Seriousness of Breakfast',
    weapons_8_app: 1.28,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 24720,
    weapons_8_round_as: 0.0,
    weapons_9: 'The Birth of the Self',
    weapons_9_app: 0.72,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0,
    weapons_10: 'Today Is Another Peaceful Day',
    weapons_10_app: 0.5,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'The Ashblazing Grand Duke',
    artifacts_1_1: 'The Ashblazing Grand Duke',
    artifacts_1_2: '',
    artifacts_1_app: 73.8,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 27260,
    artifacts_1_round_as: 3226,
    artifacts_2: 'Iron Cavalry Against the Scourge',
    artifacts_2_1: 'Iron Cavalry Against the Scourge',
    artifacts_2_2: '',
    artifacts_2_app: 10.89,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 25867,
    artifacts_2_round_as: 2992,
    artifacts_3: 'Firesmith of Lava-Forging, The Ashblazing Grand Duke',
    artifacts_3_1: 'Firesmith of Lava-Forging',
    artifacts_3_2: 'The Ashblazing Grand Duke',
    artifacts_3_app: 3.06,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 29000,
    artifacts_3_round_as: 0.0,
    artifacts_4: 'BE +16%, The Ashblazing Grand Duke',
    artifacts_4_1: 'BE +16%',
    artifacts_4_2: 'The Ashblazing Grand Duke',
    artifacts_4_app: 2.56,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 0.0,
    artifacts_5: 'SPD +6%, Firesmith of Lava-Forging',
    artifacts_5_1: 'SPD +6%',
    artifacts_5_2: 'Firesmith of Lava-Forging',
    artifacts_5_app: 1.28,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0.0,
    artifacts_6: 'ATK +12%, Pioneer Diver of Dead Waters',
    artifacts_6_1: 'ATK +12%',
    artifacts_6_2: 'Pioneer Diver of Dead Waters',
    artifacts_6_app: 1.28,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'BE +16%, BE +16%',
    artifacts_7_1: 'BE +16%',
    artifacts_7_2: 'BE +16%',
    artifacts_7_app: 1.28,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 25160,
    artifacts_7_round_as: 0.0,
    artifacts_8: 'BE +16%, Flex',
    artifacts_8_1: 'BE +16%',
    artifacts_8_2: 'Flex',
    artifacts_8_app: 1.28,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 0.0,
    artifacts_9: 'Firesmith of Lava-Forging',
    artifacts_9_1: 'Firesmith of Lava-Forging',
    artifacts_9_2: '',
    artifacts_9_app: 1.28,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0,
    artifacts_9_round_as: 0.0,
    artifacts_10: 'The Ashblazing Grand Duke, Flex',
    artifacts_10_1: 'The Ashblazing Grand Duke',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 1.28,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Inert Salsotto',
    planars_1_app: 43.28,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 28154,
    planars_1_round_as: 0,
    planars_2: 'Sigonia, the Unclaimed Desolation',
    planars_2_app: 17.15,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 26600,
    planars_2_round_as: 0.0,
    planars_3: 'Duran, Dynasty of Running Wolves',
    planars_3_app: 14.02,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 27130,
    planars_3_round_as: 0,
    planars_4: 'Forge of the Kalpagni Lantern',
    planars_4_app: 12.66,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 25867,
    planars_4_round_as: 2992,
    planars_5: 'Talia: Kingdom of Banditry',
    planars_5_app: 3.84,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 25160,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 80.97,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 16.17,
    body_stats_3: 'ATK',
    body_stats_3_app: 1.42,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 62.64,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 37.35,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Fire DMG Boost',
    sphere_stats_1_app: 88.6,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 11.4,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 76.87,
    rope_stats_2: 'Break Effect',
    rope_stats_2_app: 20.29,
    rope_stats_3: 'Energy Regeneration Rate',
    rope_stats_3_app: 2.85,
    char_lvl: 80.0,
    light_cone_lvl: 79.66,
    attack_lvl: 5.15,
    skill_lvl: 10.65,
    ultimate_lvl: 10.05,
    talent_lvl: 10.21,
    max_hp: 3125.79,
    atk: 3113.11,
    dfns: 980.43,
    speed: 113.58,
    crate: 66.6,
    cdmg: 131.73,
    dmg_boost: 57.37,
    heal_boost: 1,
    energy_regen: 0.63,
    effect_res: 14.65,
    effect_rate: 9.68,
    break_effect: 23.35,
    spd_sub: 6.42,
    hp_sub: 11.39,
    atk_sub: 12.2,
    def_sub: 9.71,
    crate_sub: 29.8,
    cdmg_sub: 65.03,
    res_sub: 6.98,
    ehr_sub: 9.68,
    break_sub: 21.5
  },
  {
    char: 'welt',
    app_rate_moc: 0.07,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.04,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 11,
    sample_size_players_moc: 2,
    app_rate_pf: 0.2,
    app_rate_pf_e0s1: 0.05,
    app_rate_pf_e1: 0.1,
    app_rate_pf_s0: 0.02,
    avg_round_pf: 0,
    avg_round_pf_e1: 25210,
    avg_round_pf_s0: 0,
    sample_pf: 28,
    sample_size_players_pf: 10,
    app_rate_as: 0.06,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.03,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 10,
    sample_size_players_as: 1,
    app_0: 10.71,
    round_0_moc: 99.99,
    round_0_pf: 23707,
    round_0_as: 0,
    app_1: 17.86,
    round_1_moc: 99.99,
    round_1_pf: 29296,
    round_1_as: 0,
    app_2: 28.23,
    round_2_moc: 6.33,
    round_2_pf: 28650,
    round_2_as: 0,
    app_3: 7.14,
    round_3_moc: 99.99,
    round_3_pf: 25300,
    round_3_as: 0,
    app_4: 12.36,
    round_4_moc: 6.0,
    round_4_pf: 22040,
    round_4_as: 0,
    app_5: 12.65,
    round_5_moc: 3.0,
    round_5_pf: 27867,
    round_5_as: 0,
    app_6: 20.3,
    round_6_moc: 7.33,
    round_6_pf: 28280,
    round_6_as: 0,
    cons_avg: 3.2,
    weapons_1: 'In the Name of the World',
    weapons_1_app: 50.92,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 24240,
    weapons_1_round_as: 0.0,
    weapons_2: 'Along the Passing Shore',
    weapons_2_app: 21.29,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 30000,
    weapons_2_round_as: 0.0,
    weapons_3: 'Before the Tutorial Mission Starts',
    weapons_3_app: 14.81,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 21840,
    weapons_3_round_as: 0.0,
    weapons_4: 'Fermata',
    weapons_4_app: 6.48,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Pioneer Diver of Dead Waters',
    artifacts_1_1: 'Pioneer Diver of Dead Waters',
    artifacts_1_2: '',
    artifacts_1_app: 42.59,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 27180,
    artifacts_1_round_as: 0.0,
    artifacts_2: 'Wastelander of Banditry Desert',
    artifacts_2_1: 'Wastelander of Banditry Desert',
    artifacts_2_2: '',
    artifacts_2_app: 14.81,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 24120,
    artifacts_2_round_as: 0.0,
    artifacts_3: 'Eagle of Twilight Line',
    artifacts_3_1: 'Eagle of Twilight Line',
    artifacts_3_2: '',
    artifacts_3_app: 14.81,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 0.0,
    artifacts_4: 'Scholar Lost in Erudition',
    artifacts_4_1: 'Scholar Lost in Erudition',
    artifacts_4_2: '',
    artifacts_4_app: 13.89,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 0.0,
    artifacts_5: 'Pioneer Diver of Dead Waters, Flex',
    artifacts_5_1: 'Pioneer Diver of Dead Waters',
    artifacts_5_2: 'Flex',
    artifacts_5_app: 7.41,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 21840,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Rutilant Arena',
    planars_1_app: 42.59,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 26160,
    planars_1_round_as: 0.0,
    planars_2: 'Pan-Cosmic Commercial Enterprise',
    planars_2_app: 22.22,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0,
    planars_2_round_as: 0.0,
    planars_3: 'Forge of the Kalpagni Lantern',
    planars_3_app: 7.41,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0,
    planars_3_round_as: 0.0,
    planars_4: 'Izumo Gensei and Takama Divine Realm',
    planars_4_app: 7.41,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 21840,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 70.37,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 22.22,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 50.0,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 42.59,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Imaginary DMG Boost',
    sphere_stats_1_app: 92.6,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 7.41,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 57.4,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 42.59,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 6.28,
    skill_lvl: 11.48,
    ultimate_lvl: 11.0,
    talent_lvl: 11.26,
    max_hp: 3080.52,
    atk: 2678.42,
    dfns: 1100.1,
    speed: 127.83,
    crate: 60.03,
    cdmg: 128.92,
    dmg_boost: 51.88,
    heal_boost: 1,
    energy_regen: 8.28,
    effect_res: 18.27,
    effect_rate: 27.72,
    break_effect: 13.07,
    spd_sub: 11.54,
    hp_sub: 6.03,
    atk_sub: 15.71,
    def_sub: 12.02,
    crate_sub: 27.52,
    cdmg_sub: 48.43,
    res_sub: 9.94,
    ehr_sub: 19.57,
    break_sub: 13.07
  },
  {
    char: 'silver-wolf',
    app_rate_moc: 1.37,
    app_rate_moc_e0s1: 0.07,
    app_rate_moc_e1: 0.83,
    app_rate_moc_s0: 0.01,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 8.95,
    avg_round_moc_s0: 99.99,
    sample_moc: 207,
    sample_size_players_moc: 84,
    app_rate_pf: 0.66,
    app_rate_pf_e0s1: 0.19,
    app_rate_pf_e1: 0.33,
    app_rate_pf_s0: 0.01,
    avg_round_pf: 24783,
    avg_round_pf_e1: 26695,
    avg_round_pf_s0: 0,
    sample_pf: 92,
    sample_size_players_pf: 30,
    app_rate_as: 1.23,
    app_rate_as_e0s1: 0.26,
    app_rate_as_e1: 0.68,
    app_rate_as_s0: 0.01,
    avg_round_as: 3268,
    avg_round_as_e1: 3406,
    avg_round_as_s0: 0,
    sample_as: 191,
    sample_size_players_as: 70,
    app_0: 54.67,
    round_0_moc: 8.69,
    round_0_pf: 26065,
    round_0_as: 3358,
    app_1: 16.63,
    round_1_moc: 8.9,
    round_1_pf: 28684,
    round_1_as: 3392,
    app_2: 16.5,
    round_2_moc: 7.9,
    round_2_pf: 26107,
    round_2_as: 3480,
    app_3: 1.66,
    round_3_moc: 8.5,
    round_3_pf: 27693,
    round_3_as: 3550,
    app_4: 1.01,
    round_4_moc: 9.5,
    round_4_pf: 0,
    round_4_as: 3526,
    app_5: 0.76,
    round_5_moc: 5.0,
    round_5_pf: 0,
    round_5_as: 3417,
    app_6: 9.13,
    round_6_moc: 5.4,
    round_6_pf: 33093,
    round_6_as: 3539,
    cons_avg: 1.16,
    weapons_1: 'Before the Tutorial Mission Starts',
    weapons_1_app: 51.64,
    weapons_1_round_moc: 9.67,
    weapons_1_round_pf: 25623,
    weapons_1_round_as: 3245,
    weapons_2: 'Incessant Rain',
    weapons_2_app: 39.36,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 24400,
    weapons_2_round_as: 3272,
    weapons_3: 'Good Night and Sleep Well',
    weapons_3_app: 2.77,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0,
    weapons_3_round_as: 0,
    weapons_4: 'Resolution Shines As Pearls of Sweat',
    weapons_4_app: 1.31,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 3314,
    weapons_5: 'Eyes of the Prey',
    weapons_5_app: 1.31,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0,
    weapons_6: 'Along the Passing Shore',
    weapons_6_app: 1.31,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0,
    weapons_7: 'Those Many Springs',
    weapons_7_app: 0.48,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0,
    weapons_8: 'Fermata',
    weapons_8_app: 0.42,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Genius of Brilliant Stars',
    artifacts_1_1: 'Genius of Brilliant Stars',
    artifacts_1_2: '',
    artifacts_1_app: 50.33,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 25173,
    artifacts_1_round_as: 3156,
    artifacts_2: 'Eagle of Twilight Line',
    artifacts_2_1: 'Eagle of Twilight Line',
    artifacts_2_2: '',
    artifacts_2_app: 12.72,
    artifacts_2_round_moc: 9.0,
    artifacts_2_round_pf: 0,
    artifacts_2_round_as: 0,
    artifacts_3: 'SPD +6%, SPD +6%',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'SPD +6%',
    artifacts_3_app: 10.7,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 22320,
    artifacts_3_round_as: 3376,
    artifacts_4: 'SPD +6%, Longevous Disciple',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'Longevous Disciple',
    artifacts_4_app: 3.73,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 26960,
    artifacts_4_round_as: 3334,
    artifacts_5: 'Messenger Traversing Hackerspace',
    artifacts_5_1: 'Messenger Traversing Hackerspace',
    artifacts_5_2: '',
    artifacts_5_app: 3.11,
    artifacts_5_round_moc: 10.0,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 3204,
    artifacts_6: 'SPD +6%, Flex',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Flex',
    artifacts_6_app: 2.97,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 27080,
    artifacts_6_round_as: 3198,
    artifacts_7: 'Thief of Shooting Meteor',
    artifacts_7_1: 'Thief of Shooting Meteor',
    artifacts_7_2: '',
    artifacts_7_app: 2.89,
    artifacts_7_round_moc: 10.0,
    artifacts_7_round_pf: 23600,
    artifacts_7_round_as: 0.0,
    artifacts_8: 'Pioneer Diver of Dead Waters',
    artifacts_8_1: 'Pioneer Diver of Dead Waters',
    artifacts_8_2: '',
    artifacts_8_app: 2.63,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0,
    artifacts_9: 'Quan. +10%, SPD +6%',
    artifacts_9_1: 'Quan. +10%',
    artifacts_9_2: 'SPD +6%',
    artifacts_9_app: 2.07,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 28280,
    artifacts_9_round_as: 0,
    artifacts_10: 'Musketeer of Wild Wheat',
    artifacts_10_1: 'Musketeer of Wild Wheat',
    artifacts_10_2: '',
    artifacts_10_app: 1.25,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Penacony, Land of the Dreams',
    planars_1_app: 17.88,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 25560,
    planars_1_round_as: 3297,
    planars_2: 'Sprightly Vonwacq',
    planars_2_app: 15.48,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0,
    planars_2_round_as: 3104,
    planars_3: 'Pan-Cosmic Commercial Enterprise',
    planars_3_app: 14.97,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 24400,
    planars_3_round_as: 3182,
    planars_4: 'Broken Keel',
    planars_4_app: 14.65,
    planars_4_round_moc: 9.67,
    planars_4_round_pf: 25453,
    planars_4_round_as: 3316,
    planars_5: 'Lushaka, the Sunken Seas',
    planars_5_app: 7.12,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 3292,
    body_stats_1: 'Effect Hit Rate',
    body_stats_1_app: 35.93,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 35.59,
    body_stats_3: 'CRIT DMG',
    body_stats_3_app: 10.86,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 97.42,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 2.08,
    feet_stats_3: 'HP',
    feet_stats_3_app: 0.5,
    sphere_stats_1: 'Quantum DMG Boost',
    sphere_stats_1_app: 61.1,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 10.99,
    sphere_stats_3: 'ATK',
    sphere_stats_3_app: 8.01,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 71.17,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 25.08,
    rope_stats_3: 'Break Effect',
    rope_stats_3_app: 3.75,
    char_lvl: 79.82,
    light_cone_lvl: 79.36,
    attack_lvl: 5.5,
    skill_lvl: 10.19,
    ultimate_lvl: 10.21,
    talent_lvl: 10.18,
    max_hp: 3143.78,
    atk: 2214.81,
    dfns: 1003.95,
    speed: 149.59,
    crate: 36.13,
    cdmg: 91.19,
    dmg_boost: 36.41,
    heal_boost: 0.41,
    energy_regen: 15.94,
    effect_res: 12.13,
    effect_rate: 87.14,
    break_effect: 17.25,
    spd_sub: 16.07,
    hp_sub: 10.84,
    atk_sub: 14.7,
    def_sub: 13.97,
    crate_sub: 17.3,
    cdmg_sub: 36.46,
    res_sub: 11.6,
    ehr_sub: 21.29,
    break_sub: 16.14
  },
  {
    char: 'arlan',
    app_rate_moc: 0.03,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.01,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 4,
    sample_size_players_moc: 1,
    app_rate_pf: 0.01,
    app_rate_pf_e0s1: 0.01,
    app_rate_pf_e1: 0.01,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 2,
    sample_size_players_pf: 1,
    app_rate_as: 0.0,
    app_rate_as_e0s1: 0.0,
    app_rate_as_e1: 0.0,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 0,
    sample_size_players_as: 0,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 50.0,
    round_2_moc: 99.99,
    round_2_pf: 28120,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 87.5,
    round_6_moc: 2.5,
    round_6_pf: 40000,
    round_6_as: 0,
    cons_avg: 5.5,
    weapons_1: 'Under the Blue Sky',
    weapons_1_app: 62.5,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0,
    weapons_1_round_as: 0.0,
    weapons_2: 'Something Irreplaceable',
    weapons_2_app: 37.5,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Scholar Lost in Erudition',
    artifacts_1_1: 'Scholar Lost in Erudition',
    artifacts_1_2: '',
    artifacts_1_app: 62.5,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0,
    artifacts_1_round_as: 0.0,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: '',
    planars_1_app: 0.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0.0,
    planars_1_round_as: 0.0,
    planars_2: '',
    planars_2_app: 0.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 100.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 100.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Quantum DMG Boost',
    sphere_stats_1_app: 100.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 100.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 40.0,
    attack_lvl: 3.0,
    skill_lvl: 10.0,
    ultimate_lvl: 10.0,
    talent_lvl: 10.0,
    max_hp: 3114.76,
    atk: 2772.92,
    dfns: 882.01,
    speed: 104.6,
    crate: 30.82,
    cdmg: 190.62,
    dmg_boost: 1,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 13.89,
    effect_rate: 7.34,
    break_effect: 24.62,
    spd_sub: 2.6,
    hp_sub: 16.42,
    atk_sub: 11.66,
    def_sub: 42.12,
    crate_sub: 17.82,
    cdmg_sub: 75.82,
    res_sub: 3.89,
    ehr_sub: 7.34,
    break_sub: 24.62
  },
  {
    char: 'asta',
    app_rate_moc: 0.03,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.03,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 5,
    sample_size_players_moc: 1,
    app_rate_pf: 0.11,
    app_rate_pf_e0s1: 0.06,
    app_rate_pf_e1: 0.06,
    app_rate_pf_s0: 0.03,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 16,
    sample_size_players_pf: 2,
    app_rate_as: 0.15,
    app_rate_as_e0s1: 0.04,
    app_rate_as_e1: 0.1,
    app_rate_as_s0: 0.01,
    avg_round_as: 0,
    avg_round_as_e1: 3538,
    avg_round_as_s0: 0,
    sample_as: 24,
    sample_size_players_as: 2,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 6.25,
    round_3_moc: 99.99,
    round_3_pf: 34920,
    round_3_as: 0,
    app_4: 6.25,
    round_4_moc: 99.99,
    round_4_pf: 39360,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 95.26,
    round_6_moc: 5.6,
    round_6_pf: 33986,
    round_6_as: 3494,
    cons_avg: 5.88,
    weapons_1: 'Dance! Dance! Dance!',
    weapons_1_app: 99.99,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0,
    weapons_1_round_as: 3514,
    weapons_2: '',
    weapons_2_app: 0.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'SPD +6%, SPD +6%',
    artifacts_1_1: 'SPD +6%',
    artifacts_1_2: 'SPD +6%',
    artifacts_1_app: 99.99,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0,
    artifacts_1_round_as: 3514,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Penacony, Land of the Dreams',
    planars_1_app: 55.17,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0,
    planars_1_round_as: 3480,
    planars_2: 'Lushaka, the Sunken Seas',
    planars_2_app: 44.83,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0,
    planars_2_round_as: 3549,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'HP',
    body_stats_1_app: 55.17,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 25.86,
    body_stats_3: 'DEF',
    body_stats_3_app: 18.97,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 99.99,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 74.13,
    sphere_stats_2: 'Fire DMG Boost',
    sphere_stats_2_app: 25.86,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 99.99,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 6.55,
    skill_lvl: 10.72,
    ultimate_lvl: 11.1,
    talent_lvl: 11.1,
    max_hp: 4062.28,
    atk: 1503.76,
    dfns: 1350.2,
    speed: 169.28,
    crate: 40.22,
    cdmg: 83.35,
    dmg_boost: 30.33,
    heal_boost: 1,
    energy_regen: 24.44,
    effect_res: 12.34,
    effect_rate: 12.74,
    break_effect: 7.32,
    spd_sub: 25.53,
    hp_sub: 8.64,
    atk_sub: 18.02,
    def_sub: 22.01,
    crate_sub: 20.9,
    cdmg_sub: 33.35,
    res_sub: 12.34,
    ehr_sub: 12.74,
    break_sub: 7.32
  },
  {
    char: 'herta',
    app_rate_moc: 20.93,
    app_rate_moc_e0s1: 5.67,
    app_rate_moc_e1: 13.43,
    app_rate_moc_s0: 0.68,
    avg_round_moc: 9.19,
    avg_round_moc_e1: 7.87,
    avg_round_moc_s0: 9.5,
    sample_moc: 3153,
    sample_size_players_moc: 182,
    app_rate_pf: 41.43,
    app_rate_pf_e0s1: 22.57,
    app_rate_pf_e1: 17.71,
    app_rate_pf_s0: 8.83,
    avg_round_pf: 39579,
    avg_round_pf_e1: 39984,
    avg_round_pf_s0: 39123,
    sample_pf: 5812,
    sample_size_players_pf: 285,
    app_rate_as: 26.84,
    app_rate_as_e0s1: 15.09,
    app_rate_as_e1: 11.0,
    app_rate_as_s0: 5.1,
    avg_round_as: 3427,
    avg_round_as_e1: 3557,
    avg_round_as_s0: 3382,
    sample_as: 4164,
    sample_size_players_as: 228,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 0.03,
    round_4_moc: 99.99,
    round_4_pf: 30820,
    round_4_as: 0,
    app_5: 3.36,
    round_5_moc: 8.68,
    round_5_pf: 39424,
    round_5_as: 3475,
    app_6: 96.62,
    round_6_moc: 8.15,
    round_6_pf: 39824,
    round_6_as: 3488,
    cons_avg: 5.96,
    weapons_1: 'Night on the Milky Way',
    weapons_1_app: 20.15,
    weapons_1_round_moc: 6.4,
    weapons_1_round_pf: 40000,
    weapons_1_round_as: 3498,
    weapons_2: "Geniuses' Repose",
    weapons_2_app: 19.1,
    weapons_2_round_moc: 9.29,
    weapons_2_round_pf: 39920,
    weapons_2_round_as: 3449,
    weapons_3: 'Eternal Calculus',
    weapons_3_app: 16.57,
    weapons_3_round_moc: 8.8,
    weapons_3_round_pf: 39929,
    weapons_3_round_as: 3403,
    weapons_4: 'Before Dawn',
    weapons_4_app: 13.28,
    weapons_4_round_moc: 8.67,
    weapons_4_round_pf: 40000,
    weapons_4_round_as: 3444,
    weapons_5: 'The Birth of the Self',
    weapons_5_app: 13.23,
    weapons_5_round_moc: 8.75,
    weapons_5_round_pf: 39296,
    weapons_5_round_as: 3492,
    weapons_6: 'Passkey',
    weapons_6_app: 3.83,
    weapons_6_round_moc: 1.0,
    weapons_6_round_pf: 40000,
    weapons_6_round_as: 3572,
    weapons_7: 'The Seriousness of Breakfast',
    weapons_7_app: 3.28,
    weapons_7_round_moc: 8.0,
    weapons_7_round_pf: 37110,
    weapons_7_round_as: 3428,
    weapons_8: 'Yet Hope Is Priceless',
    weapons_8_app: 2.33,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 34520,
    weapons_8_round_as: 3365,
    weapons_9: 'The Day The Cosmos Fell',
    weapons_9_app: 1.78,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 40000,
    weapons_9_round_as: 3592,
    weapons_10: 'An Instant Before A Gaze',
    weapons_10_app: 1.72,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 40000,
    weapons_10_round_as: 3279,
    artifacts_1: 'The Ashblazing Grand Duke',
    artifacts_1_1: 'The Ashblazing Grand Duke',
    artifacts_1_2: '',
    artifacts_1_app: 44.4,
    artifacts_1_round_moc: 9.11,
    artifacts_1_round_pf: 39999,
    artifacts_1_round_as: 3451,
    artifacts_2: 'Hunter of Glacial Forest',
    artifacts_2_1: 'Hunter of Glacial Forest',
    artifacts_2_2: '',
    artifacts_2_app: 13.05,
    artifacts_2_round_moc: 9.5,
    artifacts_2_round_pf: 40000,
    artifacts_2_round_as: 3410,
    artifacts_3: 'Scholar Lost in Erudition',
    artifacts_3_1: 'Scholar Lost in Erudition',
    artifacts_3_2: '',
    artifacts_3_app: 7.66,
    artifacts_3_round_moc: 8.5,
    artifacts_3_round_pf: 39944,
    artifacts_3_round_as: 3578,
    artifacts_4: 'Hunter of Glacial Forest, The Ashblazing Grand Duke',
    artifacts_4_1: 'Hunter of Glacial Forest',
    artifacts_4_2: 'The Ashblazing Grand Duke',
    artifacts_4_app: 5.33,
    artifacts_4_round_moc: 10.0,
    artifacts_4_round_pf: 38152,
    artifacts_4_round_as: 3398,
    artifacts_5: 'Eagle of Twilight Line',
    artifacts_5_1: 'Eagle of Twilight Line',
    artifacts_5_2: '',
    artifacts_5_app: 3.86,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 40000,
    artifacts_5_round_as: 3637,
    artifacts_6: 'ATK +12%, The Ashblazing Grand Duke',
    artifacts_6_1: 'ATK +12%',
    artifacts_6_2: 'The Ashblazing Grand Duke',
    artifacts_6_app: 3.07,
    artifacts_6_round_moc: 10.0,
    artifacts_6_round_pf: 36447,
    artifacts_6_round_as: 3365,
    artifacts_7: 'ATK +12%, Hunter of Glacial Forest',
    artifacts_7_1: 'ATK +12%',
    artifacts_7_2: 'Hunter of Glacial Forest',
    artifacts_7_app: 2.58,
    artifacts_7_round_moc: 1.0,
    artifacts_7_round_pf: 40000,
    artifacts_7_round_as: 0,
    artifacts_8: 'The Wind-Soaring Valorous',
    artifacts_8_1: 'The Wind-Soaring Valorous',
    artifacts_8_2: '',
    artifacts_8_app: 2.12,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 40000,
    artifacts_8_round_as: 3575,
    artifacts_9: 'The Ashblazing Grand Duke, Flex',
    artifacts_9_1: 'The Ashblazing Grand Duke',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 1.09,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 35060,
    artifacts_9_round_as: 3584,
    artifacts_10: 'Genius of Brilliant Stars',
    artifacts_10_1: 'Genius of Brilliant Stars',
    artifacts_10_2: '',
    artifacts_10_app: 0.75,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 33240,
    artifacts_10_round_as: 0.0,
    planars_1: 'Inert Salsotto',
    planars_1_app: 37.21,
    planars_1_round_moc: 8.86,
    planars_1_round_pf: 39989,
    planars_1_round_as: 3403,
    planars_2: 'Sigonia, the Unclaimed Desolation',
    planars_2_app: 23.86,
    planars_2_round_moc: 9.43,
    planars_2_round_pf: 40000,
    planars_2_round_as: 3466,
    planars_3: 'Duran, Dynasty of Running Wolves',
    planars_3_app: 15.3,
    planars_3_round_moc: 8.0,
    planars_3_round_pf: 39885,
    planars_3_round_as: 3511,
    planars_4: 'Izumo Gensei and Takama Divine Realm',
    planars_4_app: 5.88,
    planars_4_round_moc: 8.33,
    planars_4_round_pf: 39248,
    planars_4_round_as: 3560,
    planars_5: 'Rutilant Arena',
    planars_5_app: 4.09,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 38240,
    planars_5_round_as: 3613,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 70.02,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 23.84,
    body_stats_3: 'DEF',
    body_stats_3_app: 1.31,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 51.35,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 46.9,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Ice DMG Boost',
    sphere_stats_1_app: 79.31,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 14.97,
    sphere_stats_3: 'HP',
    sphere_stats_3_app: 3.02,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 89.06,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 8.61,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 79.98,
    light_cone_lvl: 79.17,
    attack_lvl: 5.25,
    skill_lvl: 11.43,
    ultimate_lvl: 11.43,
    talent_lvl: 11.68,
    max_hp: 2966.97,
    atk: 2619.31,
    dfns: 1075.92,
    speed: 119.54,
    crate: 71.2,
    cdmg: 134.75,
    dmg_boost: 55.05,
    heal_boost: 1,
    energy_regen: 1.87,
    effect_res: 7.78,
    effect_rate: 7.71,
    break_effect: 12.31,
    spd_sub: 5.04,
    hp_sub: 10.8,
    atk_sub: 16.65,
    def_sub: 13.16,
    crate_sub: 28.2,
    cdmg_sub: 63.47,
    res_sub: 7.78,
    ehr_sub: 7.71,
    break_sub: 12.31
  },
  {
    char: 'bronya',
    app_rate_moc: 6.32,
    app_rate_moc_e0s1: 1.1,
    app_rate_moc_e1: 3.86,
    app_rate_moc_s0: 0.11,
    avg_round_moc: 8.88,
    avg_round_moc_e1: 5.82,
    avg_round_moc_s0: 9.33,
    sample_moc: 952,
    sample_size_players_moc: 133,
    app_rate_pf: 5.1,
    app_rate_pf_e0s1: 1.83,
    app_rate_pf_e1: 2.54,
    app_rate_pf_s0: 0.43,
    avg_round_pf: 30504,
    avg_round_pf_e1: 34307,
    avg_round_pf_s0: 27645,
    sample_pf: 716,
    sample_size_players_pf: 93,
    app_rate_as: 5.19,
    app_rate_as_e0s1: 1.51,
    app_rate_as_e1: 2.81,
    app_rate_as_s0: 0.34,
    avg_round_as: 3418,
    avg_round_as_e1: 3552,
    avg_round_as_s0: 3417,
    sample_as: 805,
    sample_size_players_as: 114,
    app_0: 6.87,
    round_0_moc: 8.03,
    round_0_pf: 30828,
    round_0_as: 3463,
    app_1: 20.07,
    round_1_moc: 6.36,
    round_1_pf: 32864,
    round_1_as: 3500,
    app_2: 29.14,
    round_2_moc: 6.28,
    round_2_pf: 33160,
    round_2_as: 3510,
    app_3: 17.14,
    round_3_moc: 6.37,
    round_3_pf: 33101,
    round_3_as: 3528,
    app_4: 11.95,
    round_4_moc: 5.47,
    round_4_pf: 34372,
    round_4_as: 3552,
    app_5: 6.29,
    round_5_moc: 4.84,
    round_5_pf: 34951,
    round_5_as: 3568,
    app_6: 8.53,
    round_6_moc: 4.69,
    round_6_pf: 34549,
    round_6_as: 3571,
    cons_avg: 2.6,
    weapons_1: "But the Battle Isn't Over",
    weapons_1_app: 62.39,
    weapons_1_round_moc: 9.29,
    weapons_1_round_pf: 30154,
    weapons_1_round_as: 3378,
    weapons_2: 'Dance! Dance! Dance!',
    weapons_2_app: 13.15,
    weapons_2_round_moc: 6.5,
    weapons_2_round_pf: 32093,
    weapons_2_round_as: 3364,
    weapons_3: 'A Grounded Ascent',
    weapons_3_app: 11.14,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 35240,
    weapons_3_round_as: 3590,
    weapons_4: 'Past and Future',
    weapons_4_app: 9.72,
    weapons_4_round_moc: 9.0,
    weapons_4_round_pf: 26680,
    weapons_4_round_as: 3516,
    weapons_5: "For Tomorrow's Journey",
    weapons_5_app: 0.68,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0,
    weapons_5_round_as: 0,
    weapons_6: 'Poised to Bloom',
    weapons_6_app: 0.67,
    weapons_6_round_moc: 10.0,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: 'Dreamville Adventure',
    weapons_7_app: 0.44,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0,
    weapons_8: 'Planetary Rendezvous',
    weapons_8_app: 0.44,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0,
    weapons_9: 'Carve the Moon, Weave the Clouds',
    weapons_9_app: 0.24,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 28000,
    weapons_9_round_as: 0.0,
    weapons_10: 'Earthly Escapade',
    weapons_10_app: 0.24,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0,
    weapons_10_round_as: 0.0,
    artifacts_1: "Sacerdos' Relived Ordeal",
    artifacts_1_1: "Sacerdos' Relived Ordeal",
    artifacts_1_2: '',
    artifacts_1_app: 36.39,
    artifacts_1_round_moc: 8.25,
    artifacts_1_round_pf: 31987,
    artifacts_1_round_as: 3534,
    artifacts_2: 'Messenger Traversing Hackerspace',
    artifacts_2_1: 'Messenger Traversing Hackerspace',
    artifacts_2_2: '',
    artifacts_2_app: 27.09,
    artifacts_2_round_moc: 9.6,
    artifacts_2_round_pf: 27455,
    artifacts_2_round_as: 3323,
    artifacts_3: 'SPD +6%, SPD +6%',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'SPD +6%',
    artifacts_3_app: 11.41,
    artifacts_3_round_moc: 5.75,
    artifacts_3_round_pf: 37987,
    artifacts_3_round_as: 3486,
    artifacts_4: 'SPD +6%, Flex',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'Flex',
    artifacts_4_app: 7.2,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 37080,
    artifacts_4_round_as: 3284,
    artifacts_5: 'Eagle of Twilight Line',
    artifacts_5_1: 'Eagle of Twilight Line',
    artifacts_5_2: '',
    artifacts_5_app: 4.95,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0,
    artifacts_6: 'SPD +6%, Longevous Disciple',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Longevous Disciple',
    artifacts_6_app: 1.81,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 24000,
    artifacts_6_round_as: 0,
    artifacts_7: 'Eagle of Twilight Line, Flex',
    artifacts_7_1: 'Eagle of Twilight Line',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 1.61,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 24640,
    artifacts_7_round_as: 0,
    artifacts_8: 'BE +16%, Flex',
    artifacts_8_1: 'BE +16%',
    artifacts_8_2: 'Flex',
    artifacts_8_app: 1.37,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 0,
    artifacts_9: 'Musketeer of Wild Wheat',
    artifacts_9_1: 'Musketeer of Wild Wheat',
    artifacts_9_2: '',
    artifacts_9_app: 0.67,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: 'Pioneer Diver of Dead Waters, Flex',
    artifacts_10_1: 'Pioneer Diver of Dead Waters',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 0.48,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 21200,
    artifacts_10_round_as: 0.0,
    planars_1: 'Broken Keel',
    planars_1_app: 53.93,
    planars_1_round_moc: 8.6,
    planars_1_round_pf: 29522,
    planars_1_round_as: 3412,
    planars_2: 'Lushaka, the Sunken Seas',
    planars_2_app: 15.28,
    planars_2_round_moc: 8.33,
    planars_2_round_pf: 30980,
    planars_2_round_as: 3553,
    planars_3: 'Sprightly Vonwacq',
    planars_3_app: 11.54,
    planars_3_round_moc: 6.0,
    planars_3_round_pf: 26380,
    planars_3_round_as: 0,
    planars_4: 'Forge of the Kalpagni Lantern',
    planars_4_app: 3.4,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 3295,
    planars_5: 'Fleet of the Ageless',
    planars_5_app: 2.44,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 92.73,
    body_stats_2: 'HP',
    body_stats_2_app: 3.48,
    body_stats_3: 'DEF',
    body_stats_3_app: 2.07,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 97.75,
    feet_stats_2: 'HP',
    feet_stats_2_app: 0.84,
    feet_stats_3: 'ATK',
    feet_stats_3_app: 0.56,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 46.58,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 21.61,
    sphere_stats_3: 'Wind DMG Boost',
    sphere_stats_3_app: 7.64,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 94.72,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 2.07,
    rope_stats_3: 'HP',
    rope_stats_3_app: 2.03,
    char_lvl: 79.94,
    light_cone_lvl: 78.1,
    attack_lvl: 4.58,
    skill_lvl: 10.56,
    ultimate_lvl: 11.2,
    talent_lvl: 10.19,
    max_hp: 4028.12,
    atk: 1625.2,
    dfns: 1323.26,
    speed: 147.78,
    crate: 11.8,
    cdmg: 195.35,
    dmg_boost: 19.55,
    heal_boost: 0.09,
    energy_regen: 26.49,
    effect_res: 32.16,
    effect_rate: 10.58,
    break_effect: 16.08,
    spd_sub: 18.13,
    hp_sub: 13.47,
    atk_sub: 12.15,
    def_sub: 16.33,
    crate_sub: 6.8,
    cdmg_sub: 54.42,
    res_sub: 17.18,
    ehr_sub: 10.58,
    break_sub: 15.74
  },
  {
    char: 'seele',
    app_rate_moc: 0.19,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.11,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 8.0,
    avg_round_moc_s0: 99.99,
    sample_moc: 28,
    sample_size_players_moc: 23,
    app_rate_pf: 0.16,
    app_rate_pf_e0s1: 0.01,
    app_rate_pf_e1: 0.1,
    app_rate_pf_s0: 0.01,
    avg_round_pf: 0,
    avg_round_pf_e1: 25030,
    avg_round_pf_s0: 0,
    sample_pf: 22,
    sample_size_players_pf: 17,
    app_rate_as: 0.99,
    app_rate_as_e0s1: 0.21,
    app_rate_as_e1: 0.68,
    app_rate_as_s0: 0.04,
    avg_round_as: 3382,
    avg_round_as_e1: 3440,
    avg_round_as_s0: 0,
    sample_as: 153,
    sample_size_players_as: 79,
    app_0: 56.27,
    round_0_moc: 7.43,
    round_0_pf: 27085,
    round_0_as: 3437,
    app_1: 15.76,
    round_1_moc: 8.0,
    round_1_pf: 27130,
    round_1_as: 3388,
    app_2: 13.9,
    round_2_moc: 7.5,
    round_2_pf: 25630,
    round_2_as: 3415,
    app_3: 3.47,
    round_3_moc: 9.0,
    round_3_pf: 30160,
    round_3_as: 3436,
    app_4: 5.08,
    round_4_moc: 6.33,
    round_4_pf: 31640,
    round_4_as: 3440,
    app_5: 0.65,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 3390,
    app_6: 5.04,
    round_6_moc: 2.75,
    round_6_pf: 31160,
    round_6_as: 3748,
    cons_avg: 1.07,
    weapons_1: 'In the Night',
    weapons_1_app: 78.57,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0,
    weapons_1_round_as: 3306,
    weapons_2: 'Cruising in the Stellar Sea',
    weapons_2_app: 15.79,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 32200,
    weapons_2_round_as: 3494,
    weapons_3: 'Return to Darkness',
    weapons_3_app: 1.49,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0,
    weapons_3_round_as: 0,
    weapons_4: 'Swordplay',
    weapons_4_app: 0.83,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 3201,
    weapons_5: 'After the Charmony Fall',
    weapons_5_app: 0.83,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0,
    weapons_6: 'Only Silence Remains',
    weapons_6_app: 0.83,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Genius of Brilliant Stars',
    artifacts_1_1: 'Genius of Brilliant Stars',
    artifacts_1_2: '',
    artifacts_1_app: 92.77,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 32200,
    artifacts_1_round_as: 3355,
    artifacts_2: 'Eagle of Twilight Line',
    artifacts_2_1: 'Eagle of Twilight Line',
    artifacts_2_2: '',
    artifacts_2_app: 2.25,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0,
    artifacts_3: 'Quan. +10%, Eagle of Twilight Line',
    artifacts_3_1: 'Quan. +10%',
    artifacts_3_2: 'Eagle of Twilight Line',
    artifacts_3_app: 0.83,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0,
    artifacts_4: 'Scholar Lost in Erudition',
    artifacts_4_1: 'Scholar Lost in Erudition',
    artifacts_4_2: '',
    artifacts_4_app: 0.83,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 3229,
    artifacts_5: 'Hero of Triumphant Song, Flex',
    artifacts_5_1: 'Hero of Triumphant Song',
    artifacts_5_2: 'Flex',
    artifacts_5_app: 0.83,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0,
    artifacts_6: 'Quan. +10%, ATK +12%',
    artifacts_6_1: 'Quan. +10%',
    artifacts_6_2: 'ATK +12%',
    artifacts_6_app: 0.83,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0,
    artifacts_7: 'Quan. +10%, Scholar Lost in Erudition',
    artifacts_7_1: 'Quan. +10%',
    artifacts_7_2: 'Scholar Lost in Erudition',
    artifacts_7_app: 0.83,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Rutilant Arena',
    planars_1_app: 50.83,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 32200,
    planars_1_round_as: 3345,
    planars_2: 'Firmament Frontline: Glamoth',
    planars_2_app: 39.79,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0,
    planars_2_round_as: 3312,
    planars_3: 'Inert Salsotto',
    planars_3_app: 4.15,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 3400,
    planars_4: 'Space Sealing Station',
    planars_4_app: 1.49,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 0,
    planars_5: 'Penacony, Land of the Dreams',
    planars_5_app: 1.25,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 58.03,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 41.03,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 96.26,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 2.81,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Quantum DMG Boost',
    sphere_stats_1_app: 93.69,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 5.38,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 93.39,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 4.74,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 79.24,
    attack_lvl: 6.05,
    skill_lvl: 10.37,
    ultimate_lvl: 10.12,
    talent_lvl: 10.33,
    max_hp: 2904.53,
    atk: 3248.04,
    dfns: 1032.73,
    speed: 121.07,
    crate: 76.94,
    cdmg: 192.87,
    dmg_boost: 45.99,
    heal_boost: 1,
    energy_regen: 0.99,
    effect_res: 6.3,
    effect_rate: 3.84,
    break_effect: 11.54,
    spd_sub: 6.07,
    hp_sub: 8.56,
    atk_sub: 17.94,
    def_sub: 9.33,
    crate_sub: 37.48,
    cdmg_sub: 81.77,
    res_sub: 6.3,
    ehr_sub: 3.84,
    break_sub: 11.71
  },
  {
    char: 'serval',
    app_rate_moc: 7.66,
    app_rate_moc_e0s1: 1.66,
    app_rate_moc_e1: 5.53,
    app_rate_moc_s0: 0.2,
    avg_round_moc: 8.92,
    avg_round_moc_e1: 6.92,
    avg_round_moc_s0: 9.25,
    sample_moc: 1153,
    sample_size_players_moc: 27,
    app_rate_pf: 3.64,
    app_rate_pf_e0s1: 1.9,
    app_rate_pf_e1: 1.64,
    app_rate_pf_s0: 0.71,
    avg_round_pf: 37842,
    avg_round_pf_e1: 40000,
    avg_round_pf_s0: 36393,
    sample_pf: 510,
    sample_size_players_pf: 19,
    app_rate_as: 2.96,
    app_rate_as_e0s1: 1.4,
    app_rate_as_e1: 1.5,
    app_rate_as_s0: 0.43,
    avg_round_as: 3406,
    avg_round_as_e1: 3543,
    avg_round_as_s0: 3371,
    sample_as: 459,
    sample_size_players_as: 12,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 0.52,
    round_1_moc: 7.75,
    round_1_pf: 39120,
    round_1_as: 3247,
    app_2: 1.81,
    round_2_moc: 7.4,
    round_2_pf: 38846,
    round_2_as: 3482,
    app_3: 1.37,
    round_3_moc: 6.38,
    round_3_pf: 35940,
    round_3_as: 3462,
    app_4: 4.5,
    round_4_moc: 7.33,
    round_4_pf: 39580,
    round_4_as: 3477,
    app_5: 5.41,
    round_5_moc: 8.44,
    round_5_pf: 38883,
    round_5_as: 3456,
    app_6: 86.39,
    round_6_moc: 7.64,
    round_6_pf: 39221,
    round_6_as: 3485,
    cons_avg: 5.72,
    weapons_1: 'Passkey',
    weapons_1_app: 80.32,
    weapons_1_round_moc: 9.33,
    weapons_1_round_pf: 38013,
    weapons_1_round_as: 3372,
    weapons_2: 'Make the World Clamor',
    weapons_2_app: 4.17,
    weapons_2_round_moc: 10.0,
    weapons_2_round_pf: 0,
    weapons_2_round_as: 0.0,
    weapons_3: 'Into the Unreachable Veil',
    weapons_3_app: 3.22,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 3408,
    weapons_4: 'Night on the Milky Way',
    weapons_4_app: 2.96,
    weapons_4_round_moc: 6.0,
    weapons_4_round_pf: 35400,
    weapons_4_round_as: 0.0,
    weapons_5: 'The Seriousness of Breakfast',
    weapons_5_app: 1.74,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: 'The Great Cosmic Enterprise',
    weapons_6_app: 1.74,
    weapons_6_round_moc: 9.0,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: "Geniuses' Repose",
    weapons_7_app: 1.22,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Eagle of Twilight Line',
    artifacts_1_1: 'Eagle of Twilight Line',
    artifacts_1_2: '',
    artifacts_1_app: 71.18,
    artifacts_1_round_moc: 9.4,
    artifacts_1_round_pf: 38504,
    artifacts_1_round_as: 3316,
    artifacts_2: 'SPD +6%, SPD +6%',
    artifacts_2_1: 'SPD +6%',
    artifacts_2_2: 'SPD +6%',
    artifacts_2_app: 7.37,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 36900,
    artifacts_2_round_as: 3570,
    artifacts_3: 'Scholar Lost in Erudition',
    artifacts_3_1: 'Scholar Lost in Erudition',
    artifacts_3_2: '',
    artifacts_3_app: 6.16,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 3408,
    artifacts_4: 'SPD +6%, Flex',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'Flex',
    artifacts_4_app: 4.44,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 36200,
    artifacts_4_round_as: 3367,
    artifacts_5: 'Band of Sizzling Thunder, Scholar Lost in Erudition',
    artifacts_5_1: 'Band of Sizzling Thunder',
    artifacts_5_2: 'Scholar Lost in Erudition',
    artifacts_5_app: 2.96,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 24080,
    artifacts_5_round_as: 0.0,
    artifacts_6: 'Pioneer Diver of Dead Waters',
    artifacts_6_1: 'Pioneer Diver of Dead Waters',
    artifacts_6_2: '',
    artifacts_6_app: 2.96,
    artifacts_6_round_moc: 6.0,
    artifacts_6_round_pf: 35400,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'Eagle of Twilight Line, Flex',
    artifacts_7_1: 'Eagle of Twilight Line',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 1.74,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: 'Scholar Lost in Erudition, Flex',
    artifacts_8_1: 'Scholar Lost in Erudition',
    artifacts_8_2: 'Flex',
    artifacts_8_app: 1.74,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Sprightly Vonwacq',
    planars_1_app: 62.86,
    planars_1_round_moc: 9.4,
    planars_1_round_pf: 38090,
    planars_1_round_as: 3358,
    planars_2: 'Lushaka, the Sunken Seas',
    planars_2_app: 5.13,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 36720,
    planars_2_round_as: 3367,
    planars_3: 'Space Sealing Station',
    planars_3_app: 3.22,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 3408,
    planars_4: 'Fleet of the Ageless',
    planars_4_app: 2.96,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 0.0,
    planars_5: 'Penacony, Land of the Dreams',
    planars_5_app: 2.7,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 40000,
    planars_5_round_as: 0,
    body_stats_1: 'HP',
    body_stats_1_app: 30.51,
    body_stats_2: 'Effect Hit Rate',
    body_stats_2_app: 21.11,
    body_stats_3: 'CRIT DMG',
    body_stats_3_app: 16.67,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 92.57,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 3.72,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'DEF',
    sphere_stats_1_app: 24.23,
    sphere_stats_2: 'HP',
    sphere_stats_2_app: 21.47,
    sphere_stats_3: 'Lightning DMG Boost',
    sphere_stats_3_app: 20.65,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 81.22,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 16.79,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 79.86,
    light_cone_lvl: 79.57,
    attack_lvl: 5.01,
    skill_lvl: 9.3,
    ultimate_lvl: 9.14,
    talent_lvl: 8.78,
    max_hp: 3021.83,
    atk: 1618.75,
    dfns: 882.97,
    speed: 149.3,
    crate: 41.46,
    cdmg: 83.2,
    dmg_boost: 7.94,
    heal_boost: 1,
    energy_regen: 19.32,
    effect_res: 19.04,
    effect_rate: 33.54,
    break_effect: 20.84,
    spd_sub: 20.88,
    hp_sub: 13.38,
    atk_sub: 10.24,
    def_sub: 10.29,
    crate_sub: 12.45,
    cdmg_sub: 32.07,
    res_sub: 12.08,
    ehr_sub: 10.83,
    break_sub: 20.84
  },
  {
    char: 'gepard',
    app_rate_moc: 0.33,
    app_rate_moc_e0s1: 0.02,
    app_rate_moc_e1: 0.18,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 9.21,
    avg_round_moc_s0: 99.99,
    sample_moc: 49,
    sample_size_players_moc: 5,
    app_rate_pf: 0.49,
    app_rate_pf_e0s1: 0.14,
    app_rate_pf_e1: 0.26,
    app_rate_pf_s0: 0.03,
    avg_round_pf: 27004,
    avg_round_pf_e1: 32797,
    avg_round_pf_s0: 0,
    sample_pf: 69,
    sample_size_players_pf: 6,
    app_rate_as: 0.29,
    app_rate_as_e0s1: 0.08,
    app_rate_as_e1: 0.17,
    app_rate_as_s0: 0.03,
    avg_round_as: 3290,
    avg_round_as_e1: 3406,
    avg_round_as_s0: 0,
    sample_as: 45,
    sample_size_players_as: 4,
    app_0: 30.03,
    round_0_moc: 9.0,
    round_0_pf: 30244,
    round_0_as: 3368,
    app_1: 26.91,
    round_1_moc: 8.47,
    round_1_pf: 32845,
    round_1_as: 3335,
    app_2: 27.59,
    round_2_moc: 8.86,
    round_2_pf: 31905,
    round_2_as: 3431,
    app_3: 8.04,
    round_3_moc: 8.33,
    round_3_pf: 31411,
    round_3_as: 3458,
    app_4: 5.6,
    round_4_moc: 8.67,
    round_4_pf: 32890,
    round_4_as: 3277,
    app_5: 1.83,
    round_5_moc: 5.0,
    round_5_pf: 34080,
    round_5_as: 3337,
    app_6: 1,
    round_6_moc: 99.99,
    round_6_pf: 0,
    round_6_as: 0,
    cons_avg: 1.38,
    weapons_1: 'Moment of Victory',
    weapons_1_app: 47.87,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0,
    weapons_1_round_as: 3408,
    weapons_2: 'Trend of the Universal Market',
    weapons_2_app: 43.52,
    weapons_2_round_moc: 9.0,
    weapons_2_round_pf: 24040,
    weapons_2_round_as: 3475,
    weapons_3: 'Day One of My New Life',
    weapons_3_app: 8.61,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 3315,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Knight of Purity Palace',
    artifacts_1_1: 'Knight of Purity Palace',
    artifacts_1_2: '',
    artifacts_1_app: 84.04,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0,
    artifacts_1_round_as: 3362,
    artifacts_2: 'SPD +6%, SPD +6%',
    artifacts_2_1: 'SPD +6%',
    artifacts_2_2: 'SPD +6%',
    artifacts_2_app: 15.97,
    artifacts_2_round_moc: 9.0,
    artifacts_2_round_pf: 24040,
    artifacts_2_round_as: 3475,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Belobog of the Architects',
    planars_1_app: 40.51,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0,
    planars_1_round_as: 3408,
    planars_2: 'Fleet of the Ageless',
    planars_2_app: 27.56,
    planars_2_round_moc: 9.0,
    planars_2_round_pf: 24040,
    planars_2_round_as: 3475,
    planars_3: 'Penacony, Land of the Dreams',
    planars_3_app: 15.97,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0,
    planars_3_round_as: 0,
    planars_4: 'Broken Keel',
    planars_4_app: 7.36,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'DEF',
    body_stats_1_app: 100.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 100.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'DEF',
    sphere_stats_1_app: 100.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 92.65,
    rope_stats_2: 'HP',
    rope_stats_2_app: 7.36,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 4.94,
    skill_lvl: 8.55,
    ultimate_lvl: 10.81,
    talent_lvl: 9.16,
    max_hp: 4040.62,
    atk: 1462.17,
    dfns: 3491.7,
    speed: 137.49,
    crate: 10.72,
    cdmg: 56.01,
    dmg_boost: 19.54,
    heal_boost: 1,
    energy_regen: 19.0,
    effect_res: 42.05,
    effect_rate: 33.92,
    break_effect: 16.52,
    spd_sub: 18.27,
    hp_sub: 20.33,
    atk_sub: 11.77,
    def_sub: 32.81,
    crate_sub: 5.72,
    cdmg_sub: 6.01,
    res_sub: 21.28,
    ehr_sub: 20.95,
    break_sub: 16.52
  },
  {
    char: 'natasha',
    app_rate_moc: 0.05,
    app_rate_moc_e0s1: 0.01,
    app_rate_moc_e1: 0.03,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 7,
    sample_size_players_moc: 2,
    app_rate_pf: 0.04,
    app_rate_pf_e0s1: 0.01,
    app_rate_pf_e1: 0.02,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 6,
    sample_size_players_pf: 4,
    app_rate_as: 0.04,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.01,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 6,
    sample_size_players_as: 2,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 15.75,
    round_4_moc: 10.0,
    round_4_pf: 40000,
    round_4_as: 3265,
    app_5: 16.67,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 3439,
    app_6: 79.12,
    round_6_moc: 8.33,
    round_6_pf: 35592,
    round_6_as: 3417,
    cons_avg: 5.63,
    weapons_1: 'Post-Op Conversation',
    weapons_1_app: 69.22,
    weapons_1_round_moc: 10.0,
    weapons_1_round_pf: 40000,
    weapons_1_round_as: 3265,
    weapons_2: 'Quid Pro Quo',
    weapons_2_app: 23.07,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0,
    weapons_2_round_as: 0,
    weapons_3: 'Perfect Timing',
    weapons_3_app: 7.69,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'SPD +6%, Longevous Disciple',
    artifacts_1_1: 'SPD +6%',
    artifacts_1_2: 'Longevous Disciple',
    artifacts_1_app: 42.3,
    artifacts_1_round_moc: 10.0,
    artifacts_1_round_pf: 40000,
    artifacts_1_round_as: 3265,
    artifacts_2: 'Passerby of Wandering Cloud',
    artifacts_2_1: 'Passerby of Wandering Cloud',
    artifacts_2_2: '',
    artifacts_2_app: 26.92,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0,
    artifacts_2_round_as: 0.0,
    artifacts_3: 'Eagle of Twilight Line, Flex',
    artifacts_3_1: 'Eagle of Twilight Line',
    artifacts_3_2: 'Flex',
    artifacts_3_app: 23.07,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 0,
    artifacts_4: 'Longevous Disciple, Passerby of Wandering Cloud',
    artifacts_4_1: 'Longevous Disciple',
    artifacts_4_2: 'Passerby of Wandering Cloud',
    artifacts_4_app: 7.69,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Fleet of the Ageless',
    planars_1_app: 42.3,
    planars_1_round_moc: 10.0,
    planars_1_round_pf: 40000,
    planars_1_round_as: 3265,
    planars_2: 'Sprightly Vonwacq',
    planars_2_app: 7.69,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0,
    planars_2_round_as: 0.0,
    planars_3: 'Broken Keel',
    planars_3_app: 7.69,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'Outgoing Healing Boost',
    body_stats_1_app: 100.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 100.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 76.92,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'HP',
    rope_stats_1_app: 42.3,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 34.61,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 75.77,
    light_cone_lvl: 73.85,
    attack_lvl: 4.5,
    skill_lvl: 10.73,
    ultimate_lvl: 10.31,
    talent_lvl: 8.73,
    max_hp: 5412.06,
    atk: 1315.54,
    dfns: 1067.31,
    speed: 131.39,
    crate: 10.51,
    cdmg: 64.55,
    dmg_boost: 1,
    heal_boost: 38.02,
    energy_regen: 17.34,
    effect_res: 29.95,
    effect_rate: 8.38,
    break_effect: 10.44,
    spd_sub: 9.75,
    hp_sub: 28.06,
    atk_sub: 14.09,
    def_sub: 14.12,
    crate_sub: 5.51,
    cdmg_sub: 14.55,
    res_sub: 13.03,
    ehr_sub: 8.38,
    break_sub: 10.44
  },
  {
    char: 'pela',
    app_rate_moc: 7.61,
    app_rate_moc_e0s1: 1.2,
    app_rate_moc_e1: 5.38,
    app_rate_moc_s0: 0.03,
    avg_round_moc: 9.13,
    avg_round_moc_e1: 8.44,
    avg_round_moc_s0: 99.99,
    sample_moc: 1146,
    sample_size_players_moc: 31,
    app_rate_pf: 6.44,
    app_rate_pf_e0s1: 2.91,
    app_rate_pf_e1: 2.97,
    app_rate_pf_s0: 0.32,
    avg_round_pf: 28066,
    avg_round_pf_e1: 31397,
    avg_round_pf_s0: 26498,
    sample_pf: 903,
    sample_size_players_pf: 37,
    app_rate_as: 6.06,
    app_rate_as_e0s1: 2.67,
    app_rate_as_e1: 2.84,
    app_rate_as_s0: 0.24,
    avg_round_as: 3353,
    avg_round_as_e1: 3483,
    avg_round_as_s0: 3290,
    sample_as: 941,
    sample_size_players_as: 28,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 0.34,
    round_3_moc: 9.25,
    round_3_pf: 27747,
    round_3_as: 0,
    app_4: 0.47,
    round_4_moc: 8.83,
    round_4_pf: 34160,
    round_4_as: 3440,
    app_5: 1.04,
    round_5_moc: 7.71,
    round_5_pf: 30236,
    round_5_as: 3393,
    app_6: 98.26,
    round_6_moc: 8.37,
    round_6_pf: 30179,
    round_6_as: 3441,
    cons_avg: 5.97,
    weapons_1: 'Resolution Shines As Pearls of Sweat',
    weapons_1_app: 86.57,
    weapons_1_round_moc: 10.0,
    weapons_1_round_pf: 29430,
    weapons_1_round_as: 3362,
    weapons_2: 'Before the Tutorial Mission Starts',
    weapons_2_app: 12.03,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0,
    weapons_2_round_as: 3301,
    weapons_3: 'Eyes of the Prey',
    weapons_3_app: 0.71,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 26840,
    weapons_3_round_as: 0.0,
    weapons_4: 'Solitary Healing',
    weapons_4_app: 0.7,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 3150,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Eagle of Twilight Line',
    artifacts_1_1: 'Eagle of Twilight Line',
    artifacts_1_2: '',
    artifacts_1_app: 47.43,
    artifacts_1_round_moc: 10.0,
    artifacts_1_round_pf: 29304,
    artifacts_1_round_as: 3358,
    artifacts_2: 'SPD +6%, SPD +6%',
    artifacts_2_1: 'SPD +6%',
    artifacts_2_2: 'SPD +6%',
    artifacts_2_app: 16.97,
    artifacts_2_round_moc: 10.0,
    artifacts_2_round_pf: 32080,
    artifacts_2_round_as: 3308,
    artifacts_3: 'SPD +6%, Guard of Wuthering Snow',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'Guard of Wuthering Snow',
    artifacts_3_app: 12.02,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 3362,
    artifacts_4: 'SPD +6%, Flex',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'Flex',
    artifacts_4_app: 5.65,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 3376,
    artifacts_5: 'SPD +6%, Longevous Disciple',
    artifacts_5_1: 'SPD +6%',
    artifacts_5_2: 'Longevous Disciple',
    artifacts_5_app: 3.8,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0.0,
    artifacts_6: 'Musketeer of Wild Wheat',
    artifacts_6_1: 'Musketeer of Wild Wheat',
    artifacts_6_2: '',
    artifacts_6_app: 2.36,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 26840,
    artifacts_6_round_as: 3352,
    artifacts_7: 'SPD +6%, BE +16%',
    artifacts_7_1: 'SPD +6%',
    artifacts_7_2: 'BE +16%',
    artifacts_7_app: 2.36,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0,
    artifacts_7_round_as: 3269,
    artifacts_8: 'Guard of Wuthering Snow',
    artifacts_8_1: 'Guard of Wuthering Snow',
    artifacts_8_2: '',
    artifacts_8_app: 1.65,
    artifacts_8_round_moc: 10.0,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 3346,
    artifacts_9: 'Messenger Traversing Hackerspace',
    artifacts_9_1: 'Messenger Traversing Hackerspace',
    artifacts_9_2: '',
    artifacts_9_app: 0.95,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: 'Thief of Shooting Meteor',
    artifacts_10_1: 'Thief of Shooting Meteor',
    artifacts_10_2: '',
    artifacts_10_app: 0.95,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Broken Keel',
    planars_1_app: 32.29,
    planars_1_round_moc: 10.0,
    planars_1_round_pf: 29080,
    planars_1_round_as: 3369,
    planars_2: 'Sprightly Vonwacq',
    planars_2_app: 26.19,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 28027,
    planars_2_round_as: 3350,
    planars_3: 'Lushaka, the Sunken Seas',
    planars_3_app: 18.15,
    planars_3_round_moc: 10.0,
    planars_3_round_pf: 31440,
    planars_3_round_as: 3370,
    planars_4: 'Fleet of the Ageless',
    planars_4_app: 6.38,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 0,
    planars_5: 'Penacony, Land of the Dreams',
    planars_5_app: 2.82,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 27920,
    planars_5_round_as: 3182,
    body_stats_1: 'Effect Hit Rate',
    body_stats_1_app: 84.19,
    body_stats_2: 'DEF',
    body_stats_2_app: 7.54,
    body_stats_3: 'HP',
    body_stats_3_app: 3.01,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 99.99,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 53.26,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 21.71,
    sphere_stats_3: 'Ice DMG Boost',
    sphere_stats_3_app: 11.29,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 89.3,
    rope_stats_2: 'DEF',
    rope_stats_2_app: 4.03,
    rope_stats_3: 'ATK',
    rope_stats_3_app: 2.3,
    char_lvl: 79.67,
    light_cone_lvl: 78.42,
    attack_lvl: 4.89,
    skill_lvl: 8.56,
    ultimate_lvl: 11.64,
    talent_lvl: 11.37,
    max_hp: 3571.92,
    atk: 1728.58,
    dfns: 1033.85,
    speed: 157.71,
    crate: 13.45,
    cdmg: 64.0,
    dmg_boost: 20.87,
    heal_boost: 1,
    energy_regen: 19.52,
    effect_res: 18.48,
    effect_rate: 70.37,
    break_effect: 18.21,
    spd_sub: 23.53,
    hp_sub: 14.16,
    atk_sub: 13.94,
    def_sub: 20.71,
    crate_sub: 8.68,
    cdmg_sub: 14.77,
    res_sub: 13.76,
    ehr_sub: 19.4,
    break_sub: 17.82
  },
  {
    char: 'clara',
    app_rate_moc: 0.53,
    app_rate_moc_e0s1: 0.05,
    app_rate_moc_e1: 0.37,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 8.9,
    avg_round_moc_s0: 99.99,
    sample_moc: 80,
    sample_size_players_moc: 39,
    app_rate_pf: 1.87,
    app_rate_pf_e0s1: 0.84,
    app_rate_pf_e1: 0.93,
    app_rate_pf_s0: 0.28,
    avg_round_pf: 24409,
    avg_round_pf_e1: 27084,
    avg_round_pf_s0: 24137,
    sample_pf: 262,
    sample_size_players_pf: 70,
    app_rate_as: 0.9,
    app_rate_as_e0s1: 0.22,
    app_rate_as_e1: 0.59,
    app_rate_as_s0: 0.05,
    avg_round_as: 3186,
    avg_round_as_e1: 3271,
    avg_round_as_s0: 0,
    sample_as: 140,
    sample_size_players_as: 59,
    app_0: 10.74,
    round_0_moc: 9.75,
    round_0_pf: 24621,
    round_0_as: 3235,
    app_1: 21.38,
    round_1_moc: 8.71,
    round_1_pf: 24822,
    round_1_as: 3249,
    app_2: 22.18,
    round_2_moc: 9.27,
    round_2_pf: 25299,
    round_2_as: 3249,
    app_3: 14.38,
    round_3_moc: 8.9,
    round_3_pf: 25821,
    round_3_as: 3268,
    app_4: 10.72,
    round_4_moc: 8.42,
    round_4_pf: 27722,
    round_4_as: 3278,
    app_5: 6.62,
    round_5_moc: 7.86,
    round_5_pf: 25875,
    round_5_as: 3299,
    app_6: 14.0,
    round_6_moc: 6.79,
    round_6_pf: 28760,
    round_6_as: 3246,
    cons_avg: 2.69,
    weapons_1: 'Something Irreplaceable',
    weapons_1_app: 43.81,
    weapons_1_round_moc: 8.67,
    weapons_1_round_pf: 26630,
    weapons_1_round_as: 3304,
    weapons_2: 'Dance at Sunset',
    weapons_2_app: 36.55,
    weapons_2_round_moc: 8.0,
    weapons_2_round_pf: 26048,
    weapons_2_round_as: 3139,
    weapons_3: 'On the Fall of an Aeon',
    weapons_3_app: 11.08,
    weapons_3_round_moc: 8.0,
    weapons_3_round_pf: 24540,
    weapons_3_round_as: 3146,
    weapons_4: 'The Unreachable Side',
    weapons_4_app: 3.82,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 26060,
    weapons_4_round_as: 0,
    weapons_5: 'Brighter Than the Sun',
    weapons_5_app: 2.92,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0,
    weapons_5_round_as: 0,
    weapons_6: 'Nowhere to Run',
    weapons_6_app: 1.02,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0,
    weapons_6_round_as: 0.0,
    weapons_7: 'A Secret Vow',
    weapons_7_app: 0.4,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 3249,
    weapons_8: 'Dance! Dance! Dance!',
    weapons_8_app: 0.4,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Poet of Mourning Collapse',
    artifacts_1_1: 'Poet of Mourning Collapse',
    artifacts_1_2: '',
    artifacts_1_app: 43.78,
    artifacts_1_round_moc: 9.0,
    artifacts_1_round_pf: 28029,
    artifacts_1_round_as: 3134,
    artifacts_2: 'Champion of Streetwise Boxing',
    artifacts_2_1: 'Champion of Streetwise Boxing',
    artifacts_2_2: '',
    artifacts_2_app: 23.74,
    artifacts_2_round_moc: 8.0,
    artifacts_2_round_pf: 25400,
    artifacts_2_round_as: 3306,
    artifacts_3: 'Champion of Streetwise Boxing, The Ashblazing Grand Duke',
    artifacts_3_1: 'Champion of Streetwise Boxing',
    artifacts_3_2: 'The Ashblazing Grand Duke',
    artifacts_3_app: 6.35,
    artifacts_3_round_moc: 8.0,
    artifacts_3_round_pf: 25392,
    artifacts_3_round_as: 3271,
    artifacts_4: 'Longevous Disciple',
    artifacts_4_1: 'Longevous Disciple',
    artifacts_4_2: '',
    artifacts_4_app: 5.53,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 0,
    artifacts_5: 'ATK +12%, The Ashblazing Grand Duke',
    artifacts_5_1: 'ATK +12%',
    artifacts_5_2: 'The Ashblazing Grand Duke',
    artifacts_5_app: 4.13,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 24360,
    artifacts_5_round_as: 0,
    artifacts_6: 'The Ashblazing Grand Duke',
    artifacts_6_1: 'The Ashblazing Grand Duke',
    artifacts_6_2: '',
    artifacts_6_app: 2.13,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 24040,
    artifacts_6_round_as: 0,
    artifacts_7: 'Scholar Lost in Erudition, The Ashblazing Grand Duke',
    artifacts_7_1: 'Scholar Lost in Erudition',
    artifacts_7_2: 'The Ashblazing Grand Duke',
    artifacts_7_app: 2.03,
    artifacts_7_round_moc: 8.0,
    artifacts_7_round_pf: 24280,
    artifacts_7_round_as: 0.0,
    artifacts_8: 'Champion of Streetwise Boxing, Flex',
    artifacts_8_1: 'Champion of Streetwise Boxing',
    artifacts_8_2: 'Flex',
    artifacts_8_app: 2.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 0.0,
    artifacts_9: 'Eagle of Twilight Line',
    artifacts_9_1: 'Eagle of Twilight Line',
    artifacts_9_2: '',
    artifacts_9_app: 1.33,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0,
    artifacts_9_round_as: 0.0,
    artifacts_10: 'ATK +12%, ATK +12%',
    artifacts_10_1: 'ATK +12%',
    artifacts_10_2: 'ATK +12%',
    artifacts_10_app: 1.33,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 24000,
    artifacts_10_round_as: 0.0,
    planars_1: 'Duran, Dynasty of Running Wolves',
    planars_1_app: 60.68,
    planars_1_round_moc: 8.0,
    planars_1_round_pf: 25569,
    planars_1_round_as: 3122,
    planars_2: 'Inert Salsotto',
    planars_2_app: 32.48,
    planars_2_round_moc: 8.0,
    planars_2_round_pf: 26433,
    planars_2_round_as: 3223,
    planars_3: 'Rutilant Arena',
    planars_3_app: 1.33,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0,
    planars_3_round_as: 0.0,
    planars_4: 'Space Sealing Station',
    planars_4_app: 0.75,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0,
    planars_5: 'Sprightly Vonwacq',
    planars_5_app: 0.67,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 70.72,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 27.6,
    body_stats_3: 'ATK',
    body_stats_3_app: 0.41,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 95.08,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 2.43,
    feet_stats_3: 'HP',
    feet_stats_3_app: 0.46,
    sphere_stats_1: 'Physical DMG Boost',
    sphere_stats_1_app: 92.57,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 6.62,
    sphere_stats_3: 'Ice DMG Boost',
    sphere_stats_3_app: 0.81,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 97.51,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 0.87,
    rope_stats_3: 'HP',
    rope_stats_3_app: 0.81,
    char_lvl: 80.0,
    light_cone_lvl: 79.95,
    attack_lvl: 5.84,
    skill_lvl: 11.2,
    ultimate_lvl: 10.67,
    talent_lvl: 10.69,
    max_hp: 3591.66,
    atk: 3630.56,
    dfns: 1061.05,
    speed: 89.87,
    crate: 65.33,
    cdmg: 156.37,
    dmg_boost: 53.33,
    heal_boost: 1,
    energy_regen: 0.39,
    effect_res: 9.3,
    effect_rate: 7.88,
    break_effect: 13.91,
    spd_sub: 2.9,
    hp_sub: 8.65,
    atk_sub: 16.96,
    def_sub: 11.52,
    crate_sub: 33.32,
    cdmg_sub: 74.05,
    res_sub: 9.3,
    ehr_sub: 7.88,
    break_sub: 13.91
  },
  {
    char: 'sampo',
    app_rate_moc: 0.0,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.0,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 0,
    sample_size_players_moc: 0,
    app_rate_pf: 0.01,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.01,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 2,
    sample_size_players_pf: 0,
    app_rate_as: 0.06,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.04,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 10,
    sample_size_players_as: 0,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 1,
    round_6_moc: 99.99,
    round_6_pf: 0,
    round_6_as: 0,
    cons_avg: 1,
    weapons_1: '',
    weapons_1_app: 0.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0.0,
    weapons_1_round_as: 0.0,
    weapons_2: '',
    weapons_2_app: 0.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: '',
    artifacts_1_1: '',
    artifacts_1_2: '',
    artifacts_1_app: 0.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0.0,
    artifacts_1_round_as: 0.0,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: '',
    planars_1_app: 0.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0.0,
    planars_1_round_as: 0.0,
    planars_2: '',
    planars_2_app: 0.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: '',
    body_stats_1_app: 0.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: '',
    feet_stats_1_app: 0.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: '',
    sphere_stats_1_app: 0.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: '',
    rope_stats_1_app: 0.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 1,
    light_cone_lvl: 1,
    attack_lvl: 1,
    skill_lvl: 1,
    ultimate_lvl: 1,
    talent_lvl: 1,
    max_hp: 1,
    atk: 1,
    dfns: 1,
    speed: 1,
    crate: 1,
    cdmg: 1,
    dmg_boost: 1,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 1,
    effect_rate: 1,
    break_effect: 1,
    spd_sub: 1,
    hp_sub: 1,
    atk_sub: 1,
    def_sub: 1,
    crate_sub: 1,
    cdmg_sub: 1,
    res_sub: 1,
    ehr_sub: 1,
    break_sub: 1
  },
  {
    char: 'hook',
    app_rate_moc: 0.02,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.0,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 3,
    sample_size_players_moc: 2,
    app_rate_pf: 0.01,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.0,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 2,
    sample_size_players_pf: 2,
    app_rate_as: 0.03,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.01,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 5,
    sample_size_players_as: 5,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 100.0,
    round_6_moc: 5.0,
    round_6_pf: 28180,
    round_6_as: 3224,
    cons_avg: 6.0,
    weapons_1: 'On the Fall of an Aeon',
    weapons_1_app: 45.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0,
    weapons_1_round_as: 0,
    weapons_2: 'The Moles Welcome You',
    weapons_2_app: 35.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0,
    weapons_2_round_as: 0,
    weapons_3: 'I Shall Be My Own Sword',
    weapons_3_app: 10.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0,
    weapons_4: 'Indelible Promise',
    weapons_4_app: 10.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 3322,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Scholar Lost in Erudition',
    artifacts_1_1: 'Scholar Lost in Erudition',
    artifacts_1_2: '',
    artifacts_1_app: 55.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0,
    artifacts_1_round_as: 0,
    artifacts_2: 'Firesmith of Lava-Forging',
    artifacts_2_1: 'Firesmith of Lava-Forging',
    artifacts_2_2: '',
    artifacts_2_app: 35.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0,
    artifacts_2_round_as: 0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Rutilant Arena',
    planars_1_app: 55.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0,
    planars_1_round_as: 0,
    planars_2: 'Space Sealing Station',
    planars_2_app: 35.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0,
    planars_2_round_as: 0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 65.0,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 35.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 80.0,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 10.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Fire DMG Boost',
    sphere_stats_1_app: 90.0,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 10.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 100.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 6.6,
    skill_lvl: 12.0,
    ultimate_lvl: 12.0,
    talent_lvl: 12.0,
    max_hp: 3741.27,
    atk: 2605.39,
    dfns: 793.49,
    speed: 125.79,
    crate: 77.18,
    cdmg: 145.62,
    dmg_boost: 38.49,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 4.58,
    effect_rate: 7.67,
    break_effect: 28.1,
    spd_sub: 11.76,
    hp_sub: 6.37,
    atk_sub: 12.48,
    def_sub: 11.53,
    crate_sub: 42.31,
    cdmg_sub: 57.64,
    res_sub: 4.58,
    ehr_sub: 7.67,
    break_sub: 23.2
  },
  {
    char: 'qingque',
    app_rate_moc: 0.39,
    app_rate_moc_e0s1: 0.01,
    app_rate_moc_e1: 0.27,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 8.4,
    avg_round_moc_s0: 99.99,
    sample_moc: 58,
    sample_size_players_moc: 30,
    app_rate_pf: 0.17,
    app_rate_pf_e0s1: 0.05,
    app_rate_pf_e1: 0.09,
    app_rate_pf_s0: 0.02,
    avg_round_pf: 0,
    avg_round_pf_e1: 26800,
    avg_round_pf_s0: 0,
    sample_pf: 24,
    sample_size_players_pf: 15,
    app_rate_as: 0.16,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.09,
    app_rate_as_s0: 0.01,
    avg_round_as: 0,
    avg_round_as_e1: 3284,
    avg_round_as_s0: 0,
    sample_as: 25,
    sample_size_players_as: 16,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 4.17,
    round_2_moc: 99.99,
    round_2_pf: 40000,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 2.38,
    round_4_moc: 5.0,
    round_4_pf: 0,
    round_4_as: 3267,
    app_5: 4.17,
    round_5_moc: 99.99,
    round_5_pf: 36200,
    round_5_as: 0,
    app_6: 96.21,
    round_6_moc: 8.31,
    round_6_pf: 27443,
    round_6_as: 3278,
    cons_avg: 5.92,
    weapons_1: 'Today Is Another Peaceful Day',
    weapons_1_app: 45.42,
    weapons_1_round_moc: 10.0,
    weapons_1_round_pf: 27860,
    weapons_1_round_as: 3331,
    weapons_2: 'Before Dawn',
    weapons_2_app: 15.71,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0,
    weapons_3: "Geniuses' Repose",
    weapons_3_app: 15.34,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 24640,
    weapons_3_round_as: 0,
    weapons_4: 'Yet Hope Is Priceless',
    weapons_4_app: 10.8,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0,
    weapons_4_round_as: 0,
    weapons_5: 'Night on the Milky Way',
    weapons_5_app: 3.23,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 24520,
    weapons_5_round_as: 0.0,
    weapons_6: 'The Day The Cosmos Fell',
    weapons_6_app: 3.23,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0,
    weapons_6_round_as: 0.0,
    weapons_7: 'Into the Unreachable Veil',
    weapons_7_app: 3.06,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0,
    weapons_8: 'Eternal Calculus',
    weapons_8_app: 1.75,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: 'An Instant Before A Gaze',
    weapons_9_app: 1.48,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Genius of Brilliant Stars',
    artifacts_1_1: 'Genius of Brilliant Stars',
    artifacts_1_2: '',
    artifacts_1_app: 63.81,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 24580,
    artifacts_1_round_as: 0,
    artifacts_2: 'Poet of Mourning Collapse',
    artifacts_2_1: 'Poet of Mourning Collapse',
    artifacts_2_2: '',
    artifacts_2_app: 34.44,
    artifacts_2_round_moc: 10.0,
    artifacts_2_round_pf: 27860,
    artifacts_2_round_as: 3331,
    artifacts_3: 'The Ashblazing Grand Duke',
    artifacts_3_1: 'The Ashblazing Grand Duke',
    artifacts_3_2: '',
    artifacts_3_app: 1.75,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Rutilant Arena',
    planars_1_app: 89.19,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 24580,
    planars_1_round_as: 3331,
    planars_2: 'Inert Salsotto',
    planars_2_app: 4.54,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0,
    planars_2_round_as: 0,
    planars_3: 'Space Sealing Station',
    planars_3_app: 2.79,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0,
    planars_3_round_as: 0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 63.11,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 36.9,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 89.82,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 10.18,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Quantum DMG Boost',
    sphere_stats_1_app: 75.09,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 24.92,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 93.42,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 4.76,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 7.0,
    skill_lvl: 11.98,
    ultimate_lvl: 11.92,
    talent_lvl: 11.93,
    max_hp: 2898.01,
    atk: 3258.51,
    dfns: 1048.82,
    speed: 99.08,
    crate: 66.1,
    cdmg: 175.31,
    dmg_boost: 53.42,
    heal_boost: 1,
    energy_regen: 0.93,
    effect_res: 6.75,
    effect_rate: 5.06,
    break_effect: 12.89,
    spd_sub: 2.52,
    hp_sub: 6.92,
    atk_sub: 17.51,
    def_sub: 10.12,
    crate_sub: 39.47,
    cdmg_sub: 77.43,
    res_sub: 6.75,
    ehr_sub: 5.06,
    break_sub: 12.89
  },
  {
    char: 'tingyun',
    app_rate_moc: 0.73,
    app_rate_moc_e0s1: 0.08,
    app_rate_moc_e1: 0.42,
    app_rate_moc_s0: 0.01,
    avg_round_moc: 7.92,
    avg_round_moc_e1: 7.81,
    avg_round_moc_s0: 99.99,
    sample_moc: 110,
    sample_size_players_moc: 9,
    app_rate_pf: 1.86,
    app_rate_pf_e0s1: 0.93,
    app_rate_pf_e1: 0.78,
    app_rate_pf_s0: 0.38,
    avg_round_pf: 26925,
    avg_round_pf_e1: 31840,
    avg_round_pf_s0: 26520,
    sample_pf: 261,
    sample_size_players_pf: 9,
    app_rate_as: 1.53,
    app_rate_as_e0s1: 0.36,
    app_rate_as_e1: 0.85,
    app_rate_as_s0: 0.08,
    avg_round_as: 3374,
    avg_round_as_e1: 3564,
    avg_round_as_s0: 3363,
    sample_as: 237,
    sample_size_players_as: 10,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 0.38,
    round_2_moc: 99.99,
    round_2_pf: 29920,
    round_2_as: 0,
    app_3: 1.33,
    round_3_moc: 9.5,
    round_3_pf: 29280,
    round_3_as: 3207,
    app_4: 1.65,
    round_4_moc: 9.33,
    round_4_pf: 25530,
    round_4_as: 3331,
    app_5: 1.36,
    round_5_moc: 10.0,
    round_5_pf: 25900,
    round_5_as: 0,
    app_6: 96.0,
    round_6_moc: 6.87,
    round_6_pf: 30351,
    round_6_as: 3569,
    cons_avg: 5.91,
    weapons_1: 'Dance! Dance! Dance!',
    weapons_1_app: 52.91,
    weapons_1_round_moc: 8.0,
    weapons_1_round_pf: 28160,
    weapons_1_round_as: 0,
    weapons_2: 'A Grounded Ascent',
    weapons_2_app: 23.04,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 26480,
    weapons_2_round_as: 0,
    weapons_3: "But the Battle Isn't Over",
    weapons_3_app: 8.93,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0,
    weapons_3_round_as: 3546,
    weapons_4: 'Meshing Cogs',
    weapons_4_app: 7.56,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0,
    weapons_4_round_as: 0,
    weapons_5: 'Carve the Moon, Weave the Clouds',
    weapons_5_app: 4.7,
    weapons_5_round_moc: 10.0,
    weapons_5_round_pf: 0,
    weapons_5_round_as: 0.0,
    weapons_6: 'Memories of the Past',
    weapons_6_app: 2.86,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: "Sacerdos' Relived Ordeal",
    artifacts_1_1: "Sacerdos' Relived Ordeal",
    artifacts_1_2: '',
    artifacts_1_app: 46.73,
    artifacts_1_round_moc: 8.0,
    artifacts_1_round_pf: 24933,
    artifacts_1_round_as: 3546,
    artifacts_2: 'Eagle of Twilight Line',
    artifacts_2_1: 'Eagle of Twilight Line',
    artifacts_2_2: '',
    artifacts_2_app: 20.83,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 24320,
    artifacts_2_round_as: 0,
    artifacts_3: 'SPD +6%, SPD +6%',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'SPD +6%',
    artifacts_3_app: 12.26,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 0,
    artifacts_4: 'SPD +6%, ATK +12%',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'ATK +12%',
    artifacts_4_app: 10.79,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 40000,
    artifacts_4_round_as: 0,
    artifacts_5: 'Musketeer of Wild Wheat',
    artifacts_5_1: 'Musketeer of Wild Wheat',
    artifacts_5_2: '',
    artifacts_5_app: 4.7,
    artifacts_5_round_moc: 10.0,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0.0,
    artifacts_6: 'SPD +6%, Flex',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Flex',
    artifacts_6_app: 3.22,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'Messenger Traversing Hackerspace',
    artifacts_7_1: 'Messenger Traversing Hackerspace',
    artifacts_7_2: '',
    artifacts_7_app: 1.48,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Broken Keel',
    planars_1_app: 29.12,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 25380,
    planars_1_round_as: 0,
    planars_2: 'Lushaka, the Sunken Seas',
    planars_2_app: 26.26,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 32160,
    planars_2_round_as: 0,
    planars_3: 'Sprightly Vonwacq',
    planars_3_app: 20.45,
    planars_3_round_moc: 8.0,
    planars_3_round_pf: 0,
    planars_3_round_as: 3219,
    planars_4: 'Penacony, Land of the Dreams',
    planars_4_app: 14.74,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 3872,
    planars_5: 'Fleet of the Ageless',
    planars_5_app: 9.4,
    planars_5_round_moc: 10.0,
    planars_5_round_pf: 24040,
    planars_5_round_as: 0.0,
    body_stats_1: 'ATK',
    body_stats_1_app: 80.57,
    body_stats_2: 'HP',
    body_stats_2_app: 19.43,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 100.01,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'ATK',
    sphere_stats_1_app: 63.97,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 34.06,
    sphere_stats_3: 'HP',
    sphere_stats_3_app: 1.97,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 100.01,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 78.76,
    attack_lvl: 5.47,
    skill_lvl: 11.82,
    ultimate_lvl: 11.93,
    talent_lvl: 10.54,
    max_hp: 3016.48,
    atk: 2514.34,
    dfns: 1289.33,
    speed: 169.73,
    crate: 9.65,
    cdmg: 55.93,
    dmg_boost: 6.68,
    heal_boost: 1,
    energy_regen: 22.49,
    effect_res: 22.71,
    effect_rate: 8.11,
    break_effect: 12.44,
    spd_sub: 26.92,
    hp_sub: 14.09,
    atk_sub: 28.61,
    def_sub: 17.49,
    crate_sub: 5.36,
    cdmg_sub: 5.93,
    res_sub: 19.5,
    ehr_sub: 8.11,
    break_sub: 12.78
  },
  {
    char: 'jing-yuan',
    app_rate_moc: 2.97,
    app_rate_moc_e0s1: 0.28,
    app_rate_moc_e1: 2.14,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 9.09,
    avg_round_moc_e1: 7.4,
    avg_round_moc_s0: 99.99,
    sample_moc: 448,
    sample_size_players_moc: 329,
    app_rate_pf: 3.56,
    app_rate_pf_e0s1: 1.08,
    app_rate_pf_e1: 2.12,
    app_rate_pf_s0: 0.19,
    avg_round_pf: 28745,
    avg_round_pf_e1: 33688,
    avg_round_pf_s0: 25688,
    sample_pf: 500,
    sample_size_players_pf: 336,
    app_rate_as: 0.28,
    app_rate_as_e0s1: 0.04,
    app_rate_as_e1: 0.16,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 3328,
    avg_round_as_s0: 0,
    sample_as: 43,
    sample_size_players_as: 36,
    app_0: 70.98,
    round_0_moc: 8.1,
    round_0_pf: 31539,
    round_0_as: 3255,
    app_1: 18.08,
    round_1_moc: 7.31,
    round_1_pf: 33538,
    round_1_as: 3386,
    app_2: 4.92,
    round_2_moc: 6.0,
    round_2_pf: 38050,
    round_2_as: 3522,
    app_3: 0.43,
    round_3_moc: 8.0,
    round_3_pf: 33893,
    round_3_as: 0,
    app_4: 0.43,
    round_4_moc: 8.0,
    round_4_pf: 35467,
    round_4_as: 0,
    app_5: 0.21,
    round_5_moc: 9.0,
    round_5_pf: 38560,
    round_5_as: 0,
    app_6: 5.0,
    round_6_moc: 5.38,
    round_6_pf: 39600,
    round_6_as: 3518,
    cons_avg: 0.62,
    weapons_1: 'Before Dawn',
    weapons_1_app: 81.11,
    weapons_1_round_moc: 9.0,
    weapons_1_round_pf: 29923,
    weapons_1_round_as: 3237,
    weapons_2: 'Today Is Another Peaceful Day',
    weapons_2_app: 3.89,
    weapons_2_round_moc: 8.67,
    weapons_2_round_pf: 28480,
    weapons_2_round_as: 0.0,
    weapons_3: 'Night on the Milky Way',
    weapons_3_app: 3.57,
    weapons_3_round_moc: 10.0,
    weapons_3_round_pf: 31660,
    weapons_3_round_as: 0,
    weapons_4: "Geniuses' Repose",
    weapons_4_app: 2.96,
    weapons_4_round_moc: 10.0,
    weapons_4_round_pf: 28208,
    weapons_4_round_as: 0.0,
    weapons_5: 'The Seriousness of Breakfast',
    weapons_5_app: 2.33,
    weapons_5_round_moc: 7.0,
    weapons_5_round_pf: 25720,
    weapons_5_round_as: 0.0,
    weapons_6: 'The Day The Cosmos Fell',
    weapons_6_app: 1.61,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 27560,
    weapons_6_round_as: 0.0,
    weapons_7: 'Eternal Calculus',
    weapons_7_app: 1.57,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 26867,
    weapons_7_round_as: 0,
    weapons_8: 'The Birth of the Self',
    weapons_8_app: 1.21,
    weapons_8_round_moc: 9.0,
    weapons_8_round_pf: 21660,
    weapons_8_round_as: 0.0,
    weapons_9: 'Yet Hope Is Priceless',
    weapons_9_app: 0.4,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0,
    weapons_9_round_as: 0,
    weapons_10: 'An Instant Before A Gaze',
    weapons_10_app: 0.27,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'The Ashblazing Grand Duke',
    artifacts_1_1: 'The Ashblazing Grand Duke',
    artifacts_1_2: '',
    artifacts_1_app: 95.37,
    artifacts_1_round_moc: 9.12,
    artifacts_1_round_pf: 29687,
    artifacts_1_round_as: 3237,
    artifacts_2: 'Band of Sizzling Thunder',
    artifacts_2_1: 'Band of Sizzling Thunder',
    artifacts_2_2: '',
    artifacts_2_app: 1.49,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 27067,
    artifacts_2_round_as: 0,
    artifacts_3: 'The Ashblazing Grand Duke, Flex',
    artifacts_3_1: 'The Ashblazing Grand Duke',
    artifacts_3_2: 'Flex',
    artifacts_3_app: 0.58,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 25500,
    artifacts_3_round_as: 0.0,
    artifacts_4: 'Band of Sizzling Thunder, The Ashblazing Grand Duke',
    artifacts_4_1: 'Band of Sizzling Thunder',
    artifacts_4_2: 'The Ashblazing Grand Duke',
    artifacts_4_app: 0.41,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 21280,
    artifacts_4_round_as: 0.0,
    artifacts_5: 'Scholar Lost in Erudition, The Ashblazing Grand Duke',
    artifacts_5_1: 'Scholar Lost in Erudition',
    artifacts_5_2: 'The Ashblazing Grand Duke',
    artifacts_5_app: 0.4,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0.0,
    artifacts_6: 'SPD +6%, The Ashblazing Grand Duke',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'The Ashblazing Grand Duke',
    artifacts_6_app: 0.27,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'ATK +12%, The Ashblazing Grand Duke',
    artifacts_7_1: 'ATK +12%',
    artifacts_7_2: 'The Ashblazing Grand Duke',
    artifacts_7_app: 0.27,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 24120,
    artifacts_7_round_as: 0.0,
    artifacts_8: 'SPD +6%, Band of Sizzling Thunder',
    artifacts_8_1: 'SPD +6%',
    artifacts_8_2: 'Band of Sizzling Thunder',
    artifacts_8_app: 0.15,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 0.0,
    artifacts_9: 'Scholar Lost in Erudition',
    artifacts_9_1: 'Scholar Lost in Erudition',
    artifacts_9_2: '',
    artifacts_9_app: 0.15,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0,
    artifacts_9_round_as: 0.0,
    artifacts_10: 'Pioneer Diver of Dead Waters, Flex',
    artifacts_10_1: 'Pioneer Diver of Dead Waters',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 0.15,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0,
    artifacts_10_round_as: 0.0,
    planars_1: 'The Wondrous BananAmusement Park',
    planars_1_app: 75.18,
    planars_1_round_moc: 9.0,
    planars_1_round_pf: 29081,
    planars_1_round_as: 3237,
    planars_2: 'Inert Salsotto',
    planars_2_app: 22.8,
    planars_2_round_moc: 9.2,
    planars_2_round_pf: 28510,
    planars_2_round_as: 0,
    planars_3: 'Firmament Frontline: Glamoth',
    planars_3_app: 0.68,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 25700,
    planars_3_round_as: 0.0,
    planars_4: 'Duran, Dynasty of Running Wolves',
    planars_4_app: 0.27,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 28240,
    planars_4_round_as: 0.0,
    planars_5: 'Sigonia, the Unclaimed Desolation',
    planars_5_app: 0.15,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 30840,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 50.47,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 47.61,
    body_stats_3: 'ATK',
    body_stats_3_app: 1.49,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 82.92,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 16.64,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Lightning DMG Boost',
    sphere_stats_1_app: 78.37,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 21.34,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 98.67,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 0.74,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 79.84,
    attack_lvl: 4.82,
    skill_lvl: 10.06,
    ultimate_lvl: 10.11,
    talent_lvl: 10.14,
    max_hp: 3176.98,
    atk: 3004.25,
    dfns: 1171.91,
    speed: 136.11,
    crate: 67.94,
    cdmg: 193.5,
    dmg_boost: 30.68,
    heal_boost: 1,
    energy_regen: 0.15,
    effect_res: 7.43,
    effect_rate: 5.73,
    break_effect: 11.64,
    spd_sub: 12.07,
    hp_sub: 9.01,
    atk_sub: 17.47,
    def_sub: 9.7,
    crate_sub: 31.89,
    cdmg_sub: 68.2,
    res_sub: 7.43,
    ehr_sub: 5.73,
    break_sub: 11.64
  },
  {
    char: 'sushang',
    app_rate_moc: 0.01,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.01,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 1,
    sample_size_players_moc: 0,
    app_rate_pf: 0.0,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.0,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 0,
    sample_size_players_pf: 0,
    app_rate_as: 0.05,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.03,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 8,
    sample_size_players_as: 1,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 12.5,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 3209,
    app_6: 87.5,
    round_6_moc: 99.99,
    round_6_pf: 0,
    round_6_as: 3407,
    cons_avg: 5.88,
    weapons_1: 'Sleep Like the Dead',
    weapons_1_app: 100.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0.0,
    weapons_1_round_as: 0,
    weapons_2: '',
    weapons_2_app: 0.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Scholar Lost in Erudition',
    artifacts_1_1: 'Scholar Lost in Erudition',
    artifacts_1_2: '',
    artifacts_1_app: 100.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0.0,
    artifacts_1_round_as: 0,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Inert Salsotto',
    planars_1_app: 100.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0.0,
    planars_1_round_as: 0,
    planars_2: '',
    planars_2_app: 0.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 100.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 100.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Physical DMG Boost',
    sphere_stats_1_app: 100.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 100.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 7.0,
    skill_lvl: 12.0,
    ultimate_lvl: 12.0,
    talent_lvl: 12.0,
    max_hp: 3182.0,
    atk: 2872.5,
    dfns: 1206.58,
    speed: 118.5,
    crate: 89.04,
    cdmg: 146.1,
    dmg_boost: 38.88,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 16.42,
    effect_rate: 12.1,
    break_effect: 18.79,
    spd_sub: 11.5,
    hp_sub: 7.34,
    atk_sub: 1,
    def_sub: 19.98,
    crate_sub: 35.64,
    cdmg_sub: 66.1,
    res_sub: 16.42,
    ehr_sub: 12.1,
    break_sub: 18.79
  },
  {
    char: 'luocha',
    app_rate_moc: 23.7,
    app_rate_moc_e0s1: 5.17,
    app_rate_moc_e1: 15.15,
    app_rate_moc_s0: 0.45,
    avg_round_moc: 8.96,
    avg_round_moc_e1: 7.06,
    avg_round_moc_s0: 9.38,
    sample_moc: 3570,
    sample_size_players_moc: 588,
    app_rate_pf: 30.77,
    app_rate_pf_e0s1: 12.71,
    app_rate_pf_e1: 15.64,
    app_rate_pf_s0: 2.08,
    avg_round_pf: 33586,
    avg_round_pf_e1: 38567,
    avg_round_pf_s0: 31800,
    sample_pf: 4317,
    sample_size_players_pf: 612,
    app_rate_as: 27.93,
    app_rate_as_e0s1: 11.99,
    app_rate_as_e1: 14.13,
    app_rate_as_s0: 1.95,
    avg_round_as: 3472,
    avg_round_as_e1: 3585,
    avg_round_as_s0: 3398,
    sample_as: 4334,
    sample_size_players_as: 637,
    app_0: 85.58,
    round_0_moc: 7.77,
    round_0_pf: 35181,
    round_0_as: 3536,
    app_1: 10.15,
    round_1_moc: 6.77,
    round_1_pf: 38217,
    round_1_as: 3558,
    app_2: 2.73,
    round_2_moc: 5.06,
    round_2_pf: 39894,
    round_2_as: 3671,
    app_3: 0.37,
    round_3_moc: 6.47,
    round_3_pf: 37840,
    round_3_as: 3576,
    app_4: 0.12,
    round_4_moc: 5.6,
    round_4_pf: 34370,
    round_4_as: 3547,
    app_5: 0.09,
    round_5_moc: 2.0,
    round_5_pf: 38208,
    round_5_as: 3652,
    app_6: 0.95,
    round_6_moc: 3.55,
    round_6_pf: 40000,
    round_6_as: 3773,
    cons_avg: 0.23,
    weapons_1: 'Perfect Timing',
    weapons_1_app: 36.92,
    weapons_1_round_moc: 9.12,
    weapons_1_round_pf: 33412,
    weapons_1_round_as: 3461,
    weapons_2: 'Echoes of the Coffin',
    weapons_2_app: 24.91,
    weapons_2_round_moc: 9.67,
    weapons_2_round_pf: 33220,
    weapons_2_round_as: 3473,
    weapons_3: 'Time Waits for No One',
    weapons_3_app: 9.54,
    weapons_3_round_moc: 9.11,
    weapons_3_round_pf: 31816,
    weapons_3_round_as: 3456,
    weapons_4: 'Shared Feeling',
    weapons_4_app: 7.13,
    weapons_4_round_moc: 8.19,
    weapons_4_round_pf: 31935,
    weapons_4_round_as: 3468,
    weapons_5: 'Quid Pro Quo',
    weapons_5_app: 6.62,
    weapons_5_round_moc: 8.3,
    weapons_5_round_pf: 32436,
    weapons_5_round_as: 3445,
    weapons_6: 'Post-Op Conversation',
    weapons_6_app: 5.8,
    weapons_6_round_moc: 8.22,
    weapons_6_round_pf: 32476,
    weapons_6_round_as: 3512,
    weapons_7: 'Multiplication',
    weapons_7_app: 2.93,
    weapons_7_round_moc: 8.75,
    weapons_7_round_pf: 32288,
    weapons_7_round_as: 3346,
    weapons_8: 'Hey, Over Here',
    weapons_8_app: 1.99,
    weapons_8_round_moc: 7.2,
    weapons_8_round_pf: 34298,
    weapons_8_round_as: 3505,
    weapons_9: 'Night of Fright',
    weapons_9_app: 1.73,
    weapons_9_round_moc: 6.0,
    weapons_9_round_pf: 34240,
    weapons_9_round_as: 3338,
    weapons_10: 'Warmth Shortens Cold Nights',
    weapons_10_app: 1.38,
    weapons_10_round_moc: 9.0,
    weapons_10_round_pf: 40000,
    weapons_10_round_as: 3588,
    artifacts_1: 'ATK +12%, Passerby of Wandering Cloud',
    artifacts_1_1: 'ATK +12%',
    artifacts_1_2: 'Passerby of Wandering Cloud',
    artifacts_1_app: 25.62,
    artifacts_1_round_moc: 9.45,
    artifacts_1_round_pf: 32120,
    artifacts_1_round_as: 3450,
    artifacts_2: 'Musketeer of Wild Wheat',
    artifacts_2_1: 'Musketeer of Wild Wheat',
    artifacts_2_2: '',
    artifacts_2_app: 14.56,
    artifacts_2_round_moc: 8.52,
    artifacts_2_round_pf: 32956,
    artifacts_2_round_as: 3456,
    artifacts_3: 'SPD +6%, SPD +6%',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'SPD +6%',
    artifacts_3_app: 13.61,
    artifacts_3_round_moc: 7.58,
    artifacts_3_round_pf: 33332,
    artifacts_3_round_as: 3455,
    artifacts_4: 'SPD +6%, Passerby of Wandering Cloud',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'Passerby of Wandering Cloud',
    artifacts_4_app: 10.99,
    artifacts_4_round_moc: 9.36,
    artifacts_4_round_pf: 32737,
    artifacts_4_round_as: 3471,
    artifacts_5: 'SPD +6%, ATK +12%',
    artifacts_5_1: 'SPD +6%',
    artifacts_5_2: 'ATK +12%',
    artifacts_5_app: 9.54,
    artifacts_5_round_moc: 8.62,
    artifacts_5_round_pf: 33389,
    artifacts_5_round_as: 3475,
    artifacts_6: 'Passerby of Wandering Cloud',
    artifacts_6_1: 'Passerby of Wandering Cloud',
    artifacts_6_2: '',
    artifacts_6_app: 9.52,
    artifacts_6_round_moc: 9.6,
    artifacts_6_round_pf: 32627,
    artifacts_6_round_as: 3449,
    artifacts_7: "Sacerdos' Relived Ordeal",
    artifacts_7_1: "Sacerdos' Relived Ordeal",
    artifacts_7_2: '',
    artifacts_7_app: 5.32,
    artifacts_7_round_moc: 7.71,
    artifacts_7_round_pf: 33887,
    artifacts_7_round_as: 3526,
    artifacts_8: 'ATK +12%, ATK +12%',
    artifacts_8_1: 'ATK +12%',
    artifacts_8_2: 'ATK +12%',
    artifacts_8_app: 2.03,
    artifacts_8_round_moc: 8.25,
    artifacts_8_round_pf: 32528,
    artifacts_8_round_as: 3451,
    artifacts_9: 'SPD +6%, Flex',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 2.03,
    artifacts_9_round_moc: 8.2,
    artifacts_9_round_pf: 33720,
    artifacts_9_round_as: 3411,
    artifacts_10: 'Hero of Triumphant Song, Passerby of Wandering Cloud',
    artifacts_10_1: 'Hero of Triumphant Song',
    artifacts_10_2: 'Passerby of Wandering Cloud',
    artifacts_10_app: 0.37,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 29640,
    artifacts_10_round_as: 0.0,
    planars_1: 'Broken Keel',
    planars_1_app: 53.23,
    planars_1_round_moc: 9.0,
    planars_1_round_pf: 32726,
    planars_1_round_as: 3457,
    planars_2: 'Giant Tree of Rapt Brooding',
    planars_2_app: 18.48,
    planars_2_round_moc: 7.55,
    planars_2_round_pf: 34494,
    planars_2_round_as: 3523,
    planars_3: 'Space Sealing Station',
    planars_3_app: 10.04,
    planars_3_round_moc: 9.38,
    planars_3_round_pf: 31884,
    planars_3_round_as: 3477,
    planars_4: 'Fleet of the Ageless',
    planars_4_app: 7.56,
    planars_4_round_moc: 9.44,
    planars_4_round_pf: 31787,
    planars_4_round_as: 3437,
    planars_5: 'Penacony, Land of the Dreams',
    planars_5_app: 3.39,
    planars_5_round_moc: 8.5,
    planars_5_round_pf: 34250,
    planars_5_round_as: 3430,
    body_stats_1: 'Outgoing Healing Boost',
    body_stats_1_app: 80.59,
    body_stats_2: 'ATK',
    body_stats_2_app: 15.92,
    body_stats_3: 'CRIT Rate',
    body_stats_3_app: 0.89,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 86.78,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 12.49,
    feet_stats_3: 'HP',
    feet_stats_3_app: 0.49,
    sphere_stats_1: 'ATK',
    sphere_stats_1_app: 86.81,
    sphere_stats_2: 'HP',
    sphere_stats_2_app: 7.12,
    sphere_stats_3: 'Imaginary DMG Boost',
    sphere_stats_3_app: 3.84,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 56.44,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 41.07,
    rope_stats_3: 'HP',
    rope_stats_3_app: 1.78,
    char_lvl: 79.96,
    light_cone_lvl: 79.22,
    attack_lvl: 4.43,
    skill_lvl: 9.47,
    ultimate_lvl: 8.08,
    talent_lvl: 9.68,
    max_hp: 3982.0,
    atk: 3283.05,
    dfns: 1042.49,
    speed: 144.84,
    crate: 13.1,
    cdmg: 66.42,
    dmg_boost: 1.5,
    heal_boost: 34.56,
    energy_regen: 12.45,
    effect_res: 37.77,
    effect_rate: 11.07,
    break_effect: 17.57,
    spd_sub: 16.39,
    hp_sub: 16.51,
    atk_sub: 24.38,
    def_sub: 17.95,
    crate_sub: 8.1,
    cdmg_sub: 16.2,
    res_sub: 21.4,
    ehr_sub: 11.74,
    break_sub: 17.88
  },
  {
    char: 'yukong',
    app_rate_moc: 0.01,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.01,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 2,
    sample_size_players_moc: 0,
    app_rate_pf: 0.01,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.01,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 2,
    sample_size_players_pf: 0,
    app_rate_as: 0.01,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.01,
    app_rate_as_s0: 0.01,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 2,
    sample_size_players_as: 0,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 1,
    round_6_moc: 99.99,
    round_6_pf: 0,
    round_6_as: 0,
    cons_avg: 1,
    weapons_1: '',
    weapons_1_app: 0.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0.0,
    weapons_1_round_as: 0.0,
    weapons_2: '',
    weapons_2_app: 0.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: '',
    artifacts_1_1: '',
    artifacts_1_2: '',
    artifacts_1_app: 0.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0.0,
    artifacts_1_round_as: 0.0,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: '',
    planars_1_app: 0.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0.0,
    planars_1_round_as: 0.0,
    planars_2: '',
    planars_2_app: 0.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: '',
    body_stats_1_app: 0.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: '',
    feet_stats_1_app: 0.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: '',
    sphere_stats_1_app: 0.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: '',
    rope_stats_1_app: 0.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 1,
    light_cone_lvl: 1,
    attack_lvl: 1,
    skill_lvl: 1,
    ultimate_lvl: 1,
    talent_lvl: 1,
    max_hp: 1,
    atk: 1,
    dfns: 1,
    speed: 1,
    crate: 1,
    cdmg: 1,
    dmg_boost: 1,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 1,
    effect_rate: 1,
    break_effect: 1,
    spd_sub: 1,
    hp_sub: 1,
    atk_sub: 1,
    def_sub: 1,
    crate_sub: 1,
    cdmg_sub: 1,
    res_sub: 1,
    ehr_sub: 1,
    break_sub: 1
  },
  {
    char: 'yanqing',
    app_rate_moc: 0.0,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.0,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 0,
    sample_size_players_moc: 0,
    app_rate_pf: 0.0,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.0,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 0,
    sample_size_players_pf: 0,
    app_rate_as: 0.01,
    app_rate_as_e0s1: 0.0,
    app_rate_as_e1: 0.01,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 1,
    sample_size_players_as: 1,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 100.0,
    round_6_moc: 99.99,
    round_6_pf: 0,
    round_6_as: 3187,
    cons_avg: 6.0,
    weapons_1: 'Baptism of Pure Thought',
    weapons_1_app: 100.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0.0,
    weapons_1_round_as: 0,
    weapons_2: '',
    weapons_2_app: 0.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Pioneer Diver of Dead Waters',
    artifacts_1_1: 'Pioneer Diver of Dead Waters',
    artifacts_1_2: '',
    artifacts_1_app: 100.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0.0,
    artifacts_1_round_as: 0,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Inert Salsotto',
    planars_1_app: 100.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0.0,
    planars_1_round_as: 0,
    planars_2: '',
    planars_2_app: 0.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 100.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 100.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Ice DMG Boost',
    sphere_stats_1_app: 100.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 100.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 5.0,
    skill_lvl: 12.0,
    ultimate_lvl: 12.0,
    talent_lvl: 12.0,
    max_hp: 2799.03,
    atk: 3345.68,
    dfns: 1203.74,
    speed: 138.9,
    crate: 32.23,
    cdmg: 220.98,
    dmg_boost: 53.28,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 1,
    effect_rate: 7.78,
    break_effect: 1,
    spd_sub: 29.9,
    hp_sub: 3.46,
    atk_sub: 19.87,
    def_sub: 19.98,
    crate_sub: 15.23,
    cdmg_sub: 86.18,
    res_sub: 1,
    ehr_sub: 7.78,
    break_sub: 1
  },
  {
    char: 'bailu',
    app_rate_moc: 0.9,
    app_rate_moc_e0s1: 0.18,
    app_rate_moc_e1: 0.55,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 9.0,
    avg_round_moc_e1: 7.97,
    avg_round_moc_s0: 99.99,
    sample_moc: 136,
    sample_size_players_moc: 12,
    app_rate_pf: 0.8,
    app_rate_pf_e0s1: 0.31,
    app_rate_pf_e1: 0.39,
    app_rate_pf_s0: 0.04,
    avg_round_pf: 32869,
    avg_round_pf_e1: 37675,
    avg_round_pf_s0: 0,
    sample_pf: 112,
    sample_size_players_pf: 11,
    app_rate_as: 0.84,
    app_rate_as_e0s1: 0.37,
    app_rate_as_e1: 0.39,
    app_rate_as_s0: 0.06,
    avg_round_as: 3424,
    avg_round_as_e1: 3472,
    avg_round_as_s0: 0,
    sample_as: 130,
    sample_size_players_as: 13,
    app_0: 21.25,
    round_0_moc: 7.68,
    round_0_pf: 32536,
    round_0_as: 3424,
    app_1: 27.53,
    round_1_moc: 8.26,
    round_1_pf: 34693,
    round_1_as: 3465,
    app_2: 23.01,
    round_2_moc: 8.0,
    round_2_pf: 35723,
    round_2_as: 3451,
    app_3: 14.44,
    round_3_moc: 8.9,
    round_3_pf: 38660,
    round_3_as: 3476,
    app_4: 6.57,
    round_4_moc: 9.0,
    round_4_pf: 35840,
    round_4_as: 3390,
    app_5: 2.11,
    round_5_moc: 6.33,
    round_5_pf: 38800,
    round_5_as: 3590,
    app_6: 5.07,
    round_6_moc: 8.25,
    round_6_pf: 32624,
    round_6_as: 3478,
    cons_avg: 1.84,
    weapons_1: 'Time Waits for No One',
    weapons_1_app: 37.61,
    weapons_1_round_moc: 8.0,
    weapons_1_round_pf: 36000,
    weapons_1_round_as: 3384,
    weapons_2: 'Post-Op Conversation',
    weapons_2_app: 24.03,
    weapons_2_round_moc: 9.0,
    weapons_2_round_pf: 32907,
    weapons_2_round_as: 3616,
    weapons_3: 'Quid Pro Quo',
    weapons_3_app: 18.81,
    weapons_3_round_moc: 8.5,
    weapons_3_round_pf: 31180,
    weapons_3_round_as: 3458,
    weapons_4: 'Perfect Timing',
    weapons_4_app: 5.43,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0,
    weapons_4_round_as: 0,
    weapons_5: 'Warmth Shortens Cold Nights',
    weapons_5_app: 5.21,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0,
    weapons_5_round_as: 0,
    weapons_6: 'Hey, Over Here',
    weapons_6_app: 2.5,
    weapons_6_round_moc: 10.0,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 3655,
    weapons_7: 'Night of Fright',
    weapons_7_app: 2.5,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0,
    weapons_8: 'What Is Real?',
    weapons_8_app: 1.14,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Passerby of Wandering Cloud',
    artifacts_1_1: 'Passerby of Wandering Cloud',
    artifacts_1_2: '',
    artifacts_1_app: 23.8,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 26240,
    artifacts_1_round_as: 3363,
    artifacts_2: 'Longevous Disciple, Passerby of Wandering Cloud',
    artifacts_2_1: 'Longevous Disciple',
    artifacts_2_2: 'Passerby of Wandering Cloud',
    artifacts_2_app: 17.23,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 36000,
    artifacts_2_round_as: 3502,
    artifacts_3: 'SPD +6%, SPD +6%',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'SPD +6%',
    artifacts_3_app: 16.31,
    artifacts_3_round_moc: 9.5,
    artifacts_3_round_pf: 31240,
    artifacts_3_round_as: 3636,
    artifacts_4: 'SPD +6%, Passerby of Wandering Cloud',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'Passerby of Wandering Cloud',
    artifacts_4_app: 8.15,
    artifacts_4_round_moc: 8.5,
    artifacts_4_round_pf: 31120,
    artifacts_4_round_as: 3582,
    artifacts_5: 'Messenger Traversing Hackerspace',
    artifacts_5_1: 'Messenger Traversing Hackerspace',
    artifacts_5_2: '',
    artifacts_5_app: 5.66,
    artifacts_5_round_moc: 8.0,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0.0,
    artifacts_6: 'SPD +6%, Longevous Disciple',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Longevous Disciple',
    artifacts_6_app: 5.21,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 37480,
    artifacts_6_round_as: 0,
    artifacts_7: 'ATK +12%, Passerby of Wandering Cloud',
    artifacts_7_1: 'ATK +12%',
    artifacts_7_2: 'Passerby of Wandering Cloud',
    artifacts_7_app: 4.07,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0,
    artifacts_7_round_as: 0,
    artifacts_8: "Sacerdos' Relived Ordeal",
    artifacts_8_1: "Sacerdos' Relived Ordeal",
    artifacts_8_2: '',
    artifacts_8_app: 4.07,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 0,
    artifacts_9: 'ATK +12%, Flex',
    artifacts_9_1: 'ATK +12%',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 2.71,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0,
    artifacts_9_round_as: 0,
    artifacts_10: 'Quan. +10%, Flex',
    artifacts_10_1: 'Quan. +10%',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 2.5,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0,
    planars_1: 'Fleet of the Ageless',
    planars_1_app: 47.62,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 29493,
    planars_1_round_as: 3432,
    planars_2: 'Broken Keel',
    planars_2_app: 25.18,
    planars_2_round_moc: 8.33,
    planars_2_round_pf: 31120,
    planars_2_round_as: 3476,
    planars_3: 'Giant Tree of Rapt Brooding',
    planars_3_app: 12.23,
    planars_3_round_moc: 10.0,
    planars_3_round_pf: 37480,
    planars_3_round_as: 3655,
    planars_4: 'Lushaka, the Sunken Seas',
    planars_4_app: 8.15,
    planars_4_round_moc: 9.0,
    planars_4_round_pf: 31240,
    planars_4_round_as: 3616,
    planars_5: 'Forge of the Kalpagni Lantern',
    planars_5_app: 2.71,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0,
    planars_5_round_as: 0,
    body_stats_1: 'Outgoing Healing Boost',
    body_stats_1_app: 75.23,
    body_stats_2: 'HP',
    body_stats_2_app: 24.77,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 83.69,
    feet_stats_2: 'HP',
    feet_stats_2_app: 16.31,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 94.51,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 5.49,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 75.33,
    rope_stats_2: 'HP',
    rope_stats_2_app: 24.68,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 79.88,
    light_cone_lvl: 79.14,
    attack_lvl: 3.99,
    skill_lvl: 9.77,
    ultimate_lvl: 9.69,
    talent_lvl: 9.89,
    max_hp: 6653.48,
    atk: 1595.03,
    dfns: 1218.18,
    speed: 145.57,
    crate: 11.66,
    cdmg: 60.28,
    dmg_boost: 1,
    heal_boost: 40.53,
    energy_regen: 18.48,
    effect_res: 35.15,
    effect_rate: 12.37,
    break_effect: 19.96,
    spd_sub: 19.32,
    hp_sub: 27.71,
    atk_sub: 14.27,
    def_sub: 11.84,
    crate_sub: 6.66,
    cdmg_sub: 10.28,
    res_sub: 23.09,
    ehr_sub: 12.37,
    break_sub: 19.96
  },
  {
    char: 'trailblazer-destruction',
    app_rate_moc: 0.0,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.0,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 0,
    sample_size_players_moc: 0,
    app_rate_pf: 0.01,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.0,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 1,
    sample_size_players_pf: 0,
    app_rate_as: 0.01,
    app_rate_as_e0s1: 0.0,
    app_rate_as_e1: 0.01,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 1,
    sample_size_players_as: 0,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 100.0,
    round_6_moc: 99.99,
    round_6_pf: 40000,
    round_6_as: 3588,
    cons_avg: 6.0,
    weapons_1: 'On the Fall of an Aeon',
    weapons_1_app: 100.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0,
    weapons_1_round_as: 0,
    weapons_2: '',
    weapons_2_app: 0.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Pioneer Diver of Dead Waters, Flex',
    artifacts_1_1: 'Pioneer Diver of Dead Waters',
    artifacts_1_2: 'Flex',
    artifacts_1_app: 100.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0,
    artifacts_1_round_as: 0,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: '',
    planars_1_app: 0.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0.0,
    planars_1_round_as: 0.0,
    planars_2: '',
    planars_2_app: 0.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: '',
    body_stats_1_app: 0.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: '',
    feet_stats_1_app: 0.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: '',
    sphere_stats_1_app: 0.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: '',
    rope_stats_1_app: 0.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 1,
    light_cone_lvl: 1,
    attack_lvl: 1,
    skill_lvl: 1,
    ultimate_lvl: 1,
    talent_lvl: 1,
    max_hp: 1,
    atk: 1,
    dfns: 1,
    speed: 1,
    crate: 1,
    cdmg: 1,
    dmg_boost: 1,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 1,
    effect_rate: 1,
    break_effect: 1,
    spd_sub: 1,
    hp_sub: 1,
    atk_sub: 1,
    def_sub: 1,
    crate_sub: 1,
    cdmg_sub: 1,
    res_sub: 1,
    ehr_sub: 1,
    break_sub: 1
  },
  {
    char: 'trailblazer-preservation',
    app_rate_moc: 0.02,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.01,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 3,
    sample_size_players_moc: 1,
    app_rate_pf: 0.01,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.01,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 2,
    sample_size_players_pf: 1,
    app_rate_as: 0.0,
    app_rate_as_e0s1: 0.0,
    app_rate_as_e1: 0.0,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 0,
    sample_size_players_as: 0,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 100.0,
    round_6_moc: 3.0,
    round_6_pf: 37680,
    round_6_as: 0,
    cons_avg: 6.0,
    weapons_1: 'Time Waits for No One',
    weapons_1_app: 100.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0,
    weapons_1_round_as: 0.0,
    weapons_2: '',
    weapons_2_app: 0.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'SPD +6%, SPD +6%',
    artifacts_1_1: 'SPD +6%',
    artifacts_1_2: 'SPD +6%',
    artifacts_1_app: 100.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0,
    artifacts_1_round_as: 0.0,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Broken Keel',
    planars_1_app: 100.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0,
    planars_1_round_as: 0.0,
    planars_2: '',
    planars_2_app: 0.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'HP',
    body_stats_1_app: 100.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 100.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 100.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 100.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 7.0,
    skill_lvl: 6.0,
    ultimate_lvl: 11.0,
    talent_lvl: 8.0,
    max_hp: 6407.2,
    atk: 1692.34,
    dfns: 1713.01,
    speed: 166.83,
    crate: 13.42,
    cdmg: 79.16,
    dmg_boost: 1,
    heal_boost: 12.0,
    energy_regen: 19.44,
    effect_res: 32.46,
    effect_rate: 4.32,
    break_effect: 34.99,
    spd_sub: 35.4,
    hp_sub: 11.23,
    atk_sub: 4.32,
    def_sub: 19.44,
    crate_sub: 8.42,
    cdmg_sub: 29.16,
    res_sub: 22.46,
    ehr_sub: 4.32,
    break_sub: 34.99
  },
  {
    char: 'blade',
    app_rate_moc: 1.53,
    app_rate_moc_e0s1: 0.31,
    app_rate_moc_e1: 0.86,
    app_rate_moc_s0: 0.03,
    avg_round_moc: 9.17,
    avg_round_moc_e1: 8.18,
    avg_round_moc_s0: 99.99,
    sample_moc: 231,
    sample_size_players_moc: 110,
    app_rate_pf: 1.48,
    app_rate_pf_e0s1: 0.58,
    app_rate_pf_e1: 0.71,
    app_rate_pf_s0: 0.13,
    avg_round_pf: 29159,
    avg_round_pf_e1: 32215,
    avg_round_pf_s0: 26920,
    sample_pf: 208,
    sample_size_players_pf: 88,
    app_rate_as: 2.79,
    app_rate_as_e0s1: 1.01,
    app_rate_as_e1: 1.38,
    app_rate_as_s0: 0.18,
    avg_round_as: 3397,
    avg_round_as_e1: 3440,
    avg_round_as_s0: 3312,
    sample_as: 433,
    sample_size_players_as: 188,
    app_0: 68.31,
    round_0_moc: 8.22,
    round_0_pf: 31045,
    round_0_as: 3420,
    app_1: 15.86,
    round_1_moc: 7.62,
    round_1_pf: 31292,
    round_1_as: 3429,
    app_2: 4.61,
    round_2_moc: 7.67,
    round_2_pf: 30749,
    round_2_as: 3488,
    app_3: 0.79,
    round_3_moc: 10.0,
    round_3_pf: 24080,
    round_3_as: 3506,
    app_4: 1.95,
    round_4_moc: 6.25,
    round_4_pf: 35360,
    round_4_as: 3495,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 8.48,
    round_6_moc: 5.92,
    round_6_pf: 40000,
    round_6_as: 3551,
    cons_avg: 0.86,
    weapons_1: 'The Unreachable Side',
    weapons_1_app: 77.09,
    weapons_1_round_moc: 9.3,
    weapons_1_round_pf: 30520,
    weapons_1_round_as: 3406,
    weapons_2: 'Ninja Record: Sound Hunt',
    weapons_2_app: 13.63,
    weapons_2_round_moc: 9.0,
    weapons_2_round_pf: 28800,
    weapons_2_round_as: 3458,
    weapons_3: 'A Secret Vow',
    weapons_3_app: 4.0,
    weapons_3_round_moc: 9.0,
    weapons_3_round_pf: 27100,
    weapons_3_round_as: 3274,
    weapons_4: 'Dance at Sunset',
    weapons_4_app: 2.7,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 35480,
    weapons_4_round_as: 0,
    weapons_5: 'Flames Afar',
    weapons_5_app: 0.89,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 3474,
    weapons_6: 'I Shall Be My Own Sword',
    weapons_6_app: 0.51,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0,
    weapons_6_round_as: 0,
    weapons_7: 'Something Irreplaceable',
    weapons_7_app: 0.44,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0,
    weapons_8: 'Nowhere to Run',
    weapons_8_app: 0.28,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0,
    weapons_8_round_as: 0.0,
    weapons_9: 'Flame of Blood, Blaze My Path',
    weapons_9_app: 0.23,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0,
    weapons_10: 'On the Fall of an Aeon',
    weapons_10_app: 0.23,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0,
    artifacts_1: 'Longevous Disciple',
    artifacts_1_1: 'Longevous Disciple',
    artifacts_1_2: '',
    artifacts_1_app: 86.65,
    artifacts_1_round_moc: 9.17,
    artifacts_1_round_pf: 30026,
    artifacts_1_round_as: 3400,
    artifacts_2: 'Eagle of Twilight Line, Longevous Disciple',
    artifacts_2_1: 'Eagle of Twilight Line',
    artifacts_2_2: 'Longevous Disciple',
    artifacts_2_app: 3.82,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 26740,
    artifacts_2_round_as: 3434,
    artifacts_3: 'SPD +6%, Longevous Disciple',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'Longevous Disciple',
    artifacts_3_app: 2.38,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 39960,
    artifacts_3_round_as: 0,
    artifacts_4: 'Longevous Disciple, The Ashblazing Grand Duke',
    artifacts_4_1: 'Longevous Disciple',
    artifacts_4_2: 'The Ashblazing Grand Duke',
    artifacts_4_app: 2.11,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 0,
    artifacts_5: 'Poet of Mourning Collapse',
    artifacts_5_1: 'Poet of Mourning Collapse',
    artifacts_5_2: '',
    artifacts_5_app: 1.16,
    artifacts_5_round_moc: 10.0,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 3341,
    artifacts_6: 'Longevous Disciple, Flex',
    artifacts_6_1: 'Longevous Disciple',
    artifacts_6_2: 'Flex',
    artifacts_6_app: 0.82,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 30320,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'ATK +12%, Longevous Disciple',
    artifacts_7_1: 'ATK +12%',
    artifacts_7_2: 'Longevous Disciple',
    artifacts_7_app: 0.72,
    artifacts_7_round_moc: 7.0,
    artifacts_7_round_pf: 28760,
    artifacts_7_round_as: 3549,
    artifacts_8: 'Eagle of Twilight Line',
    artifacts_8_1: 'Eagle of Twilight Line',
    artifacts_8_2: '',
    artifacts_8_app: 0.72,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 0,
    artifacts_9: 'Eagle of Twilight Line, Flex',
    artifacts_9_1: 'Eagle of Twilight Line',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 0.44,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 3526,
    artifacts_10: 'Quan. +10%, Scholar Lost in Erudition',
    artifacts_10_1: 'Quan. +10%',
    artifacts_10_2: 'Scholar Lost in Erudition',
    artifacts_10_app: 0.28,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Rutilant Arena',
    planars_1_app: 39.45,
    planars_1_round_moc: 9.43,
    planars_1_round_pf: 26954,
    planars_1_round_as: 3410,
    planars_2: "Bone Collection's Serene Demesne",
    planars_2_app: 30.0,
    planars_2_round_moc: 7.6,
    planars_2_round_pf: 32790,
    planars_2_round_as: 3392,
    planars_3: 'Inert Salsotto',
    planars_3_app: 26.9,
    planars_3_round_moc: 9.0,
    planars_3_round_pf: 28288,
    planars_3_round_as: 3425,
    planars_4: 'Broken Keel',
    planars_4_app: 0.72,
    planars_4_round_moc: 10.0,
    planars_4_round_pf: 29200,
    planars_4_round_as: 3178,
    planars_5: 'Duran, Dynasty of Running Wolves',
    planars_5_app: 0.68,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 87.2,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 9.46,
    body_stats_3: 'HP',
    body_stats_3_app: 3.35,
    feet_stats_1: 'HP',
    feet_stats_1_app: 52.73,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 47.28,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Wind DMG Boost',
    sphere_stats_1_app: 68.68,
    sphere_stats_2: 'HP',
    sphere_stats_2_app: 30.54,
    sphere_stats_3: 'ATK',
    sphere_stats_3_app: 0.49,
    rope_stats_1: 'HP',
    rope_stats_1_app: 97.88,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 0.78,
    rope_stats_3: 'Energy Regeneration Rate',
    rope_stats_3_app: 0.75,
    char_lvl: 79.98,
    light_cone_lvl: 79.91,
    attack_lvl: 6.15,
    skill_lvl: 10.24,
    ultimate_lvl: 10.27,
    talent_lvl: 10.33,
    max_hp: 7525.86,
    atk: 1636.48,
    dfns: 929.82,
    speed: 118.09,
    crate: 69.33,
    cdmg: 179.76,
    dmg_boost: 27.23,
    heal_boost: 1,
    energy_regen: 0.2,
    effect_res: 17.34,
    effect_rate: 7.4,
    break_effect: 11.68,
    spd_sub: 8.42,
    hp_sub: 18.82,
    atk_sub: 12.08,
    def_sub: 10.17,
    crate_sub: 28.76,
    cdmg_sub: 71.9,
    res_sub: 7.32,
    ehr_sub: 7.4,
    break_sub: 11.68
  },
  {
    char: 'kafka',
    app_rate_moc: 0.69,
    app_rate_moc_e0s1: 0.01,
    app_rate_moc_e1: 0.24,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 8.5,
    avg_round_moc_s0: 99.99,
    sample_moc: 104,
    sample_size_players_moc: 84,
    app_rate_pf: 2.43,
    app_rate_pf_e0s1: 0.61,
    app_rate_pf_e1: 1.35,
    app_rate_pf_s0: 0.09,
    avg_round_pf: 25365,
    avg_round_pf_e1: 27642,
    avg_round_pf_s0: 24227,
    sample_pf: 341,
    sample_size_players_pf: 236,
    app_rate_as: 0.25,
    app_rate_as_e0s1: 0.0,
    app_rate_as_e1: 0.1,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 3203,
    avg_round_as_s0: 0,
    sample_as: 39,
    sample_size_players_as: 35,
    app_0: 41.96,
    round_0_moc: 8.07,
    round_0_pf: 26487,
    round_0_as: 3283,
    app_1: 14.72,
    round_1_moc: 7.46,
    round_1_pf: 28100,
    round_1_as: 3242,
    app_2: 21.1,
    round_2_moc: 8.03,
    round_2_pf: 27781,
    round_2_as: 3211,
    app_3: 0.44,
    round_3_moc: 7.0,
    round_3_pf: 28840,
    round_3_as: 0,
    app_4: 2.64,
    round_4_moc: 6.83,
    round_4_pf: 35173,
    round_4_as: 3401,
    app_5: 1.39,
    round_5_moc: 10.0,
    round_5_pf: 0,
    round_5_as: 3252,
    app_6: 18.79,
    round_6_moc: 7.95,
    round_6_pf: 34781,
    round_6_as: 3381,
    cons_avg: 1.84,
    weapons_1: 'Patience Is All You Need',
    weapons_1_app: 85.03,
    weapons_1_round_moc: 8.0,
    weapons_1_round_pf: 26655,
    weapons_1_round_as: 0,
    weapons_2: 'Good Night and Sleep Well',
    weapons_2_app: 8.37,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 25137,
    weapons_2_round_as: 0,
    weapons_3: 'Solitary Healing',
    weapons_3_app: 4.82,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 25750,
    weapons_3_round_as: 0,
    weapons_4: 'Fermata',
    weapons_4_app: 1.18,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 25180,
    weapons_4_round_as: 0.0,
    weapons_5: 'Reforged Remembrance',
    weapons_5_app: 0.3,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0,
    weapons_5_round_as: 0.0,
    weapons_6: 'Resolution Shines As Pearls of Sweat',
    weapons_6_app: 0.3,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Prisoner in Deep Confinement',
    artifacts_1_1: 'Prisoner in Deep Confinement',
    artifacts_1_2: '',
    artifacts_1_app: 92.54,
    artifacts_1_round_moc: 8.0,
    artifacts_1_round_pf: 26337,
    artifacts_1_round_as: 0,
    artifacts_2: 'Band of Sizzling Thunder',
    artifacts_2_1: 'Band of Sizzling Thunder',
    artifacts_2_2: '',
    artifacts_2_app: 4.23,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 24560,
    artifacts_2_round_as: 0,
    artifacts_3: 'Eagle of Twilight Line',
    artifacts_3_1: 'Eagle of Twilight Line',
    artifacts_3_2: '',
    artifacts_3_app: 1.89,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 0.0,
    artifacts_4: 'SPD +6%, SPD +6%',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'SPD +6%',
    artifacts_4_app: 0.45,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0,
    artifacts_5: 'ATK +12%, Firesmith of Lava-Forging',
    artifacts_5_1: 'ATK +12%',
    artifacts_5_2: 'Firesmith of Lava-Forging',
    artifacts_5_app: 0.3,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0.0,
    artifacts_6: 'ATK +12%, Flex',
    artifacts_6_1: 'ATK +12%',
    artifacts_6_2: 'Flex',
    artifacts_6_app: 0.3,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'Eagle of Twilight Line, Flex',
    artifacts_7_1: 'Eagle of Twilight Line',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 0.3,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Firmament Frontline: Glamoth',
    planars_1_app: 86.73,
    planars_1_round_moc: 8.0,
    planars_1_round_pf: 26332,
    planars_1_round_as: 0,
    planars_2: 'Space Sealing Station',
    planars_2_app: 9.29,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 25328,
    planars_2_round_as: 0,
    planars_3: 'Lushaka, the Sunken Seas',
    planars_3_app: 3.55,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0,
    planars_3_round_as: 0.0,
    planars_4: 'Forge of the Kalpagni Lantern',
    planars_4_app: 0.45,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'ATK',
    body_stats_1_app: 99.69,
    body_stats_2: 'Effect Hit Rate',
    body_stats_2_app: 0.3,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 79.73,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 20.28,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Lightning DMG Boost',
    sphere_stats_1_app: 95.3,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 4.7,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 87.25,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 12.45,
    rope_stats_3: 'Break Effect',
    rope_stats_3_app: 0.3,
    char_lvl: 80.0,
    light_cone_lvl: 79.98,
    attack_lvl: 5.43,
    skill_lvl: 10.51,
    ultimate_lvl: 10.44,
    talent_lvl: 10.12,
    max_hp: 3364.16,
    atk: 3876.82,
    dfns: 1109.01,
    speed: 145.95,
    crate: 10.76,
    cdmg: 61.75,
    dmg_boost: 37.36,
    heal_boost: 1,
    energy_regen: 2.57,
    effect_res: 10.05,
    effect_rate: 34.67,
    break_effect: 17.8,
    spd_sub: 25.91,
    hp_sub: 11.4,
    atk_sub: 33.53,
    def_sub: 11.27,
    crate_sub: 5.76,
    cdmg_sub: 11.75,
    res_sub: 10.05,
    ehr_sub: 16.8,
    break_sub: 17.06
  },
  {
    char: 'luka',
    app_rate_moc: 0.01,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.01,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 1,
    sample_size_players_moc: 0,
    app_rate_pf: 0.01,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.01,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 1,
    sample_size_players_pf: 0,
    app_rate_as: 0.05,
    app_rate_as_e0s1: 0.03,
    app_rate_as_e1: 0.03,
    app_rate_as_s0: 0.02,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 8,
    sample_size_players_as: 2,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 12.5,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 3062,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 87.5,
    round_6_moc: 99.99,
    round_6_pf: 0,
    round_6_as: 3228,
    cons_avg: 5.62,
    weapons_1: 'Solitary Healing',
    weapons_1_app: 50.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0.0,
    weapons_1_round_as: 0,
    weapons_2: 'Good Night and Sleep Well',
    weapons_2_app: 50.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_2: '',
    artifacts_1_app: 100.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0.0,
    artifacts_1_round_as: 0,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Talia: Kingdom of Banditry',
    planars_1_app: 100.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0.0,
    planars_1_round_as: 0,
    planars_2: '',
    planars_2_app: 0.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'Effect Hit Rate',
    body_stats_1_app: 100.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 100.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Physical DMG Boost',
    sphere_stats_1_app: 100.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'Break Effect',
    rope_stats_1_app: 100.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 7.0,
    skill_lvl: 12.0,
    ultimate_lvl: 12.0,
    talent_lvl: 12.0,
    max_hp: 2856.08,
    atk: 1962.06,
    dfns: 1096.05,
    speed: 148.68,
    crate: 17.8,
    cdmg: 58.1,
    dmg_boost: 38.88,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 13.18,
    effect_rate: 79.34,
    break_effect: 177.06,
    spd_sub: 20.65,
    hp_sub: 7.78,
    atk_sub: 18.58,
    def_sub: 9.45,
    crate_sub: 12.8,
    cdmg_sub: 8.1,
    res_sub: 13.18,
    ehr_sub: 18.14,
    break_sub: 60.26
  },
  {
    char: 'imbibitor-lunae',
    app_rate_moc: 1.93,
    app_rate_moc_e0s1: 0.03,
    app_rate_moc_e1: 1.13,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 8.09,
    avg_round_moc_s0: 99.99,
    sample_moc: 291,
    sample_size_players_moc: 221,
    app_rate_pf: 0.57,
    app_rate_pf_e0s1: 0.01,
    app_rate_pf_e1: 0.23,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 26372,
    avg_round_pf_s0: 0,
    sample_pf: 80,
    sample_size_players_pf: 67,
    app_rate_as: 0.73,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.39,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 3325,
    avg_round_as_s0: 0,
    sample_as: 113,
    sample_size_players_as: 90,
    app_0: 7.61,
    round_0_moc: 9.33,
    round_0_pf: 22213,
    round_0_as: 3168,
    app_1: 1.99,
    round_1_moc: 8.57,
    round_1_pf: 0,
    round_1_as: 3189,
    app_2: 51.34,
    round_2_moc: 7.84,
    round_2_pf: 26244,
    round_2_as: 3344,
    app_3: 11.82,
    round_3_moc: 8.35,
    round_3_pf: 26490,
    round_3_as: 3400,
    app_4: 2.5,
    round_4_moc: 8.57,
    round_4_pf: 29973,
    round_4_as: 3318,
    app_5: 1.37,
    round_5_moc: 7.5,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 24.28,
    round_6_moc: 5.12,
    round_6_pf: 31304,
    round_6_as: 3519,
    cons_avg: 2.99,
    weapons_1: 'Brighter Than the Sun',
    weapons_1_app: 95.42,
    weapons_1_round_moc: 8.67,
    weapons_1_round_pf: 21040,
    weapons_1_round_as: 3106,
    weapons_2: 'On the Fall of an Aeon',
    weapons_2_app: 4.06,
    weapons_2_round_moc: 10.0,
    weapons_2_round_pf: 0,
    weapons_2_round_as: 0,
    weapons_3: 'Indelible Promise',
    weapons_3_app: 0.26,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: 'Something Irreplaceable',
    weapons_4_app: 0.26,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Musketeer of Wild Wheat',
    artifacts_1_1: 'Musketeer of Wild Wheat',
    artifacts_1_2: '',
    artifacts_1_app: 40.47,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0,
    artifacts_1_round_as: 0,
    artifacts_2: 'ATK +12%, Wastelander of Banditry Desert',
    artifacts_2_1: 'ATK +12%',
    artifacts_2_2: 'Wastelander of Banditry Desert',
    artifacts_2_app: 19.78,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 21040,
    artifacts_2_round_as: 0,
    artifacts_3: 'Wastelander of Banditry Desert',
    artifacts_3_1: 'Wastelander of Banditry Desert',
    artifacts_3_2: '',
    artifacts_3_app: 10.23,
    artifacts_3_round_moc: 10.0,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 0,
    artifacts_4: 'ATK +12%, ATK +12%',
    artifacts_4_1: 'ATK +12%',
    artifacts_4_2: 'ATK +12%',
    artifacts_4_app: 6.99,
    artifacts_4_round_moc: 6.0,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 0,
    artifacts_5: 'Genius of Brilliant Stars',
    artifacts_5_1: 'Genius of Brilliant Stars',
    artifacts_5_2: '',
    artifacts_5_app: 4.52,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0,
    artifacts_6: 'ATK +12%, Scholar Lost in Erudition',
    artifacts_6_1: 'ATK +12%',
    artifacts_6_2: 'Scholar Lost in Erudition',
    artifacts_6_app: 3.8,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0,
    artifacts_7: 'Poet of Mourning Collapse',
    artifacts_7_1: 'Poet of Mourning Collapse',
    artifacts_7_2: '',
    artifacts_7_app: 2.34,
    artifacts_7_round_moc: 10.0,
    artifacts_7_round_pf: 0,
    artifacts_7_round_as: 0.0,
    artifacts_8: 'ATK +12%, Flex',
    artifacts_8_1: 'ATK +12%',
    artifacts_8_2: 'Flex',
    artifacts_8_app: 1.76,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 0,
    artifacts_9: 'Wastelander of Banditry Desert, Flex',
    artifacts_9_1: 'Wastelander of Banditry Desert',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 1.3,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: 'SPD +6%, Flex',
    artifacts_10_1: 'SPD +6%',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 0.78,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Rutilant Arena',
    planars_1_app: 96.94,
    planars_1_round_moc: 8.67,
    planars_1_round_pf: 21040,
    planars_1_round_as: 3106,
    planars_2: 'Sigonia, the Unclaimed Desolation',
    planars_2_app: 0.52,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: 'Firmament Frontline: Glamoth',
    planars_3_app: 0.26,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: 'Inert Salsotto',
    planars_4_app: 0.26,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 91.56,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 7.64,
    body_stats_3: 'ATK',
    body_stats_3_app: 0.8,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 69.87,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 29.6,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Imaginary DMG Boost',
    sphere_stats_1_app: 79.39,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 20.07,
    sphere_stats_3: 'Wind DMG Boost',
    sphere_stats_3_app: 0.27,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 92.38,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 6.55,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 79.99,
    attack_lvl: 6.46,
    skill_lvl: 10.92,
    ultimate_lvl: 10.55,
    talent_lvl: 10.57,
    max_hp: 3517.79,
    atk: 3163.26,
    dfns: 880.13,
    speed: 117.84,
    crate: 80.82,
    cdmg: 191.06,
    dmg_boost: 56.51,
    heal_boost: 1,
    energy_regen: 1.28,
    effect_res: 7.13,
    effect_rate: 7.3,
    break_effect: 10.22,
    spd_sub: 4.55,
    hp_sub: 9.18,
    atk_sub: 18.75,
    def_sub: 9.5,
    crate_sub: 33.82,
    cdmg_sub: 79.76,
    res_sub: 7.13,
    ehr_sub: 7.3,
    break_sub: 10.22
  },
  {
    char: 'lynx',
    app_rate_moc: 0.88,
    app_rate_moc_e0s1: 0.22,
    app_rate_moc_e1: 0.56,
    app_rate_moc_s0: 0.03,
    avg_round_moc: 8.82,
    avg_round_moc_e1: 8.07,
    avg_round_moc_s0: 99.99,
    sample_moc: 132,
    sample_size_players_moc: 1,
    app_rate_pf: 0.64,
    app_rate_pf_e0s1: 0.29,
    app_rate_pf_e1: 0.26,
    app_rate_pf_s0: 0.07,
    avg_round_pf: 29711,
    avg_round_pf_e1: 34293,
    avg_round_pf_s0: 28748,
    sample_pf: 90,
    sample_size_players_pf: 0,
    app_rate_as: 0.6,
    app_rate_as_e0s1: 0.26,
    app_rate_as_e1: 0.27,
    app_rate_as_s0: 0.05,
    avg_round_as: 3357,
    avg_round_as_e1: 3486,
    avg_round_as_s0: 0,
    sample_as: 93,
    sample_size_players_as: 1,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 0.96,
    round_1_moc: 6.0,
    round_1_pf: 40000,
    round_1_as: 3151,
    app_2: 0.76,
    round_2_moc: 9.0,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 2.25,
    round_3_moc: 8.33,
    round_3_pf: 28320,
    round_3_as: 0,
    app_4: 2.53,
    round_4_moc: 8.0,
    round_4_pf: 32000,
    round_4_as: 3327,
    app_5: 1.92,
    round_5_moc: 8.0,
    round_5_pf: 40000,
    round_5_as: 3498,
    app_6: 92.67,
    round_6_moc: 8.14,
    round_6_pf: 32403,
    round_6_as: 3434,
    cons_avg: 5.82,
    weapons_1: 'Time Waits for No One',
    weapons_1_app: 41.51,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0.0,
    weapons_1_round_as: 0.0,
    weapons_2: 'Post-Op Conversation',
    weapons_2_app: 30.19,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 21680,
    weapons_2_round_as: 0.0,
    weapons_3: 'Quid Pro Quo',
    weapons_3_app: 28.3,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'SPD +6%, SPD +6%',
    artifacts_1_1: 'SPD +6%',
    artifacts_1_2: 'SPD +6%',
    artifacts_1_app: 71.7,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 21680,
    artifacts_1_round_as: 0.0,
    artifacts_2: 'Passerby of Wandering Cloud',
    artifacts_2_1: 'Passerby of Wandering Cloud',
    artifacts_2_2: '',
    artifacts_2_app: 28.3,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Fleet of the Ageless',
    planars_1_app: 30.19,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 21680,
    planars_1_round_as: 0.0,
    planars_2: 'Giant Tree of Rapt Brooding',
    planars_2_app: 28.3,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'Outgoing Healing Boost',
    body_stats_1_app: 41.51,
    body_stats_2: 'HP',
    body_stats_2_app: 28.3,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 69.81,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 69.81,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'DEF',
    rope_stats_1_app: 41.51,
    rope_stats_2: 'HP',
    rope_stats_2_app: 28.3,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 5.59,
    skill_lvl: 11.59,
    ultimate_lvl: 11.59,
    talent_lvl: 10.38,
    max_hp: 6316.4,
    atk: 1526.7,
    dfns: 1585.05,
    speed: 158.87,
    crate: 10.01,
    cdmg: 66.81,
    dmg_boost: 1,
    heal_boost: 32.93,
    energy_regen: 1,
    effect_res: 34.83,
    effect_rate: 6.91,
    break_effect: 17.72,
    spd_sub: 24.27,
    hp_sub: 27.72,
    atk_sub: 18.31,
    def_sub: 6.73,
    crate_sub: 8.42,
    cdmg_sub: 41.47,
    res_sub: 24.83,
    ehr_sub: 6.91,
    break_sub: 17.72
  },
  {
    char: 'fu-xuan',
    app_rate_moc: 16.09,
    app_rate_moc_e0s1: 2.34,
    app_rate_moc_e1: 11.0,
    app_rate_moc_s0: 0.29,
    avg_round_moc: 9.37,
    avg_round_moc_e1: 8.21,
    avg_round_moc_s0: 9.91,
    sample_moc: 2424,
    sample_size_players_moc: 747,
    app_rate_pf: 15.03,
    app_rate_pf_e0s1: 5.05,
    app_rate_pf_e1: 8.21,
    app_rate_pf_s0: 1.61,
    avg_round_pf: 37701,
    avg_round_pf_e1: 37751,
    avg_round_pf_s0: 38192,
    sample_pf: 2109,
    sample_size_players_pf: 625,
    app_rate_as: 13.83,
    app_rate_as_e0s1: 4.83,
    app_rate_as_e1: 7.39,
    app_rate_as_s0: 1.5,
    avg_round_as: 3376,
    avg_round_as_e1: 3450,
    avg_round_as_s0: 3336,
    sample_as: 2146,
    sample_size_players_as: 674,
    app_0: 63.98,
    round_0_moc: 8.57,
    round_0_pf: 37347,
    round_0_as: 3409,
    app_1: 26.55,
    round_1_moc: 7.03,
    round_1_pf: 38525,
    round_1_as: 3472,
    app_2: 6.96,
    round_2_moc: 6.64,
    round_2_pf: 39029,
    round_2_as: 3477,
    app_3: 0.74,
    round_3_moc: 6.39,
    round_3_pf: 36640,
    round_3_as: 3555,
    app_4: 0.31,
    round_4_moc: 6.0,
    round_4_pf: 36180,
    round_4_as: 3571,
    app_5: 0.05,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 1.45,
    round_6_moc: 3.67,
    round_6_pf: 40000,
    round_6_as: 3656,
    cons_avg: 0.53,
    weapons_1: 'She Already Shut Her Eyes',
    weapons_1_app: 63.79,
    weapons_1_round_moc: 9.18,
    weapons_1_round_pf: 38655,
    weapons_1_round_as: 3394,
    weapons_2: 'Trend of the Universal Market',
    weapons_2_app: 13.69,
    weapons_2_round_moc: 9.75,
    weapons_2_round_pf: 29982,
    weapons_2_round_as: 3321,
    weapons_3: 'Texture of Memories',
    weapons_3_app: 11.81,
    weapons_3_round_moc: 9.3,
    weapons_3_round_pf: 38979,
    weapons_3_round_as: 3370,
    weapons_4: 'Moment of Victory',
    weapons_4_app: 5.94,
    weapons_4_round_moc: 9.67,
    weapons_4_round_pf: 37087,
    weapons_4_round_as: 3368,
    weapons_5: "Landau's Choice",
    weapons_5_app: 2.72,
    weapons_5_round_moc: 9.17,
    weapons_5_round_pf: 40000,
    weapons_5_round_as: 3387,
    weapons_6: 'Day One of My New Life',
    weapons_6_app: 1.78,
    weapons_6_round_moc: 9.0,
    weapons_6_round_pf: 37424,
    weapons_6_round_as: 3388,
    weapons_7: 'We Are Wildfire',
    weapons_7_app: 0.21,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 40000,
    weapons_7_round_as: 3388,
    weapons_8: 'Time Waits for No One',
    weapons_8_app: 0.04,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: 'Defense',
    weapons_9_app: 0.04,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Guard of Wuthering Snow, Longevous Disciple',
    artifacts_1_1: 'Guard of Wuthering Snow',
    artifacts_1_2: 'Longevous Disciple',
    artifacts_1_app: 54.99,
    artifacts_1_round_moc: 9.3,
    artifacts_1_round_pf: 38241,
    artifacts_1_round_as: 3360,
    artifacts_2: 'SPD +6%, Longevous Disciple',
    artifacts_2_1: 'SPD +6%',
    artifacts_2_2: 'Longevous Disciple',
    artifacts_2_app: 21.95,
    artifacts_2_round_moc: 9.47,
    artifacts_2_round_pf: 37742,
    artifacts_2_round_as: 3379,
    artifacts_3: 'Longevous Disciple',
    artifacts_3_1: 'Longevous Disciple',
    artifacts_3_2: '',
    artifacts_3_app: 6.76,
    artifacts_3_round_moc: 9.5,
    artifacts_3_round_pf: 34256,
    artifacts_3_round_as: 3400,
    artifacts_4: 'SPD +6%, Guard of Wuthering Snow',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'Guard of Wuthering Snow',
    artifacts_4_app: 2.99,
    artifacts_4_round_moc: 8.67,
    artifacts_4_round_pf: 38360,
    artifacts_4_round_as: 3278,
    artifacts_5: 'Guard of Wuthering Snow',
    artifacts_5_1: 'Guard of Wuthering Snow',
    artifacts_5_2: '',
    artifacts_5_app: 1.69,
    artifacts_5_round_moc: 9.5,
    artifacts_5_round_pf: 40000,
    artifacts_5_round_as: 3402,
    artifacts_6: 'Genius of Brilliant Stars',
    artifacts_6_1: 'Genius of Brilliant Stars',
    artifacts_6_2: '',
    artifacts_6_app: 1.57,
    artifacts_6_round_moc: 6.0,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0,
    artifacts_7: 'Longevous Disciple, Flex',
    artifacts_7_1: 'Longevous Disciple',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 1.32,
    artifacts_7_round_moc: 9.5,
    artifacts_7_round_pf: 34080,
    artifacts_7_round_as: 3319,
    artifacts_8: 'SPD +6%, SPD +6%',
    artifacts_8_1: 'SPD +6%',
    artifacts_8_2: 'SPD +6%',
    artifacts_8_app: 1.11,
    artifacts_8_round_moc: 10.0,
    artifacts_8_round_pf: 34160,
    artifacts_8_round_as: 3402,
    artifacts_9: 'Longevous Disciple, Passerby of Wandering Cloud',
    artifacts_9_1: 'Longevous Disciple',
    artifacts_9_2: 'Passerby of Wandering Cloud',
    artifacts_9_app: 0.92,
    artifacts_9_round_moc: 7.33,
    artifacts_9_round_pf: 0,
    artifacts_9_round_as: 0,
    artifacts_10: 'Guard of Wuthering Snow, Passerby of Wandering Cloud',
    artifacts_10_1: 'Guard of Wuthering Snow',
    artifacts_10_2: 'Passerby of Wandering Cloud',
    artifacts_10_app: 0.35,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 3402,
    planars_1: 'Broken Keel',
    planars_1_app: 51.61,
    planars_1_round_moc: 9.53,
    planars_1_round_pf: 38654,
    planars_1_round_as: 3393,
    planars_2: 'Fleet of the Ageless',
    planars_2_app: 36.2,
    planars_2_round_moc: 9.12,
    planars_2_round_pf: 35279,
    planars_2_round_as: 3340,
    planars_3: 'Lushaka, the Sunken Seas',
    planars_3_app: 2.92,
    planars_3_round_moc: 9.0,
    planars_3_round_pf: 40000,
    planars_3_round_as: 3250,
    planars_4: 'Penacony, Land of the Dreams',
    planars_4_app: 2.66,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 40000,
    planars_4_round_as: 3357,
    planars_5: "Bone Collection's Serene Demesne",
    planars_5_app: 1.79,
    planars_5_round_moc: 7.5,
    planars_5_round_pf: 31080,
    planars_5_round_as: 3401,
    body_stats_1: 'HP',
    body_stats_1_app: 92.19,
    body_stats_2: 'DEF',
    body_stats_2_app: 3.82,
    body_stats_3: 'CRIT Rate',
    body_stats_3_app: 1.25,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 79.75,
    feet_stats_2: 'HP',
    feet_stats_2_app: 19.0,
    feet_stats_3: 'DEF',
    feet_stats_3_app: 1.26,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 89.43,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 7.68,
    sphere_stats_3: 'Quantum DMG Boost',
    sphere_stats_3_app: 2.75,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 56.72,
    rope_stats_2: 'HP',
    rope_stats_2_app: 41.22,
    rope_stats_3: 'DEF',
    rope_stats_3_app: 1.76,
    char_lvl: 79.99,
    light_cone_lvl: 79.79,
    attack_lvl: 5.02,
    skill_lvl: 10.09,
    ultimate_lvl: 9.05,
    talent_lvl: 9.99,
    max_hp: 8305.88,
    atk: 1391.52,
    dfns: 1634.89,
    speed: 135.84,
    crate: 29.86,
    cdmg: 62.31,
    dmg_boost: 1.44,
    heal_boost: 0.31,
    energy_regen: 19.47,
    effect_res: 37.56,
    effect_rate: 8.49,
    break_effect: 13.72,
    spd_sub: 14.26,
    hp_sub: 25.2,
    atk_sub: 11.23,
    def_sub: 32.6,
    crate_sub: 8.2,
    cdmg_sub: 12.31,
    res_sub: 20.29,
    ehr_sub: 8.21,
    break_sub: 13.72
  },
  {
    char: 'topaz',
    app_rate_moc: 5.68,
    app_rate_moc_e0s1: 0.86,
    app_rate_moc_e1: 3.82,
    app_rate_moc_s0: 0.07,
    avg_round_moc: 9.53,
    avg_round_moc_e1: 7.92,
    avg_round_moc_s0: 9.29,
    sample_moc: 856,
    sample_size_players_moc: 439,
    app_rate_pf: 0.36,
    app_rate_pf_e0s1: 0.07,
    app_rate_pf_e1: 0.2,
    app_rate_pf_s0: 0.01,
    avg_round_pf: 23652,
    avg_round_pf_e1: 26897,
    avg_round_pf_s0: 0,
    sample_pf: 50,
    sample_size_players_pf: 30,
    app_rate_as: 11.74,
    app_rate_as_e0s1: 5.18,
    app_rate_as_e1: 5.74,
    app_rate_as_s0: 2.0,
    avg_round_as: 3370,
    avg_round_as_e1: 3463,
    avg_round_as_s0: 3337,
    sample_as: 1821,
    sample_size_players_as: 691,
    app_0: 70.76,
    round_0_moc: 8.45,
    round_0_pf: 25052,
    round_0_as: 3408,
    app_1: 23.33,
    round_1_moc: 6.33,
    round_1_pf: 30311,
    round_1_as: 3491,
    app_2: 2.87,
    round_2_moc: 6.95,
    round_2_pf: 27760,
    round_2_as: 3482,
    app_3: 0.19,
    round_3_moc: 5.0,
    round_3_pf: 0,
    round_3_as: 3556,
    app_4: 0.44,
    round_4_moc: 5.4,
    round_4_pf: 25440,
    round_4_as: 3607,
    app_5: 0.11,
    round_5_moc: 7.5,
    round_5_pf: 0,
    round_5_as: 3444,
    app_6: 2.3,
    round_6_moc: 4.97,
    round_6_pf: 36952,
    round_6_as: 3604,
    cons_avg: 0.46,
    weapons_1: 'Worrisome, Blissful',
    weapons_1_app: 76.3,
    weapons_1_round_moc: 9.59,
    weapons_1_round_pf: 24880,
    weapons_1_round_as: 3393,
    weapons_2: 'Swordplay',
    weapons_2_app: 9.63,
    weapons_2_round_moc: 9.75,
    weapons_2_round_pf: 0,
    weapons_2_round_as: 3384,
    weapons_3: 'Cruising in the Stellar Sea',
    weapons_3_app: 6.96,
    weapons_3_round_moc: 9.33,
    weapons_3_round_pf: 0,
    weapons_3_round_as: 3383,
    weapons_4: 'Final Victor',
    weapons_4_app: 2.68,
    weapons_4_round_moc: 10.0,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 3366,
    weapons_5: 'Sleep Like the Dead',
    weapons_5_app: 2.46,
    weapons_5_round_moc: 9.33,
    weapons_5_round_pf: 0,
    weapons_5_round_as: 3361,
    weapons_6: 'Only Silence Remains',
    weapons_6_app: 0.78,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 3340,
    weapons_7: 'In the Night',
    weapons_7_app: 0.31,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 3370,
    weapons_8: 'Baptism of Pure Thought',
    weapons_8_app: 0.18,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 3345,
    weapons_9: 'River Flows in Spring',
    weapons_9_app: 0.16,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 3488,
    weapons_10: 'Return to Darkness',
    weapons_10_app: 0.13,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'The Ashblazing Grand Duke',
    artifacts_1_1: 'The Ashblazing Grand Duke',
    artifacts_1_2: '',
    artifacts_1_app: 83.06,
    artifacts_1_round_moc: 9.65,
    artifacts_1_round_pf: 25120,
    artifacts_1_round_as: 3383,
    artifacts_2: 'Pioneer Diver of Dead Waters',
    artifacts_2_1: 'Pioneer Diver of Dead Waters',
    artifacts_2_2: '',
    artifacts_2_app: 6.25,
    artifacts_2_round_moc: 9.5,
    artifacts_2_round_pf: 24400,
    artifacts_2_round_as: 3358,
    artifacts_3: 'The Ashblazing Grand Duke, Flex',
    artifacts_3_1: 'The Ashblazing Grand Duke',
    artifacts_3_2: 'Flex',
    artifacts_3_app: 2.56,
    artifacts_3_round_moc: 8.67,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 3404,
    artifacts_4: 'ATK +12%, The Ashblazing Grand Duke',
    artifacts_4_1: 'ATK +12%',
    artifacts_4_2: 'The Ashblazing Grand Duke',
    artifacts_4_app: 1.97,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 3413,
    artifacts_5: 'Pioneer Diver of Dead Waters, The Ashblazing Grand Duke',
    artifacts_5_1: 'Pioneer Diver of Dead Waters',
    artifacts_5_2: 'The Ashblazing Grand Duke',
    artifacts_5_app: 1.08,
    artifacts_5_round_moc: 10.0,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 3457,
    artifacts_6: 'Firesmith of Lava-Forging, The Ashblazing Grand Duke',
    artifacts_6_1: 'Firesmith of Lava-Forging',
    artifacts_6_2: 'The Ashblazing Grand Duke',
    artifacts_6_app: 1.05,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 3313,
    artifacts_7: 'ATK +12%, Flex',
    artifacts_7_1: 'ATK +12%',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 0.46,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0,
    artifacts_8: 'Firesmith of Lava-Forging',
    artifacts_8_1: 'Firesmith of Lava-Forging',
    artifacts_8_2: '',
    artifacts_8_app: 0.35,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 3296,
    artifacts_9: 'SPD +6%, The Ashblazing Grand Duke',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'The Ashblazing Grand Duke',
    artifacts_9_app: 0.26,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 3382,
    artifacts_10: 'Scholar Lost in Erudition, The Ashblazing Grand Duke',
    artifacts_10_1: 'Scholar Lost in Erudition',
    artifacts_10_2: 'The Ashblazing Grand Duke',
    artifacts_10_app: 0.18,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0,
    planars_1: 'Duran, Dynasty of Running Wolves',
    planars_1_app: 48.69,
    planars_1_round_moc: 9.65,
    planars_1_round_pf: 24400,
    planars_1_round_as: 3399,
    planars_2: 'Inert Salsotto',
    planars_2_app: 36.48,
    planars_2_round_moc: 9.55,
    planars_2_round_pf: 25120,
    planars_2_round_as: 3362,
    planars_3: 'The Wondrous BananAmusement Park',
    planars_3_app: 6.39,
    planars_3_round_moc: 10.0,
    planars_3_round_pf: 0,
    planars_3_round_as: 3408,
    planars_4: 'Izumo Gensei and Takama Divine Realm',
    planars_4_app: 3.39,
    planars_4_round_moc: 8.67,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 3428,
    planars_5: 'Firmament Frontline: Glamoth',
    planars_5_app: 1.47,
    planars_5_round_moc: 10.0,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 3348,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 57.33,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 41.47,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 79.57,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 19.55,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Fire DMG Boost',
    sphere_stats_1_app: 86.93,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 12.38,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 96.92,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 1.94,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 79.65,
    attack_lvl: 5.61,
    skill_lvl: 10.05,
    ultimate_lvl: 9.99,
    talent_lvl: 9.98,
    max_hp: 3130.62,
    atk: 2479.07,
    dfns: 1000.92,
    speed: 138.16,
    crate: 80.6,
    cdmg: 153.21,
    dmg_boost: 56.17,
    heal_boost: 1,
    energy_regen: 0.39,
    effect_res: 7.74,
    effect_rate: 7.6,
    break_effect: 13.27,
    spd_sub: 6.86,
    hp_sub: 10.16,
    atk_sub: 18.06,
    def_sub: 10.99,
    crate_sub: 31.89,
    cdmg_sub: 64.24,
    res_sub: 7.74,
    ehr_sub: 7.6,
    break_sub: 13.25
  },
  {
    char: 'guinaifen',
    app_rate_moc: 0.02,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.01,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 3,
    sample_size_players_moc: 0,
    app_rate_pf: 0.04,
    app_rate_pf_e0s1: 0.01,
    app_rate_pf_e1: 0.01,
    app_rate_pf_s0: 0.01,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 5,
    sample_size_players_pf: 0,
    app_rate_as: 0.01,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.0,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 2,
    sample_size_players_as: 0,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 1,
    round_6_moc: 99.99,
    round_6_pf: 0,
    round_6_as: 0,
    cons_avg: 1,
    weapons_1: '',
    weapons_1_app: 0.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0.0,
    weapons_1_round_as: 0.0,
    weapons_2: '',
    weapons_2_app: 0.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: '',
    artifacts_1_1: '',
    artifacts_1_2: '',
    artifacts_1_app: 0.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0.0,
    artifacts_1_round_as: 0.0,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: '',
    planars_1_app: 0.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0.0,
    planars_1_round_as: 0.0,
    planars_2: '',
    planars_2_app: 0.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: '',
    body_stats_1_app: 0.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: '',
    feet_stats_1_app: 0.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: '',
    sphere_stats_1_app: 0.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: '',
    rope_stats_1_app: 0.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 1,
    light_cone_lvl: 1,
    attack_lvl: 1,
    skill_lvl: 1,
    ultimate_lvl: 1,
    talent_lvl: 1,
    max_hp: 1,
    atk: 1,
    dfns: 1,
    speed: 1,
    crate: 1,
    cdmg: 1,
    dmg_boost: 1,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 1,
    effect_rate: 1,
    break_effect: 1,
    spd_sub: 1,
    hp_sub: 1,
    atk_sub: 1,
    def_sub: 1,
    crate_sub: 1,
    cdmg_sub: 1,
    res_sub: 1,
    ehr_sub: 1,
    break_sub: 1
  },
  {
    char: 'jingliu',
    app_rate_moc: 0.8,
    app_rate_moc_e0s1: 0.03,
    app_rate_moc_e1: 0.5,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 8.69,
    avg_round_moc_s0: 99.99,
    sample_moc: 121,
    sample_size_players_moc: 69,
    app_rate_pf: 0.21,
    app_rate_pf_e0s1: 0.06,
    app_rate_pf_e1: 0.06,
    app_rate_pf_s0: 0.01,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 29,
    sample_size_players_pf: 16,
    app_rate_as: 0.34,
    app_rate_as_e0s1: 0.05,
    app_rate_as_e1: 0.12,
    app_rate_as_s0: 0.02,
    avg_round_as: 0,
    avg_round_as_e1: 3296,
    avg_round_as_s0: 0,
    sample_as: 52,
    sample_size_players_as: 34,
    app_0: 38.61,
    round_0_moc: 9.08,
    round_0_pf: 26731,
    round_0_as: 3280,
    app_1: 21.77,
    round_1_moc: 8.64,
    round_1_pf: 34947,
    round_1_as: 3238,
    app_2: 6.9,
    round_2_moc: 6.08,
    round_2_pf: 24280,
    round_2_as: 3427,
    app_3: 2.49,
    round_3_moc: 5.33,
    round_3_pf: 24000,
    round_3_as: 3291,
    app_4: 2.49,
    round_4_moc: 7.33,
    round_4_pf: 28600,
    round_4_as: 3534,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 27.73,
    round_6_moc: 4.96,
    round_6_pf: 34596,
    round_6_as: 3417,
    cons_avg: 2.19,
    weapons_1: 'I Shall Be My Own Sword',
    weapons_1_app: 95.43,
    weapons_1_round_moc: 10.0,
    weapons_1_round_pf: 25480,
    weapons_1_round_as: 3209,
    weapons_2: 'On the Fall of an Aeon',
    weapons_2_app: 2.96,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0,
    weapons_3: 'Something Irreplaceable',
    weapons_3_app: 0.8,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Scholar Lost in Erudition',
    artifacts_1_1: 'Scholar Lost in Erudition',
    artifacts_1_2: '',
    artifacts_1_app: 38.0,
    artifacts_1_round_moc: 10.0,
    artifacts_1_round_pf: 26280,
    artifacts_1_round_as: 3199,
    artifacts_2: 'Genius of Brilliant Stars',
    artifacts_2_1: 'Genius of Brilliant Stars',
    artifacts_2_2: '',
    artifacts_2_app: 27.86,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 24680,
    artifacts_2_round_as: 0,
    artifacts_3: 'Hunter of Glacial Forest',
    artifacts_3_1: 'Hunter of Glacial Forest',
    artifacts_3_2: '',
    artifacts_3_app: 25.34,
    artifacts_3_round_moc: 10.0,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 3224,
    artifacts_4: 'Hunter of Glacial Forest, Scholar Lost in Erudition',
    artifacts_4_1: 'Hunter of Glacial Forest',
    artifacts_4_2: 'Scholar Lost in Erudition',
    artifacts_4_app: 2.39,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 0,
    artifacts_5: 'Scholar Lost in Erudition, Flex',
    artifacts_5_1: 'Scholar Lost in Erudition',
    artifacts_5_2: 'Flex',
    artifacts_5_app: 2.28,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0,
    artifacts_6: 'SPD +6%, SPD +6%',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'SPD +6%',
    artifacts_6_app: 0.91,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'Quan. +10%, Flex',
    artifacts_7_1: 'Quan. +10%',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 0.8,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: 'ATK +12%, Hunter of Glacial Forest',
    artifacts_8_1: 'ATK +12%',
    artifacts_8_2: 'Hunter of Glacial Forest',
    artifacts_8_app: 0.8,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: 'Hunter of Glacial Forest, Flex',
    artifacts_9_1: 'Hunter of Glacial Forest',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 0.8,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Rutilant Arena',
    planars_1_app: 95.44,
    planars_1_round_moc: 10.0,
    planars_1_round_pf: 25480,
    planars_1_round_as: 3209,
    planars_2: 'Firmament Frontline: Glamoth',
    planars_2_app: 1.59,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0,
    planars_2_round_as: 0,
    planars_3: 'Celestial Differentiator',
    planars_3_app: 0.68,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 96.06,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 3.94,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 86.85,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 13.15,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Ice DMG Boost',
    sphere_stats_1_app: 96.56,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 2.57,
    sphere_stats_3: 'Imaginary DMG Boost',
    sphere_stats_3_app: 0.86,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 91.64,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 5.15,
    rope_stats_3: 'HP',
    rope_stats_3_app: 0.86,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 5.54,
    skill_lvl: 10.84,
    ultimate_lvl: 10.96,
    talent_lvl: 11.0,
    max_hp: 3891.89,
    atk: 2524.24,
    dfns: 1010.92,
    speed: 137.36,
    crate: 44.37,
    cdmg: 248.31,
    dmg_boost: 40.2,
    heal_boost: 1,
    energy_regen: 1.0,
    effect_res: 8.21,
    effect_rate: 4.25,
    break_effect: 10.99,
    spd_sub: 8.92,
    hp_sub: 10.07,
    atk_sub: 21.4,
    def_sub: 10.81,
    crate_sub: 27.17,
    cdmg_sub: 77.51,
    res_sub: 8.21,
    ehr_sub: 4.25,
    break_sub: 10.99
  },
  {
    char: 'huohuo',
    app_rate_moc: 24.95,
    app_rate_moc_e0s1: 5.25,
    app_rate_moc_e1: 16.53,
    app_rate_moc_s0: 0.69,
    avg_round_moc: 8.9,
    avg_round_moc_e1: 7.18,
    avg_round_moc_s0: 9.52,
    sample_moc: 3757,
    sample_size_players_moc: 874,
    app_rate_pf: 23.14,
    app_rate_pf_e0s1: 10.81,
    app_rate_pf_e1: 10.96,
    app_rate_pf_s0: 3.71,
    avg_round_pf: 37125,
    avg_round_pf_e1: 37894,
    avg_round_pf_s0: 37178,
    sample_pf: 3247,
    sample_size_players_pf: 791,
    app_rate_as: 17.79,
    app_rate_as_e0s1: 8.08,
    app_rate_as_e1: 8.64,
    app_rate_as_s0: 2.28,
    avg_round_as: 3412,
    avg_round_as_e1: 3491,
    avg_round_as_s0: 3376,
    sample_as: 2761,
    sample_size_players_as: 722,
    app_0: 80.3,
    round_0_moc: 7.96,
    round_0_pf: 37265,
    round_0_as: 3445,
    app_1: 16.91,
    round_1_moc: 6.11,
    round_1_pf: 38841,
    round_1_as: 3502,
    app_2: 1.91,
    round_2_moc: 5.35,
    round_2_pf: 38270,
    round_2_as: 3542,
    app_3: 0.11,
    round_3_moc: 5.5,
    round_3_pf: 34160,
    round_3_as: 3364,
    app_4: 0.03,
    round_4_moc: 8.0,
    round_4_pf: 40000,
    round_4_as: 0,
    app_5: 0.05,
    round_5_moc: 99.99,
    round_5_pf: 38260,
    round_5_as: 3401,
    app_6: 0.73,
    round_6_moc: 1.07,
    round_6_pf: 40000,
    round_6_as: 3727,
    cons_avg: 0.26,
    weapons_1: 'Night of Fright',
    weapons_1_app: 30.31,
    weapons_1_round_moc: 8.14,
    weapons_1_round_pf: 34623,
    weapons_1_round_as: 3445,
    weapons_2: 'Post-Op Conversation',
    weapons_2_app: 23.08,
    weapons_2_round_moc: 8.84,
    weapons_2_round_pf: 35270,
    weapons_2_round_as: 3399,
    weapons_3: 'Quid Pro Quo',
    weapons_3_app: 17.02,
    weapons_3_round_moc: 8.83,
    weapons_3_round_pf: 34220,
    weapons_3_round_as: 3357,
    weapons_4: 'Shared Feeling',
    weapons_4_app: 12.28,
    weapons_4_round_moc: 8.86,
    weapons_4_round_pf: 33248,
    weapons_4_round_as: 3443,
    weapons_5: 'Hey, Over Here',
    weapons_5_app: 7.68,
    weapons_5_round_moc: 9.64,
    weapons_5_round_pf: 36652,
    weapons_5_round_as: 3383,
    weapons_6: 'Time Waits for No One',
    weapons_6_app: 7.21,
    weapons_6_round_moc: 8.19,
    weapons_6_round_pf: 35083,
    weapons_6_round_as: 3446,
    weapons_7: 'Perfect Timing',
    weapons_7_app: 1.08,
    weapons_7_round_moc: 8.0,
    weapons_7_round_pf: 35176,
    weapons_7_round_as: 3357,
    weapons_8: 'Warmth Shortens Cold Nights',
    weapons_8_app: 0.35,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 36660,
    weapons_8_round_as: 3404,
    weapons_9: 'Fine Fruit',
    weapons_9_app: 0.21,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0,
    weapons_10: 'What Is Real?',
    weapons_10_app: 0.17,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0,
    weapons_10_round_as: 3500,
    artifacts_1: 'Passerby of Wandering Cloud',
    artifacts_1_1: 'Passerby of Wandering Cloud',
    artifacts_1_2: '',
    artifacts_1_app: 29.58,
    artifacts_1_round_moc: 8.9,
    artifacts_1_round_pf: 34068,
    artifacts_1_round_as: 3395,
    artifacts_2: 'Messenger Traversing Hackerspace',
    artifacts_2_1: 'Messenger Traversing Hackerspace',
    artifacts_2_2: '',
    artifacts_2_app: 19.75,
    artifacts_2_round_moc: 8.65,
    artifacts_2_round_pf: 37653,
    artifacts_2_round_as: 3442,
    artifacts_3: 'SPD +6%, Passerby of Wandering Cloud',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'Passerby of Wandering Cloud',
    artifacts_3_app: 12.63,
    artifacts_3_round_moc: 8.33,
    artifacts_3_round_pf: 34508,
    artifacts_3_round_as: 3397,
    artifacts_4: 'SPD +6%, Longevous Disciple',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'Longevous Disciple',
    artifacts_4_app: 11.72,
    artifacts_4_round_moc: 8.52,
    artifacts_4_round_pf: 32817,
    artifacts_4_round_as: 3425,
    artifacts_5: 'SPD +6%, SPD +6%',
    artifacts_5_1: 'SPD +6%',
    artifacts_5_2: 'SPD +6%',
    artifacts_5_app: 9.54,
    artifacts_5_round_moc: 8.79,
    artifacts_5_round_pf: 35029,
    artifacts_5_round_as: 3390,
    artifacts_6: 'Longevous Disciple, Passerby of Wandering Cloud',
    artifacts_6_1: 'Longevous Disciple',
    artifacts_6_2: 'Passerby of Wandering Cloud',
    artifacts_6_app: 7.89,
    artifacts_6_round_moc: 9.14,
    artifacts_6_round_pf: 37531,
    artifacts_6_round_as: 3367,
    artifacts_7: 'Eagle of Twilight Line',
    artifacts_7_1: 'Eagle of Twilight Line',
    artifacts_7_2: '',
    artifacts_7_app: 2.66,
    artifacts_7_round_moc: 8.5,
    artifacts_7_round_pf: 33910,
    artifacts_7_round_as: 3303,
    artifacts_8: 'SPD +6%, Flex',
    artifacts_8_1: 'SPD +6%',
    artifacts_8_2: 'Flex',
    artifacts_8_app: 2.25,
    artifacts_8_round_moc: 6.67,
    artifacts_8_round_pf: 40000,
    artifacts_8_round_as: 3424,
    artifacts_9: 'Passerby of Wandering Cloud, Flex',
    artifacts_9_1: 'Passerby of Wandering Cloud',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 0.83,
    artifacts_9_round_moc: 9.33,
    artifacts_9_round_pf: 40000,
    artifacts_9_round_as: 3488,
    artifacts_10: 'Longevous Disciple, Flex',
    artifacts_10_1: 'Longevous Disciple',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 0.77,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 36427,
    artifacts_10_round_as: 3433,
    planars_1: 'Fleet of the Ageless',
    planars_1_app: 44.04,
    planars_1_round_moc: 8.85,
    planars_1_round_pf: 37263,
    planars_1_round_as: 3397,
    planars_2: 'Broken Keel',
    planars_2_app: 32.36,
    planars_2_round_moc: 8.34,
    planars_2_round_pf: 34513,
    planars_2_round_as: 3424,
    planars_3: 'Lushaka, the Sunken Seas',
    planars_3_app: 9.65,
    planars_3_round_moc: 7.83,
    planars_3_round_pf: 33531,
    planars_3_round_as: 3443,
    planars_4: 'Giant Tree of Rapt Brooding',
    planars_4_app: 4.85,
    planars_4_round_moc: 9.0,
    planars_4_round_pf: 32429,
    planars_4_round_as: 3329,
    planars_5: 'Penacony, Land of the Dreams',
    planars_5_app: 4.11,
    planars_5_round_moc: 9.2,
    planars_5_round_pf: 34737,
    planars_5_round_as: 3394,
    body_stats_1: 'Outgoing Healing Boost',
    body_stats_1_app: 84.56,
    body_stats_2: 'HP',
    body_stats_2_app: 14.44,
    body_stats_3: 'Effect Hit Rate',
    body_stats_3_app: 0.26,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 92.0,
    feet_stats_2: 'HP',
    feet_stats_2_app: 7.51,
    feet_stats_3: 'ATK',
    feet_stats_3_app: 0.13,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 96.29,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 1.48,
    sphere_stats_3: 'Wind DMG Boost',
    sphere_stats_3_app: 0.83,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 91.74,
    rope_stats_2: 'HP',
    rope_stats_2_app: 7.55,
    rope_stats_3: 'ATK',
    rope_stats_3_app: 0.38,
    char_lvl: 79.94,
    light_cone_lvl: 79.21,
    attack_lvl: 3.98,
    skill_lvl: 9.48,
    ultimate_lvl: 9.95,
    talent_lvl: 9.66,
    max_hp: 6116.85,
    atk: 1606.82,
    dfns: 1201.96,
    speed: 146.66,
    crate: 11.16,
    cdmg: 61.66,
    dmg_boost: 0.56,
    heal_boost: 44.56,
    energy_regen: 26.02,
    effect_res: 39.1,
    effect_rate: 11.8,
    break_effect: 16.62,
    spd_sub: 16.38,
    hp_sub: 27.4,
    atk_sub: 14.78,
    def_sub: 21.19,
    crate_sub: 6.58,
    cdmg_sub: 11.66,
    res_sub: 19.35,
    ehr_sub: 12.03,
    break_sub: 16.99
  },
  {
    char: 'hanya',
    app_rate_moc: 0.02,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.01,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 3,
    sample_size_players_moc: 0,
    app_rate_pf: 0.04,
    app_rate_pf_e0s1: 0.03,
    app_rate_pf_e1: 0.01,
    app_rate_pf_s0: 0.01,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 6,
    sample_size_players_pf: 0,
    app_rate_as: 0.03,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.03,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 5,
    sample_size_players_as: 0,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 16.67,
    round_2_moc: 99.99,
    round_2_pf: 24320,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 16.67,
    round_4_moc: 99.99,
    round_4_pf: 22600,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 66.67,
    round_6_moc: 99.99,
    round_6_pf: 25150,
    round_6_as: 0,
    cons_avg: 5.0,
    weapons_1: 'Dance! Dance! Dance!',
    weapons_1_app: 100.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 24040,
    weapons_1_round_as: 0.0,
    weapons_2: '',
    weapons_2_app: 0.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Eagle of Twilight Line',
    artifacts_1_1: 'Eagle of Twilight Line',
    artifacts_1_2: '',
    artifacts_1_app: 100.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 24040,
    artifacts_1_round_as: 0.0,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Lushaka, the Sunken Seas',
    planars_1_app: 100.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 24040,
    planars_1_round_as: 0.0,
    planars_2: '',
    planars_2_app: 0.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: '',
    body_stats_1_app: 0.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: '',
    feet_stats_1_app: 0.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: '',
    sphere_stats_1_app: 0.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: '',
    rope_stats_1_app: 0.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 1,
    light_cone_lvl: 1,
    attack_lvl: 1,
    skill_lvl: 1,
    ultimate_lvl: 1,
    talent_lvl: 1,
    max_hp: 1,
    atk: 1,
    dfns: 1,
    speed: 1,
    crate: 1,
    cdmg: 1,
    dmg_boost: 1,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 1,
    effect_rate: 1,
    break_effect: 1,
    spd_sub: 1,
    hp_sub: 1,
    atk_sub: 1,
    def_sub: 1,
    crate_sub: 1,
    cdmg_sub: 1,
    res_sub: 1,
    ehr_sub: 1,
    break_sub: 1
  },
  {
    char: 'argenti',
    app_rate_moc: 1.71,
    app_rate_moc_e0s1: 0.46,
    app_rate_moc_e1: 1.1,
    app_rate_moc_s0: 0.05,
    avg_round_moc: 8.14,
    avg_round_moc_e1: 6.13,
    avg_round_moc_s0: 99.99,
    sample_moc: 258,
    sample_size_players_moc: 73,
    app_rate_pf: 6.94,
    app_rate_pf_e0s1: 3.31,
    app_rate_pf_e1: 3.22,
    app_rate_pf_s0: 1.25,
    avg_round_pf: 33144,
    avg_round_pf_e1: 34981,
    avg_round_pf_s0: 31557,
    sample_pf: 973,
    sample_size_players_pf: 368,
    app_rate_as: 2.61,
    app_rate_as_e0s1: 1.18,
    app_rate_as_e1: 1.27,
    app_rate_as_s0: 0.37,
    avg_round_as: 3478,
    avg_round_as_e1: 3521,
    avg_round_as_s0: 3430,
    sample_as: 405,
    sample_size_players_as: 157,
    app_0: 85.4,
    round_0_moc: 6.56,
    round_0_pf: 34054,
    round_0_as: 3503,
    app_1: 10.77,
    round_1_moc: 6.0,
    round_1_pf: 34865,
    round_1_as: 3499,
    app_2: 2.01,
    round_2_moc: 5.33,
    round_2_pf: 36989,
    round_2_as: 3579,
    app_3: 0.79,
    round_3_moc: 99.99,
    round_3_pf: 38253,
    round_3_as: 3528,
    app_4: 0.1,
    round_4_moc: 99.99,
    round_4_pf: 27400,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 1.1,
    round_6_moc: 6.0,
    round_6_pf: 39760,
    round_6_as: 3618,
    cons_avg: 0.23,
    weapons_1: 'An Instant Before A Gaze',
    weapons_1_app: 40.13,
    weapons_1_round_moc: 7.33,
    weapons_1_round_pf: 32688,
    weapons_1_round_as: 3440,
    weapons_2: 'Today Is Another Peaceful Day',
    weapons_2_app: 14.5,
    weapons_2_round_moc: 7.0,
    weapons_2_round_pf: 33797,
    weapons_2_round_as: 3392,
    weapons_3: 'Passkey',
    weapons_3_app: 11.76,
    weapons_3_round_moc: 7.2,
    weapons_3_round_pf: 40000,
    weapons_3_round_as: 3509,
    weapons_4: 'Eternal Calculus',
    weapons_4_app: 6.98,
    weapons_4_round_moc: 4.0,
    weapons_4_round_pf: 34038,
    weapons_4_round_as: 3472,
    weapons_5: 'Night on the Milky Way',
    weapons_5_app: 6.62,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 32470,
    weapons_5_round_as: 3306,
    weapons_6: "Geniuses' Repose",
    weapons_6_app: 4.78,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 32153,
    weapons_6_round_as: 3324,
    weapons_7: 'Into the Unreachable Veil',
    weapons_7_app: 3.9,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 34980,
    weapons_7_round_as: 3537,
    weapons_8: 'Make the World Clamor',
    weapons_8_app: 3.2,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 30813,
    weapons_8_round_as: 3326,
    weapons_9: 'The Seriousness of Breakfast',
    weapons_9_app: 2.11,
    weapons_9_round_moc: 10.0,
    weapons_9_round_pf: 25900,
    weapons_9_round_as: 0.0,
    weapons_10: 'The Day The Cosmos Fell',
    weapons_10_app: 2.03,
    weapons_10_round_moc: 7.0,
    weapons_10_round_pf: 36520,
    weapons_10_round_as: 3556,
    artifacts_1: 'Scholar Lost in Erudition',
    artifacts_1_1: 'Scholar Lost in Erudition',
    artifacts_1_2: '',
    artifacts_1_app: 40.48,
    artifacts_1_round_moc: 7.0,
    artifacts_1_round_pf: 33553,
    artifacts_1_round_as: 3399,
    artifacts_2: 'Champion of Streetwise Boxing',
    artifacts_2_1: 'Champion of Streetwise Boxing',
    artifacts_2_2: '',
    artifacts_2_app: 22.28,
    artifacts_2_round_moc: 7.0,
    artifacts_2_round_pf: 30401,
    artifacts_2_round_as: 3404,
    artifacts_3: 'Eagle of Twilight Line',
    artifacts_3_1: 'Eagle of Twilight Line',
    artifacts_3_2: '',
    artifacts_3_app: 19.19,
    artifacts_3_round_moc: 6.4,
    artifacts_3_round_pf: 39837,
    artifacts_3_round_as: 3536,
    artifacts_4: 'ATK +12%, Champion of Streetwise Boxing',
    artifacts_4_1: 'ATK +12%',
    artifacts_4_2: 'Champion of Streetwise Boxing',
    artifacts_4_app: 3.67,
    artifacts_4_round_moc: 3.0,
    artifacts_4_round_pf: 34268,
    artifacts_4_round_as: 3378,
    artifacts_5: 'SPD +6%, SPD +6%',
    artifacts_5_1: 'SPD +6%',
    artifacts_5_2: 'SPD +6%',
    artifacts_5_app: 1.8,
    artifacts_5_round_moc: 9.5,
    artifacts_5_round_pf: 40000,
    artifacts_5_round_as: 3400,
    artifacts_6: 'ATK +12%, Scholar Lost in Erudition',
    artifacts_6_1: 'ATK +12%',
    artifacts_6_2: 'Scholar Lost in Erudition',
    artifacts_6_app: 1.39,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 31760,
    artifacts_6_round_as: 3494,
    artifacts_7: 'Champion of Streetwise Boxing, Scholar Lost in Erudition',
    artifacts_7_1: 'Champion of Streetwise Boxing',
    artifacts_7_2: 'Scholar Lost in Erudition',
    artifacts_7_app: 1.08,
    artifacts_7_round_moc: 10.0,
    artifacts_7_round_pf: 40000,
    artifacts_7_round_as: 0.0,
    artifacts_8: 'Scholar Lost in Erudition, Flex',
    artifacts_8_1: 'Scholar Lost in Erudition',
    artifacts_8_2: 'Flex',
    artifacts_8_app: 0.97,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 36413,
    artifacts_8_round_as: 3303,
    artifacts_9: 'Eagle of Twilight Line, Flex',
    artifacts_9_1: 'Eagle of Twilight Line',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 0.73,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 3540,
    artifacts_10: 'Thief of Shooting Meteor',
    artifacts_10_1: 'Thief of Shooting Meteor',
    artifacts_10_2: '',
    artifacts_10_app: 0.73,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 28000,
    artifacts_10_round_as: 0.0,
    planars_1: 'Inert Salsotto',
    planars_1_app: 56.88,
    planars_1_round_moc: 6.9,
    planars_1_round_pf: 33033,
    planars_1_round_as: 3422,
    planars_2: 'Sigonia, the Unclaimed Desolation',
    planars_2_app: 12.63,
    planars_2_round_moc: 6.67,
    planars_2_round_pf: 34075,
    planars_2_round_as: 3485,
    planars_3: 'Lushaka, the Sunken Seas',
    planars_3_app: 6.81,
    planars_3_round_moc: 5.4,
    planars_3_round_pf: 40000,
    planars_3_round_as: 3563,
    planars_4: 'Firmament Frontline: Glamoth',
    planars_4_app: 5.12,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 30126,
    planars_4_round_as: 0.0,
    planars_5: 'Rutilant Arena',
    planars_5_app: 4.2,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 32483,
    planars_5_round_as: 3514,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 51.07,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 40.74,
    body_stats_3: 'ATK',
    body_stats_3_app: 2.08,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 67.28,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 30.12,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Physical DMG Boost',
    sphere_stats_1_app: 76.87,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 16.21,
    sphere_stats_3: 'DEF',
    sphere_stats_3_app: 2.06,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 63.41,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 35.07,
    rope_stats_3: 'HP',
    rope_stats_3_app: 0.5,
    char_lvl: 79.95,
    light_cone_lvl: 79.74,
    attack_lvl: 4.21,
    skill_lvl: 9.88,
    ultimate_lvl: 10.01,
    talent_lvl: 9.96,
    max_hp: 3200.19,
    atk: 2929.26,
    dfns: 925.83,
    speed: 130.33,
    crate: 56.62,
    cdmg: 157.07,
    dmg_boost: 46.67,
    heal_boost: 0.32,
    energy_regen: 7.41,
    effect_res: 7.94,
    effect_rate: 7.91,
    break_effect: 12.75,
    spd_sub: 9.23,
    hp_sub: 10.55,
    atk_sub: 17.43,
    def_sub: 10.51,
    crate_sub: 27.02,
    cdmg_sub: 58.44,
    res_sub: 7.94,
    ehr_sub: 7.91,
    break_sub: 13.39
  },
  {
    char: 'xueyi',
    app_rate_moc: 0.06,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.05,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 9,
    sample_size_players_moc: 6,
    app_rate_pf: 0.11,
    app_rate_pf_e0s1: 0.04,
    app_rate_pf_e1: 0.04,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 15,
    sample_size_players_pf: 7,
    app_rate_as: 0.18,
    app_rate_as_e0s1: 0.04,
    app_rate_as_e1: 0.13,
    app_rate_as_s0: 0.01,
    avg_round_as: 0,
    avg_round_as_e1: 3463,
    avg_round_as_s0: 0,
    sample_as: 28,
    sample_size_players_as: 6,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 3.57,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 3219,
    app_5: 5.84,
    round_5_moc: 10.0,
    round_5_pf: 31320,
    round_5_as: 3420,
    app_6: 92.33,
    round_6_moc: 6.5,
    round_6_pf: 32397,
    round_6_as: 3445,
    cons_avg: 5.9,
    weapons_1: 'On the Fall of an Aeon',
    weapons_1_app: 49.39,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 40000,
    weapons_1_round_as: 3288,
    weapons_2: 'Indelible Promise',
    weapons_2_app: 34.69,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 37080,
    weapons_2_round_as: 3524,
    weapons_3: 'Whereabouts Should Dreams Rest',
    weapons_3_app: 15.92,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0,
    weapons_3_round_as: 0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Genius of Brilliant Stars',
    artifacts_1_1: 'Genius of Brilliant Stars',
    artifacts_1_2: '',
    artifacts_1_app: 82.86,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 38053,
    artifacts_1_round_as: 3524,
    artifacts_2: 'Hero of Triumphant Song, Pioneer Diver of Dead Waters',
    artifacts_2_1: 'Hero of Triumphant Song',
    artifacts_2_2: 'Pioneer Diver of Dead Waters',
    artifacts_2_app: 8.57,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 3288,
    artifacts_3: 'Iron Cavalry Against the Scourge',
    artifacts_3_1: 'Iron Cavalry Against the Scourge',
    artifacts_3_2: '',
    artifacts_3_app: 8.57,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Inert Salsotto',
    planars_1_app: 52.24,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 38053,
    planars_1_round_as: 3406,
    planars_2: 'Talia: Kingdom of Banditry',
    planars_2_app: 17.14,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0,
    planars_3: 'Duran, Dynasty of Running Wolves',
    planars_3_app: 15.92,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0,
    planars_3_round_as: 0,
    planars_4: 'Firmament Frontline: Glamoth',
    planars_4_app: 7.35,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 58.37,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 41.64,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 53.47,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 46.53,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'ATK',
    sphere_stats_1_app: 92.66,
    sphere_stats_2: 'Quantum DMG Boost',
    sphere_stats_2_app: 7.35,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'Break Effect',
    rope_stats_1_app: 78.37,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 21.63,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 79.55,
    attack_lvl: 6.69,
    skill_lvl: 11.65,
    ultimate_lvl: 11.7,
    talent_lvl: 11.65,
    max_hp: 3362.7,
    atk: 2447.94,
    dfns: 884.29,
    speed: 123.19,
    crate: 63.57,
    cdmg: 140.33,
    dmg_boost: 18.93,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 8.7,
    effect_rate: 5.14,
    break_effect: 167.05,
    spd_sub: 6.24,
    hp_sub: 4.99,
    atk_sub: 15.22,
    def_sub: 7.85,
    crate_sub: 37.95,
    cdmg_sub: 70.06,
    res_sub: 8.7,
    ehr_sub: 5.14,
    break_sub: 43.95
  },
  {
    char: 'ruan-mei',
    app_rate_moc: 60.75,
    app_rate_moc_e0s1: 9.73,
    app_rate_moc_e1: 43.46,
    app_rate_moc_s0: 1.16,
    avg_round_moc: 9.26,
    avg_round_moc_e1: 6.82,
    avg_round_moc_s0: 9.6,
    sample_moc: 9150,
    sample_size_players_moc: 3877,
    app_rate_pf: 52.31,
    app_rate_pf_e0s1: 12.42,
    app_rate_pf_e1: 35.55,
    app_rate_pf_s0: 3.81,
    avg_round_pf: 29866,
    avg_round_pf_e1: 34043,
    avg_round_pf_s0: 27317,
    sample_pf: 7338,
    sample_size_players_pf: 3088,
    app_rate_as: 60.78,
    app_rate_as_e0s1: 15.67,
    app_rate_as_e1: 40.09,
    app_rate_as_s0: 3.48,
    avg_round_as: 3453,
    avg_round_as_e1: 3543,
    avg_round_as_s0: 3349,
    sample_as: 9431,
    sample_size_players_as: 3794,
    app_0: 43.93,
    round_0_moc: 8.41,
    round_0_pf: 31516,
    round_0_as: 3484,
    app_1: 47.88,
    round_1_moc: 6.12,
    round_1_pf: 34237,
    round_1_as: 3559,
    app_2: 5.79,
    round_2_moc: 5.44,
    round_2_pf: 37837,
    round_2_as: 3590,
    app_3: 0.66,
    round_3_moc: 5.94,
    round_3_pf: 38681,
    round_3_as: 3568,
    app_4: 0.32,
    round_4_moc: 4.28,
    round_4_pf: 38743,
    round_4_as: 3645,
    app_5: 0.13,
    round_5_moc: 2.5,
    round_5_pf: 40000,
    round_5_as: 3737,
    app_6: 1.29,
    round_6_moc: 0.84,
    round_6_pf: 40000,
    round_6_as: 3801,
    cons_avg: 0.71,
    weapons_1: 'Past Self in Mirror',
    weapons_1_app: 48.96,
    weapons_1_round_moc: 9.14,
    weapons_1_round_pf: 30356,
    weapons_1_round_as: 3454,
    weapons_2: 'Memories of the Past',
    weapons_2_app: 39.13,
    weapons_2_round_moc: 9.47,
    weapons_2_round_pf: 29756,
    weapons_2_round_as: 3432,
    weapons_3: 'Dance! Dance! Dance!',
    weapons_3_app: 7.99,
    weapons_3_round_moc: 9.58,
    weapons_3_round_pf: 29656,
    weapons_3_round_as: 3484,
    weapons_4: 'Meshing Cogs',
    weapons_4_app: 2.97,
    weapons_4_round_moc: 10.0,
    weapons_4_round_pf: 30106,
    weapons_4_round_as: 3432,
    weapons_5: "But the Battle Isn't Over",
    weapons_5_app: 0.47,
    weapons_5_round_moc: 9.5,
    weapons_5_round_pf: 29488,
    weapons_5_round_as: 3417,
    weapons_6: 'Carve the Moon, Weave the Clouds',
    weapons_6_app: 0.15,
    weapons_6_round_moc: 8.0,
    weapons_6_round_pf: 28880,
    weapons_6_round_as: 3499,
    weapons_7: 'Past and Future',
    weapons_7_app: 0.07,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0,
    weapons_7_round_as: 3505,
    weapons_8: 'Poised to Bloom',
    weapons_8_app: 0.06,
    weapons_8_round_moc: 6.0,
    weapons_8_round_pf: 0,
    weapons_8_round_as: 3658,
    weapons_9: 'Planetary Rendezvous',
    weapons_9_app: 0.04,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0,
    weapons_9_round_as: 0,
    weapons_10: 'Earthly Escapade',
    weapons_10_app: 0.03,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0,
    weapons_10_round_as: 0,
    artifacts_1: 'Watchmaker, Master of Dream Machinations',
    artifacts_1_1: 'Watchmaker, Master of Dream Machinations',
    artifacts_1_2: '',
    artifacts_1_app: 42.14,
    artifacts_1_round_moc: 9.36,
    artifacts_1_round_pf: 29887,
    artifacts_1_round_as: 3439,
    artifacts_2: 'SPD +6%, BE +16%',
    artifacts_2_1: 'SPD +6%',
    artifacts_2_2: 'BE +16%',
    artifacts_2_app: 19.64,
    artifacts_2_round_moc: 9.34,
    artifacts_2_round_pf: 30467,
    artifacts_2_round_as: 3442,
    artifacts_3: 'Messenger Traversing Hackerspace',
    artifacts_3_1: 'Messenger Traversing Hackerspace',
    artifacts_3_2: '',
    artifacts_3_app: 14.68,
    artifacts_3_round_moc: 9.45,
    artifacts_3_round_pf: 30006,
    artifacts_3_round_as: 3470,
    artifacts_4: 'Thief of Shooting Meteor',
    artifacts_4_1: 'Thief of Shooting Meteor',
    artifacts_4_2: '',
    artifacts_4_app: 12.84,
    artifacts_4_round_moc: 9.41,
    artifacts_4_round_pf: 29385,
    artifacts_4_round_as: 3426,
    artifacts_5: 'BE +16%, BE +16%',
    artifacts_5_1: 'BE +16%',
    artifacts_5_2: 'BE +16%',
    artifacts_5_app: 6.08,
    artifacts_5_round_moc: 9.37,
    artifacts_5_round_pf: 30504,
    artifacts_5_round_as: 3464,
    artifacts_6: 'BE +16%, Flex',
    artifacts_6_1: 'BE +16%',
    artifacts_6_2: 'Flex',
    artifacts_6_app: 1.47,
    artifacts_6_round_moc: 9.8,
    artifacts_6_round_pf: 32775,
    artifacts_6_round_as: 3471,
    artifacts_7: 'SPD +6%, SPD +6%',
    artifacts_7_1: 'SPD +6%',
    artifacts_7_2: 'SPD +6%',
    artifacts_7_app: 0.87,
    artifacts_7_round_moc: 8.0,
    artifacts_7_round_pf: 30370,
    artifacts_7_round_as: 3630,
    artifacts_8: 'SPD +6%, Flex',
    artifacts_8_1: 'SPD +6%',
    artifacts_8_2: 'Flex',
    artifacts_8_app: 0.56,
    artifacts_8_round_moc: 9.0,
    artifacts_8_round_pf: 24784,
    artifacts_8_round_as: 3378,
    artifacts_9: 'Iron Cavalry Against the Scourge',
    artifacts_9_1: 'Iron Cavalry Against the Scourge',
    artifacts_9_2: '',
    artifacts_9_app: 0.35,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 40000,
    artifacts_9_round_as: 0,
    artifacts_10: 'BE +16%, Longevous Disciple',
    artifacts_10_1: 'BE +16%',
    artifacts_10_2: 'Longevous Disciple',
    artifacts_10_app: 0.14,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 3436,
    planars_1: 'Sprightly Vonwacq',
    planars_1_app: 46.92,
    planars_1_round_moc: 9.34,
    planars_1_round_pf: 30252,
    planars_1_round_as: 3449,
    planars_2: 'Talia: Kingdom of Banditry',
    planars_2_app: 16.79,
    planars_2_round_moc: 9.51,
    planars_2_round_pf: 29421,
    planars_2_round_as: 3429,
    planars_3: 'Fleet of the Ageless',
    planars_3_app: 10.05,
    planars_3_round_moc: 9.28,
    planars_3_round_pf: 28788,
    planars_3_round_as: 3426,
    planars_4: 'Penacony, Land of the Dreams',
    planars_4_app: 9.34,
    planars_4_round_moc: 9.45,
    planars_4_round_pf: 29927,
    planars_4_round_as: 3433,
    planars_5: 'Broken Keel',
    planars_5_app: 8.73,
    planars_5_round_moc: 9.33,
    planars_5_round_pf: 30126,
    planars_5_round_as: 3483,
    body_stats_1: 'HP',
    body_stats_1_app: 62.21,
    body_stats_2: 'DEF',
    body_stats_2_app: 28.08,
    body_stats_3: 'ATK',
    body_stats_3_app: 5.44,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 90.73,
    feet_stats_2: 'HP',
    feet_stats_2_app: 5.4,
    feet_stats_3: 'DEF',
    feet_stats_3_app: 2.89,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 57.93,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 28.2,
    sphere_stats_3: 'Ice DMG Boost',
    sphere_stats_3_app: 5.55,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 85.64,
    rope_stats_2: 'Break Effect',
    rope_stats_2_app: 13.38,
    rope_stats_3: 'HP',
    rope_stats_3_app: 0.53,
    char_lvl: 79.99,
    light_cone_lvl: 79.0,
    attack_lvl: 3.9,
    skill_lvl: 9.93,
    ultimate_lvl: 10.02,
    talent_lvl: 9.97,
    max_hp: 4324.69,
    atk: 1708.52,
    dfns: 1654.27,
    speed: 148.46,
    crate: 10.83,
    cdmg: 61.66,
    dmg_boost: 2.14,
    heal_boost: 0.17,
    energy_regen: 19.72,
    effect_res: 16.39,
    effect_rate: 10.37,
    break_effect: 187.67,
    spd_sub: 14.32,
    hp_sub: 12.49,
    atk_sub: 13.72,
    def_sub: 14.96,
    crate_sub: 5.83,
    cdmg_sub: 11.66,
    res_sub: 15.51,
    ehr_sub: 9.43,
    break_sub: 71.98
  },
  {
    char: 'dr-ratio',
    app_rate_moc: 0.53,
    app_rate_moc_e0s1: 0.03,
    app_rate_moc_e1: 0.31,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 9.04,
    avg_round_moc_s0: 99.99,
    sample_moc: 80,
    sample_size_players_moc: 46,
    app_rate_pf: 0.05,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.01,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 7,
    sample_size_players_pf: 3,
    app_rate_as: 0.19,
    app_rate_as_e0s1: 0.04,
    app_rate_as_e1: 0.09,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 3290,
    avg_round_as_s0: 0,
    sample_as: 29,
    sample_size_players_as: 18,
    app_0: 70.52,
    round_0_moc: 8.91,
    round_0_pf: 22900,
    round_0_as: 3250,
    app_1: 7.78,
    round_1_moc: 7.8,
    round_1_pf: 29040,
    round_1_as: 3315,
    app_2: 3.65,
    round_2_moc: 9.0,
    round_2_pf: 0,
    round_2_as: 3250,
    app_3: 1.25,
    round_3_moc: 10.0,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 17.42,
    round_6_moc: 5.6,
    round_6_pf: 34270,
    round_6_as: 3368,
    cons_avg: 1.22,
    weapons_1: 'Baptism of Pure Thought',
    weapons_1_app: 75.56,
    weapons_1_round_moc: 9.67,
    weapons_1_round_pf: 0,
    weapons_1_round_as: 3245,
    weapons_2: 'Cruising in the Stellar Sea',
    weapons_2_app: 13.44,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0,
    weapons_2_round_as: 3277,
    weapons_3: 'Worrisome, Blissful',
    weapons_3_app: 6.72,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0,
    weapons_4: 'Sleep Like the Dead',
    weapons_4_app: 2.14,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 2948,
    weapons_5: 'Swordplay',
    weapons_5_app: 0.99,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Pioneer Diver of Dead Waters',
    artifacts_1_1: 'Pioneer Diver of Dead Waters',
    artifacts_1_2: '',
    artifacts_1_app: 78.39,
    artifacts_1_round_moc: 10.0,
    artifacts_1_round_pf: 0,
    artifacts_1_round_as: 3233,
    artifacts_2: 'ATK +12%, The Ashblazing Grand Duke',
    artifacts_2_1: 'ATK +12%',
    artifacts_2_2: 'The Ashblazing Grand Duke',
    artifacts_2_app: 5.58,
    artifacts_2_round_moc: 9.0,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 3314,
    artifacts_3: 'Eagle of Twilight Line',
    artifacts_3_1: 'Eagle of Twilight Line',
    artifacts_3_2: '',
    artifacts_3_app: 3.44,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 0,
    artifacts_4: 'Pioneer Diver of Dead Waters, The Ashblazing Grand Duke',
    artifacts_4_1: 'Pioneer Diver of Dead Waters',
    artifacts_4_2: 'The Ashblazing Grand Duke',
    artifacts_4_app: 2.45,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 0.0,
    artifacts_5: 'SPD +6%, ATK +12%',
    artifacts_5_1: 'SPD +6%',
    artifacts_5_2: 'ATK +12%',
    artifacts_5_app: 2.14,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0,
    artifacts_6: 'The Ashblazing Grand Duke',
    artifacts_6_1: 'The Ashblazing Grand Duke',
    artifacts_6_2: '',
    artifacts_6_app: 1.3,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'ATK +12%, Pioneer Diver of Dead Waters',
    artifacts_7_1: 'ATK +12%',
    artifacts_7_2: 'Pioneer Diver of Dead Waters',
    artifacts_7_app: 1.15,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: 'SPD +6%, The Ashblazing Grand Duke',
    artifacts_8_1: 'SPD +6%',
    artifacts_8_2: 'The Ashblazing Grand Duke',
    artifacts_8_app: 1.15,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: 'ATK +12%, Flex',
    artifacts_9_1: 'ATK +12%',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 1.15,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: 'The Ashblazing Grand Duke, Wastelander of Banditry Desert',
    artifacts_10_1: 'The Ashblazing Grand Duke',
    artifacts_10_2: 'Wastelander of Banditry Desert',
    artifacts_10_app: 1.15,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Duran, Dynasty of Running Wolves',
    planars_1_app: 53.29,
    planars_1_round_moc: 10.0,
    planars_1_round_pf: 0,
    planars_1_round_as: 3250,
    planars_2: 'Inert Salsotto',
    planars_2_app: 38.86,
    planars_2_round_moc: 9.0,
    planars_2_round_pf: 0,
    planars_2_round_as: 3154,
    planars_3: 'Sprightly Vonwacq',
    planars_3_app: 3.44,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0,
    planars_3_round_as: 0,
    planars_4: 'Izumo Gensei and Takama Divine Realm',
    planars_4_app: 3.28,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0,
    planars_5: 'Firmament Frontline: Glamoth',
    planars_5_app: 1.15,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 62.68,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 35.82,
    body_stats_3: 'ATK',
    body_stats_3_app: 1.49,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 87.61,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 12.38,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Imaginary DMG Boost',
    sphere_stats_1_app: 88.28,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 10.22,
    sphere_stats_3: 'Physical DMG Boost',
    sphere_stats_3_app: 1.49,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 92.1,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 7.89,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 5.53,
    skill_lvl: 10.67,
    ultimate_lvl: 10.65,
    talent_lvl: 10.68,
    max_hp: 2934.85,
    atk: 3045.98,
    dfns: 1219.5,
    speed: 136.48,
    crate: 73.45,
    cdmg: 179.11,
    dmg_boost: 34.62,
    heal_boost: 1,
    energy_regen: 1.79,
    effect_res: 7.07,
    effect_rate: 8.31,
    break_effect: 15.78,
    spd_sub: 9.24,
    hp_sub: 7.09,
    atk_sub: 18.13,
    def_sub: 6.13,
    crate_sub: 34.39,
    cdmg_sub: 70.74,
    res_sub: 7.07,
    ehr_sub: 8.31,
    break_sub: 15.78
  },
  {
    char: 'black-swan',
    app_rate_moc: 0.82,
    app_rate_moc_e0s1: 0.01,
    app_rate_moc_e1: 0.29,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 8.73,
    avg_round_moc_s0: 99.99,
    sample_moc: 123,
    sample_size_players_moc: 78,
    app_rate_pf: 2.55,
    app_rate_pf_e0s1: 0.8,
    app_rate_pf_e1: 1.28,
    app_rate_pf_s0: 0.14,
    avg_round_pf: 25540,
    avg_round_pf_e1: 27109,
    avg_round_pf_s0: 24527,
    sample_pf: 358,
    sample_size_players_pf: 188,
    app_rate_as: 0.34,
    app_rate_as_e0s1: 0.03,
    app_rate_as_e1: 0.15,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 3239,
    avg_round_as_s0: 0,
    sample_as: 53,
    sample_size_players_as: 34,
    app_0: 43.26,
    round_0_moc: 9.38,
    round_0_pf: 25918,
    round_0_as: 3224,
    app_1: 36.32,
    round_1_moc: 8.13,
    round_1_pf: 29181,
    round_1_as: 3219,
    app_2: 9.62,
    round_2_moc: 7.65,
    round_2_pf: 30477,
    round_2_as: 3316,
    app_3: 1.48,
    round_3_moc: 7.33,
    round_3_pf: 28350,
    round_3_as: 3238,
    app_4: 0.61,
    round_4_moc: 7.0,
    round_4_pf: 40000,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 8.77,
    round_6_moc: 5.19,
    round_6_pf: 39338,
    round_6_as: 3530,
    cons_avg: 1.15,
    weapons_1: 'Reforged Remembrance',
    weapons_1_app: 63.46,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 26037,
    weapons_1_round_as: 3062,
    weapons_2: 'Eyes of the Prey',
    weapons_2_app: 26.37,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 25343,
    weapons_2_round_as: 3137,
    weapons_3: 'Those Many Springs',
    weapons_3_app: 4.02,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0,
    weapons_3_round_as: 0,
    weapons_4: "It's Showtime",
    weapons_4_app: 1.6,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 26670,
    weapons_4_round_as: 0.0,
    weapons_5: 'Solitary Healing',
    weapons_5_app: 1.27,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 26800,
    weapons_5_round_as: 3428,
    weapons_6: 'Before the Tutorial Mission Starts',
    weapons_6_app: 1.08,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 24720,
    weapons_6_round_as: 0,
    weapons_7: 'Good Night and Sleep Well',
    weapons_7_app: 0.88,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 24480,
    weapons_7_round_as: 0,
    weapons_8: 'Resolution Shines As Pearls of Sweat',
    weapons_8_app: 0.63,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 24840,
    weapons_8_round_as: 0.0,
    weapons_9: 'Patience Is All You Need',
    weapons_9_app: 0.45,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0,
    weapons_9_round_as: 0.0,
    weapons_10: 'Incessant Rain',
    weapons_10_app: 0.23,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 27360,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Prisoner in Deep Confinement',
    artifacts_1_1: 'Prisoner in Deep Confinement',
    artifacts_1_2: '',
    artifacts_1_app: 97.69,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 25658,
    artifacts_1_round_as: 3209,
    artifacts_2: 'ATK +12%, Flex',
    artifacts_2_1: 'ATK +12%',
    artifacts_2_2: 'Flex',
    artifacts_2_app: 0.64,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0,
    artifacts_2_round_as: 0,
    artifacts_3: 'Guard of Wuthering Snow',
    artifacts_3_1: 'Guard of Wuthering Snow',
    artifacts_3_2: '',
    artifacts_3_app: 0.62,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 0,
    artifacts_4: 'ATK +12%, ATK +12%',
    artifacts_4_1: 'ATK +12%',
    artifacts_4_2: 'ATK +12%',
    artifacts_4_app: 0.23,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 0.0,
    artifacts_5: 'ATK +12%, Eagle of Twilight Line',
    artifacts_5_1: 'ATK +12%',
    artifacts_5_2: 'Eagle of Twilight Line',
    artifacts_5_app: 0.23,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0.0,
    artifacts_6: 'Eagle of Twilight Line',
    artifacts_6_1: 'Eagle of Twilight Line',
    artifacts_6_2: '',
    artifacts_6_app: 0.2,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'SPD +6%, Flex',
    artifacts_7_1: 'SPD +6%',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 0.2,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: 'SPD +6%, ATK +12%',
    artifacts_8_1: 'SPD +6%',
    artifacts_8_2: 'ATK +12%',
    artifacts_8_app: 0.19,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Pan-Cosmic Commercial Enterprise',
    planars_1_app: 57.71,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 25493,
    planars_1_round_as: 3245,
    planars_2: 'Firmament Frontline: Glamoth',
    planars_2_app: 35.09,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 25913,
    planars_2_round_as: 3137,
    planars_3: 'Space Sealing Station',
    planars_3_app: 5.1,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 26024,
    planars_3_round_as: 0,
    planars_4: 'Sprightly Vonwacq',
    planars_4_app: 0.82,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 0,
    planars_5: 'Lushaka, the Sunken Seas',
    planars_5_app: 0.2,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'Effect Hit Rate',
    body_stats_1_app: 62.01,
    body_stats_2: 'ATK',
    body_stats_2_app: 37.99,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 87.5,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 12.5,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Wind DMG Boost',
    sphere_stats_1_app: 72.71,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 27.3,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 94.13,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 5.6,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 80.0,
    attack_lvl: 5.82,
    skill_lvl: 10.18,
    ultimate_lvl: 10.1,
    talent_lvl: 10.24,
    max_hp: 3156.09,
    atk: 3424.14,
    dfns: 1087.76,
    speed: 143.99,
    crate: 10.56,
    cdmg: 59.54,
    dmg_boost: 42.55,
    heal_boost: 1,
    energy_regen: 1.09,
    effect_res: 7.76,
    effect_rate: 122.62,
    break_effect: 17.22,
    spd_sub: 19.97,
    hp_sub: 11.17,
    atk_sub: 27.97,
    def_sub: 12.96,
    crate_sub: 5.56,
    cdmg_sub: 9.54,
    res_sub: 7.76,
    ehr_sub: 37.69,
    break_sub: 17.28
  },
  {
    char: 'misha',
    app_rate_moc: 0.0,
    app_rate_moc_e0s1: 0.0,
    app_rate_moc_e1: 0.0,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 0,
    sample_size_players_moc: 0,
    app_rate_pf: 0.01,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.01,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 1,
    sample_size_players_pf: 0,
    app_rate_as: 0.0,
    app_rate_as_e0s1: 0.0,
    app_rate_as_e1: 0.0,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 0,
    sample_size_players_as: 0,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 1,
    round_6_moc: 99.99,
    round_6_pf: 0,
    round_6_as: 0,
    cons_avg: 1,
    weapons_1: '',
    weapons_1_app: 0.0,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0.0,
    weapons_1_round_as: 0.0,
    weapons_2: '',
    weapons_2_app: 0.0,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 0.0,
    weapons_3: '',
    weapons_3_app: 0.0,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 0.0,
    weapons_4: '',
    weapons_4_app: 0.0,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0.0,
    weapons_5: '',
    weapons_5_app: 0.0,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0.0,
    weapons_6: '',
    weapons_6_app: 0.0,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: '',
    weapons_7_app: 0.0,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: '',
    artifacts_1_1: '',
    artifacts_1_2: '',
    artifacts_1_app: 0.0,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0.0,
    artifacts_1_round_as: 0.0,
    artifacts_2: '',
    artifacts_2_1: '',
    artifacts_2_2: '',
    artifacts_2_app: 0.0,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0.0,
    artifacts_3: '',
    artifacts_3_1: '',
    artifacts_3_2: '',
    artifacts_3_app: 0.0,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0.0,
    artifacts_4: '',
    artifacts_4_1: '',
    artifacts_4_2: '',
    artifacts_4_app: 0.0,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0.0,
    artifacts_5: '',
    artifacts_5_1: '',
    artifacts_5_2: '',
    artifacts_5_app: 0.0,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: '',
    artifacts_6_1: '',
    artifacts_6_2: '',
    artifacts_6_app: 0.0,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: '',
    artifacts_7_1: '',
    artifacts_7_2: '',
    artifacts_7_app: 0.0,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: '',
    planars_1_app: 0.0,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 0.0,
    planars_1_round_as: 0.0,
    planars_2: '',
    planars_2_app: 0.0,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: '',
    planars_3_app: 0.0,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: '',
    body_stats_1_app: 0.0,
    body_stats_2: '',
    body_stats_2_app: 0.0,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: '',
    feet_stats_1_app: 0.0,
    feet_stats_2: '',
    feet_stats_2_app: 0.0,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: '',
    sphere_stats_1_app: 0.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: '',
    rope_stats_1_app: 0.0,
    rope_stats_2: '',
    rope_stats_2_app: 0.0,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 1,
    light_cone_lvl: 1,
    attack_lvl: 1,
    skill_lvl: 1,
    ultimate_lvl: 1,
    talent_lvl: 1,
    max_hp: 1,
    atk: 1,
    dfns: 1,
    speed: 1,
    crate: 1,
    cdmg: 1,
    dmg_boost: 1,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 1,
    effect_rate: 1,
    break_effect: 1,
    spd_sub: 1,
    hp_sub: 1,
    atk_sub: 1,
    def_sub: 1,
    crate_sub: 1,
    cdmg_sub: 1,
    res_sub: 1,
    ehr_sub: 1,
    break_sub: 1
  },
  {
    char: 'sparkle',
    app_rate_moc: 12.06,
    app_rate_moc_e0s1: 1.1,
    app_rate_moc_e1: 7.1,
    app_rate_moc_s0: 0.15,
    avg_round_moc: 8.94,
    avg_round_moc_e1: 7.61,
    avg_round_moc_s0: 9.31,
    sample_moc: 1816,
    sample_size_players_moc: 829,
    app_rate_pf: 9.76,
    app_rate_pf_e0s1: 1.66,
    app_rate_pf_e1: 5.65,
    app_rate_pf_s0: 0.34,
    avg_round_pf: 28911,
    avg_round_pf_e1: 33014,
    avg_round_pf_s0: 28021,
    sample_pf: 1369,
    sample_size_players_pf: 657,
    app_rate_as: 8.95,
    app_rate_as_e0s1: 1.75,
    app_rate_as_e1: 4.98,
    app_rate_as_s0: 0.34,
    avg_round_as: 3364,
    avg_round_as_e1: 3477,
    avg_round_as_s0: 3318,
    sample_as: 1389,
    sample_size_players_as: 683,
    app_0: 63.18,
    round_0_moc: 7.93,
    round_0_pf: 32065,
    round_0_as: 3451,
    app_1: 9.43,
    round_1_moc: 6.95,
    round_1_pf: 33391,
    round_1_as: 3464,
    app_2: 19.8,
    round_2_moc: 4.75,
    round_2_pf: 35205,
    round_2_as: 3581,
    app_3: 0.99,
    round_3_moc: 5.16,
    round_3_pf: 33209,
    round_3_as: 3605,
    app_4: 0.59,
    round_4_moc: 1.57,
    round_4_pf: 39994,
    round_4_as: 3639,
    app_5: 0.13,
    round_5_moc: 6.5,
    round_5_pf: 40000,
    round_5_as: 3410,
    app_6: 5.9,
    round_6_moc: 1.58,
    round_6_pf: 40000,
    round_6_as: 3749,
    cons_avg: 0.9,
    weapons_1: 'Earthly Escapade',
    weapons_1_app: 61.93,
    weapons_1_round_moc: 9.07,
    weapons_1_round_pf: 29414,
    weapons_1_round_as: 3368,
    weapons_2: 'Dance! Dance! Dance!',
    weapons_2_app: 16.48,
    weapons_2_round_moc: 9.25,
    weapons_2_round_pf: 29845,
    weapons_2_round_as: 3379,
    weapons_3: "But the Battle Isn't Over",
    weapons_3_app: 9.92,
    weapons_3_round_moc: 8.62,
    weapons_3_round_pf: 30218,
    weapons_3_round_as: 3364,
    weapons_4: 'Past and Future',
    weapons_4_app: 7.65,
    weapons_4_round_moc: 9.62,
    weapons_4_round_pf: 27300,
    weapons_4_round_as: 3325,
    weapons_5: 'Carve the Moon, Weave the Clouds',
    weapons_5_app: 0.98,
    weapons_5_round_moc: 10.0,
    weapons_5_round_pf: 28240,
    weapons_5_round_as: 3356,
    weapons_6: 'A Grounded Ascent',
    weapons_6_app: 0.67,
    weapons_6_round_moc: 10.0,
    weapons_6_round_pf: 0,
    weapons_6_round_as: 3354,
    weapons_7: 'Planetary Rendezvous',
    weapons_7_app: 0.56,
    weapons_7_round_moc: 9.0,
    weapons_7_round_pf: 21040,
    weapons_7_round_as: 3348,
    weapons_8: 'Poised to Bloom',
    weapons_8_app: 0.48,
    weapons_8_round_moc: 7.0,
    weapons_8_round_pf: 33320,
    weapons_8_round_as: 0,
    weapons_9: 'Memories of the Past',
    weapons_9_app: 0.23,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0,
    weapons_9_round_as: 0,
    weapons_10: 'Past Self in Mirror',
    weapons_10_app: 0.15,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0,
    artifacts_1: 'Messenger Traversing Hackerspace',
    artifacts_1_1: 'Messenger Traversing Hackerspace',
    artifacts_1_2: '',
    artifacts_1_app: 32.48,
    artifacts_1_round_moc: 9.41,
    artifacts_1_round_pf: 29255,
    artifacts_1_round_as: 3341,
    artifacts_2: "Sacerdos' Relived Ordeal",
    artifacts_2_1: "Sacerdos' Relived Ordeal",
    artifacts_2_2: '',
    artifacts_2_app: 29.49,
    artifacts_2_round_moc: 9.08,
    artifacts_2_round_pf: 31879,
    artifacts_2_round_as: 3385,
    artifacts_3: 'SPD +6%, Flex',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'Flex',
    artifacts_3_app: 11.09,
    artifacts_3_round_moc: 8.29,
    artifacts_3_round_pf: 28548,
    artifacts_3_round_as: 3463,
    artifacts_4: 'SPD +6%, SPD +6%',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'SPD +6%',
    artifacts_4_app: 10.18,
    artifacts_4_round_moc: 9.5,
    artifacts_4_round_pf: 25852,
    artifacts_4_round_as: 3356,
    artifacts_5: 'Eagle of Twilight Line',
    artifacts_5_1: 'Eagle of Twilight Line',
    artifacts_5_2: '',
    artifacts_5_app: 9.03,
    artifacts_5_round_moc: 5.0,
    artifacts_5_round_pf: 31904,
    artifacts_5_round_as: 3346,
    artifacts_6: 'SPD +6%, Longevous Disciple',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Longevous Disciple',
    artifacts_6_app: 1.52,
    artifacts_6_round_moc: 7.0,
    artifacts_6_round_pf: 23660,
    artifacts_6_round_as: 3208,
    artifacts_7: 'SPD +6%, Guard of Wuthering Snow',
    artifacts_7_1: 'SPD +6%',
    artifacts_7_2: 'Guard of Wuthering Snow',
    artifacts_7_app: 0.87,
    artifacts_7_round_moc: 9.0,
    artifacts_7_round_pf: 22680,
    artifacts_7_round_as: 3204,
    artifacts_8: 'Quan. +10%, SPD +6%',
    artifacts_8_1: 'Quan. +10%',
    artifacts_8_2: 'SPD +6%',
    artifacts_8_app: 0.59,
    artifacts_8_round_moc: 9.0,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 3476,
    artifacts_9: 'SPD +6%, ATK +12%',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'ATK +12%',
    artifacts_9_app: 0.55,
    artifacts_9_round_moc: 10.0,
    artifacts_9_round_pf: 29240,
    artifacts_9_round_as: 0,
    artifacts_10: 'Eagle of Twilight Line, Flex',
    artifacts_10_1: 'Eagle of Twilight Line',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 0.39,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 40000,
    artifacts_10_round_as: 0,
    planars_1: 'Broken Keel',
    planars_1_app: 61.35,
    planars_1_round_moc: 9.38,
    planars_1_round_pf: 29845,
    planars_1_round_as: 3353,
    planars_2: 'Penacony, Land of the Dreams',
    planars_2_app: 11.31,
    planars_2_round_moc: 8.7,
    planars_2_round_pf: 29608,
    planars_2_round_as: 3371,
    planars_3: 'Lushaka, the Sunken Seas',
    planars_3_app: 9.92,
    planars_3_round_moc: 7.33,
    planars_3_round_pf: 29343,
    planars_3_round_as: 3402,
    planars_4: 'Sprightly Vonwacq',
    planars_4_app: 6.57,
    planars_4_round_moc: 8.0,
    planars_4_round_pf: 27400,
    planars_4_round_as: 3335,
    planars_5: 'Forge of the Kalpagni Lantern',
    planars_5_app: 3.04,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 30770,
    planars_5_round_as: 3375,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 98.29,
    body_stats_2: 'ATK',
    body_stats_2_app: 0.64,
    body_stats_3: 'HP',
    body_stats_3_app: 0.6,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 98.93,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 0.28,
    feet_stats_3: 'HP',
    feet_stats_3_app: 0.22,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 47.42,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 24.35,
    sphere_stats_3: 'ATK',
    sphere_stats_3_app: 9.3,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 96.45,
    rope_stats_2: 'HP',
    rope_stats_2_app: 1.38,
    rope_stats_3: 'ATK',
    rope_stats_3_app: 1.2,
    char_lvl: 79.97,
    light_cone_lvl: 79.19,
    attack_lvl: 4.4,
    skill_lvl: 10.24,
    ultimate_lvl: 10.16,
    talent_lvl: 10.15,
    max_hp: 4832.36,
    atk: 1578.43,
    dfns: 1205.95,
    speed: 160.97,
    crate: 11.0,
    cdmg: 213.45,
    dmg_boost: 2.47,
    heal_boost: 1,
    energy_regen: 20.93,
    effect_res: 31.46,
    effect_rate: 8.21,
    break_effect: 12.52,
    spd_sub: 25.59,
    hp_sub: 12.31,
    atk_sub: 13.12,
    def_sub: 15.34,
    crate_sub: 6.0,
    cdmg_sub: 52.57,
    res_sub: 15.31,
    ehr_sub: 8.04,
    break_sub: 14.98
  },
  {
    char: 'gallagher',
    app_rate_moc: 46.48,
    app_rate_moc_e0s1: 10.21,
    app_rate_moc_e1: 32.4,
    app_rate_moc_s0: 0.97,
    avg_round_moc: 8.94,
    avg_round_moc_e1: 6.96,
    avg_round_moc_s0: 9.22,
    sample_moc: 7001,
    sample_size_players_moc: 299,
    app_rate_pf: 42.43,
    app_rate_pf_e0s1: 20.13,
    app_rate_pf_e1: 20.7,
    app_rate_pf_s0: 4.38,
    avg_round_pf: 33865,
    avg_round_pf_e1: 35294,
    avg_round_pf_s0: 32689,
    sample_pf: 5952,
    sample_size_players_pf: 257,
    app_rate_as: 47.59,
    app_rate_as_e0s1: 22.85,
    app_rate_as_e1: 23.33,
    app_rate_as_s0: 3.95,
    avg_round_as: 3481,
    avg_round_as_e1: 3568,
    avg_round_as_s0: 3393,
    sample_as: 7384,
    sample_size_players_as: 307,
    app_0: 0.11,
    round_0_moc: 8.92,
    round_0_pf: 37170,
    round_0_as: 3582,
    app_1: 0.27,
    round_1_moc: 7.96,
    round_1_pf: 36440,
    round_1_as: 3463,
    app_2: 0.74,
    round_2_moc: 7.59,
    round_2_pf: 33376,
    round_2_as: 3437,
    app_3: 1.39,
    round_3_moc: 8.49,
    round_3_pf: 34499,
    round_3_as: 3446,
    app_4: 2.14,
    round_4_moc: 8.58,
    round_4_pf: 33198,
    round_4_as: 3480,
    app_5: 3.16,
    round_5_moc: 8.61,
    round_5_pf: 33948,
    round_5_as: 3467,
    app_6: 92.18,
    round_6_moc: 7.6,
    round_6_pf: 34745,
    round_6_as: 3534,
    cons_avg: 5.84,
    weapons_1: 'Quid Pro Quo',
    weapons_1_app: 27.45,
    weapons_1_round_moc: 9.0,
    weapons_1_round_pf: 34361,
    weapons_1_round_as: 3417,
    weapons_2: 'What Is Real?',
    weapons_2_app: 21.74,
    weapons_2_round_moc: 8.21,
    weapons_2_round_pf: 34481,
    weapons_2_round_as: 3452,
    weapons_3: 'Shared Feeling',
    weapons_3_app: 16.18,
    weapons_3_round_moc: 7.83,
    weapons_3_round_pf: 36817,
    weapons_3_round_as: 3562,
    weapons_4: 'Post-Op Conversation',
    weapons_4_app: 9.38,
    weapons_4_round_moc: 6.4,
    weapons_4_round_pf: 34111,
    weapons_4_round_as: 3450,
    weapons_5: 'Multiplication',
    weapons_5_app: 7.08,
    weapons_5_round_moc: 9.5,
    weapons_5_round_pf: 38080,
    weapons_5_round_as: 3476,
    weapons_6: 'Warmth Shortens Cold Nights',
    weapons_6_app: 3.34,
    weapons_6_round_moc: 4.0,
    weapons_6_round_pf: 34867,
    weapons_6_round_as: 3532,
    weapons_7: 'Perfect Timing',
    weapons_7_app: 3.34,
    weapons_7_round_moc: 8.5,
    weapons_7_round_pf: 33867,
    weapons_7_round_as: 3484,
    weapons_8: "Dream's Montage",
    weapons_8_app: 3.24,
    weapons_8_round_moc: 8.0,
    weapons_8_round_pf: 26680,
    weapons_8_round_as: 3473,
    weapons_9: 'Time Waits for No One',
    weapons_9_app: 2.5,
    weapons_9_round_moc: 9.0,
    weapons_9_round_pf: 38720,
    weapons_9_round_as: 3682,
    weapons_10: 'Scent Alone Stays True',
    weapons_10_app: 1.99,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 26800,
    weapons_10_round_as: 3579,
    artifacts_1: 'SPD +6%, BE +16%',
    artifacts_1_1: 'SPD +6%',
    artifacts_1_2: 'BE +16%',
    artifacts_1_app: 29.82,
    artifacts_1_round_moc: 8.06,
    artifacts_1_round_pf: 34794,
    artifacts_1_round_as: 3488,
    artifacts_2: 'SPD +6%, SPD +6%',
    artifacts_2_1: 'SPD +6%',
    artifacts_2_2: 'SPD +6%',
    artifacts_2_app: 25.0,
    artifacts_2_round_moc: 8.45,
    artifacts_2_round_pf: 38257,
    artifacts_2_round_as: 3493,
    artifacts_3: "Sacerdos' Relived Ordeal",
    artifacts_3_1: "Sacerdos' Relived Ordeal",
    artifacts_3_2: '',
    artifacts_3_app: 8.47,
    artifacts_3_round_moc: 6.5,
    artifacts_3_round_pf: 34327,
    artifacts_3_round_as: 3466,
    artifacts_4: 'BE +16%, BE +16%',
    artifacts_4_1: 'BE +16%',
    artifacts_4_2: 'BE +16%',
    artifacts_4_app: 7.61,
    artifacts_4_round_moc: 8.0,
    artifacts_4_round_pf: 34987,
    artifacts_4_round_as: 3444,
    artifacts_5: 'Thief of Shooting Meteor',
    artifacts_5_1: 'Thief of Shooting Meteor',
    artifacts_5_2: '',
    artifacts_5_app: 6.36,
    artifacts_5_round_moc: 9.5,
    artifacts_5_round_pf: 35704,
    artifacts_5_round_as: 3390,
    artifacts_6: 'SPD +6%, Passerby of Wandering Cloud',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Passerby of Wandering Cloud',
    artifacts_6_app: 5.86,
    artifacts_6_round_moc: 9.5,
    artifacts_6_round_pf: 32277,
    artifacts_6_round_as: 3492,
    artifacts_7: 'Iron Cavalry Against the Scourge',
    artifacts_7_1: 'Iron Cavalry Against the Scourge',
    artifacts_7_2: '',
    artifacts_7_app: 3.44,
    artifacts_7_round_moc: 10.0,
    artifacts_7_round_pf: 34820,
    artifacts_7_round_as: 3248,
    artifacts_8: 'SPD +6%, Flex',
    artifacts_8_1: 'SPD +6%',
    artifacts_8_2: 'Flex',
    artifacts_8_app: 2.6,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 40000,
    artifacts_8_round_as: 3381,
    artifacts_9: 'BE +16%, Passerby of Wandering Cloud',
    artifacts_9_1: 'BE +16%',
    artifacts_9_2: 'Passerby of Wandering Cloud',
    artifacts_9_app: 2.5,
    artifacts_9_round_moc: 10.0,
    artifacts_9_round_pf: 35900,
    artifacts_9_round_as: 3471,
    artifacts_10: 'BE +16%, Flex',
    artifacts_10_1: 'BE +16%',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 2.38,
    artifacts_10_round_moc: 10.0,
    artifacts_10_round_pf: 34507,
    artifacts_10_round_as: 3425,
    planars_1: 'Forge of the Kalpagni Lantern',
    planars_1_app: 30.0,
    planars_1_round_moc: 8.13,
    planars_1_round_pf: 33881,
    planars_1_round_as: 3424,
    planars_2: 'Giant Tree of Rapt Brooding',
    planars_2_app: 22.03,
    planars_2_round_moc: 8.2,
    planars_2_round_pf: 37101,
    planars_2_round_as: 3549,
    planars_3: 'Broken Keel',
    planars_3_app: 15.74,
    planars_3_round_moc: 8.29,
    planars_3_round_pf: 33739,
    planars_3_round_as: 3484,
    planars_4: 'Talia: Kingdom of Banditry',
    planars_4_app: 12.09,
    planars_4_round_moc: 7.57,
    planars_4_round_pf: 32953,
    planars_4_round_as: 3468,
    planars_5: 'Sprightly Vonwacq',
    planars_5_app: 7.82,
    planars_5_round_moc: 7.5,
    planars_5_round_pf: 38898,
    planars_5_round_as: 3481,
    body_stats_1: 'Outgoing Healing Boost',
    body_stats_1_app: 87.84,
    body_stats_2: 'HP',
    body_stats_2_app: 8.13,
    body_stats_3: 'ATK',
    body_stats_3_app: 1.85,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 98.83,
    feet_stats_2: 'HP',
    feet_stats_2_app: 0.82,
    feet_stats_3: 'ATK',
    feet_stats_3_app: 0.12,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 68.47,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 13.92,
    sphere_stats_3: 'Fire DMG Boost',
    sphere_stats_3_app: 3.4,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 86.08,
    rope_stats_2: 'Break Effect',
    rope_stats_2_app: 12.44,
    rope_stats_3: 'HP',
    rope_stats_3_app: 0.93,
    char_lvl: 79.88,
    light_cone_lvl: 78.23,
    attack_lvl: 5.7,
    skill_lvl: 10.98,
    ultimate_lvl: 9.23,
    talent_lvl: 11.52,
    max_hp: 4615.78,
    atk: 1463.93,
    dfns: 1033.69,
    speed: 153.9,
    crate: 11.04,
    cdmg: 61.66,
    dmg_boost: 2.07,
    heal_boost: 34.56,
    energy_regen: 19.03,
    effect_res: 43.1,
    effect_rate: 10.72,
    break_effect: 95.87,
    spd_sub: 21.95,
    hp_sub: 14.72,
    atk_sub: 12.56,
    def_sub: 16.83,
    crate_sub: 6.68,
    cdmg_sub: 11.66,
    res_sub: 15.29,
    ehr_sub: 10.72,
    break_sub: 50.24
  },
  {
    char: 'acheron',
    app_rate_moc: 14.7,
    app_rate_moc_e0s1: 0.86,
    app_rate_moc_e1: 9.55,
    app_rate_moc_s0: 0.01,
    avg_round_moc: 9.31,
    avg_round_moc_e1: 7.72,
    avg_round_moc_s0: 99.99,
    sample_moc: 2214,
    sample_size_players_moc: 1841,
    app_rate_pf: 18.89,
    app_rate_pf_e0s1: 4.52,
    app_rate_pf_e1: 10.69,
    app_rate_pf_s0: 0.48,
    avg_round_pf: 27481,
    avg_round_pf_e1: 33233,
    avg_round_pf_s0: 26039,
    sample_pf: 2650,
    sample_size_players_pf: 2104,
    app_rate_as: 10.65,
    app_rate_as_e0s1: 1.76,
    app_rate_as_e1: 5.99,
    app_rate_as_s0: 0.09,
    avg_round_as: 3318,
    avg_round_as_e1: 3505,
    avg_round_as_s0: 3257,
    sample_as: 1653,
    sample_size_players_as: 1400,
    app_0: 28.75,
    round_0_moc: 8.81,
    round_0_pf: 28173,
    round_0_as: 3349,
    app_1: 4.31,
    round_1_moc: 9.05,
    round_1_pf: 29694,
    round_1_as: 3402,
    app_2: 45.59,
    round_2_moc: 6.73,
    round_2_pf: 34339,
    round_2_as: 3538,
    app_3: 3.07,
    round_3_moc: 6.7,
    round_3_pf: 34741,
    round_3_as: 3577,
    app_4: 1.48,
    round_4_moc: 7.02,
    round_4_pf: 34340,
    round_4_as: 3627,
    app_5: 0.42,
    round_5_moc: 8.57,
    round_5_pf: 34269,
    round_5_as: 3591,
    app_6: 16.38,
    round_6_moc: 4.79,
    round_6_pf: 39452,
    round_6_as: 3725,
    cons_avg: 2.11,
    weapons_1: 'Along the Passing Shore',
    weapons_1_app: 97.81,
    weapons_1_round_moc: 9.28,
    weapons_1_round_pf: 27684,
    weapons_1_round_as: 3321,
    weapons_2: 'Good Night and Sleep Well',
    weapons_2_app: 1.49,
    weapons_2_round_moc: 8.75,
    weapons_2_round_pf: 26141,
    weapons_2_round_as: 3154,
    weapons_3: 'Boundless Choreo',
    weapons_3_app: 0.22,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 24736,
    weapons_3_round_as: 0,
    weapons_4: 'Incessant Rain',
    weapons_4_app: 0.17,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 25000,
    weapons_4_round_as: 0,
    weapons_5: 'Before the Tutorial Mission Starts',
    weapons_5_app: 0.09,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0,
    weapons_5_round_as: 0,
    weapons_6: 'In the Name of the World',
    weapons_6_app: 0.09,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 25840,
    weapons_6_round_as: 0.0,
    weapons_7: 'Patience Is All You Need',
    weapons_7_app: 0.08,
    weapons_7_round_moc: 9.0,
    weapons_7_round_pf: 25620,
    weapons_7_round_as: 0.0,
    weapons_8: 'Fermata',
    weapons_8_app: 0.03,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 29760,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Pioneer Diver of Dead Waters',
    artifacts_1_1: 'Pioneer Diver of Dead Waters',
    artifacts_1_2: '',
    artifacts_1_app: 96.91,
    artifacts_1_round_moc: 9.21,
    artifacts_1_round_pf: 27592,
    artifacts_1_round_as: 3314,
    artifacts_2: 'Genius of Brilliant Stars',
    artifacts_2_1: 'Genius of Brilliant Stars',
    artifacts_2_2: '',
    artifacts_2_app: 0.58,
    artifacts_2_round_moc: 10.0,
    artifacts_2_round_pf: 26520,
    artifacts_2_round_as: 3101,
    artifacts_3: 'Scholar Lost in Erudition',
    artifacts_3_1: 'Scholar Lost in Erudition',
    artifacts_3_2: '',
    artifacts_3_app: 0.49,
    artifacts_3_round_moc: 9.0,
    artifacts_3_round_pf: 24040,
    artifacts_3_round_as: 3178,
    artifacts_4: 'Pioneer Diver of Dead Waters, Flex',
    artifacts_4_1: 'Pioneer Diver of Dead Waters',
    artifacts_4_2: 'Flex',
    artifacts_4_app: 0.35,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 23760,
    artifacts_4_round_as: 3558,
    artifacts_5: 'ATK +12%, ATK +12%',
    artifacts_5_1: 'ATK +12%',
    artifacts_5_2: 'ATK +12%',
    artifacts_5_app: 0.17,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0,
    artifacts_6: 'ATK +12%, Flex',
    artifacts_6_1: 'ATK +12%',
    artifacts_6_2: 'Flex',
    artifacts_6_app: 0.15,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0,
    artifacts_7: 'Poet of Mourning Collapse',
    artifacts_7_1: 'Poet of Mourning Collapse',
    artifacts_7_2: '',
    artifacts_7_app: 0.15,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 27560,
    artifacts_7_round_as: 0,
    artifacts_8: 'Prisoner in Deep Confinement',
    artifacts_8_1: 'Prisoner in Deep Confinement',
    artifacts_8_2: '',
    artifacts_8_app: 0.13,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 0,
    artifacts_9: 'ATK +12%, Pioneer Diver of Dead Waters',
    artifacts_9_1: 'ATK +12%',
    artifacts_9_2: 'Pioneer Diver of Dead Waters',
    artifacts_9_app: 0.11,
    artifacts_9_round_moc: 10.0,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 3376,
    artifacts_10: 'Pioneer Diver of Dead Waters, Scholar Lost in Erudition',
    artifacts_10_1: 'Pioneer Diver of Dead Waters',
    artifacts_10_2: 'Scholar Lost in Erudition',
    artifacts_10_app: 0.1,
    artifacts_10_round_moc: 10.0,
    artifacts_10_round_pf: 27200,
    artifacts_10_round_as: 0.0,
    planars_1: 'Izumo Gensei and Takama Divine Realm',
    planars_1_app: 91.43,
    planars_1_round_moc: 9.23,
    planars_1_round_pf: 27854,
    planars_1_round_as: 3317,
    planars_2: 'Inert Salsotto',
    planars_2_app: 6.56,
    planars_2_round_moc: 9.33,
    planars_2_round_pf: 27702,
    planars_2_round_as: 3303,
    planars_3: 'Rutilant Arena',
    planars_3_app: 0.44,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 28200,
    planars_3_round_as: 3350,
    planars_4: 'Sigonia, the Unclaimed Desolation',
    planars_4_app: 0.39,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 32400,
    planars_4_round_as: 0,
    planars_5: 'Firmament Frontline: Glamoth',
    planars_5_app: 0.31,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 23260,
    planars_5_round_as: 0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 52.5,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 46.19,
    body_stats_3: 'ATK',
    body_stats_3_app: 1.08,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 78.08,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 21.66,
    feet_stats_3: 'HP',
    feet_stats_3_app: 0.06,
    sphere_stats_1: 'ATK',
    sphere_stats_1_app: 59.3,
    sphere_stats_2: 'Lightning DMG Boost',
    sphere_stats_2_app: 40.43,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 99.7,
    rope_stats_2: 'Break Effect',
    rope_stats_2_app: 0.06,
    rope_stats_3: 'HP',
    rope_stats_3_app: 0.02,
    char_lvl: 80.0,
    light_cone_lvl: 79.99,
    attack_lvl: 5.11,
    skill_lvl: 10.32,
    ultimate_lvl: 10.48,
    talent_lvl: 10.37,
    max_hp: 3186.88,
    atk: 3828.63,
    dfns: 972.88,
    speed: 106.13,
    crate: 59.18,
    cdmg: 221.23,
    dmg_boost: 23.71,
    heal_boost: 1,
    energy_regen: 1,
    effect_res: 7.78,
    effect_rate: 7.45,
    break_effect: 11.66,
    spd_sub: 4.6,
    hp_sub: 9.93,
    atk_sub: 15.38,
    def_sub: 10.28,
    crate_sub: 34.72,
    cdmg_sub: 76.27,
    res_sub: 7.78,
    ehr_sub: 7.45,
    break_sub: 11.66
  },
  {
    char: 'aventurine',
    app_rate_moc: 32.55,
    app_rate_moc_e0s1: 6.89,
    app_rate_moc_e1: 20.95,
    app_rate_moc_s0: 0.72,
    avg_round_moc: 9.2,
    avg_round_moc_e1: 7.46,
    avg_round_moc_s0: 9.5,
    sample_moc: 4903,
    sample_size_players_moc: 2117,
    app_rate_pf: 33.24,
    app_rate_pf_e0s1: 14.75,
    app_rate_pf_e1: 15.33,
    app_rate_pf_s0: 4.73,
    avg_round_pf: 34765,
    avg_round_pf_e1: 35101,
    avg_round_pf_s0: 37785,
    sample_pf: 4663,
    sample_size_players_pf: 2027,
    app_rate_as: 38.52,
    app_rate_as_e0s1: 19.31,
    app_rate_as_e1: 16.56,
    app_rate_as_s0: 6.86,
    avg_round_as: 3400,
    avg_round_as_e1: 3485,
    avg_round_as_s0: 3374,
    sample_as: 5977,
    sample_size_players_as: 2368,
    app_0: 83.02,
    round_0_moc: 8.24,
    round_0_pf: 34950,
    round_0_as: 3438,
    app_1: 10.03,
    round_1_moc: 6.87,
    round_1_pf: 37305,
    round_1_as: 3494,
    app_2: 4.61,
    round_2_moc: 5.48,
    round_2_pf: 39437,
    round_2_as: 3552,
    app_3: 0.29,
    round_3_moc: 7.62,
    round_3_pf: 36978,
    round_3_as: 3548,
    app_4: 0.38,
    round_4_moc: 7.18,
    round_4_pf: 39036,
    round_4_as: 3463,
    app_5: 0.06,
    round_5_moc: 5.67,
    round_5_pf: 36933,
    round_5_as: 3489,
    app_6: 1.62,
    round_6_moc: 4.77,
    round_6_pf: 39152,
    round_6_as: 3598,
    cons_avg: 0.32,
    weapons_1: 'Inherently Unjust Destiny',
    weapons_1_app: 54.02,
    weapons_1_round_moc: 9.04,
    weapons_1_round_pf: 34201,
    weapons_1_round_as: 3415,
    weapons_2: 'Moment of Victory',
    weapons_2_app: 24.29,
    weapons_2_round_moc: 9.3,
    weapons_2_round_pf: 37203,
    weapons_2_round_as: 3395,
    weapons_3: 'Trend of the Universal Market',
    weapons_3_app: 9.99,
    weapons_3_round_moc: 9.59,
    weapons_3_round_pf: 31852,
    weapons_3_round_as: 3375,
    weapons_4: 'Day One of My New Life',
    weapons_4_app: 5.21,
    weapons_4_round_moc: 8.94,
    weapons_4_round_pf: 33589,
    weapons_4_round_as: 3383,
    weapons_5: 'Concert for Two',
    weapons_5_app: 2.54,
    weapons_5_round_moc: 9.18,
    weapons_5_round_pf: 34327,
    weapons_5_round_as: 3344,
    weapons_6: "Destiny's Threads Forewoven",
    weapons_6_app: 2.28,
    weapons_6_round_moc: 8.58,
    weapons_6_round_pf: 32925,
    weapons_6_round_as: 3401,
    weapons_7: "Landau's Choice",
    weapons_7_app: 0.73,
    weapons_7_round_moc: 9.67,
    weapons_7_round_pf: 33663,
    weapons_7_round_as: 3411,
    weapons_8: 'Texture of Memories',
    weapons_8_app: 0.49,
    weapons_8_round_moc: 9.4,
    weapons_8_round_pf: 36000,
    weapons_8_round_as: 3319,
    weapons_9: 'This Is Me!',
    weapons_9_app: 0.41,
    weapons_9_round_moc: 9.0,
    weapons_9_round_pf: 38113,
    weapons_9_round_as: 3414,
    weapons_10: 'She Already Shut Her Eyes',
    weapons_10_app: 0.02,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 3050,
    artifacts_1: 'Knight of Purity Palace',
    artifacts_1_1: 'Knight of Purity Palace',
    artifacts_1_2: '',
    artifacts_1_app: 52.33,
    artifacts_1_round_moc: 9.27,
    artifacts_1_round_pf: 34127,
    artifacts_1_round_as: 3385,
    artifacts_2: 'Pioneer Diver of Dead Waters',
    artifacts_2_1: 'Pioneer Diver of Dead Waters',
    artifacts_2_2: '',
    artifacts_2_app: 21.79,
    artifacts_2_round_moc: 9.29,
    artifacts_2_round_pf: 34207,
    artifacts_2_round_as: 3431,
    artifacts_3: 'Knight of Purity Palace, The Ashblazing Grand Duke',
    artifacts_3_1: 'Knight of Purity Palace',
    artifacts_3_2: 'The Ashblazing Grand Duke',
    artifacts_3_app: 8.31,
    artifacts_3_round_moc: 8.71,
    artifacts_3_round_pf: 34388,
    artifacts_3_round_as: 3411,
    artifacts_4: 'Pioneer Diver of Dead Waters, The Ashblazing Grand Duke',
    artifacts_4_1: 'Pioneer Diver of Dead Waters',
    artifacts_4_2: 'The Ashblazing Grand Duke',
    artifacts_4_app: 3.64,
    artifacts_4_round_moc: 8.56,
    artifacts_4_round_pf: 36900,
    artifacts_4_round_as: 3408,
    artifacts_5: 'Knight of Purity Palace, Pioneer Diver of Dead Waters',
    artifacts_5_1: 'Knight of Purity Palace',
    artifacts_5_2: 'Pioneer Diver of Dead Waters',
    artifacts_5_app: 2.59,
    artifacts_5_round_moc: 9.56,
    artifacts_5_round_pf: 33558,
    artifacts_5_round_as: 3393,
    artifacts_6: 'SPD +6%, Knight of Purity Palace',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Knight of Purity Palace',
    artifacts_6_app: 2.3,
    artifacts_6_round_moc: 9.25,
    artifacts_6_round_pf: 35436,
    artifacts_6_round_as: 3366,
    artifacts_7: 'SPD +6%, The Ashblazing Grand Duke',
    artifacts_7_1: 'SPD +6%',
    artifacts_7_2: 'The Ashblazing Grand Duke',
    artifacts_7_app: 1.05,
    artifacts_7_round_moc: 9.0,
    artifacts_7_round_pf: 32864,
    artifacts_7_round_as: 3453,
    artifacts_8: 'SPD +6%, SPD +6%',
    artifacts_8_1: 'SPD +6%',
    artifacts_8_2: 'SPD +6%',
    artifacts_8_app: 0.99,
    artifacts_8_round_moc: 9.5,
    artifacts_8_round_pf: 28820,
    artifacts_8_round_as: 3431,
    artifacts_9: 'SPD +6%, Pioneer Diver of Dead Waters',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'Pioneer Diver of Dead Waters',
    artifacts_9_app: 0.81,
    artifacts_9_round_moc: 6.67,
    artifacts_9_round_pf: 32710,
    artifacts_9_round_as: 3422,
    artifacts_10: 'SPD +6%, Flex',
    artifacts_10_1: 'SPD +6%',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 0.23,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 3460,
    planars_1: 'Broken Keel',
    planars_1_app: 48.58,
    planars_1_round_moc: 9.23,
    planars_1_round_pf: 34333,
    planars_1_round_as: 3399,
    planars_2: 'Inert Salsotto',
    planars_2_app: 26.28,
    planars_2_round_moc: 9.07,
    planars_2_round_pf: 33901,
    planars_2_round_as: 3410,
    planars_3: 'Belobog of the Architects',
    planars_3_app: 9.91,
    planars_3_round_moc: 9.29,
    planars_3_round_pf: 34612,
    planars_3_round_as: 3361,
    planars_4: 'Duran, Dynasty of Running Wolves',
    planars_4_app: 9.58,
    planars_4_round_moc: 9.05,
    planars_4_round_pf: 33639,
    planars_4_round_as: 3420,
    planars_5: 'Lushaka, the Sunken Seas',
    planars_5_app: 2.84,
    planars_5_round_moc: 8.64,
    planars_5_round_pf: 34233,
    planars_5_round_as: 3420,
    body_stats_1: 'DEF',
    body_stats_1_app: 51.63,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 43.58,
    body_stats_3: 'CRIT Rate',
    body_stats_3_app: 4.56,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 69.07,
    feet_stats_2: 'DEF',
    feet_stats_2_app: 30.7,
    feet_stats_3: 'ATK',
    feet_stats_3_app: 0.13,
    sphere_stats_1: 'DEF',
    sphere_stats_1_app: 80.21,
    sphere_stats_2: 'Imaginary DMG Boost',
    sphere_stats_2_app: 19.66,
    sphere_stats_3: 'HP',
    sphere_stats_3_app: 0.06,
    rope_stats_1: 'DEF',
    rope_stats_1_app: 94.07,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 5.76,
    rope_stats_3: 'ATK',
    rope_stats_3_app: 0.1,
    char_lvl: 79.99,
    light_cone_lvl: 79.84,
    attack_lvl: 5.05,
    skill_lvl: 9.96,
    ultimate_lvl: 9.81,
    talent_lvl: 9.93,
    max_hp: 3336.75,
    atk: 1380.87,
    dfns: 4409.32,
    speed: 134.37,
    crate: 30.32,
    cdmg: 125.25,
    dmg_boost: 21.3,
    heal_boost: 1,
    energy_regen: 1.28,
    effect_res: 28.4,
    effect_rate: 12.9,
    break_effect: 12.31,
    spd_sub: 9.1,
    hp_sub: 12.47,
    atk_sub: 12.27,
    def_sub: 27.5,
    crate_sub: 20.55,
    cdmg_sub: 47.0,
    res_sub: 13.33,
    ehr_sub: 9.14,
    break_sub: 12.31
  },
  {
    char: 'robin',
    app_rate_moc: 34.98,
    app_rate_moc_e0s1: 6.64,
    app_rate_moc_e1: 23.33,
    app_rate_moc_s0: 0.56,
    avg_round_moc: 9.04,
    avg_round_moc_e1: 6.65,
    avg_round_moc_s0: 9.35,
    sample_moc: 5268,
    sample_size_players_moc: 2642,
    app_rate_pf: 37.63,
    app_rate_pf_e0s1: 15.77,
    app_rate_pf_e1: 19.27,
    app_rate_pf_s0: 5.52,
    avg_round_pf: 34203,
    avg_round_pf_e1: 37834,
    avg_round_pf_s0: 34086,
    sample_pf: 5279,
    sample_size_players_pf: 2522,
    app_rate_as: 44.58,
    app_rate_as_e0s1: 19.88,
    app_rate_as_e1: 21.77,
    app_rate_as_s0: 7.42,
    avg_round_as: 3397,
    avg_round_as_e1: 3516,
    avg_round_as_s0: 3368,
    sample_as: 6917,
    sample_size_players_as: 3272,
    app_0: 62.44,
    round_0_moc: 8.37,
    round_0_pf: 34420,
    round_0_as: 3424,
    app_1: 29.71,
    round_1_moc: 5.71,
    round_1_pf: 38642,
    round_1_as: 3544,
    app_2: 5.83,
    round_2_moc: 3.74,
    round_2_pf: 39771,
    round_2_as: 3615,
    app_3: 0.34,
    round_3_moc: 4.38,
    round_3_pf: 38820,
    round_3_as: 3666,
    app_4: 0.17,
    round_4_moc: 4.4,
    round_4_pf: 37824,
    round_4_as: 3652,
    app_5: 0.04,
    round_5_moc: 4.33,
    round_5_pf: 36760,
    round_5_as: 3698,
    app_6: 1.47,
    round_6_moc: 1.27,
    round_6_pf: 40000,
    round_6_as: 3733,
    cons_avg: 0.52,
    weapons_1: "For Tomorrow's Journey",
    weapons_1_app: 39.67,
    weapons_1_round_moc: 9.24,
    weapons_1_round_pf: 33635,
    weapons_1_round_as: 3380,
    weapons_2: 'Flowing Nightglow',
    weapons_2_app: 39.51,
    weapons_2_round_moc: 8.92,
    weapons_2_round_pf: 34684,
    weapons_2_round_as: 3428,
    weapons_3: "But the Battle Isn't Over",
    weapons_3_app: 15.28,
    weapons_3_round_moc: 8.75,
    weapons_3_round_pf: 33883,
    weapons_3_round_as: 3410,
    weapons_4: 'Poised to Bloom',
    weapons_4_app: 3.45,
    weapons_4_round_moc: 9.0,
    weapons_4_round_pf: 35293,
    weapons_4_round_as: 3406,
    weapons_5: 'Carve the Moon, Weave the Clouds',
    weapons_5_app: 0.86,
    weapons_5_round_moc: 9.0,
    weapons_5_round_pf: 34370,
    weapons_5_round_as: 3385,
    weapons_6: 'Meshing Cogs',
    weapons_6_app: 0.32,
    weapons_6_round_moc: 8.0,
    weapons_6_round_pf: 37087,
    weapons_6_round_as: 3300,
    weapons_7: 'Past Self in Mirror',
    weapons_7_app: 0.23,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0,
    weapons_7_round_as: 0,
    weapons_8: 'Dreamville Adventure',
    weapons_8_app: 0.13,
    weapons_8_round_moc: 9.0,
    weapons_8_round_pf: 32260,
    weapons_8_round_as: 3418,
    weapons_9: 'Dance! Dance! Dance!',
    weapons_9_app: 0.12,
    weapons_9_round_moc: 10.0,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 3358,
    weapons_10: 'Earthly Escapade',
    weapons_10_app: 0.12,
    weapons_10_round_moc: 3.0,
    weapons_10_round_pf: 40000,
    weapons_10_round_as: 0,
    artifacts_1: 'ATK +12%, ATK +12%',
    artifacts_1_1: 'ATK +12%',
    artifacts_1_2: 'ATK +12%',
    artifacts_1_app: 82.05,
    artifacts_1_round_moc: 9.04,
    artifacts_1_round_pf: 33979,
    artifacts_1_round_as: 3398,
    artifacts_2: 'SPD +6%, ATK +12%',
    artifacts_2_1: 'SPD +6%',
    artifacts_2_2: 'ATK +12%',
    artifacts_2_app: 6.47,
    artifacts_2_round_moc: 9.42,
    artifacts_2_round_pf: 34283,
    artifacts_2_round_as: 3382,
    artifacts_3: 'ATK +12%, Hero of Triumphant Song',
    artifacts_3_1: 'ATK +12%',
    artifacts_3_2: 'Hero of Triumphant Song',
    artifacts_3_app: 3.7,
    artifacts_3_round_moc: 8.92,
    artifacts_3_round_pf: 36584,
    artifacts_3_round_as: 3434,
    artifacts_4: 'Musketeer of Wild Wheat',
    artifacts_4_1: 'Musketeer of Wild Wheat',
    artifacts_4_2: '',
    artifacts_4_app: 2.52,
    artifacts_4_round_moc: 9.15,
    artifacts_4_round_pf: 36156,
    artifacts_4_round_as: 3391,
    artifacts_5: 'ATK +12%, Flex',
    artifacts_5_1: 'ATK +12%',
    artifacts_5_2: 'Flex',
    artifacts_5_app: 1.68,
    artifacts_5_round_moc: 9.5,
    artifacts_5_round_pf: 34594,
    artifacts_5_round_as: 3390,
    artifacts_6: 'Champion of Streetwise Boxing',
    artifacts_6_1: 'Champion of Streetwise Boxing',
    artifacts_6_2: '',
    artifacts_6_app: 0.9,
    artifacts_6_round_moc: 9.29,
    artifacts_6_round_pf: 34738,
    artifacts_6_round_as: 3392,
    artifacts_7: 'Messenger Traversing Hackerspace',
    artifacts_7_1: 'Messenger Traversing Hackerspace',
    artifacts_7_2: '',
    artifacts_7_app: 0.44,
    artifacts_7_round_moc: 9.5,
    artifacts_7_round_pf: 31994,
    artifacts_7_round_as: 3326,
    artifacts_8: 'ATK +12%, Champion of Streetwise Boxing',
    artifacts_8_1: 'ATK +12%',
    artifacts_8_2: 'Champion of Streetwise Boxing',
    artifacts_8_app: 0.32,
    artifacts_8_round_moc: 7.67,
    artifacts_8_round_pf: 36328,
    artifacts_8_round_as: 3433,
    artifacts_9: 'ATK +12%, Pioneer Diver of Dead Waters',
    artifacts_9_1: 'ATK +12%',
    artifacts_9_2: 'Pioneer Diver of Dead Waters',
    artifacts_9_app: 0.24,
    artifacts_9_round_moc: 9.0,
    artifacts_9_round_pf: 28800,
    artifacts_9_round_as: 3407,
    artifacts_10: 'SPD +6%, SPD +6%',
    artifacts_10_1: 'SPD +6%',
    artifacts_10_2: 'SPD +6%',
    artifacts_10_app: 0.14,
    artifacts_10_round_moc: 7.0,
    artifacts_10_round_pf: 32120,
    artifacts_10_round_as: 0.0,
    planars_1: 'Sprightly Vonwacq',
    planars_1_app: 52.48,
    planars_1_round_moc: 8.93,
    planars_1_round_pf: 34240,
    planars_1_round_as: 3396,
    planars_2: 'Lushaka, the Sunken Seas',
    planars_2_app: 17.5,
    planars_2_round_moc: 8.76,
    planars_2_round_pf: 33932,
    planars_2_round_as: 3437,
    planars_3: 'Fleet of the Ageless',
    planars_3_app: 14.84,
    planars_3_round_moc: 9.43,
    planars_3_round_pf: 34258,
    planars_3_round_as: 3393,
    planars_4: 'Space Sealing Station',
    planars_4_app: 5.29,
    planars_4_round_moc: 9.15,
    planars_4_round_pf: 33041,
    planars_4_round_as: 3360,
    planars_5: 'Broken Keel',
    planars_5_app: 5.18,
    planars_5_round_moc: 9.81,
    planars_5_round_pf: 33384,
    planars_5_round_as: 3371,
    body_stats_1: 'ATK',
    body_stats_1_app: 99.57,
    body_stats_2: 'HP',
    body_stats_2_app: 0.11,
    body_stats_3: 'DEF',
    body_stats_3_app: 0.04,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 92.87,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 6.95,
    feet_stats_3: 'DEF',
    feet_stats_3_app: 0.03,
    sphere_stats_1: 'ATK',
    sphere_stats_1_app: 86.92,
    sphere_stats_2: 'Physical DMG Boost',
    sphere_stats_2_app: 11.71,
    sphere_stats_3: 'HP',
    sphere_stats_3_app: 0.92,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 96.84,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 2.86,
    rope_stats_3: 'Break Effect',
    rope_stats_3_app: 0.05,
    char_lvl: 79.99,
    light_cone_lvl: 79.84,
    attack_lvl: 3.54,
    skill_lvl: 10.01,
    ultimate_lvl: 10.04,
    talent_lvl: 9.96,
    max_hp: 3852.2,
    atk: 4201.32,
    dfns: 1134.32,
    speed: 124.54,
    crate: 12.62,
    cdmg: 66.2,
    dmg_boost: 4.69,
    heal_boost: 0.03,
    energy_regen: 23.97,
    effect_res: 16.1,
    effect_rate: 11.35,
    break_effect: 16.2,
    spd_sub: 17.18,
    hp_sub: 16.45,
    atk_sub: 28.47,
    def_sub: 19.07,
    crate_sub: 7.62,
    cdmg_sub: 16.51,
    res_sub: 15.58,
    ehr_sub: 11.35,
    break_sub: 16.87
  },
  {
    char: 'trailblazer-harmony',
    app_rate_moc: 15.28,
    app_rate_moc_e0s1: 2.18,
    app_rate_moc_e1: 11.44,
    app_rate_moc_s0: 0.39,
    avg_round_moc: 9.33,
    avg_round_moc_e1: 6.48,
    avg_round_moc_s0: 9.52,
    sample_moc: 2302,
    sample_size_players_moc: 107,
    app_rate_pf: 6.43,
    app_rate_pf_e0s1: 1.16,
    app_rate_pf_e1: 4.58,
    app_rate_pf_s0: 0.46,
    avg_round_pf: 26921,
    avg_round_pf_e1: 33992,
    avg_round_pf_s0: 25326,
    sample_pf: 902,
    sample_size_players_pf: 82,
    app_rate_as: 6.48,
    app_rate_as_e0s1: 1.26,
    app_rate_as_e1: 4.62,
    app_rate_as_s0: 0.54,
    avg_round_as: 3269,
    avg_round_as_e1: 3440,
    avg_round_as_s0: 3228,
    sample_as: 1005,
    sample_size_players_as: 84,
    app_0: 0.11,
    round_0_moc: 99.99,
    round_0_pf: 29800,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 2.36,
    round_2_moc: 8.46,
    round_2_pf: 29926,
    round_2_as: 3305,
    app_3: 1.09,
    round_3_moc: 8.45,
    round_3_pf: 25971,
    round_3_as: 3268,
    app_4: 2.66,
    round_4_moc: 8.78,
    round_4_pf: 29371,
    round_4_as: 3292,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 93.87,
    round_6_moc: 6.53,
    round_6_pf: 33673,
    round_6_as: 3441,
    cons_avg: 5.82,
    weapons_1: 'Dance! Dance! Dance!',
    weapons_1_app: 56.87,
    weapons_1_round_moc: 9.0,
    weapons_1_round_pf: 30878,
    weapons_1_round_as: 3249,
    weapons_2: 'Memories of the Past',
    weapons_2_app: 31.07,
    weapons_2_round_moc: 9.14,
    weapons_2_round_pf: 23731,
    weapons_2_round_as: 3241,
    weapons_3: 'Past Self in Mirror',
    weapons_3_app: 6.27,
    weapons_3_round_moc: 8.67,
    weapons_3_round_pf: 27000,
    weapons_3_round_as: 3113,
    weapons_4: 'Meshing Cogs',
    weapons_4_app: 3.28,
    weapons_4_round_moc: 10.0,
    weapons_4_round_pf: 24312,
    weapons_4_round_as: 3311,
    weapons_5: 'Dreamville Adventure',
    weapons_5_app: 0.48,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 26400,
    weapons_5_round_as: 3538,
    weapons_6: "But the Battle Isn't Over",
    weapons_6_app: 0.27,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0,
    weapons_6_round_as: 3253,
    weapons_7: 'Past and Future',
    weapons_7_app: 0.18,
    weapons_7_round_moc: 9.0,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: 'Poised to Bloom',
    weapons_8_app: 0.15,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 3242,
    weapons_9: 'Carve the Moon, Weave the Clouds',
    weapons_9_app: 0.15,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0,
    weapons_10: "For Tomorrow's Journey",
    weapons_10_app: 0.12,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 3147,
    artifacts_1: 'Watchmaker, Master of Dream Machinations',
    artifacts_1_1: 'Watchmaker, Master of Dream Machinations',
    artifacts_1_2: '',
    artifacts_1_app: 79.31,
    artifacts_1_round_moc: 9.14,
    artifacts_1_round_pf: 25611,
    artifacts_1_round_as: 3255,
    artifacts_2: 'Eagle of Twilight Line',
    artifacts_2_1: 'Eagle of Twilight Line',
    artifacts_2_2: '',
    artifacts_2_app: 8.22,
    artifacts_2_round_moc: 9.0,
    artifacts_2_round_pf: 40000,
    artifacts_2_round_as: 3171,
    artifacts_3: 'BE +16%, BE +16%',
    artifacts_3_1: 'BE +16%',
    artifacts_3_2: 'BE +16%',
    artifacts_3_app: 2.22,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 21760,
    artifacts_3_round_as: 3397,
    artifacts_4: 'SPD +6%, BE +16%',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'BE +16%',
    artifacts_4_app: 1.98,
    artifacts_4_round_moc: 5.0,
    artifacts_4_round_pf: 34840,
    artifacts_4_round_as: 0,
    artifacts_5: 'Thief of Shooting Meteor',
    artifacts_5_1: 'Thief of Shooting Meteor',
    artifacts_5_2: '',
    artifacts_5_app: 1.73,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 24040,
    artifacts_5_round_as: 0,
    artifacts_6: 'BE +16%, Flex',
    artifacts_6_1: 'BE +16%',
    artifacts_6_2: 'Flex',
    artifacts_6_app: 1.4,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0,
    artifacts_7: 'Iron Cavalry Against the Scourge',
    artifacts_7_1: 'Iron Cavalry Against the Scourge',
    artifacts_7_2: '',
    artifacts_7_app: 1.31,
    artifacts_7_round_moc: 8.0,
    artifacts_7_round_pf: 0,
    artifacts_7_round_as: 0,
    artifacts_8: 'Messenger Traversing Hackerspace',
    artifacts_8_1: 'Messenger Traversing Hackerspace',
    artifacts_8_2: '',
    artifacts_8_app: 1.27,
    artifacts_8_round_moc: 10.0,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 3279,
    artifacts_9: 'SPD +6%, Flex',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 0.58,
    artifacts_9_round_moc: 10.0,
    artifacts_9_round_pf: 0,
    artifacts_9_round_as: 0,
    artifacts_10: 'Eagle of Twilight Line, Flex',
    artifacts_10_1: 'Eagle of Twilight Line',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 0.4,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Talia: Kingdom of Banditry',
    planars_1_app: 53.87,
    planars_1_round_moc: 9.44,
    planars_1_round_pf: 25149,
    planars_1_round_as: 3283,
    planars_2: 'Forge of the Kalpagni Lantern',
    planars_2_app: 26.35,
    planars_2_round_moc: 8.67,
    planars_2_round_pf: 26780,
    planars_2_round_as: 3273,
    planars_3: 'Sprightly Vonwacq',
    planars_3_app: 12.39,
    planars_3_round_moc: 9.0,
    planars_3_round_pf: 40000,
    planars_3_round_as: 3254,
    planars_4: 'Lushaka, the Sunken Seas',
    planars_4_app: 1.89,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 0,
    planars_5: 'Penacony, Land of the Dreams',
    planars_5_app: 1.79,
    planars_5_round_moc: 9.0,
    planars_5_round_pf: 32240,
    planars_5_round_as: 0,
    body_stats_1: 'HP',
    body_stats_1_app: 50.84,
    body_stats_2: 'DEF',
    body_stats_2_app: 31.25,
    body_stats_3: 'ATK',
    body_stats_3_app: 11.87,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 99.72,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 0.27,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 43.49,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 26.75,
    sphere_stats_3: 'ATK',
    sphere_stats_3_app: 7.34,
    rope_stats_1: 'Break Effect',
    rope_stats_1_app: 62.62,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 37.38,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 78.39,
    attack_lvl: 4.65,
    skill_lvl: 9.59,
    ultimate_lvl: 11.77,
    talent_lvl: 11.74,
    max_hp: 3915.53,
    atk: 1427.56,
    dfns: 1659.45,
    speed: 152.42,
    crate: 10.91,
    cdmg: 64.42,
    dmg_boost: 13.96,
    heal_boost: 1,
    energy_regen: 8.27,
    effect_res: 22.14,
    effect_rate: 10.74,
    break_effect: 183.63,
    spd_sub: 20.78,
    hp_sub: 12.29,
    atk_sub: 13.3,
    def_sub: 15.97,
    crate_sub: 5.69,
    cdmg_sub: 12.51,
    res_sub: 12.27,
    ehr_sub: 10.74,
    break_sub: 65.4
  },
  {
    char: 'boothill',
    app_rate_moc: 2.2,
    app_rate_moc_e0s1: 0.3,
    app_rate_moc_e1: 1.6,
    app_rate_moc_s0: 0.03,
    avg_round_moc: 9.22,
    avg_round_moc_e1: 7.26,
    avg_round_moc_s0: 99.99,
    sample_moc: 332,
    sample_size_players_moc: 245,
    app_rate_pf: 0.15,
    app_rate_pf_e0s1: 0.01,
    app_rate_pf_e1: 0.06,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 21,
    sample_size_players_pf: 13,
    app_rate_as: 5.12,
    app_rate_as_e0s1: 1.66,
    app_rate_as_e1: 3.18,
    app_rate_as_s0: 0.45,
    avg_round_as: 3442,
    avg_round_as_e1: 3575,
    avg_round_as_s0: 3415,
    sample_as: 795,
    sample_size_players_as: 521,
    app_0: 77.03,
    round_0_moc: 8.26,
    round_0_pf: 26080,
    round_0_as: 3512,
    app_1: 10.65,
    round_1_moc: 6.98,
    round_1_pf: 27540,
    round_1_as: 3602,
    app_2: 6.2,
    round_2_moc: 5.75,
    round_2_pf: 31880,
    round_2_as: 3679,
    app_3: 0.8,
    round_3_moc: 8.0,
    round_3_pf: 0,
    round_3_as: 3548,
    app_4: 0.18,
    round_4_moc: 3.0,
    round_4_pf: 0,
    round_4_as: 3650,
    app_5: 0.13,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 3725,
    app_6: 5.07,
    round_6_moc: 4.91,
    round_6_pf: 33560,
    round_6_as: 3711,
    cons_avg: 0.57,
    weapons_1: 'Sailing Towards A Second Life',
    weapons_1_app: 80.82,
    weapons_1_round_moc: 9.11,
    weapons_1_round_pf: 24940,
    weapons_1_round_as: 3455,
    weapons_2: 'Shadowed By Night',
    weapons_2_app: 15.28,
    weapons_2_round_moc: 9.2,
    weapons_2_round_pf: 0,
    weapons_2_round_as: 3414,
    weapons_3: 'Cruising in the Stellar Sea',
    weapons_3_app: 0.99,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 3384,
    weapons_4: 'River Flows in Spring',
    weapons_4_app: 0.91,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0,
    weapons_4_round_as: 3518,
    weapons_5: 'Adversarial',
    weapons_5_app: 0.81,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 3410,
    weapons_6: 'Sleep Like the Dead',
    weapons_6_app: 0.36,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 3457,
    weapons_7: 'In the Night',
    weapons_7_app: 0.36,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 3179,
    weapons_8: 'Subscribe for More!',
    weapons_8_app: 0.18,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0,
    weapons_9: 'Swordplay',
    weapons_9_app: 0.18,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 3385,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_2: '',
    artifacts_1_app: 67.47,
    artifacts_1_round_moc: 8.75,
    artifacts_1_round_pf: 24940,
    artifacts_1_round_as: 3444,
    artifacts_2: 'BE +16%, BE +16%',
    artifacts_2_1: 'BE +16%',
    artifacts_2_2: 'BE +16%',
    artifacts_2_app: 9.78,
    artifacts_2_round_moc: 9.67,
    artifacts_2_round_pf: 0,
    artifacts_2_round_as: 3420,
    artifacts_3: 'Thief of Shooting Meteor',
    artifacts_3_1: 'Thief of Shooting Meteor',
    artifacts_3_2: '',
    artifacts_3_app: 9.18,
    artifacts_3_round_moc: 9.5,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 3393,
    artifacts_4: 'Eagle of Twilight Line',
    artifacts_4_1: 'Eagle of Twilight Line',
    artifacts_4_2: '',
    artifacts_4_app: 5.25,
    artifacts_4_round_moc: 9.67,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 3582,
    artifacts_5: 'SPD +6%, BE +16%',
    artifacts_5_1: 'SPD +6%',
    artifacts_5_2: 'BE +16%',
    artifacts_5_app: 3.08,
    artifacts_5_round_moc: 10.0,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 3461,
    artifacts_6: 'BE +16%, Flex',
    artifacts_6_1: 'BE +16%',
    artifacts_6_2: 'Flex',
    artifacts_6_app: 1.54,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 3333,
    artifacts_7: 'Eagle of Twilight Line, Flex',
    artifacts_7_1: 'Eagle of Twilight Line',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 0.27,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 3680,
    artifacts_8: 'BE +16%, Champion of Streetwise Boxing',
    artifacts_8_1: 'BE +16%',
    artifacts_8_2: 'Champion of Streetwise Boxing',
    artifacts_8_app: 0.27,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 3501,
    artifacts_9: 'SPD +6%, Flex',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 0.27,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 3264,
    artifacts_10: 'BE +16%, Pioneer Diver of Dead Waters',
    artifacts_10_1: 'BE +16%',
    artifacts_10_2: 'Pioneer Diver of Dead Waters',
    artifacts_10_app: 0.27,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0,
    planars_1: 'Talia: Kingdom of Banditry',
    planars_1_app: 90.39,
    planars_1_round_moc: 9.1,
    planars_1_round_pf: 24940,
    planars_1_round_as: 3443,
    planars_2: 'Forge of the Kalpagni Lantern',
    planars_2_app: 6.79,
    planars_2_round_moc: 9.0,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 3410,
    planars_3: 'Firmament Frontline: Glamoth',
    planars_3_app: 0.37,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0,
    planars_3_round_as: 0,
    planars_4: 'Rutilant Arena',
    planars_4_app: 0.27,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0,
    planars_5: 'Lushaka, the Sunken Seas',
    planars_5_app: 0.09,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 44.29,
    body_stats_2: 'HP',
    body_stats_2_app: 18.72,
    body_stats_3: 'ATK',
    body_stats_3_app: 13.07,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 98.08,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 0.38,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Physical DMG Boost',
    sphere_stats_1_app: 36.56,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 22.28,
    sphere_stats_3: 'DEF',
    sphere_stats_3_app: 16.21,
    rope_stats_1: 'Break Effect',
    rope_stats_1_app: 98.24,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 0.74,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 79.82,
    attack_lvl: 5.73,
    skill_lvl: 10.04,
    ultimate_lvl: 9.86,
    talent_lvl: 10.1,
    max_hp: 3612.36,
    atk: 2125.32,
    dfns: 1120.53,
    speed: 152.51,
    crate: 28.41,
    cdmg: 66.77,
    dmg_boost: 14.19,
    heal_boost: 0.36,
    energy_regen: 0.06,
    effect_res: 8.1,
    effect_rate: 7.69,
    break_effect: 269.38,
    spd_sub: 19.8,
    hp_sub: 11.44,
    atk_sub: 13.31,
    def_sub: 14.32,
    crate_sub: 8.8,
    cdmg_sub: 14.99,
    res_sub: 8.1,
    ehr_sub: 7.69,
    break_sub: 75.18
  },
  {
    char: 'firefly',
    app_rate_moc: 29.45,
    app_rate_moc_e0s1: 3.13,
    app_rate_moc_e1: 22.46,
    app_rate_moc_s0: 0.39,
    avg_round_moc: 9.58,
    avg_round_moc_e1: 6.71,
    avg_round_moc_s0: 9.94,
    sample_moc: 4436,
    sample_size_players_moc: 3466,
    app_rate_pf: 12.15,
    app_rate_pf_e0s1: 0.82,
    app_rate_pf_e1: 9.39,
    app_rate_pf_s0: 0.25,
    avg_round_pf: 24649,
    avg_round_pf_e1: 33393,
    avg_round_pf_s0: 23712,
    sample_pf: 1704,
    sample_size_players_pf: 1442,
    app_rate_as: 17.49,
    app_rate_as_e0s1: 2.06,
    app_rate_as_e1: 13.29,
    app_rate_as_s0: 0.82,
    avg_round_as: 3243,
    avg_round_as_e1: 3457,
    avg_round_as_s0: 3227,
    sample_as: 2714,
    sample_size_players_as: 2093,
    app_0: 25.39,
    round_0_moc: 9.21,
    round_0_pf: 25792,
    round_0_as: 3271,
    app_1: 13.86,
    round_1_moc: 8.52,
    round_1_pf: 28802,
    round_1_as: 3356,
    app_2: 51.04,
    round_2_moc: 5.6,
    round_2_pf: 35252,
    round_2_as: 3536,
    app_3: 1.51,
    round_3_moc: 5.41,
    round_3_pf: 38017,
    round_3_as: 3562,
    app_4: 0.32,
    round_4_moc: 6.0,
    round_4_pf: 34911,
    round_4_as: 3510,
    app_5: 0.12,
    round_5_moc: 5.8,
    round_5_pf: 36020,
    round_5_as: 3690,
    app_6: 7.75,
    round_6_moc: 3.12,
    round_6_pf: 40000,
    round_6_as: 3740,
    cons_avg: 1.69,
    weapons_1: 'Whereabouts Should Dreams Rest',
    weapons_1_app: 72.38,
    weapons_1_round_moc: 9.52,
    weapons_1_round_pf: 24846,
    weapons_1_round_as: 3255,
    weapons_2: 'On the Fall of an Aeon',
    weapons_2_app: 25.32,
    weapons_2_round_moc: 9.62,
    weapons_2_round_pf: 24432,
    weapons_2_round_as: 3237,
    weapons_3: 'Indelible Promise',
    weapons_3_app: 1.36,
    weapons_3_round_moc: 9.38,
    weapons_3_round_pf: 24360,
    weapons_3_round_as: 3184,
    weapons_4: 'Something Irreplaceable',
    weapons_4_app: 0.19,
    weapons_4_round_moc: 9.5,
    weapons_4_round_pf: 24460,
    weapons_4_round_as: 3200,
    weapons_5: 'Under the Blue Sky',
    weapons_5_app: 0.16,
    weapons_5_round_moc: 10.0,
    weapons_5_round_pf: 0,
    weapons_5_round_as: 0,
    weapons_6: 'A Secret Vow',
    weapons_6_app: 0.08,
    weapons_6_round_moc: 10.0,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 3172,
    weapons_7: 'The Moles Welcome You',
    weapons_7_app: 0.07,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0,
    weapons_7_round_as: 0,
    weapons_8: 'Woof! Walk Time!',
    weapons_8_app: 0.06,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 3279,
    weapons_9: 'Ninja Record: Sound Hunt',
    weapons_9_app: 0.05,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0,
    weapons_10: 'Flames Afar',
    weapons_10_app: 0.04,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0,
    artifacts_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_2: '',
    artifacts_1_app: 98.65,
    artifacts_1_round_moc: 9.57,
    artifacts_1_round_pf: 24615,
    artifacts_1_round_as: 3244,
    artifacts_2: 'BE +16%, Flex',
    artifacts_2_1: 'BE +16%',
    artifacts_2_2: 'Flex',
    artifacts_2_app: 0.38,
    artifacts_2_round_moc: 9.67,
    artifacts_2_round_pf: 0,
    artifacts_2_round_as: 3230,
    artifacts_3: 'BE +16%, BE +16%',
    artifacts_3_1: 'BE +16%',
    artifacts_3_2: 'BE +16%',
    artifacts_3_app: 0.13,
    artifacts_3_round_moc: 10.0,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 3185,
    artifacts_4: 'Thief of Shooting Meteor',
    artifacts_4_1: 'Thief of Shooting Meteor',
    artifacts_4_2: '',
    artifacts_4_app: 0.13,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 3298,
    artifacts_5: 'SPD +6%, BE +16%',
    artifacts_5_1: 'SPD +6%',
    artifacts_5_2: 'BE +16%',
    artifacts_5_app: 0.07,
    artifacts_5_round_moc: 6.0,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0.0,
    artifacts_6: 'Genius of Brilliant Stars',
    artifacts_6_1: 'Genius of Brilliant Stars',
    artifacts_6_2: '',
    artifacts_6_app: 0.03,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0,
    artifacts_7: 'ATK +12%, Scholar Lost in Erudition',
    artifacts_7_1: 'ATK +12%',
    artifacts_7_2: 'Scholar Lost in Erudition',
    artifacts_7_app: 0.02,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0,
    artifacts_7_round_as: 0,
    artifacts_8: 'BE +16%, Pioneer Diver of Dead Waters',
    artifacts_8_1: 'BE +16%',
    artifacts_8_2: 'Pioneer Diver of Dead Waters',
    artifacts_8_app: 0.01,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: 'The Ashblazing Grand Duke',
    artifacts_9_1: 'The Ashblazing Grand Duke',
    artifacts_9_2: '',
    artifacts_9_app: 0.01,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: 'The Ashblazing Grand Duke, Flex',
    artifacts_10_1: 'The Ashblazing Grand Duke',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 0.01,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Forge of the Kalpagni Lantern',
    planars_1_app: 98.94,
    planars_1_round_moc: 9.57,
    planars_1_round_pf: 24615,
    planars_1_round_as: 3243,
    planars_2: 'Talia: Kingdom of Banditry',
    planars_2_app: 0.46,
    planars_2_round_moc: 9.25,
    planars_2_round_pf: 0,
    planars_2_round_as: 3250,
    planars_3: 'Firmament Frontline: Glamoth',
    planars_3_app: 0.03,
    planars_3_round_moc: 9.5,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: 'Inert Salsotto',
    planars_4_app: 0.03,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0,
    planars_5: 'Lushaka, the Sunken Seas',
    planars_5_app: 0.02,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'ATK',
    body_stats_1_app: 99.03,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 0.25,
    body_stats_3: 'DEF',
    body_stats_3_app: 0.03,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 96.45,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 3.05,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'ATK',
    sphere_stats_1_app: 97.2,
    sphere_stats_2: 'Fire DMG Boost',
    sphere_stats_2_app: 2.37,
    sphere_stats_3: 'HP',
    sphere_stats_3_app: 0.03,
    rope_stats_1: 'Break Effect',
    rope_stats_1_app: 99.25,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 0.52,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 79.95,
    attack_lvl: 5.08,
    skill_lvl: 10.2,
    ultimate_lvl: 10.18,
    talent_lvl: 10.03,
    max_hp: 2997.54,
    atk: 2504.99,
    dfns: 1512.54,
    speed: 156.91,
    crate: 10.44,
    cdmg: 61.02,
    dmg_boost: 0.92,
    heal_boost: 0.01,
    energy_regen: 0.01,
    effect_res: 28.11,
    effect_rate: 8.12,
    break_effect: 242.07,
    spd_sub: 17.57,
    hp_sub: 12.49,
    atk_sub: 20.48,
    def_sub: 14.65,
    crate_sub: 5.44,
    cdmg_sub: 11.02,
    res_sub: 9.58,
    ehr_sub: 8.12,
    break_sub: 77.09
  },
  {
    char: 'jade',
    app_rate_moc: 20.84,
    app_rate_moc_e0s1: 5.74,
    app_rate_moc_e1: 12.71,
    app_rate_moc_s0: 1.01,
    avg_round_moc: 8.91,
    avg_round_moc_e1: 6.85,
    avg_round_moc_s0: 9.53,
    sample_moc: 3138,
    sample_size_players_moc: 1316,
    app_rate_pf: 22.7,
    app_rate_pf_e0s1: 11.68,
    app_rate_pf_e1: 9.94,
    app_rate_pf_s0: 4.63,
    avg_round_pf: 39727,
    avg_round_pf_e1: 40000,
    avg_round_pf_s0: 39274,
    sample_pf: 3185,
    sample_size_players_pf: 1380,
    app_rate_as: 19.41,
    app_rate_as_e0s1: 9.61,
    app_rate_as_e1: 8.75,
    app_rate_as_s0: 3.24,
    avg_round_as: 3473,
    avg_round_as_e1: 3575,
    avg_round_as_s0: 3429,
    sample_as: 3011,
    sample_size_players_as: 1263,
    app_0: 82.72,
    round_0_moc: 7.89,
    round_0_pf: 39915,
    round_0_as: 3514,
    app_1: 14.23,
    round_1_moc: 5.79,
    round_1_pf: 40000,
    round_1_as: 3605,
    app_2: 1.8,
    round_2_moc: 4.93,
    round_2_pf: 40000,
    round_2_as: 3660,
    app_3: 0.08,
    round_3_moc: 4.0,
    round_3_pf: 33280,
    round_3_as: 3383,
    app_4: 0.1,
    round_4_moc: 4.5,
    round_4_pf: 38520,
    round_4_as: 3726,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 1.08,
    round_6_moc: 0.71,
    round_6_pf: 40000,
    round_6_as: 3804,
    cons_avg: 0.25,
    weapons_1: 'Yet Hope Is Priceless',
    weapons_1_app: 32.76,
    weapons_1_round_moc: 8.57,
    weapons_1_round_pf: 39780,
    weapons_1_round_as: 3500,
    weapons_2: 'Eternal Calculus',
    weapons_2_app: 15.85,
    weapons_2_round_moc: 8.93,
    weapons_2_round_pf: 39248,
    weapons_2_round_as: 3446,
    weapons_3: 'Night on the Milky Way',
    weapons_3_app: 15.47,
    weapons_3_round_moc: 8.67,
    weapons_3_round_pf: 39751,
    weapons_3_round_as: 3477,
    weapons_4: 'Today Is Another Peaceful Day',
    weapons_4_app: 13.57,
    weapons_4_round_moc: 8.44,
    weapons_4_round_pf: 39937,
    weapons_4_round_as: 3520,
    weapons_5: "Geniuses' Repose",
    weapons_5_app: 9.19,
    weapons_5_round_moc: 9.12,
    weapons_5_round_pf: 39530,
    weapons_5_round_as: 3426,
    weapons_6: 'Before Dawn',
    weapons_6_app: 4.09,
    weapons_6_round_moc: 8.0,
    weapons_6_round_pf: 39823,
    weapons_6_round_as: 3490,
    weapons_7: 'The Seriousness of Breakfast',
    weapons_7_app: 3.41,
    weapons_7_round_moc: 8.68,
    weapons_7_round_pf: 40000,
    weapons_7_round_as: 3442,
    weapons_8: 'The Birth of the Self',
    weapons_8_app: 3.08,
    weapons_8_round_moc: 9.47,
    weapons_8_round_pf: 39117,
    weapons_8_round_as: 3426,
    weapons_9: 'The Day The Cosmos Fell',
    weapons_9_app: 1.44,
    weapons_9_round_moc: 9.44,
    weapons_9_round_pf: 38492,
    weapons_9_round_as: 3438,
    weapons_10: 'Make the World Clamor',
    weapons_10_app: 0.18,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 37093,
    weapons_10_round_as: 3467,
    artifacts_1: 'The Ashblazing Grand Duke',
    artifacts_1_1: 'The Ashblazing Grand Duke',
    artifacts_1_2: '',
    artifacts_1_app: 50.06,
    artifacts_1_round_moc: 8.9,
    artifacts_1_round_pf: 39674,
    artifacts_1_round_as: 3466,
    artifacts_2: 'Genius of Brilliant Stars',
    artifacts_2_1: 'Genius of Brilliant Stars',
    artifacts_2_2: '',
    artifacts_2_app: 20.35,
    artifacts_2_round_moc: 9.04,
    artifacts_2_round_pf: 39643,
    artifacts_2_round_as: 3469,
    artifacts_3: 'Poet of Mourning Collapse',
    artifacts_3_1: 'Poet of Mourning Collapse',
    artifacts_3_2: '',
    artifacts_3_app: 19.63,
    artifacts_3_round_moc: 8.63,
    artifacts_3_round_pf: 39798,
    artifacts_3_round_as: 3484,
    artifacts_4: 'The Wind-Soaring Valorous',
    artifacts_4_1: 'The Wind-Soaring Valorous',
    artifacts_4_2: '',
    artifacts_4_app: 3.8,
    artifacts_4_round_moc: 8.46,
    artifacts_4_round_pf: 38412,
    artifacts_4_round_as: 3450,
    artifacts_5: 'Quan. +10%, The Ashblazing Grand Duke',
    artifacts_5_1: 'Quan. +10%',
    artifacts_5_2: 'The Ashblazing Grand Duke',
    artifacts_5_app: 1.69,
    artifacts_5_round_moc: 8.43,
    artifacts_5_round_pf: 39655,
    artifacts_5_round_as: 3464,
    artifacts_6: 'ATK +12%, The Ashblazing Grand Duke',
    artifacts_6_1: 'ATK +12%',
    artifacts_6_2: 'The Ashblazing Grand Duke',
    artifacts_6_app: 1.33,
    artifacts_6_round_moc: 7.88,
    artifacts_6_round_pf: 39764,
    artifacts_6_round_as: 3551,
    artifacts_7: 'The Ashblazing Grand Duke, Flex',
    artifacts_7_1: 'The Ashblazing Grand Duke',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 0.58,
    artifacts_7_round_moc: 7.75,
    artifacts_7_round_pf: 39787,
    artifacts_7_round_as: 3537,
    artifacts_8: 'Scholar Lost in Erudition, The Ashblazing Grand Duke',
    artifacts_8_1: 'Scholar Lost in Erudition',
    artifacts_8_2: 'The Ashblazing Grand Duke',
    artifacts_8_app: 0.45,
    artifacts_8_round_moc: 8.0,
    artifacts_8_round_pf: 39110,
    artifacts_8_round_as: 3535,
    artifacts_9: 'Quan. +10%, Flex',
    artifacts_9_1: 'Quan. +10%',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 0.33,
    artifacts_9_round_moc: 8.25,
    artifacts_9_round_pf: 39560,
    artifacts_9_round_as: 3636,
    artifacts_10: 'Quan. +10%, ATK +12%',
    artifacts_10_1: 'Quan. +10%',
    artifacts_10_2: 'ATK +12%',
    artifacts_10_app: 0.33,
    artifacts_10_round_moc: 9.5,
    artifacts_10_round_pf: 40000,
    artifacts_10_round_as: 3529,
    planars_1: 'Duran, Dynasty of Running Wolves',
    planars_1_app: 54.22,
    planars_1_round_moc: 9.02,
    planars_1_round_pf: 39497,
    planars_1_round_as: 3463,
    planars_2: 'Izumo Gensei and Takama Divine Realm',
    planars_2_app: 17.3,
    planars_2_round_moc: 8.59,
    planars_2_round_pf: 40000,
    planars_2_round_as: 3476,
    planars_3: 'Inert Salsotto',
    planars_3_app: 16.08,
    planars_3_round_moc: 8.52,
    planars_3_round_pf: 39690,
    planars_3_round_as: 3515,
    planars_4: 'Sigonia, the Unclaimed Desolation',
    planars_4_app: 9.96,
    planars_4_round_moc: 8.78,
    planars_4_round_pf: 39471,
    planars_4_round_as: 3445,
    planars_5: 'Rutilant Arena',
    planars_5_app: 0.72,
    planars_5_round_moc: 8.75,
    planars_5_round_pf: 39980,
    planars_5_round_as: 3448,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 78.69,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 20.81,
    body_stats_3: 'ATK',
    body_stats_3_app: 0.5,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 87.16,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 12.69,
    feet_stats_3: 'HP',
    feet_stats_3_app: 0.15,
    sphere_stats_1: 'Quantum DMG Boost',
    sphere_stats_1_app: 89.8,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 9.73,
    sphere_stats_3: 'DEF',
    sphere_stats_3_app: 0.1,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 96.13,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 3.48,
    rope_stats_3: 'Break Effect',
    rope_stats_3_app: 0.12,
    char_lvl: 79.99,
    light_cone_lvl: 79.78,
    attack_lvl: 5.49,
    skill_lvl: 9.68,
    ultimate_lvl: 9.82,
    talent_lvl: 9.96,
    max_hp: 3094.02,
    atk: 3124.12,
    dfns: 1136.2,
    speed: 106.5,
    crate: 71.64,
    cdmg: 130.85,
    dmg_boost: 61.7,
    heal_boost: 1,
    energy_regen: 0.68,
    effect_res: 17.97,
    effect_rate: 7.78,
    break_effect: 12.74,
    spd_sub: 2.49,
    hp_sub: 11.38,
    atk_sub: 16.08,
    def_sub: 13.15,
    crate_sub: 31.8,
    cdmg_sub: 66.01,
    res_sub: 7.94,
    ehr_sub: 7.78,
    break_sub: 12.74
  },
  {
    char: 'yunli',
    app_rate_moc: 2.34,
    app_rate_moc_e0s1: 0.35,
    app_rate_moc_e1: 1.53,
    app_rate_moc_s0: 0.02,
    avg_round_moc: 9.38,
    avg_round_moc_e1: 7.74,
    avg_round_moc_s0: 99.99,
    sample_moc: 352,
    sample_size_players_moc: 258,
    app_rate_pf: 3.66,
    app_rate_pf_e0s1: 1.5,
    app_rate_pf_e1: 1.85,
    app_rate_pf_s0: 0.31,
    avg_round_pf: 24955,
    avg_round_pf_e1: 30919,
    avg_round_pf_s0: 24056,
    sample_pf: 514,
    sample_size_players_pf: 330,
    app_rate_as: 4.83,
    app_rate_as_e0s1: 1.68,
    app_rate_as_e1: 2.76,
    app_rate_as_s0: 0.35,
    avg_round_as: 3273,
    avg_round_as_e1: 3399,
    avg_round_as_s0: 3238,
    sample_as: 749,
    sample_size_players_as: 483,
    app_0: 72.84,
    round_0_moc: 8.52,
    round_0_pf: 26170,
    round_0_as: 3329,
    app_1: 16.18,
    round_1_moc: 6.21,
    round_1_pf: 32846,
    round_1_as: 3465,
    app_2: 6.34,
    round_2_moc: 4.43,
    round_2_pf: 36909,
    round_2_as: 3536,
    app_3: 1.41,
    round_3_moc: 6.22,
    round_3_pf: 33190,
    round_3_as: 3413,
    app_4: 0.18,
    round_4_moc: 4.0,
    round_4_pf: 40000,
    round_4_as: 3718,
    app_5: 0.13,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 3351,
    app_6: 2.98,
    round_6_moc: 2.87,
    round_6_pf: 40000,
    round_6_as: 3666,
    cons_avg: 0.52,
    weapons_1: 'Dance at Sunset',
    weapons_1_app: 91.12,
    weapons_1_round_moc: 9.17,
    weapons_1_round_pf: 25150,
    weapons_1_round_as: 3301,
    weapons_2: 'Something Irreplaceable',
    weapons_2_app: 3.85,
    weapons_2_round_moc: 9.67,
    weapons_2_round_pf: 24108,
    weapons_2_round_as: 3245,
    weapons_3: 'On the Fall of an Aeon',
    weapons_3_app: 3.17,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 24160,
    weapons_3_round_as: 3208,
    weapons_4: 'The Unreachable Side',
    weapons_4_app: 0.73,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 21880,
    weapons_4_round_as: 3219,
    weapons_5: 'Under the Blue Sky',
    weapons_5_app: 0.38,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 26200,
    weapons_5_round_as: 3552,
    weapons_6: 'Brighter Than the Sun',
    weapons_6_app: 0.28,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 21520,
    weapons_6_round_as: 0,
    weapons_7: 'Ninja Record: Sound Hunt',
    weapons_7_app: 0.28,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0,
    weapons_7_round_as: 3150,
    weapons_8: 'Indelible Promise',
    weapons_8_app: 0.1,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 24080,
    weapons_8_round_as: 0.0,
    weapons_9: 'I Shall Be My Own Sword',
    weapons_9_app: 0.1,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 24880,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'The Wind-Soaring Valorous',
    artifacts_1_1: 'The Wind-Soaring Valorous',
    artifacts_1_2: '',
    artifacts_1_app: 93.34,
    artifacts_1_round_moc: 9.37,
    artifacts_1_round_pf: 24742,
    artifacts_1_round_as: 3291,
    artifacts_2: 'The Ashblazing Grand Duke',
    artifacts_2_1: 'The Ashblazing Grand Duke',
    artifacts_2_2: '',
    artifacts_2_app: 2.71,
    artifacts_2_round_moc: 8.0,
    artifacts_2_round_pf: 32420,
    artifacts_2_round_as: 3294,
    artifacts_3: 'Poet of Mourning Collapse',
    artifacts_3_1: 'Poet of Mourning Collapse',
    artifacts_3_2: '',
    artifacts_3_app: 1.08,
    artifacts_3_round_moc: 5.0,
    artifacts_3_round_pf: 27720,
    artifacts_3_round_as: 3368,
    artifacts_4: 'ATK +12%, Flex',
    artifacts_4_1: 'ATK +12%',
    artifacts_4_2: 'Flex',
    artifacts_4_app: 0.47,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 26420,
    artifacts_4_round_as: 0,
    artifacts_5: 'Eagle of Twilight Line',
    artifacts_5_1: 'Eagle of Twilight Line',
    artifacts_5_2: '',
    artifacts_5_app: 0.36,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 24920,
    artifacts_5_round_as: 3087,
    artifacts_6: 'Quan. +10%, Pioneer Diver of Dead Waters',
    artifacts_6_1: 'Quan. +10%',
    artifacts_6_2: 'Pioneer Diver of Dead Waters',
    artifacts_6_app: 0.27,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 0,
    artifacts_7: 'Champion of Streetwise Boxing',
    artifacts_7_1: 'Champion of Streetwise Boxing',
    artifacts_7_2: '',
    artifacts_7_app: 0.27,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0,
    artifacts_7_round_as: 0,
    artifacts_8: 'Genius of Brilliant Stars',
    artifacts_8_1: 'Genius of Brilliant Stars',
    artifacts_8_2: '',
    artifacts_8_app: 0.27,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 0,
    artifacts_9: 'Champion of Streetwise Boxing, The Ashblazing Grand Duke',
    artifacts_9_1: 'Champion of Streetwise Boxing',
    artifacts_9_2: 'The Ashblazing Grand Duke',
    artifacts_9_app: 0.26,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 3202,
    artifacts_10: 'Longevous Disciple',
    artifacts_10_1: 'Longevous Disciple',
    artifacts_10_2: '',
    artifacts_10_app: 0.19,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 24880,
    artifacts_10_round_as: 0,
    planars_1: 'Duran, Dynasty of Running Wolves',
    planars_1_app: 73.46,
    planars_1_round_moc: 9.12,
    planars_1_round_pf: 24871,
    planars_1_round_as: 3306,
    planars_2: 'Inert Salsotto',
    planars_2_app: 24.83,
    planars_2_round_moc: 9.75,
    planars_2_round_pf: 24885,
    planars_2_round_as: 3246,
    planars_3: 'Sigonia, the Unclaimed Desolation',
    planars_3_app: 0.36,
    planars_3_round_moc: 8.0,
    planars_3_round_pf: 27680,
    planars_3_round_as: 3463,
    planars_4: 'Rutilant Arena',
    planars_4_app: 0.29,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 23400,
    planars_4_round_as: 0.0,
    planars_5: 'Izumo Gensei and Takama Divine Realm',
    planars_5_app: 0.09,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 83.96,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 14.55,
    body_stats_3: 'ATK',
    body_stats_3_app: 0.94,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 97.5,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 1.78,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Physical DMG Boost',
    sphere_stats_1_app: 89.89,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 9.84,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 90.04,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 9.5,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 79.99,
    light_cone_lvl: 79.82,
    attack_lvl: 4.76,
    skill_lvl: 9.84,
    ultimate_lvl: 10.11,
    talent_lvl: 9.97,
    max_hp: 3878.59,
    atk: 3443.52,
    dfns: 1080.77,
    speed: 96.2,
    crate: 83.02,
    cdmg: 167.63,
    dmg_boost: 34.98,
    heal_boost: 1,
    energy_regen: 1.85,
    effect_res: 7.78,
    effect_rate: 7.34,
    break_effect: 11.24,
    spd_sub: 2.2,
    hp_sub: 10.39,
    atk_sub: 15.52,
    def_sub: 10.83,
    crate_sub: 35.16,
    cdmg_sub: 74.88,
    res_sub: 7.78,
    ehr_sub: 7.34,
    break_sub: 11.24
  },
  {
    char: 'march-7th',
    app_rate_moc: 0.05,
    app_rate_moc_e0s1: 0.01,
    app_rate_moc_e1: 0.02,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 99.99,
    avg_round_moc_s0: 99.99,
    sample_moc: 7,
    sample_size_players_moc: 4,
    app_rate_pf: 0.14,
    app_rate_pf_e0s1: 0.06,
    app_rate_pf_e1: 0.05,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 20,
    sample_size_players_pf: 3,
    app_rate_as: 0.08,
    app_rate_as_e0s1: 0.01,
    app_rate_as_e1: 0.05,
    app_rate_as_s0: 0.0,
    avg_round_as: 0,
    avg_round_as_e1: 0,
    avg_round_as_s0: 0,
    sample_as: 12,
    sample_size_players_as: 5,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 1,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 0,
    app_3: 1,
    round_3_moc: 99.99,
    round_3_pf: 0,
    round_3_as: 0,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 100.0,
    round_6_moc: 6.29,
    round_6_pf: 35352,
    round_6_as: 3382,
    cons_avg: 6.0,
    weapons_1: 'Moment of Victory',
    weapons_1_app: 25.37,
    weapons_1_round_moc: 6.0,
    weapons_1_round_pf: 40000,
    weapons_1_round_as: 0.0,
    weapons_2: 'She Already Shut Her Eyes',
    weapons_2_app: 19.23,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 40000,
    weapons_2_round_as: 0,
    weapons_3: 'Cruising in the Stellar Sea',
    weapons_3_app: 10.37,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0,
    weapons_3_round_as: 0.0,
    weapons_4: 'Worrisome, Blissful',
    weapons_4_app: 10.37,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 31320,
    weapons_4_round_as: 0.0,
    weapons_5: 'Inherently Unjust Destiny',
    weapons_5_app: 8.86,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0,
    weapons_6: 'Texture of Memories',
    weapons_6_app: 8.47,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 3406,
    weapons_7: 'Day One of My New Life',
    weapons_7_app: 4.63,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: 'Shadowed By Night',
    weapons_8_app: 4.23,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0,
    weapons_9: 'Baptism of Pure Thought',
    weapons_9_app: 4.23,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0,
    weapons_10: "Landau's Choice",
    weapons_10_app: 4.23,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0,
    artifacts_1: 'Knight of Purity Palace',
    artifacts_1_1: 'Knight of Purity Palace',
    artifacts_1_2: '',
    artifacts_1_app: 42.3,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 40000,
    artifacts_1_round_as: 0,
    artifacts_2: "Sacerdos' Relived Ordeal",
    artifacts_2_1: "Sacerdos' Relived Ordeal",
    artifacts_2_2: '',
    artifacts_2_app: 15.0,
    artifacts_2_round_moc: 6.0,
    artifacts_2_round_pf: 40000,
    artifacts_2_round_as: 0.0,
    artifacts_3: 'ATK +12%, Scholar Lost in Erudition',
    artifacts_3_1: 'ATK +12%',
    artifacts_3_2: 'Scholar Lost in Erudition',
    artifacts_3_app: 10.37,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 0.0,
    artifacts_4: 'Musketeer of Wild Wheat',
    artifacts_4_1: 'Musketeer of Wild Wheat',
    artifacts_4_2: '',
    artifacts_4_app: 10.37,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 31320,
    artifacts_4_round_as: 0.0,
    artifacts_5: 'Eagle of Twilight Line',
    artifacts_5_1: 'Eagle of Twilight Line',
    artifacts_5_2: '',
    artifacts_5_app: 4.63,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0.0,
    artifacts_6: 'SPD +6%, Flex',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Flex',
    artifacts_6_app: 4.63,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'Iron Cavalry Against the Scourge',
    artifacts_7_1: 'Iron Cavalry Against the Scourge',
    artifacts_7_2: '',
    artifacts_7_app: 4.23,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0,
    artifacts_8: 'Messenger Traversing Hackerspace',
    artifacts_8_1: 'Messenger Traversing Hackerspace',
    artifacts_8_2: '',
    artifacts_8_app: 4.23,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 3406,
    artifacts_9: 'SPD +6%, Scholar Lost in Erudition',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'Scholar Lost in Erudition',
    artifacts_9_app: 4.23,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Belobog of the Architects',
    planars_1_app: 42.7,
    planars_1_round_moc: 99.99,
    planars_1_round_pf: 40000,
    planars_1_round_as: 0,
    planars_2: 'Penacony, Land of the Dreams',
    planars_2_app: 15.0,
    planars_2_round_moc: 6.0,
    planars_2_round_pf: 40000,
    planars_2_round_as: 0.0,
    planars_3: 'Rutilant Arena',
    planars_3_app: 14.6,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 31320,
    planars_3_round_as: 0,
    planars_4: 'Izumo Gensei and Takama Divine Realm',
    planars_4_app: 10.37,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 0.0,
    planars_5: 'Lushaka, the Sunken Seas',
    planars_5_app: 4.63,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'Effect Hit Rate',
    body_stats_1_app: 54.39,
    body_stats_2: 'DEF',
    body_stats_2_app: 45.61,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 72.16,
    feet_stats_2: 'DEF',
    feet_stats_2_app: 27.84,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'DEF',
    sphere_stats_1_app: 100.0,
    sphere_stats_2: '',
    sphere_stats_2_app: 0.0,
    sphere_stats_3: '',
    sphere_stats_3_app: 0.0,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 64.94,
    rope_stats_2: 'DEF',
    rope_stats_2_app: 35.06,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 76.54,
    attack_lvl: 5.03,
    skill_lvl: 11.26,
    ultimate_lvl: 8.55,
    talent_lvl: 8.72,
    max_hp: 3355.6,
    atk: 1470.8,
    dfns: 3273.75,
    speed: 140.37,
    crate: 11.72,
    cdmg: 63.57,
    dmg_boost: 18.15,
    heal_boost: 1,
    energy_regen: 17.59,
    effect_res: 29.52,
    effect_rate: 72.91,
    break_effect: 11.12,
    spd_sub: 19.34,
    hp_sub: 10.96,
    atk_sub: 10.52,
    def_sub: 21.33,
    crate_sub: 6.72,
    cdmg_sub: 13.57,
    res_sub: 17.91,
    ehr_sub: 39.42,
    break_sub: 11.12
  },
  {
    char: 'march-7th-swordmaster',
    app_rate_moc: 4.29,
    app_rate_moc_e0s1: 0.9,
    app_rate_moc_e1: 3.07,
    app_rate_moc_s0: 0.06,
    avg_round_moc: 9.59,
    avg_round_moc_e1: 8.38,
    avg_round_moc_s0: 99.99,
    sample_moc: 646,
    sample_size_players_moc: 59,
    app_rate_pf: 0.33,
    app_rate_pf_e0s1: 0.15,
    app_rate_pf_e1: 0.14,
    app_rate_pf_s0: 0.06,
    avg_round_pf: 23522,
    avg_round_pf_e1: 25696,
    avg_round_pf_s0: 0,
    sample_pf: 46,
    sample_size_players_pf: 4,
    app_rate_as: 11.7,
    app_rate_as_e0s1: 7.04,
    app_rate_as_e1: 4.4,
    app_rate_as_s0: 3.37,
    avg_round_as: 3412,
    avg_round_as_e1: 3527,
    avg_round_as_s0: 3384,
    sample_as: 1815,
    sample_size_players_as: 110,
    app_0: 2.17,
    round_0_moc: 99.99,
    round_0_pf: 22880,
    round_0_as: 0,
    app_1: 1,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 0,
    app_2: 0.22,
    round_2_moc: 99.99,
    round_2_pf: 0,
    round_2_as: 3322,
    app_3: 0.32,
    round_3_moc: 9.0,
    round_3_pf: 0,
    round_3_as: 3440,
    app_4: 0.2,
    round_4_moc: 6.0,
    round_4_pf: 0,
    round_4_as: 3348,
    app_5: 0.25,
    round_5_moc: 7.0,
    round_5_pf: 0,
    round_5_as: 3340,
    app_6: 99.04,
    round_6_moc: 8.68,
    round_6_pf: 24903,
    round_6_as: 3460,
    cons_avg: 5.97,
    weapons_1: 'Cruising in the Stellar Sea',
    weapons_1_app: 22.52,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0,
    weapons_1_round_as: 3536,
    weapons_2: 'In the Night',
    weapons_2_app: 20.13,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0,
    weapons_2_round_as: 3483,
    weapons_3: 'Swordplay',
    weapons_3_app: 19.12,
    weapons_3_round_moc: 99.99,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 3552,
    weapons_4: 'Sleep Like the Dead',
    weapons_4_app: 11.95,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0,
    weapons_5: 'Subscribe for More!',
    weapons_5_app: 7.17,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 0,
    weapons_6: 'Worrisome, Blissful',
    weapons_6_app: 7.17,
    weapons_6_round_moc: 9.0,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 3443,
    weapons_7: 'Only Silence Remains',
    weapons_7_app: 4.78,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Musketeer of Wild Wheat',
    artifacts_1_1: 'Musketeer of Wild Wheat',
    artifacts_1_2: '',
    artifacts_1_app: 49.81,
    artifacts_1_round_moc: 99.99,
    artifacts_1_round_pf: 0,
    artifacts_1_round_as: 3463,
    artifacts_2: 'The Wind-Soaring Valorous',
    artifacts_2_1: 'The Wind-Soaring Valorous',
    artifacts_2_2: '',
    artifacts_2_app: 9.56,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0.0,
    artifacts_2_round_as: 0,
    artifacts_3: 'SPD +6%, Hero of Triumphant Song',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'Hero of Triumphant Song',
    artifacts_3_app: 7.17,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 0,
    artifacts_4: 'ATK +12%, Flex',
    artifacts_4_1: 'ATK +12%',
    artifacts_4_2: 'Flex',
    artifacts_4_app: 7.17,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 3788,
    artifacts_5: 'ATK +12%, ATK +12%',
    artifacts_5_1: 'ATK +12%',
    artifacts_5_2: 'ATK +12%',
    artifacts_5_app: 7.17,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0,
    artifacts_6: 'ATK +12%, Pioneer Diver of Dead Waters',
    artifacts_6_1: 'ATK +12%',
    artifacts_6_2: 'Pioneer Diver of Dead Waters',
    artifacts_6_app: 7.17,
    artifacts_6_round_moc: 9.0,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 3443,
    artifacts_7: 'Eagle of Twilight Line',
    artifacts_7_1: 'Eagle of Twilight Line',
    artifacts_7_2: '',
    artifacts_7_app: 4.78,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 3483,
    artifacts_8: 'ATK +12%, Hero of Triumphant Song',
    artifacts_8_1: 'ATK +12%',
    artifacts_8_2: 'Hero of Triumphant Song',
    artifacts_8_app: 4.78,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0,
    artifacts_9: 'Eagle of Twilight Line, Flex',
    artifacts_9_1: 'Eagle of Twilight Line',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 2.39,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Rutilant Arena',
    planars_1_app: 88.05,
    planars_1_round_moc: 9.0,
    planars_1_round_pf: 0,
    planars_1_round_as: 3517,
    planars_2: 'Sprightly Vonwacq',
    planars_2_app: 2.39,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0.0,
    planars_2_round_as: 0.0,
    planars_3: 'Inert Salsotto',
    planars_3_app: 2.39,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 0.0,
    planars_4: '',
    planars_4_app: 0.0,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 0.0,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 78.92,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 20.44,
    body_stats_3: 'ATK',
    body_stats_3_app: 0.65,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 86.65,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 13.34,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Imaginary DMG Boost',
    sphere_stats_1_app: 79.85,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 17.32,
    sphere_stats_3: 'Lightning DMG Boost',
    sphere_stats_3_app: 0.65,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 91.61,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 4.25,
    rope_stats_3: 'Break Effect',
    rope_stats_3_app: 3.5,
    char_lvl: 79.96,
    light_cone_lvl: 79.58,
    attack_lvl: 6.96,
    skill_lvl: 11.66,
    ultimate_lvl: 11.1,
    talent_lvl: 11.63,
    max_hp: 3067.85,
    atk: 2661.58,
    dfns: 1144.68,
    speed: 138.37,
    crate: 78.99,
    cdmg: 150.43,
    dmg_boost: 31.26,
    heal_boost: 1,
    energy_regen: 1.19,
    effect_res: 8.57,
    effect_rate: 8.19,
    break_effect: 12.39,
    spd_sub: 9.84,
    hp_sub: 11.11,
    atk_sub: 14.99,
    def_sub: 12.86,
    crate_sub: 29.03,
    cdmg_sub: 60.62,
    res_sub: 8.57,
    ehr_sub: 8.19,
    break_sub: 12.39
  },
  {
    char: 'jiaoqiu',
    app_rate_moc: 13.35,
    app_rate_moc_e0s1: 1.12,
    app_rate_moc_e1: 8.66,
    app_rate_moc_s0: 0.03,
    avg_round_moc: 8.91,
    avg_round_moc_e1: 6.77,
    avg_round_moc_s0: 99.99,
    sample_moc: 2011,
    sample_size_players_moc: 806,
    app_rate_pf: 16.56,
    app_rate_pf_e0s1: 4.06,
    app_rate_pf_e1: 9.37,
    app_rate_pf_s0: 0.38,
    avg_round_pf: 28181,
    avg_round_pf_e1: 34622,
    avg_round_pf_s0: 27023,
    sample_pf: 2323,
    sample_size_players_pf: 847,
    app_rate_as: 10.22,
    app_rate_as_e0s1: 2.02,
    app_rate_as_e1: 5.79,
    app_rate_as_s0: 0.11,
    avg_round_as: 3345,
    avg_round_as_e1: 3527,
    avg_round_as_s0: 3308,
    sample_as: 1586,
    sample_size_players_as: 652,
    app_0: 80.71,
    round_0_moc: 6.85,
    round_0_pf: 33058,
    round_0_as: 3499,
    app_1: 12.76,
    round_1_moc: 4.77,
    round_1_pf: 38601,
    round_1_as: 3644,
    app_2: 4.74,
    round_2_moc: 4.36,
    round_2_pf: 38722,
    round_2_as: 3579,
    app_3: 0.15,
    round_3_moc: 3.33,
    round_3_pf: 40000,
    round_3_as: 3548,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 1.63,
    round_6_moc: 1.06,
    round_6_pf: 40000,
    round_6_as: 3805,
    cons_avg: 0.32,
    weapons_1: 'Those Many Springs',
    weapons_1_app: 59.88,
    weapons_1_round_moc: 8.67,
    weapons_1_round_pf: 29761,
    weapons_1_round_as: 3373,
    weapons_2: 'Eyes of the Prey',
    weapons_2_app: 13.18,
    weapons_2_round_moc: 7.83,
    weapons_2_round_pf: 28447,
    weapons_2_round_as: 3318,
    weapons_3: 'Before the Tutorial Mission Starts',
    weapons_3_app: 9.82,
    weapons_3_round_moc: 9.38,
    weapons_3_round_pf: 28317,
    weapons_3_round_as: 3345,
    weapons_4: 'Solitary Healing',
    weapons_4_app: 9.37,
    weapons_4_round_moc: 7.2,
    weapons_4_round_pf: 28856,
    weapons_4_round_as: 3416,
    weapons_5: 'Resolution Shines As Pearls of Sweat',
    weapons_5_app: 6.39,
    weapons_5_round_moc: 9.33,
    weapons_5_round_pf: 28354,
    weapons_5_round_as: 3273,
    weapons_6: 'Incessant Rain',
    weapons_6_app: 0.4,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 28240,
    weapons_6_round_as: 0,
    weapons_7: 'Patience Is All You Need',
    weapons_7_app: 0.33,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 27320,
    weapons_7_round_as: 0,
    weapons_8: 'Reforged Remembrance',
    weapons_8_app: 0.28,
    weapons_8_round_moc: 9.0,
    weapons_8_round_pf: 0,
    weapons_8_round_as: 0,
    weapons_9: 'In the Name of the World',
    weapons_9_app: 0.13,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 24160,
    weapons_9_round_as: 0,
    weapons_10: "It's Showtime",
    weapons_10_app: 0.04,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 3346,
    artifacts_1: 'Eagle of Twilight Line',
    artifacts_1_1: 'Eagle of Twilight Line',
    artifacts_1_2: '',
    artifacts_1_app: 35.76,
    artifacts_1_round_moc: 9.23,
    artifacts_1_round_pf: 29286,
    artifacts_1_round_as: 3360,
    artifacts_2: 'SPD +6%, SPD +6%',
    artifacts_2_1: 'SPD +6%',
    artifacts_2_2: 'SPD +6%',
    artifacts_2_app: 13.19,
    artifacts_2_round_moc: 7.69,
    artifacts_2_round_pf: 29093,
    artifacts_2_round_as: 3360,
    artifacts_3: 'SPD +6%, ATK +12%',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'ATK +12%',
    artifacts_3_app: 12.18,
    artifacts_3_round_moc: 8.27,
    artifacts_3_round_pf: 28576,
    artifacts_3_round_as: 3371,
    artifacts_4: 'SPD +6%, Pioneer Diver of Dead Waters',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'Pioneer Diver of Dead Waters',
    artifacts_4_app: 11.65,
    artifacts_4_round_moc: 8.5,
    artifacts_4_round_pf: 28812,
    artifacts_4_round_as: 3365,
    artifacts_5: 'Prisoner in Deep Confinement',
    artifacts_5_1: 'Prisoner in Deep Confinement',
    artifacts_5_2: '',
    artifacts_5_app: 11.53,
    artifacts_5_round_moc: 9.17,
    artifacts_5_round_pf: 27224,
    artifacts_5_round_as: 3328,
    artifacts_6: 'SPD +6%, Flex',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Flex',
    artifacts_6_app: 6.68,
    artifacts_6_round_moc: 7.8,
    artifacts_6_round_pf: 29109,
    artifacts_6_round_as: 3378,
    artifacts_7: 'Messenger Traversing Hackerspace',
    artifacts_7_1: 'Messenger Traversing Hackerspace',
    artifacts_7_2: '',
    artifacts_7_app: 2.03,
    artifacts_7_round_moc: 8.0,
    artifacts_7_round_pf: 27987,
    artifacts_7_round_as: 3299,
    artifacts_8: 'SPD +6%, Longevous Disciple',
    artifacts_8_1: 'SPD +6%',
    artifacts_8_2: 'Longevous Disciple',
    artifacts_8_app: 1.29,
    artifacts_8_round_moc: 10.0,
    artifacts_8_round_pf: 32080,
    artifacts_8_round_as: 3401,
    artifacts_9: 'Pioneer Diver of Dead Waters',
    artifacts_9_1: 'Pioneer Diver of Dead Waters',
    artifacts_9_2: '',
    artifacts_9_app: 0.71,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0,
    artifacts_9_round_as: 0,
    artifacts_10: 'ATK +12%, Pioneer Diver of Dead Waters',
    artifacts_10_1: 'ATK +12%',
    artifacts_10_2: 'Pioneer Diver of Dead Waters',
    artifacts_10_app: 0.27,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 34960,
    artifacts_10_round_as: 0.0,
    planars_1: 'Sprightly Vonwacq',
    planars_1_app: 55.85,
    planars_1_round_moc: 8.74,
    planars_1_round_pf: 29764,
    planars_1_round_as: 3369,
    planars_2: 'Lushaka, the Sunken Seas',
    planars_2_app: 11.02,
    planars_2_round_moc: 8.77,
    planars_2_round_pf: 29220,
    planars_2_round_as: 3369,
    planars_3: 'Pan-Cosmic Commercial Enterprise',
    planars_3_app: 10.51,
    planars_3_round_moc: 7.82,
    planars_3_round_pf: 27920,
    planars_3_round_as: 3367,
    planars_4: 'Broken Keel',
    planars_4_app: 8.32,
    planars_4_round_moc: 8.0,
    planars_4_round_pf: 28480,
    planars_4_round_as: 3323,
    planars_5: 'Firmament Frontline: Glamoth',
    planars_5_app: 5.66,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 28960,
    planars_5_round_as: 3301,
    body_stats_1: 'Effect Hit Rate',
    body_stats_1_app: 94.02,
    body_stats_2: 'ATK',
    body_stats_2_app: 3.83,
    body_stats_3: 'HP',
    body_stats_3_app: 1.13,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 99.06,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 0.64,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Fire DMG Boost',
    sphere_stats_1_app: 56.11,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 16.08,
    sphere_stats_3: 'HP',
    sphere_stats_3_app: 14.87,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 95.43,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 3.83,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 79.97,
    light_cone_lvl: 79.34,
    attack_lvl: 4.34,
    skill_lvl: 8.45,
    ultimate_lvl: 9.98,
    talent_lvl: 10.02,
    max_hp: 3464.63,
    atk: 1858.17,
    dfns: 1197.4,
    speed: 155.31,
    crate: 10.83,
    cdmg: 61.83,
    dmg_boost: 35.26,
    heal_boost: 1,
    energy_regen: 21.95,
    effect_res: 12.17,
    effect_rate: 149.56,
    break_effect: 17.02,
    spd_sub: 22.97,
    hp_sub: 12.45,
    atk_sub: 18.93,
    def_sub: 16.51,
    crate_sub: 5.83,
    cdmg_sub: 11.83,
    res_sub: 12.36,
    ehr_sub: 32.81,
    break_sub: 16.52
  },
  {
    char: 'feixiao',
    app_rate_moc: 10.98,
    app_rate_moc_e0s1: 1.84,
    app_rate_moc_e1: 7.66,
    app_rate_moc_s0: 0.13,
    avg_round_moc: 9.54,
    avg_round_moc_e1: 7.94,
    avg_round_moc_s0: 9.55,
    sample_moc: 1654,
    sample_size_players_moc: 1159,
    app_rate_pf: 1.51,
    app_rate_pf_e0s1: 0.27,
    app_rate_pf_e1: 1.02,
    app_rate_pf_s0: 0.06,
    avg_round_pf: 25851,
    avg_round_pf_e1: 31518,
    avg_round_pf_s0: 0,
    sample_pf: 212,
    sample_size_players_pf: 163,
    app_rate_as: 25.19,
    app_rate_as_e0s1: 12.81,
    app_rate_as_e1: 11.14,
    app_rate_as_s0: 5.53,
    avg_round_as: 3396,
    avg_round_as_e1: 3504,
    avg_round_as_s0: 3369,
    sample_as: 3909,
    sample_size_players_as: 2338,
    app_0: 75.96,
    round_0_moc: 8.68,
    round_0_pf: 28598,
    round_0_as: 3433,
    app_1: 5.89,
    round_1_moc: 8.91,
    round_1_pf: 28515,
    round_1_as: 3464,
    app_2: 14.72,
    round_2_moc: 5.52,
    round_2_pf: 33273,
    round_2_as: 3568,
    app_3: 0.47,
    round_3_moc: 4.1,
    round_3_pf: 25960,
    round_3_as: 3528,
    app_4: 0.19,
    round_4_moc: 6.17,
    round_4_pf: 40000,
    round_4_as: 3443,
    app_5: 0.11,
    round_5_moc: 9.5,
    round_5_pf: 37320,
    round_5_as: 3520,
    app_6: 2.67,
    round_6_moc: 1.0,
    round_6_pf: 40000,
    round_6_as: 3731,
    cons_avg: 0.54,
    weapons_1: 'I Venture Forth to Hunt',
    weapons_1_app: 67.51,
    weapons_1_round_moc: 9.32,
    weapons_1_round_pf: 26660,
    weapons_1_round_as: 3420,
    weapons_2: 'Cruising in the Stellar Sea',
    weapons_2_app: 16.11,
    weapons_2_round_moc: 9.5,
    weapons_2_round_pf: 25440,
    weapons_2_round_as: 3391,
    weapons_3: 'Baptism of Pure Thought',
    weapons_3_app: 7.86,
    weapons_3_round_moc: 9.85,
    weapons_3_round_pf: 24400,
    weapons_3_round_as: 3419,
    weapons_4: 'In the Night',
    weapons_4_app: 2.78,
    weapons_4_round_moc: 9.38,
    weapons_4_round_pf: 23480,
    weapons_4_round_as: 3397,
    weapons_5: 'Swordplay',
    weapons_5_app: 1.97,
    weapons_5_round_moc: 9.86,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 3422,
    weapons_6: 'Worrisome, Blissful',
    weapons_6_app: 1.69,
    weapons_6_round_moc: 10.0,
    weapons_6_round_pf: 24360,
    weapons_6_round_as: 3448,
    weapons_7: 'Sleep Like the Dead',
    weapons_7_app: 1.41,
    weapons_7_round_moc: 9.0,
    weapons_7_round_pf: 0,
    weapons_7_round_as: 3323,
    weapons_8: 'Only Silence Remains',
    weapons_8_app: 0.08,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 3360,
    weapons_9: 'Final Victor',
    weapons_9_app: 0.08,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 3333,
    weapons_10: 'River Flows in Spring',
    weapons_10_app: 0.07,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 3494,
    artifacts_1: 'The Wind-Soaring Valorous',
    artifacts_1_1: 'The Wind-Soaring Valorous',
    artifacts_1_2: '',
    artifacts_1_app: 87.53,
    artifacts_1_round_moc: 9.49,
    artifacts_1_round_pf: 26225,
    artifacts_1_round_as: 3407,
    artifacts_2: 'Eagle of Twilight Line',
    artifacts_2_1: 'Eagle of Twilight Line',
    artifacts_2_2: '',
    artifacts_2_app: 5.77,
    artifacts_2_round_moc: 8.0,
    artifacts_2_round_pf: 0,
    artifacts_2_round_as: 3433,
    artifacts_3: 'The Ashblazing Grand Duke',
    artifacts_3_1: 'The Ashblazing Grand Duke',
    artifacts_3_2: '',
    artifacts_3_app: 3.74,
    artifacts_3_round_moc: 9.6,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 3447,
    artifacts_4: 'ATK +12%, Flex',
    artifacts_4_1: 'ATK +12%',
    artifacts_4_2: 'Flex',
    artifacts_4_app: 0.47,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 3552,
    artifacts_5: 'ATK +12%, The Ashblazing Grand Duke',
    artifacts_5_1: 'ATK +12%',
    artifacts_5_2: 'The Ashblazing Grand Duke',
    artifacts_5_app: 0.42,
    artifacts_5_round_moc: 10.0,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 3380,
    artifacts_6: 'Pioneer Diver of Dead Waters',
    artifacts_6_1: 'Pioneer Diver of Dead Waters',
    artifacts_6_2: '',
    artifacts_6_app: 0.32,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0,
    artifacts_6_round_as: 3395,
    artifacts_7: 'Scholar Lost in Erudition, The Ashblazing Grand Duke',
    artifacts_7_1: 'Scholar Lost in Erudition',
    artifacts_7_2: 'The Ashblazing Grand Duke',
    artifacts_7_app: 0.32,
    artifacts_7_round_moc: 10.0,
    artifacts_7_round_pf: 0,
    artifacts_7_round_as: 3478,
    artifacts_8: 'The Ashblazing Grand Duke, Flex',
    artifacts_8_1: 'The Ashblazing Grand Duke',
    artifacts_8_2: 'Flex',
    artifacts_8_app: 0.18,
    artifacts_8_round_moc: 9.0,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0,
    artifacts_9: 'SPD +6%, The Ashblazing Grand Duke',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'The Ashblazing Grand Duke',
    artifacts_9_app: 0.1,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0,
    artifacts_10: 'ATK +12%, Scholar Lost in Erudition',
    artifacts_10_1: 'ATK +12%',
    artifacts_10_2: 'Scholar Lost in Erudition',
    artifacts_10_app: 0.08,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 3438,
    planars_1: 'Duran, Dynasty of Running Wolves',
    planars_1_app: 93.5,
    planars_1_round_moc: 9.53,
    planars_1_round_pf: 26066,
    planars_1_round_as: 3410,
    planars_2: 'Inert Salsotto',
    planars_2_app: 3.86,
    planars_2_round_moc: 9.0,
    planars_2_round_pf: 0,
    planars_2_round_as: 3401,
    planars_3: 'Izumo Gensei and Takama Divine Realm',
    planars_3_app: 1.34,
    planars_3_round_moc: 8.5,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 3433,
    planars_4: 'Firmament Frontline: Glamoth',
    planars_4_app: 0.15,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 0,
    planars_5: 'Rutilant Arena',
    planars_5_app: 0.1,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 62.32,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 37.24,
    body_stats_3: 'ATK',
    body_stats_3_app: 0.13,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 69.85,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 29.85,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Wind DMG Boost',
    sphere_stats_1_app: 87.35,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 12.3,
    sphere_stats_3: 'Physical DMG Boost',
    sphere_stats_3_app: 0.02,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 99.05,
    rope_stats_2: 'Break Effect',
    rope_stats_2_app: 0.19,
    rope_stats_3: 'Energy Regeneration Rate',
    rope_stats_3_app: 0.02,
    char_lvl: 80.0,
    light_cone_lvl: 79.86,
    attack_lvl: 4.41,
    skill_lvl: 9.95,
    ultimate_lvl: 10.08,
    talent_lvl: 10.02,
    max_hp: 2994.68,
    atk: 3018.6,
    dfns: 1101.82,
    speed: 136.56,
    crate: 91.14,
    cdmg: 149.32,
    dmg_boost: 34.54,
    heal_boost: 1,
    energy_regen: 0.02,
    effect_res: 7.62,
    effect_rate: 7.34,
    break_effect: 11.66,
    spd_sub: 5.18,
    hp_sub: 8.19,
    atk_sub: 16.87,
    def_sub: 10.06,
    crate_sub: 32.29,
    cdmg_sub: 73.13,
    res_sub: 7.62,
    ehr_sub: 7.34,
    break_sub: 11.66
  },
  {
    char: 'moze',
    app_rate_moc: 0.5,
    app_rate_moc_e0s1: 0.01,
    app_rate_moc_e1: 0.39,
    app_rate_moc_s0: 0.0,
    avg_round_moc: 99.99,
    avg_round_moc_e1: 5.49,
    avg_round_moc_s0: 99.99,
    sample_moc: 76,
    sample_size_players_moc: 13,
    app_rate_pf: 0.01,
    app_rate_pf_e0s1: 0.0,
    app_rate_pf_e1: 0.0,
    app_rate_pf_s0: 0.0,
    avg_round_pf: 0,
    avg_round_pf_e1: 0,
    avg_round_pf_s0: 0,
    sample_pf: 1,
    sample_size_players_pf: 1,
    app_rate_as: 0.64,
    app_rate_as_e0s1: 0.29,
    app_rate_as_e1: 0.29,
    app_rate_as_s0: 0.1,
    avg_round_as: 3305,
    avg_round_as_e1: 3426,
    avg_round_as_s0: 3262,
    sample_as: 99,
    sample_size_players_as: 15,
    app_0: 1,
    round_0_moc: 99.99,
    round_0_pf: 0,
    round_0_as: 0,
    app_1: 1.01,
    round_1_moc: 99.99,
    round_1_pf: 0,
    round_1_as: 3473,
    app_2: 1.71,
    round_2_moc: 10.0,
    round_2_pf: 0,
    round_2_as: 3271,
    app_3: 9.36,
    round_3_moc: 3.67,
    round_3_pf: 34000,
    round_3_as: 3270,
    app_4: 6.28,
    round_4_moc: 4.75,
    round_4_pf: 0,
    round_4_as: 3303,
    app_5: 9.11,
    round_5_moc: 5.5,
    round_5_pf: 0,
    round_5_as: 3367,
    app_6: 73.76,
    round_6_moc: 5.67,
    round_6_pf: 0,
    round_6_as: 3385,
    cons_avg: 5.41,
    weapons_1: 'Cruising in the Stellar Sea',
    weapons_1_app: 36.04,
    weapons_1_round_moc: 99.99,
    weapons_1_round_pf: 0,
    weapons_1_round_as: 3237,
    weapons_2: 'Swordplay',
    weapons_2_app: 22.41,
    weapons_2_round_moc: 99.99,
    weapons_2_round_pf: 0.0,
    weapons_2_round_as: 3313,
    weapons_3: 'Worrisome, Blissful',
    weapons_3_app: 15.86,
    weapons_3_round_moc: 10.0,
    weapons_3_round_pf: 0.0,
    weapons_3_round_as: 3473,
    weapons_4: 'Only Silence Remains',
    weapons_4_app: 9.48,
    weapons_4_round_moc: 99.99,
    weapons_4_round_pf: 0.0,
    weapons_4_round_as: 0,
    weapons_5: 'Final Victor',
    weapons_5_app: 6.37,
    weapons_5_round_moc: 99.99,
    weapons_5_round_pf: 0.0,
    weapons_5_round_as: 3224,
    weapons_6: 'Return to Darkness',
    weapons_6_app: 3.27,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 3402,
    weapons_7: 'Sleep Like the Dead',
    weapons_7_app: 3.27,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 3265,
    weapons_8: 'Baptism of Pure Thought',
    weapons_8_app: 3.27,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Pioneer Diver of Dead Waters',
    artifacts_1_1: 'Pioneer Diver of Dead Waters',
    artifacts_1_2: '',
    artifacts_1_app: 51.7,
    artifacts_1_round_moc: 10.0,
    artifacts_1_round_pf: 0.0,
    artifacts_1_round_as: 3275,
    artifacts_2: 'Eagle of Twilight Line',
    artifacts_2_1: 'Eagle of Twilight Line',
    artifacts_2_2: '',
    artifacts_2_app: 19.67,
    artifacts_2_round_moc: 99.99,
    artifacts_2_round_pf: 0,
    artifacts_2_round_as: 0,
    artifacts_3: 'The Ashblazing Grand Duke',
    artifacts_3_1: 'The Ashblazing Grand Duke',
    artifacts_3_2: '',
    artifacts_3_app: 6.54,
    artifacts_3_round_moc: 99.99,
    artifacts_3_round_pf: 0.0,
    artifacts_3_round_as: 3369,
    artifacts_4: 'ATK +12%, Eagle of Twilight Line',
    artifacts_4_1: 'ATK +12%',
    artifacts_4_2: 'Eagle of Twilight Line',
    artifacts_4_app: 6.37,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0.0,
    artifacts_4_round_as: 0,
    artifacts_5: 'The Wind-Soaring Valorous',
    artifacts_5_1: 'The Wind-Soaring Valorous',
    artifacts_5_2: '',
    artifacts_5_app: 6.37,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 0.0,
    artifacts_5_round_as: 0,
    artifacts_6: 'Eagle of Twilight Line, Flex',
    artifacts_6_1: 'Eagle of Twilight Line',
    artifacts_6_2: 'Flex',
    artifacts_6_app: 6.21,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'Pioneer Diver of Dead Waters, The Ashblazing Grand Duke',
    artifacts_7_1: 'Pioneer Diver of Dead Waters',
    artifacts_7_2: 'The Ashblazing Grand Duke',
    artifacts_7_app: 3.1,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0.0,
    artifacts_8: '',
    artifacts_8_1: '',
    artifacts_8_2: '',
    artifacts_8_app: 0.0,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0.0,
    artifacts_9: '',
    artifacts_9_1: '',
    artifacts_9_2: '',
    artifacts_9_app: 0.0,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_app: 0.0,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Duran, Dynasty of Running Wolves',
    planars_1_app: 54.81,
    planars_1_round_moc: 10.0,
    planars_1_round_pf: 0.0,
    planars_1_round_as: 3342,
    planars_2: 'Sprightly Vonwacq',
    planars_2_app: 26.04,
    planars_2_round_moc: 99.99,
    planars_2_round_pf: 0,
    planars_2_round_as: 0,
    planars_3: 'Izumo Gensei and Takama Divine Realm',
    planars_3_app: 9.64,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 0.0,
    planars_3_round_as: 3207,
    planars_4: 'Inert Salsotto',
    planars_4_app: 6.37,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 3265,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 96.29,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 3.71,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 65.46,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 31.2,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Lightning DMG Boost',
    sphere_stats_1_app: 85.89,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 10.76,
    sphere_stats_3: 'Fire DMG Boost',
    sphere_stats_3_app: 3.34,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 61.24,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 35.41,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 79.0,
    attack_lvl: 4.48,
    skill_lvl: 10.45,
    ultimate_lvl: 11.55,
    talent_lvl: 11.74,
    max_hp: 2943.41,
    atk: 2645.55,
    dfns: 899.98,
    speed: 128.47,
    crate: 77.21,
    cdmg: 145.01,
    dmg_boost: 33.4,
    heal_boost: 1,
    energy_regen: 8.3,
    effect_res: 7.74,
    effect_rate: 10.37,
    break_effect: 13.72,
    spd_sub: 9.92,
    hp_sub: 10.14,
    atk_sub: 16.3,
    def_sub: 10.98,
    crate_sub: 28.58,
    cdmg_sub: 55.18,
    res_sub: 7.74,
    ehr_sub: 10.37,
    break_sub: 13.72
  },
  {
    char: 'lingsha',
    app_rate_moc: 37.35,
    app_rate_moc_e0s1: 7.43,
    app_rate_moc_e1: 25.03,
    app_rate_moc_s0: 1.05,
    avg_round_moc: 9.07,
    avg_round_moc_e1: 6.82,
    avg_round_moc_s0: 9.41,
    sample_moc: 5543,
    sample_size_players_moc: 2319,
    app_rate_pf: 36.15,
    app_rate_pf_e0s1: 13.44,
    app_rate_pf_e1: 20.01,
    app_rate_pf_s0: 4.63,
    avg_round_pf: 38120,
    avg_round_pf_e1: 37747,
    avg_round_pf_s0: 35040,
    sample_pf: 4980,
    sample_size_players_pf: 2057,
    app_rate_as: 32.26,
    app_rate_as_e0s1: 11.47,
    app_rate_as_e1: 18.07,
    app_rate_as_s0: 3.63,
    avg_round_as: 3434,
    avg_round_as_e1: 3521,
    avg_round_as_s0: 3381,
    sample_as: 4951,
    sample_size_players_as: 2083,
    app_0: 82.6,
    round_0_moc: 7.85,
    round_0_pf: 37558,
    round_0_as: 3476,
    app_1: 15.17,
    round_1_moc: 4.41,
    round_1_pf: 40000,
    round_1_as: 3641,
    app_2: 1.74,
    round_2_moc: 3.24,
    round_2_pf: 40000,
    round_2_as: 3721,
    app_3: 0.02,
    round_3_moc: 0.0,
    round_3_pf: 40000,
    round_3_as: 0,
    app_4: 0.04,
    round_4_moc: 5.5,
    round_4_pf: 37340,
    round_4_as: 3805,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 0.44,
    round_6_moc: 0.45,
    round_6_pf: 40000,
    round_6_as: 3847,
    cons_avg: 0.21,
    weapons_1: 'Scent Alone Stays True',
    weapons_1_app: 31.84,
    weapons_1_round_moc: 8.88,
    weapons_1_round_pf: 35522,
    weapons_1_round_as: 3438,
    weapons_2: 'What Is Real?',
    weapons_2_app: 27.24,
    weapons_2_round_moc: 9.3,
    weapons_2_round_pf: 37677,
    weapons_2_round_as: 3427,
    weapons_3: 'Quid Pro Quo',
    weapons_3_app: 14.23,
    weapons_3_round_moc: 9.0,
    weapons_3_round_pf: 38562,
    weapons_3_round_as: 3442,
    weapons_4: 'Post-Op Conversation',
    weapons_4_app: 14.09,
    weapons_4_round_moc: 8.95,
    weapons_4_round_pf: 37977,
    weapons_4_round_as: 3430,
    weapons_5: "Dream's Montage",
    weapons_5_app: 4.13,
    weapons_5_round_moc: 8.23,
    weapons_5_round_pf: 38995,
    weapons_5_round_as: 3477,
    weapons_6: 'Echoes of the Coffin',
    weapons_6_app: 3.88,
    weapons_6_round_moc: 4.8,
    weapons_6_round_pf: 39795,
    weapons_6_round_as: 3446,
    weapons_7: 'Shared Feeling',
    weapons_7_app: 2.12,
    weapons_7_round_moc: 7.22,
    weapons_7_round_pf: 35272,
    weapons_7_round_as: 3519,
    weapons_8: 'Time Waits for No One',
    weapons_8_app: 1.01,
    weapons_8_round_moc: 9.67,
    weapons_8_round_pf: 37380,
    weapons_8_round_as: 3429,
    weapons_9: 'Night of Fright',
    weapons_9_app: 0.47,
    weapons_9_round_moc: 10.0,
    weapons_9_round_pf: 40000,
    weapons_9_round_as: 3457,
    weapons_10: 'Hey, Over Here',
    weapons_10_app: 0.34,
    weapons_10_round_moc: 10.0,
    weapons_10_round_pf: 31980,
    weapons_10_round_as: 3400,
    artifacts_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_2: '',
    artifacts_1_app: 67.66,
    artifacts_1_round_moc: 9.19,
    artifacts_1_round_pf: 37910,
    artifacts_1_round_as: 3432,
    artifacts_2: 'SPD +6%, BE +16%',
    artifacts_2_1: 'SPD +6%',
    artifacts_2_2: 'BE +16%',
    artifacts_2_app: 13.26,
    artifacts_2_round_moc: 8.76,
    artifacts_2_round_pf: 37660,
    artifacts_2_round_as: 3446,
    artifacts_3: 'SPD +6%, SPD +6%',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'SPD +6%',
    artifacts_3_app: 3.1,
    artifacts_3_round_moc: 7.59,
    artifacts_3_round_pf: 39951,
    artifacts_3_round_as: 3486,
    artifacts_4: 'Eagle of Twilight Line',
    artifacts_4_1: 'Eagle of Twilight Line',
    artifacts_4_2: '',
    artifacts_4_app: 2.67,
    artifacts_4_round_moc: 7.29,
    artifacts_4_round_pf: 40000,
    artifacts_4_round_as: 3465,
    artifacts_5: 'BE +16%, BE +16%',
    artifacts_5_1: 'BE +16%',
    artifacts_5_2: 'BE +16%',
    artifacts_5_app: 2.65,
    artifacts_5_round_moc: 8.8,
    artifacts_5_round_pf: 33648,
    artifacts_5_round_as: 3447,
    artifacts_6: 'Thief of Shooting Meteor',
    artifacts_6_1: 'Thief of Shooting Meteor',
    artifacts_6_2: '',
    artifacts_6_app: 2.3,
    artifacts_6_round_moc: 8.67,
    artifacts_6_round_pf: 35024,
    artifacts_6_round_as: 3344,
    artifacts_7: 'SPD +6%, Passerby of Wandering Cloud',
    artifacts_7_1: 'SPD +6%',
    artifacts_7_2: 'Passerby of Wandering Cloud',
    artifacts_7_app: 1.45,
    artifacts_7_round_moc: 9.8,
    artifacts_7_round_pf: 38610,
    artifacts_7_round_as: 3440,
    artifacts_8: 'Passerby of Wandering Cloud',
    artifacts_8_1: 'Passerby of Wandering Cloud',
    artifacts_8_2: '',
    artifacts_8_app: 1.39,
    artifacts_8_round_moc: 8.25,
    artifacts_8_round_pf: 39314,
    artifacts_8_round_as: 3409,
    artifacts_9: 'BE +16%, Flex',
    artifacts_9_1: 'BE +16%',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 0.77,
    artifacts_9_round_moc: 8.5,
    artifacts_9_round_pf: 35182,
    artifacts_9_round_as: 3412,
    artifacts_10: 'BE +16%, Passerby of Wandering Cloud',
    artifacts_10_1: 'BE +16%',
    artifacts_10_2: 'Passerby of Wandering Cloud',
    artifacts_10_app: 0.72,
    artifacts_10_round_moc: 8.75,
    artifacts_10_round_pf: 37687,
    artifacts_10_round_as: 3446,
    planars_1: 'Forge of the Kalpagni Lantern',
    planars_1_app: 83.1,
    planars_1_round_moc: 9.09,
    planars_1_round_pf: 37938,
    planars_1_round_as: 3435,
    planars_2: 'Talia: Kingdom of Banditry',
    planars_2_app: 4.16,
    planars_2_round_moc: 8.78,
    planars_2_round_pf: 34553,
    planars_2_round_as: 3339,
    planars_3: 'Lushaka, the Sunken Seas',
    planars_3_app: 4.02,
    planars_3_round_moc: 8.91,
    planars_3_round_pf: 37711,
    planars_3_round_as: 3472,
    planars_4: 'Giant Tree of Rapt Brooding',
    planars_4_app: 2.09,
    planars_4_round_moc: 7.38,
    planars_4_round_pf: 39244,
    planars_4_round_as: 3483,
    planars_5: 'Sprightly Vonwacq',
    planars_5_app: 1.75,
    planars_5_round_moc: 6.4,
    planars_5_round_pf: 37910,
    planars_5_round_as: 3460,
    body_stats_1: 'Outgoing Healing Boost',
    body_stats_1_app: 78.11,
    body_stats_2: 'ATK',
    body_stats_2_app: 17.26,
    body_stats_3: 'CRIT Rate',
    body_stats_3_app: 2.41,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 98.92,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 0.96,
    feet_stats_3: 'HP',
    feet_stats_3_app: 0.1,
    sphere_stats_1: 'ATK',
    sphere_stats_1_app: 88.01,
    sphere_stats_2: 'Fire DMG Boost',
    sphere_stats_2_app: 5.53,
    sphere_stats_3: 'HP',
    sphere_stats_3_app: 4.01,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 61.77,
    rope_stats_2: 'Break Effect',
    rope_stats_2_app: 35.9,
    rope_stats_3: 'ATK',
    rope_stats_3_app: 2.16,
    char_lvl: 79.99,
    light_cone_lvl: 79.37,
    attack_lvl: 4.3,
    skill_lvl: 9.62,
    ultimate_lvl: 9.88,
    talent_lvl: 9.71,
    max_hp: 3957.83,
    atk: 2421.27,
    dfns: 1041.0,
    speed: 149.19,
    crate: 10.83,
    cdmg: 61.66,
    dmg_boost: 2.15,
    heal_boost: 34.56,
    energy_regen: 14.61,
    effect_res: 11.36,
    effect_rate: 8.21,
    break_effect: 161.81,
    spd_sub: 19.65,
    hp_sub: 14.11,
    atk_sub: 18.61,
    def_sub: 16.78,
    crate_sub: 5.83,
    cdmg_sub: 11.66,
    res_sub: 11.23,
    ehr_sub: 8.21,
    break_sub: 54.08
  },
  {
    char: 'rappa',
    app_rate_moc: 10.9,
    app_rate_moc_e0s1: 2.77,
    app_rate_moc_e1: 7.17,
    app_rate_moc_s0: 0.48,
    avg_round_moc: 9.25,
    avg_round_moc_e1: 6.82,
    avg_round_moc_s0: 9.47,
    sample_moc: 1641,
    sample_size_players_moc: 913,
    app_rate_pf: 13.26,
    app_rate_pf_e0s1: 4.09,
    app_rate_pf_e1: 8.47,
    app_rate_pf_s0: 1.78,
    avg_round_pf: 29184,
    avg_round_pf_e1: 33632,
    avg_round_pf_s0: 27390,
    sample_pf: 1860,
    sample_size_players_pf: 941,
    app_rate_as: 3.78,
    app_rate_as_e0s1: 1.02,
    app_rate_as_e1: 2.43,
    app_rate_as_s0: 0.3,
    avg_round_as: 3303,
    avg_round_as_e1: 3423,
    avg_round_as_s0: 3242,
    sample_as: 587,
    sample_size_players_as: 372,
    app_0: 84.43,
    round_0_moc: 8.15,
    round_0_pf: 31711,
    round_0_as: 3368,
    app_1: 9.77,
    round_1_moc: 5.54,
    round_1_pf: 38108,
    round_1_as: 3475,
    app_2: 4.2,
    round_2_moc: 3.18,
    round_2_pf: 40000,
    round_2_as: 3641,
    app_3: 0.49,
    round_3_moc: 5.0,
    round_3_pf: 35697,
    round_3_as: 3476,
    app_4: 1,
    round_4_moc: 99.99,
    round_4_pf: 0,
    round_4_as: 0,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 1.11,
    round_6_moc: 1.38,
    round_6_pf: 40000,
    round_6_as: 3715,
    cons_avg: 0.26,
    weapons_1: 'Ninjutsu Inscription: Dazzling Evilbreaker',
    weapons_1_app: 61.11,
    weapons_1_round_moc: 8.93,
    weapons_1_round_pf: 31102,
    weapons_1_round_as: 3342,
    weapons_2: 'After the Charmony Fall',
    weapons_2_app: 28.31,
    weapons_2_round_moc: 9.56,
    weapons_2_round_pf: 27847,
    weapons_2_round_as: 3239,
    weapons_3: 'Eternal Calculus',
    weapons_3_app: 7.7,
    weapons_3_round_moc: 9.38,
    weapons_3_round_pf: 27584,
    weapons_3_round_as: 3272,
    weapons_4: 'Make the World Clamor',
    weapons_4_app: 2.03,
    weapons_4_round_moc: 9.12,
    weapons_4_round_pf: 28138,
    weapons_4_round_as: 3266,
    weapons_5: 'Night on the Milky Way',
    weapons_5_app: 0.48,
    weapons_5_round_moc: 9.67,
    weapons_5_round_pf: 24293,
    weapons_5_round_as: 0.0,
    weapons_6: "Geniuses' Repose",
    weapons_6_app: 0.14,
    weapons_6_round_moc: 99.99,
    weapons_6_round_pf: 24080,
    weapons_6_round_as: 0,
    weapons_7: 'Today Is Another Peaceful Day',
    weapons_7_app: 0.06,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 24440,
    weapons_7_round_as: 0.0,
    weapons_8: 'The Seriousness of Breakfast',
    weapons_8_app: 0.06,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 27920,
    weapons_8_round_as: 0.0,
    weapons_9: 'The Great Cosmic Enterprise',
    weapons_9_app: 0.05,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: 'Passkey',
    weapons_10_app: 0.03,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_2: '',
    artifacts_1_app: 90.85,
    artifacts_1_round_moc: 9.29,
    artifacts_1_round_pf: 29110,
    artifacts_1_round_as: 3308,
    artifacts_2: 'Thief of Shooting Meteor',
    artifacts_2_1: 'Thief of Shooting Meteor',
    artifacts_2_2: '',
    artifacts_2_app: 6.11,
    artifacts_2_round_moc: 9.15,
    artifacts_2_round_pf: 31619,
    artifacts_2_round_as: 3281,
    artifacts_3: 'BE +16%, Flex',
    artifacts_3_1: 'BE +16%',
    artifacts_3_2: 'Flex',
    artifacts_3_app: 0.95,
    artifacts_3_round_moc: 10.0,
    artifacts_3_round_pf: 27217,
    artifacts_3_round_as: 0,
    artifacts_4: 'BE +16%, BE +16%',
    artifacts_4_1: 'BE +16%',
    artifacts_4_2: 'BE +16%',
    artifacts_4_app: 0.71,
    artifacts_4_round_moc: 9.0,
    artifacts_4_round_pf: 28630,
    artifacts_4_round_as: 3166,
    artifacts_5: 'Eagle of Twilight Line',
    artifacts_5_1: 'Eagle of Twilight Line',
    artifacts_5_2: '',
    artifacts_5_app: 0.31,
    artifacts_5_round_moc: 10.0,
    artifacts_5_round_pf: 24000,
    artifacts_5_round_as: 0,
    artifacts_6: 'SPD +6%, BE +16%',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'BE +16%',
    artifacts_6_app: 0.29,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 30120,
    artifacts_6_round_as: 0.0,
    artifacts_7: 'Genius of Brilliant Stars',
    artifacts_7_1: 'Genius of Brilliant Stars',
    artifacts_7_2: '',
    artifacts_7_app: 0.09,
    artifacts_7_round_moc: 10.0,
    artifacts_7_round_pf: 28520,
    artifacts_7_round_as: 0.0,
    artifacts_8: 'BE +16%, ATK +12%',
    artifacts_8_1: 'BE +16%',
    artifacts_8_2: 'ATK +12%',
    artifacts_8_app: 0.06,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 0.0,
    artifacts_9: 'The Ashblazing Grand Duke, Flex',
    artifacts_9_1: 'The Ashblazing Grand Duke',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 0.05,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0,
    artifacts_10: 'Eagle of Twilight Line, Flex',
    artifacts_10_1: 'Eagle of Twilight Line',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 0.03,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Talia: Kingdom of Banditry',
    planars_1_app: 81.98,
    planars_1_round_moc: 9.35,
    planars_1_round_pf: 29126,
    planars_1_round_as: 3301,
    planars_2: 'Forge of the Kalpagni Lantern',
    planars_2_app: 16.44,
    planars_2_round_moc: 9.0,
    planars_2_round_pf: 30315,
    planars_2_round_as: 3299,
    planars_3: 'Sprightly Vonwacq',
    planars_3_app: 0.26,
    planars_3_round_moc: 10.0,
    planars_3_round_pf: 0,
    planars_3_round_as: 0,
    planars_4: 'Firmament Frontline: Glamoth',
    planars_4_app: 0.16,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 0,
    planars_5: 'Space Sealing Station',
    planars_5_app: 0.08,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 32440,
    planars_5_round_as: 0.0,
    body_stats_1: 'ATK',
    body_stats_1_app: 97.44,
    body_stats_2: 'HP',
    body_stats_2_app: 1.04,
    body_stats_3: 'CRIT DMG',
    body_stats_3_app: 0.42,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 98.83,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 0.76,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'ATK',
    sphere_stats_1_app: 94.52,
    sphere_stats_2: 'Imaginary DMG Boost',
    sphere_stats_2_app: 3.92,
    sphere_stats_3: 'HP',
    sphere_stats_3_app: 0.6,
    rope_stats_1: 'Break Effect',
    rope_stats_1_app: 91.66,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 7.83,
    rope_stats_3: 'ATK',
    rope_stats_3_app: 0.13,
    char_lvl: 80.0,
    light_cone_lvl: 79.89,
    attack_lvl: 5.46,
    skill_lvl: 8.07,
    ultimate_lvl: 9.89,
    talent_lvl: 10.01,
    max_hp: 3077.13,
    atk: 3325.16,
    dfns: 1155.43,
    speed: 150.4,
    crate: 10.83,
    cdmg: 61.66,
    dmg_boost: 1.52,
    heal_boost: 1,
    energy_regen: 1.54,
    effect_res: 11.14,
    effect_rate: 8.79,
    break_effect: 226.21,
    spd_sub: 19.73,
    hp_sub: 12.92,
    atk_sub: 16.56,
    def_sub: 15.48,
    crate_sub: 5.83,
    cdmg_sub: 11.66,
    res_sub: 11.14,
    ehr_sub: 9.53,
    break_sub: 66.32
  },
  {
    char: 'sunday',
    app_rate_moc: 40.88,
    app_rate_moc_e0s1: 8.76,
    app_rate_moc_e1: 26.56,
    app_rate_moc_s0: 0.78,
    avg_round_moc: 8.51,
    avg_round_moc_e1: 6.45,
    avg_round_moc_s0: 9.17,
    sample_moc: 6157,
    sample_size_players_moc: 3354,
    app_rate_pf: 39.04,
    app_rate_pf_e0s1: 16.14,
    app_rate_pf_e1: 19.98,
    app_rate_pf_s0: 3.02,
    avg_round_pf: 33524,
    avg_round_pf_e1: 37281,
    avg_round_pf_s0: 32765,
    sample_pf: 5477,
    sample_size_players_pf: 3055,
    app_rate_as: 33.93,
    app_rate_as_e0s1: 13.81,
    app_rate_as_e1: 17.19,
    app_rate_as_s0: 2.13,
    avg_round_as: 3450,
    avg_round_as_e1: 3565,
    avg_round_as_s0: 3375,
    sample_as: 5265,
    sample_size_players_as: 2952,
    app_0: 76.74,
    round_0_moc: 7.51,
    round_0_pf: 34417,
    round_0_as: 3504,
    app_1: 17.4,
    round_1_moc: 5.19,
    round_1_pf: 38080,
    round_1_as: 3584,
    app_2: 3.52,
    round_2_moc: 5.03,
    round_2_pf: 38980,
    round_2_as: 3602,
    app_3: 0.33,
    round_3_moc: 5.1,
    round_3_pf: 39324,
    round_3_as: 3555,
    app_4: 0.16,
    round_4_moc: 4.89,
    round_4_pf: 37650,
    round_4_as: 3619,
    app_5: 0.04,
    round_5_moc: 9.0,
    round_5_pf: 34400,
    round_5_as: 3479,
    app_6: 1.82,
    round_6_moc: 3.46,
    round_6_pf: 40000,
    round_6_as: 3706,
    cons_avg: 0.37,
    weapons_1: 'A Grounded Ascent',
    weapons_1_app: 69.13,
    weapons_1_round_moc: 8.28,
    weapons_1_round_pf: 33982,
    weapons_1_round_as: 3472,
    weapons_2: "But the Battle Isn't Over",
    weapons_2_app: 20.31,
    weapons_2_round_moc: 8.58,
    weapons_2_round_pf: 33239,
    weapons_2_round_as: 3423,
    weapons_3: 'Past and Future',
    weapons_3_app: 6.03,
    weapons_3_round_moc: 8.93,
    weapons_3_round_pf: 32343,
    weapons_3_round_as: 3392,
    weapons_4: 'Dance! Dance! Dance!',
    weapons_4_app: 2.19,
    weapons_4_round_moc: 9.25,
    weapons_4_round_pf: 33057,
    weapons_4_round_as: 3414,
    weapons_5: 'Carve the Moon, Weave the Clouds',
    weapons_5_app: 0.79,
    weapons_5_round_moc: 8.62,
    weapons_5_round_pf: 33142,
    weapons_5_round_as: 3401,
    weapons_6: 'Earthly Escapade',
    weapons_6_app: 0.67,
    weapons_6_round_moc: 8.12,
    weapons_6_round_pf: 33774,
    weapons_6_round_as: 3493,
    weapons_7: 'Meshing Cogs',
    weapons_7_app: 0.23,
    weapons_7_round_moc: 9.17,
    weapons_7_round_pf: 35131,
    weapons_7_round_as: 3462,
    weapons_8: 'Planetary Rendezvous',
    weapons_8_app: 0.18,
    weapons_8_round_moc: 7.0,
    weapons_8_round_pf: 32450,
    weapons_8_round_as: 3346,
    weapons_9: 'Poised to Bloom',
    weapons_9_app: 0.17,
    weapons_9_round_moc: 10.0,
    weapons_9_round_pf: 31700,
    weapons_9_round_as: 3481,
    weapons_10: "For Tomorrow's Journey",
    weapons_10_app: 0.07,
    weapons_10_round_moc: 8.0,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 3405,
    artifacts_1: "Sacerdos' Relived Ordeal",
    artifacts_1_1: "Sacerdos' Relived Ordeal",
    artifacts_1_2: '',
    artifacts_1_app: 93.09,
    artifacts_1_round_moc: 8.47,
    artifacts_1_round_pf: 33668,
    artifacts_1_round_as: 3451,
    artifacts_2: 'SPD +6%, SPD +6%',
    artifacts_2_1: 'SPD +6%',
    artifacts_2_2: 'SPD +6%',
    artifacts_2_app: 3.52,
    artifacts_2_round_moc: 8.73,
    artifacts_2_round_pf: 32222,
    artifacts_2_round_as: 3428,
    artifacts_3: 'SPD +6%, Flex',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'Flex',
    artifacts_3_app: 1.35,
    artifacts_3_round_moc: 8.46,
    artifacts_3_round_pf: 32032,
    artifacts_3_round_as: 3388,
    artifacts_4: 'Eagle of Twilight Line',
    artifacts_4_1: 'Eagle of Twilight Line',
    artifacts_4_2: '',
    artifacts_4_app: 0.86,
    artifacts_4_round_moc: 9.0,
    artifacts_4_round_pf: 32153,
    artifacts_4_round_as: 3472,
    artifacts_5: 'Messenger Traversing Hackerspace',
    artifacts_5_1: 'Messenger Traversing Hackerspace',
    artifacts_5_2: '',
    artifacts_5_app: 0.46,
    artifacts_5_round_moc: 10.0,
    artifacts_5_round_pf: 32636,
    artifacts_5_round_as: 3415,
    artifacts_6: 'SPD +6%, Longevous Disciple',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Longevous Disciple',
    artifacts_6_app: 0.12,
    artifacts_6_round_moc: 8.67,
    artifacts_6_round_pf: 36900,
    artifacts_6_round_as: 3406,
    artifacts_7: 'ATK +12%, Flex',
    artifacts_7_1: 'ATK +12%',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 0.03,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 29180,
    artifacts_7_round_as: 3618,
    artifacts_8: 'SPD +6%, Guard of Wuthering Snow',
    artifacts_8_1: 'SPD +6%',
    artifacts_8_2: 'Guard of Wuthering Snow',
    artifacts_8_app: 0.02,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 3185,
    artifacts_9: 'Longevous Disciple',
    artifacts_9_1: 'Longevous Disciple',
    artifacts_9_2: '',
    artifacts_9_app: 0.02,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0,
    artifacts_10: 'BE +16%, Flex',
    artifacts_10_1: 'BE +16%',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 0.01,
    artifacts_10_round_moc: 9.0,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'Lushaka, the Sunken Seas',
    planars_1_app: 70.77,
    planars_1_round_moc: 8.67,
    planars_1_round_pf: 33495,
    planars_1_round_as: 3439,
    planars_2: 'Broken Keel',
    planars_2_app: 19.67,
    planars_2_round_moc: 8.21,
    planars_2_round_pf: 33838,
    planars_2_round_as: 3478,
    planars_3: 'Sprightly Vonwacq',
    planars_3_app: 3.14,
    planars_3_round_moc: 8.0,
    planars_3_round_pf: 34455,
    planars_3_round_as: 3493,
    planars_4: 'Penacony, Land of the Dreams',
    planars_4_app: 2.72,
    planars_4_round_moc: 7.03,
    planars_4_round_pf: 34418,
    planars_4_round_as: 3483,
    planars_5: 'Forge of the Kalpagni Lantern',
    planars_5_app: 0.9,
    planars_5_round_moc: 7.43,
    planars_5_round_pf: 34916,
    planars_5_round_as: 3464,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 99.31,
    body_stats_2: 'HP',
    body_stats_2_app: 0.37,
    body_stats_3: 'DEF',
    body_stats_3_app: 0.11,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 96.14,
    feet_stats_2: 'HP',
    feet_stats_2_app: 2.14,
    feet_stats_3: 'ATK',
    feet_stats_3_app: 1.0,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 54.34,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 27.64,
    sphere_stats_3: 'ATK',
    sphere_stats_3_app: 7.3,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 98.52,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 0.67,
    rope_stats_3: 'HP',
    rope_stats_3_app: 0.53,
    char_lvl: 79.97,
    light_cone_lvl: 79.21,
    attack_lvl: 3.49,
    skill_lvl: 10.0,
    ultimate_lvl: 10.03,
    talent_lvl: 9.99,
    max_hp: 4111.71,
    atk: 1686.55,
    dfns: 1571.93,
    speed: 141.35,
    crate: 11.16,
    cdmg: 213.2,
    dmg_boost: 1.43,
    heal_boost: 0.02,
    energy_regen: 24.51,
    effect_res: 34.84,
    effect_rate: 10.79,
    break_effect: 16.71,
    spd_sub: 11.63,
    hp_sub: 13.43,
    atk_sub: 13.69,
    def_sub: 17.4,
    crate_sub: 6.16,
    cdmg_sub: 61.56,
    res_sub: 14.91,
    ehr_sub: 10.95,
    break_sub: 16.91
  },
  {
    char: 'tingyun-fugue',
    app_rate_moc: 35.51,
    app_rate_moc_e0s1: 5.25,
    app_rate_moc_e1: 25.95,
    app_rate_moc_s0: 0.8,
    avg_round_moc: 9.31,
    avg_round_moc_e1: 6.42,
    avg_round_moc_s0: 9.62,
    sample_moc: 5348,
    sample_size_players_moc: 2476,
    app_rate_pf: 24.96,
    app_rate_pf_e0s1: 4.85,
    app_rate_pf_e1: 17.52,
    app_rate_pf_s0: 2.02,
    avg_round_pf: 28779,
    avg_round_pf_e1: 33788,
    avg_round_pf_s0: 27174,
    sample_pf: 3502,
    sample_size_players_pf: 1642,
    app_rate_as: 23.48,
    app_rate_as_e0s1: 4.04,
    app_rate_as_e1: 16.82,
    app_rate_as_s0: 1.3,
    avg_round_as: 3342,
    avg_round_as_e1: 3501,
    avg_round_as_s0: 3295,
    sample_as: 3643,
    sample_size_players_as: 1729,
    app_0: 67.23,
    round_0_moc: 7.88,
    round_0_pf: 31188,
    round_0_as: 3401,
    app_1: 21.12,
    round_1_moc: 4.66,
    round_1_pf: 38003,
    round_1_as: 3658,
    app_2: 9.43,
    round_2_moc: 3.42,
    round_2_pf: 40000,
    round_2_as: 3725,
    app_3: 0.19,
    round_3_moc: 4.89,
    round_3_pf: 37073,
    round_3_as: 3557,
    app_4: 0.13,
    round_4_moc: 5.8,
    round_4_pf: 35880,
    round_4_as: 3603,
    app_5: 0.07,
    round_5_moc: 99.99,
    round_5_pf: 40000,
    round_5_as: 3776,
    app_6: 1.86,
    round_6_moc: 0.51,
    round_6_pf: 40000,
    round_6_as: 3830,
    cons_avg: 0.52,
    weapons_1: 'Long Road Leads Home',
    weapons_1_app: 39.63,
    weapons_1_round_moc: 9.0,
    weapons_1_round_pf: 29291,
    weapons_1_round_as: 3341,
    weapons_2: 'Resolution Shines As Pearls of Sweat',
    weapons_2_app: 37.6,
    weapons_2_round_moc: 9.06,
    weapons_2_round_pf: 27611,
    weapons_2_round_as: 3362,
    weapons_3: 'Solitary Healing',
    weapons_3_app: 15.4,
    weapons_3_round_moc: 9.69,
    weapons_3_round_pf: 26993,
    weapons_3_round_as: 3279,
    weapons_4: 'Before the Tutorial Mission Starts',
    weapons_4_app: 5.67,
    weapons_4_round_moc: 9.62,
    weapons_4_round_pf: 29580,
    weapons_4_round_as: 3204,
    weapons_5: 'Fermata',
    weapons_5_app: 0.65,
    weapons_5_round_moc: 10.0,
    weapons_5_round_pf: 29300,
    weapons_5_round_as: 3252,
    weapons_6: 'Good Night and Sleep Well',
    weapons_6_app: 0.29,
    weapons_6_round_moc: 9.5,
    weapons_6_round_pf: 27460,
    weapons_6_round_as: 3245,
    weapons_7: 'Eyes of the Prey',
    weapons_7_app: 0.2,
    weapons_7_round_moc: 99.99,
    weapons_7_round_pf: 0,
    weapons_7_round_as: 3463,
    weapons_8: 'Incessant Rain',
    weapons_8_app: 0.19,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0,
    weapons_8_round_as: 0,
    weapons_9: 'Those Many Springs',
    weapons_9_app: 0.08,
    weapons_9_round_moc: 9.0,
    weapons_9_round_pf: 28640,
    weapons_9_round_as: 0.0,
    weapons_10: 'Boundless Choreo',
    weapons_10_app: 0.04,
    weapons_10_round_moc: 7.5,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0,
    artifacts_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_1: 'Iron Cavalry Against the Scourge',
    artifacts_1_2: '',
    artifacts_1_app: 71.03,
    artifacts_1_round_moc: 9.25,
    artifacts_1_round_pf: 28311,
    artifacts_1_round_as: 3330,
    artifacts_2: 'BE +16%, BE +16%',
    artifacts_2_1: 'BE +16%',
    artifacts_2_2: 'BE +16%',
    artifacts_2_app: 9.49,
    artifacts_2_round_moc: 9.44,
    artifacts_2_round_pf: 28597,
    artifacts_2_round_as: 3351,
    artifacts_3: 'Thief of Shooting Meteor',
    artifacts_3_1: 'Thief of Shooting Meteor',
    artifacts_3_2: '',
    artifacts_3_app: 6.87,
    artifacts_3_round_moc: 9.23,
    artifacts_3_round_pf: 28553,
    artifacts_3_round_as: 3352,
    artifacts_4: 'SPD +6%, BE +16%',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'BE +16%',
    artifacts_4_app: 5.11,
    artifacts_4_round_moc: 8.33,
    artifacts_4_round_pf: 30163,
    artifacts_4_round_as: 3323,
    artifacts_5: 'Eagle of Twilight Line',
    artifacts_5_1: 'Eagle of Twilight Line',
    artifacts_5_2: '',
    artifacts_5_app: 3.75,
    artifacts_5_round_moc: 10.0,
    artifacts_5_round_pf: 24000,
    artifacts_5_round_as: 0,
    artifacts_6: 'SPD +6%, SPD +6%',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'SPD +6%',
    artifacts_6_app: 1.36,
    artifacts_6_round_moc: 10.0,
    artifacts_6_round_pf: 23800,
    artifacts_6_round_as: 3292,
    artifacts_7: 'BE +16%, Flex',
    artifacts_7_1: 'BE +16%',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 1.12,
    artifacts_7_round_moc: 7.75,
    artifacts_7_round_pf: 30320,
    artifacts_7_round_as: 3335,
    artifacts_8: 'Watchmaker, Master of Dream Machinations',
    artifacts_8_1: 'Watchmaker, Master of Dream Machinations',
    artifacts_8_2: '',
    artifacts_8_app: 0.57,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 40000,
    artifacts_8_round_as: 3266,
    artifacts_9: 'SPD +6%, Flex',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 0.17,
    artifacts_9_round_moc: 9.0,
    artifacts_9_round_pf: 0,
    artifacts_9_round_as: 3325,
    artifacts_10: "Sacerdos' Relived Ordeal",
    artifacts_10_1: "Sacerdos' Relived Ordeal",
    artifacts_10_2: '',
    artifacts_10_app: 0.09,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 3323,
    planars_1: 'Forge of the Kalpagni Lantern',
    planars_1_app: 77.2,
    planars_1_round_moc: 9.31,
    planars_1_round_pf: 28271,
    planars_1_round_as: 3318,
    planars_2: 'Talia: Kingdom of Banditry',
    planars_2_app: 16.78,
    planars_2_round_moc: 9.2,
    planars_2_round_pf: 29099,
    planars_2_round_as: 3380,
    planars_3: 'Sprightly Vonwacq',
    planars_3_app: 4.02,
    planars_3_round_moc: 7.33,
    planars_3_round_pf: 27468,
    planars_3_round_as: 3357,
    planars_4: 'Lushaka, the Sunken Seas',
    planars_4_app: 1.31,
    planars_4_round_moc: 9.0,
    planars_4_round_pf: 32120,
    planars_4_round_as: 3315,
    planars_5: 'Penacony, Land of the Dreams',
    planars_5_app: 0.11,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0,
    planars_5_round_as: 3219,
    body_stats_1: 'Effect Hit Rate',
    body_stats_1_app: 91.12,
    body_stats_2: 'ATK',
    body_stats_2_app: 3.54,
    body_stats_3: 'HP',
    body_stats_3_app: 3.11,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 99.48,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 0.21,
    feet_stats_3: 'HP',
    feet_stats_3_app: 0.19,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 46.86,
    sphere_stats_2: 'DEF',
    sphere_stats_2_app: 24.07,
    sphere_stats_3: 'ATK',
    sphere_stats_3_app: 15.02,
    rope_stats_1: 'Break Effect',
    rope_stats_1_app: 71.27,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 28.38,
    rope_stats_3: 'ATK',
    rope_stats_3_app: 0.17,
    char_lvl: 79.99,
    light_cone_lvl: 79.15,
    attack_lvl: 4.58,
    skill_lvl: 9.96,
    ultimate_lvl: 8.56,
    talent_lvl: 10.02,
    max_hp: 3800.06,
    atk: 1631.94,
    dfns: 1364.12,
    speed: 161.53,
    crate: 10.65,
    cdmg: 61.2,
    dmg_boost: 3.9,
    heal_boost: 0.04,
    energy_regen: 5.78,
    effect_res: 10.8,
    effect_rate: 66.96,
    break_effect: 184.52,
    spd_sub: 15.45,
    hp_sub: 12.81,
    atk_sub: 13.42,
    def_sub: 15.56,
    crate_sub: 5.51,
    cdmg_sub: 11.02,
    res_sub: 10.8,
    ehr_sub: 23.01,
    break_sub: 63.57
  },
  {
    char: 'the-herta',
    app_rate_moc: 51.07,
    app_rate_moc_e0s1: 13.55,
    app_rate_moc_e1: 32.89,
    app_rate_moc_s0: 1.93,
    avg_round_moc: 8.96,
    avg_round_moc_e1: 6.91,
    avg_round_moc_s0: 9.45,
    sample_moc: 7692,
    sample_size_players_moc: 5454,
    app_rate_pf: 60.26,
    app_rate_pf_e0s1: 33.88,
    app_rate_pf_e1: 24.66,
    app_rate_pf_s0: 12.92,
    avg_round_pf: 39928,
    avg_round_pf_e1: 40000,
    avg_round_pf_s0: 39705,
    sample_pf: 8454,
    sample_size_players_pf: 5926,
    app_rate_as: 50.92,
    app_rate_as_e0s1: 27.62,
    app_rate_as_e1: 21.66,
    app_rate_as_s0: 9.28,
    avg_round_as: 3449,
    avg_round_as_e1: 3572,
    avg_round_as_s0: 3403,
    sample_as: 7900,
    sample_size_players_as: 5688,
    app_0: 80.76,
    round_0_moc: 8.17,
    round_0_pf: 39991,
    round_0_as: 3470,
    app_1: 5.79,
    round_1_moc: 6.87,
    round_1_pf: 40000,
    round_1_as: 3547,
    app_2: 12.02,
    round_2_moc: 4.56,
    round_2_pf: 40000,
    round_2_as: 3721,
    app_3: 0.46,
    round_3_moc: 4.11,
    round_3_pf: 40000,
    round_3_as: 3740,
    app_4: 0.08,
    round_4_moc: 3.0,
    round_4_pf: 40000,
    round_4_as: 3785,
    app_5: 0.04,
    round_5_moc: 4.33,
    round_5_pf: 40000,
    round_5_as: 3497,
    app_6: 0.85,
    round_6_moc: 1.69,
    round_6_pf: 40000,
    round_6_as: 3799,
    cons_avg: 0.37,
    weapons_1: 'Into the Unreachable Veil',
    weapons_1_app: 56.54,
    weapons_1_round_moc: 8.7,
    weapons_1_round_pf: 40000,
    weapons_1_round_as: 3491,
    weapons_2: 'Today Is Another Peaceful Day',
    weapons_2_app: 15.5,
    weapons_2_round_moc: 8.95,
    weapons_2_round_pf: 39875,
    weapons_2_round_as: 3432,
    weapons_3: 'Night on the Milky Way',
    weapons_3_app: 10.22,
    weapons_3_round_moc: 9.04,
    weapons_3_round_pf: 39781,
    weapons_3_round_as: 3411,
    weapons_4: "Geniuses' Repose",
    weapons_4_app: 6.82,
    weapons_4_round_moc: 9.36,
    weapons_4_round_pf: 39578,
    weapons_4_round_as: 3405,
    weapons_5: 'Eternal Calculus',
    weapons_5_app: 6.64,
    weapons_5_round_moc: 9.33,
    weapons_5_round_pf: 39550,
    weapons_5_round_as: 3371,
    weapons_6: 'Before Dawn',
    weapons_6_app: 2.11,
    weapons_6_round_moc: 9.19,
    weapons_6_round_pf: 39167,
    weapons_6_round_as: 3393,
    weapons_7: 'The Seriousness of Breakfast',
    weapons_7_app: 0.59,
    weapons_7_round_moc: 9.62,
    weapons_7_round_pf: 39932,
    weapons_7_round_as: 3416,
    weapons_8: 'The Day The Cosmos Fell',
    weapons_8_app: 0.49,
    weapons_8_round_moc: 9.0,
    weapons_8_round_pf: 39889,
    weapons_8_round_as: 3447,
    weapons_9: 'The Great Cosmic Enterprise',
    weapons_9_app: 0.47,
    weapons_9_round_moc: 8.2,
    weapons_9_round_pf: 39783,
    weapons_9_round_as: 3523,
    weapons_10: 'An Instant Before A Gaze',
    weapons_10_app: 0.39,
    weapons_10_round_moc: 7.33,
    weapons_10_round_pf: 39196,
    weapons_10_round_as: 3434,
    artifacts_1: 'Scholar Lost in Erudition',
    artifacts_1_1: 'Scholar Lost in Erudition',
    artifacts_1_2: '',
    artifacts_1_app: 97.49,
    artifacts_1_round_moc: 8.97,
    artifacts_1_round_pf: 39938,
    artifacts_1_round_as: 3451,
    artifacts_2: 'Poet of Mourning Collapse',
    artifacts_2_1: 'Poet of Mourning Collapse',
    artifacts_2_2: '',
    artifacts_2_app: 0.77,
    artifacts_2_round_moc: 7.86,
    artifacts_2_round_pf: 39548,
    artifacts_2_round_as: 3486,
    artifacts_3: 'Scholar Lost in Erudition, Flex',
    artifacts_3_1: 'Scholar Lost in Erudition',
    artifacts_3_2: 'Flex',
    artifacts_3_app: 0.31,
    artifacts_3_round_moc: 7.57,
    artifacts_3_round_pf: 39777,
    artifacts_3_round_as: 3416,
    artifacts_4: 'Hunter of Glacial Forest',
    artifacts_4_1: 'Hunter of Glacial Forest',
    artifacts_4_2: '',
    artifacts_4_app: 0.22,
    artifacts_4_round_moc: 9.25,
    artifacts_4_round_pf: 39456,
    artifacts_4_round_as: 3516,
    artifacts_5: 'ATK +12%, Scholar Lost in Erudition',
    artifacts_5_1: 'ATK +12%',
    artifacts_5_2: 'Scholar Lost in Erudition',
    artifacts_5_app: 0.19,
    artifacts_5_round_moc: 8.5,
    artifacts_5_round_pf: 39392,
    artifacts_5_round_as: 3397,
    artifacts_6: 'Genius of Brilliant Stars',
    artifacts_6_1: 'Genius of Brilliant Stars',
    artifacts_6_2: '',
    artifacts_6_app: 0.17,
    artifacts_6_round_moc: 8.0,
    artifacts_6_round_pf: 40000,
    artifacts_6_round_as: 3437,
    artifacts_7: 'ATK +12%, Flex',
    artifacts_7_1: 'ATK +12%',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 0.11,
    artifacts_7_round_moc: 10.0,
    artifacts_7_round_pf: 38230,
    artifacts_7_round_as: 3571,
    artifacts_8: 'ATK +12%, ATK +12%',
    artifacts_8_1: 'ATK +12%',
    artifacts_8_2: 'ATK +12%',
    artifacts_8_app: 0.09,
    artifacts_8_round_moc: 7.5,
    artifacts_8_round_pf: 40000,
    artifacts_8_round_as: 3450,
    artifacts_9: 'Hunter of Glacial Forest, Scholar Lost in Erudition',
    artifacts_9_1: 'Hunter of Glacial Forest',
    artifacts_9_2: 'Scholar Lost in Erudition',
    artifacts_9_app: 0.07,
    artifacts_9_round_moc: 9.67,
    artifacts_9_round_pf: 38576,
    artifacts_9_round_as: 3371,
    artifacts_10: 'SPD +6%, Scholar Lost in Erudition',
    artifacts_10_1: 'SPD +6%',
    artifacts_10_2: 'Scholar Lost in Erudition',
    artifacts_10_app: 0.05,
    artifacts_10_round_moc: 10.0,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 3434,
    planars_1: 'Izumo Gensei and Takama Divine Realm',
    planars_1_app: 84.22,
    planars_1_round_moc: 8.98,
    planars_1_round_pf: 39932,
    planars_1_round_as: 3445,
    planars_2: 'Rutilant Arena',
    planars_2_app: 13.24,
    planars_2_round_moc: 8.58,
    planars_2_round_pf: 39924,
    planars_2_round_as: 3491,
    planars_3: 'Sigonia, the Unclaimed Desolation',
    planars_3_app: 1.41,
    planars_3_round_moc: 9.25,
    planars_3_round_pf: 40000,
    planars_3_round_as: 3479,
    planars_4: 'Inert Salsotto',
    planars_4_app: 0.22,
    planars_4_round_moc: 8.0,
    planars_4_round_pf: 39953,
    planars_4_round_as: 3460,
    planars_5: 'Firmament Frontline: Glamoth',
    planars_5_app: 0.18,
    planars_5_round_moc: 8.88,
    planars_5_round_pf: 39347,
    planars_5_round_as: 3368,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 71.27,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 28.57,
    body_stats_3: 'ATK',
    body_stats_3_app: 0.11,
    feet_stats_1: 'ATK',
    feet_stats_1_app: 55.29,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 44.62,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'Ice DMG Boost',
    sphere_stats_1_app: 88.58,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 11.26,
    sphere_stats_3: 'Lightning DMG Boost',
    sphere_stats_3_app: 0.07,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 96.41,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 3.33,
    rope_stats_3: '',
    rope_stats_3_app: 0.0,
    char_lvl: 80.0,
    light_cone_lvl: 79.9,
    attack_lvl: 4.28,
    skill_lvl: 10.0,
    ultimate_lvl: 9.95,
    talent_lvl: 9.97,
    max_hp: 3133.22,
    atk: 3166.57,
    dfns: 1076.18,
    speed: 121.77,
    crate: 76.36,
    cdmg: 142.15,
    dmg_boost: 56.75,
    heal_boost: 1,
    energy_regen: 0.65,
    effect_res: 7.78,
    effect_rate: 7.78,
    break_effect: 11.66,
    spd_sub: 6.6,
    hp_sub: 9.83,
    atk_sub: 15.68,
    def_sub: 11.5,
    crate_sub: 31.7,
    cdmg_sub: 72.83,
    res_sub: 7.78,
    ehr_sub: 7.78,
    break_sub: 11.66
  },
  {
    char: 'trailblazer-remembrance',
    app_rate_moc: 55.76,
    app_rate_moc_e0s1: 12.81,
    app_rate_moc_e1: 36.97,
    app_rate_moc_s0: 1.03,
    avg_round_moc: 8.77,
    avg_round_moc_e1: 6.66,
    avg_round_moc_s0: 9.09,
    sample_moc: 8398,
    sample_size_players_moc: 1157,
    app_rate_pf: 68.84,
    app_rate_pf_e0s1: 34.42,
    app_rate_pf_e1: 31.33,
    app_rate_pf_s0: 6.49,
    avg_round_pf: 35296,
    avg_round_pf_e1: 39344,
    avg_round_pf_s0: 34797,
    sample_pf: 9657,
    sample_size_players_pf: 1330,
    app_rate_as: 70.19,
    app_rate_as_e0s1: 35.16,
    app_rate_as_e1: 32.33,
    app_rate_as_s0: 5.34,
    avg_round_as: 3503,
    avg_round_as_e1: 3633,
    avg_round_as_s0: 3423,
    sample_as: 10890,
    sample_size_players_as: 1473,
    app_0: 0.26,
    round_0_moc: 9.31,
    round_0_pf: 36720,
    round_0_as: 3460,
    app_1: 0.5,
    round_1_moc: 8.67,
    round_1_pf: 34936,
    round_1_as: 3500,
    app_2: 1.08,
    round_2_moc: 8.42,
    round_2_pf: 33764,
    round_2_as: 3493,
    app_3: 0.53,
    round_3_moc: 8.48,
    round_3_pf: 33234,
    round_3_as: 3488,
    app_4: 1.21,
    round_4_moc: 8.27,
    round_4_pf: 34925,
    round_4_as: 3522,
    app_5: 1.6,
    round_5_moc: 7.83,
    round_5_pf: 36979,
    round_5_as: 3525,
    app_6: 94.83,
    round_6_moc: 6.76,
    round_6_pf: 38369,
    round_6_as: 3576,
    cons_avg: 5.86,
    weapons_1: 'Victory In a Blink',
    weapons_1_app: 60.69,
    weapons_1_round_moc: 8.85,
    weapons_1_round_pf: 35084,
    weapons_1_round_as: 3492,
    weapons_2: "Memory's Curtain Never Falls",
    weapons_2_app: 38.41,
    weapons_2_round_moc: 8.57,
    weapons_2_round_pf: 37313,
    weapons_2_round_as: 3521,
    weapons_3: 'Time Woven Into Gold',
    weapons_3_app: 0.29,
    weapons_3_round_moc: 8.33,
    weapons_3_round_pf: 35305,
    weapons_3_round_as: 3526,
    weapons_4: 'Sweat Now, Cry Less',
    weapons_4_app: 0.26,
    weapons_4_round_moc: 8.67,
    weapons_4_round_pf: 34430,
    weapons_4_round_as: 3510,
    weapons_5: 'Shadowburn',
    weapons_5_app: 0.21,
    weapons_5_round_moc: 7.5,
    weapons_5_round_pf: 40000,
    weapons_5_round_as: 3477,
    weapons_6: 'Make Farewells More Beautiful',
    weapons_6_app: 0.05,
    weapons_6_round_moc: 8.0,
    weapons_6_round_pf: 0,
    weapons_6_round_as: 0,
    weapons_7: "Geniuses' Greetings",
    weapons_7_app: 0.04,
    weapons_7_round_moc: 9.0,
    weapons_7_round_pf: 27180,
    weapons_7_round_as: 3473,
    weapons_8: 'Reminiscence',
    weapons_8_app: 0.04,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 35100,
    weapons_8_round_as: 3581,
    weapons_9: 'Good Night and Sleep Well',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 40000,
    weapons_9_round_as: 3317,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'SPD +6%, SPD +6%',
    artifacts_1_1: 'SPD +6%',
    artifacts_1_2: 'SPD +6%',
    artifacts_1_app: 46.88,
    artifacts_1_round_moc: 8.67,
    artifacts_1_round_pf: 37057,
    artifacts_1_round_as: 3509,
    artifacts_2: 'Hero of Triumphant Song',
    artifacts_2_1: 'Hero of Triumphant Song',
    artifacts_2_2: '',
    artifacts_2_app: 35.45,
    artifacts_2_round_moc: 9.02,
    artifacts_2_round_pf: 34942,
    artifacts_2_round_as: 3484,
    artifacts_3: 'Eagle of Twilight Line',
    artifacts_3_1: 'Eagle of Twilight Line',
    artifacts_3_2: '',
    artifacts_3_app: 5.66,
    artifacts_3_round_moc: 8.12,
    artifacts_3_round_pf: 38757,
    artifacts_3_round_as: 3598,
    artifacts_4: 'SPD +6%, Flex',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'Flex',
    artifacts_4_app: 3.97,
    artifacts_4_round_moc: 7.29,
    artifacts_4_round_pf: 35508,
    artifacts_4_round_as: 3535,
    artifacts_5: "Sacerdos' Relived Ordeal",
    artifacts_5_1: "Sacerdos' Relived Ordeal",
    artifacts_5_2: '',
    artifacts_5_app: 3.1,
    artifacts_5_round_moc: 8.23,
    artifacts_5_round_pf: 34756,
    artifacts_5_round_as: 3466,
    artifacts_6: 'Messenger Traversing Hackerspace',
    artifacts_6_1: 'Messenger Traversing Hackerspace',
    artifacts_6_2: '',
    artifacts_6_app: 0.91,
    artifacts_6_round_moc: 8.89,
    artifacts_6_round_pf: 34365,
    artifacts_6_round_as: 3481,
    artifacts_7: 'SPD +6%, Hero of Triumphant Song',
    artifacts_7_1: 'SPD +6%',
    artifacts_7_2: 'Hero of Triumphant Song',
    artifacts_7_app: 0.91,
    artifacts_7_round_moc: 8.67,
    artifacts_7_round_pf: 38333,
    artifacts_7_round_as: 3497,
    artifacts_8: 'SPD +6%, Longevous Disciple',
    artifacts_8_1: 'SPD +6%',
    artifacts_8_2: 'Longevous Disciple',
    artifacts_8_app: 0.33,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 38540,
    artifacts_8_round_as: 3535,
    artifacts_9: 'SPD +6%, ATK +12%',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'ATK +12%',
    artifacts_9_app: 0.32,
    artifacts_9_round_moc: 6.0,
    artifacts_9_round_pf: 34288,
    artifacts_9_round_as: 3586,
    artifacts_10: 'Hero of Triumphant Song, Flex',
    artifacts_10_1: 'Hero of Triumphant Song',
    artifacts_10_2: 'Flex',
    artifacts_10_app: 0.25,
    artifacts_10_round_moc: 8.0,
    artifacts_10_round_pf: 30390,
    artifacts_10_round_as: 3507,
    planars_1: 'Lushaka, the Sunken Seas',
    planars_1_app: 40.78,
    planars_1_round_moc: 8.87,
    planars_1_round_pf: 35049,
    planars_1_round_as: 3486,
    planars_2: 'Broken Keel',
    planars_2_app: 20.91,
    planars_2_round_moc: 8.54,
    planars_2_round_pf: 35402,
    planars_2_round_as: 3512,
    planars_3: 'Sprightly Vonwacq',
    planars_3_app: 16.26,
    planars_3_round_moc: 8.62,
    planars_3_round_pf: 37804,
    planars_3_round_as: 3540,
    planars_4: 'The Wondrous BananAmusement Park',
    planars_4_app: 9.04,
    planars_4_round_moc: 8.75,
    planars_4_round_pf: 34968,
    planars_4_round_as: 3486,
    planars_5: 'Penacony, Land of the Dreams',
    planars_5_app: 5.68,
    planars_5_round_moc: 8.59,
    planars_5_round_pf: 37511,
    planars_5_round_as: 3520,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 92.59,
    body_stats_2: 'HP',
    body_stats_2_app: 5.0,
    body_stats_3: 'CRIT Rate',
    body_stats_3_app: 1.52,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 98.0,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 1.27,
    feet_stats_3: 'HP',
    feet_stats_3_app: 0.45,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 41.8,
    sphere_stats_2: 'Ice DMG Boost',
    sphere_stats_2_app: 34.14,
    sphere_stats_3: 'ATK',
    sphere_stats_3_app: 11.26,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 92.81,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 4.3,
    rope_stats_3: 'HP',
    rope_stats_3_app: 2.1,
    char_lvl: 79.98,
    light_cone_lvl: 78.65,
    attack_lvl: 5.05,
    skill_lvl: 9.56,
    ultimate_lvl: 10.59,
    talent_lvl: 10.25,
    max_hp: 3634.88,
    atk: 1829.53,
    dfns: 1266.7,
    speed: 159.01,
    crate: 13.25,
    cdmg: 208.52,
    dmg_boost: 13.25,
    heal_boost: 0.06,
    energy_regen: 21.12,
    effect_res: 15.95,
    effect_rate: 8.21,
    break_effect: 16.2,
    spd_sub: 19.59,
    hp_sub: 13.28,
    atk_sub: 16.84,
    def_sub: 16.83,
    crate_sub: 8.1,
    cdmg_sub: 47.66,
    res_sub: 13.9,
    ehr_sub: 8.21,
    break_sub: 16.37
  },
  {
    char: 'aglaea',
    app_rate_moc: 8.81,
    app_rate_moc_e0s1: 1.61,
    app_rate_moc_e1: 6.27,
    app_rate_moc_s0: 0.11,
    avg_round_moc: 8.71,
    avg_round_moc_e1: 6.13,
    avg_round_moc_s0: 9.67,
    sample_moc: 1327,
    sample_size_players_moc: 1001,
    app_rate_pf: 2.35,
    app_rate_pf_e0s1: 0.38,
    app_rate_pf_e1: 1.75,
    app_rate_pf_s0: 0.01,
    avg_round_pf: 25950,
    avg_round_pf_e1: 32720,
    avg_round_pf_s0: 0,
    sample_pf: 329,
    sample_size_players_pf: 276,
    app_rate_as: 1.51,
    app_rate_as_e0s1: 0.16,
    app_rate_as_e1: 1.2,
    app_rate_as_s0: 0.0,
    avg_round_as: 3344,
    avg_round_as_e1: 3465,
    avg_round_as_s0: 0,
    sample_as: 234,
    sample_size_players_as: 208,
    app_0: 42.79,
    round_0_moc: 7.97,
    round_0_pf: 28683,
    round_0_as: 3449,
    app_1: 48.16,
    round_1_moc: 5.48,
    round_1_pf: 33046,
    round_1_as: 3457,
    app_2: 5.65,
    round_2_moc: 4.39,
    round_2_pf: 35975,
    round_2_as: 3511,
    app_3: 0.64,
    round_3_moc: 2.0,
    round_3_pf: 40000,
    round_3_as: 3560,
    app_4: 0.64,
    round_4_moc: 3.6,
    round_4_pf: 39000,
    round_4_as: 3586,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 2.13,
    round_6_moc: 0.25,
    round_6_pf: 40000,
    round_6_as: 3650,
    cons_avg: 0.76,
    weapons_1: 'Time Woven Into Gold',
    weapons_1_app: 77.1,
    weapons_1_round_moc: 8.32,
    weapons_1_round_pf: 26700,
    weapons_1_round_as: 3344,
    weapons_2: 'Sweat Now, Cry Less',
    weapons_2_app: 10.61,
    weapons_2_round_moc: 8.89,
    weapons_2_round_pf: 25200,
    weapons_2_round_as: 0,
    weapons_3: 'Reminiscence',
    weapons_3_app: 8.75,
    weapons_3_round_moc: 8.95,
    weapons_3_round_pf: 23800,
    weapons_3_round_as: 0,
    weapons_4: "Geniuses' Greetings",
    weapons_4_app: 1.63,
    weapons_4_round_moc: 9.57,
    weapons_4_round_pf: 24200,
    weapons_4_round_as: 0,
    weapons_5: "Memory's Curtain Never Falls",
    weapons_5_app: 0.99,
    weapons_5_round_moc: 10.0,
    weapons_5_round_pf: 23920,
    weapons_5_round_as: 0.0,
    weapons_6: 'Victory In a Blink',
    weapons_6_app: 0.76,
    weapons_6_round_moc: 10.0,
    weapons_6_round_pf: 0.0,
    weapons_6_round_as: 0.0,
    weapons_7: 'Cornucopia',
    weapons_7_app: 0.06,
    weapons_7_round_moc: 9.0,
    weapons_7_round_pf: 0.0,
    weapons_7_round_as: 0.0,
    weapons_8: '',
    weapons_8_app: 0.0,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 0.0,
    weapons_8_round_as: 0.0,
    weapons_9: '',
    weapons_9_app: 0.0,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 0.0,
    weapons_10: '',
    weapons_10_app: 0.0,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0.0,
    artifacts_1: 'Hero of Triumphant Song',
    artifacts_1_1: 'Hero of Triumphant Song',
    artifacts_1_2: '',
    artifacts_1_app: 94.47,
    artifacts_1_round_moc: 8.71,
    artifacts_1_round_pf: 25994,
    artifacts_1_round_as: 3344,
    artifacts_2: 'Musketeer of Wild Wheat',
    artifacts_2_1: 'Musketeer of Wild Wheat',
    artifacts_2_2: '',
    artifacts_2_app: 0.97,
    artifacts_2_round_moc: 8.0,
    artifacts_2_round_pf: 0,
    artifacts_2_round_as: 0,
    artifacts_3: 'SPD +6%, ATK +12%',
    artifacts_3_1: 'SPD +6%',
    artifacts_3_2: 'ATK +12%',
    artifacts_3_app: 0.87,
    artifacts_3_round_moc: 10.0,
    artifacts_3_round_pf: 0,
    artifacts_3_round_as: 0,
    artifacts_4: 'SPD +6%, SPD +6%',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'SPD +6%',
    artifacts_4_app: 0.65,
    artifacts_4_round_moc: 99.99,
    artifacts_4_round_pf: 0,
    artifacts_4_round_as: 0,
    artifacts_5: 'ATK +12%, Scholar Lost in Erudition',
    artifacts_5_1: 'ATK +12%',
    artifacts_5_2: 'Scholar Lost in Erudition',
    artifacts_5_app: 0.65,
    artifacts_5_round_moc: 4.5,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0,
    artifacts_6: 'SPD +6%, Scholar Lost in Erudition',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Scholar Lost in Erudition',
    artifacts_6_app: 0.44,
    artifacts_6_round_moc: 10.0,
    artifacts_6_round_pf: 28800,
    artifacts_6_round_as: 0,
    artifacts_7: 'SPD +6%, Flex',
    artifacts_7_1: 'SPD +6%',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 0.27,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0.0,
    artifacts_7_round_as: 0,
    artifacts_8: 'ATK +12%, Flex',
    artifacts_8_1: 'ATK +12%',
    artifacts_8_2: 'Flex',
    artifacts_8_app: 0.27,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0,
    artifacts_9: 'Hero of Triumphant Song, Flex',
    artifacts_9_1: 'Hero of Triumphant Song',
    artifacts_9_2: 'Flex',
    artifacts_9_app: 0.16,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: 'SPD +6%, Hero of Triumphant Song',
    artifacts_10_1: 'SPD +6%',
    artifacts_10_2: 'Hero of Triumphant Song',
    artifacts_10_app: 0.11,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 0.0,
    planars_1: 'The Wondrous BananAmusement Park',
    planars_1_app: 88.17,
    planars_1_round_moc: 8.71,
    planars_1_round_pf: 25888,
    planars_1_round_as: 3344,
    planars_2: 'Rutilant Arena',
    planars_2_app: 8.15,
    planars_2_round_moc: 6.6,
    planars_2_round_pf: 30240,
    planars_2_round_as: 0,
    planars_3: 'Firmament Frontline: Glamoth',
    planars_3_app: 0.98,
    planars_3_round_moc: 7.25,
    planars_3_round_pf: 0,
    planars_3_round_as: 0,
    planars_4: 'Sigonia, the Unclaimed Desolation',
    planars_4_app: 0.33,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 0,
    planars_4_round_as: 0.0,
    planars_5: 'Sprightly Vonwacq',
    planars_5_app: 0.32,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 82.07,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 17.93,
    body_stats_3: '',
    body_stats_3_app: 0.0,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 83.7,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 16.23,
    feet_stats_3: 'HP',
    feet_stats_3_app: 0.07,
    sphere_stats_1: 'Lightning DMG Boost',
    sphere_stats_1_app: 94.91,
    sphere_stats_2: 'ATK',
    sphere_stats_2_app: 4.83,
    sphere_stats_3: 'Imaginary DMG Boost',
    sphere_stats_3_app: 0.14,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 55.53,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 44.25,
    rope_stats_3: 'Break Effect',
    rope_stats_3_app: 0.07,
    char_lvl: 79.99,
    light_cone_lvl: 79.99,
    attack_lvl: 6.04,
    skill_lvl: 7.52,
    ultimate_lvl: 10.02,
    talent_lvl: 9.9,
    max_hp: 3263.23,
    atk: 2444.68,
    dfns: 1094.23,
    speed: 152.25,
    crate: 74.96,
    cdmg: 142.11,
    dmg_boost: 59.27,
    heal_boost: 1,
    energy_regen: 10.81,
    effect_res: 7.53,
    effect_rate: 6.98,
    break_effect: 9.87,
    spd_sub: 15.35,
    hp_sub: 7.74,
    atk_sub: 16.3,
    def_sub: 11.35,
    crate_sub: 28.85,
    cdmg_sub: 66.15,
    res_sub: 7.53,
    ehr_sub: 6.98,
    break_sub: 9.87
  },
  {
    char: 'tribbie',
    app_rate_moc: 64.99,
    app_rate_moc_e0s1: 13.85,
    app_rate_moc_e1: 43.51,
    app_rate_moc_s0: 1.77,
    avg_round_moc: 8.76,
    avg_round_moc_e1: 6.24,
    avg_round_moc_s0: 9.34,
    sample_moc: 9788,
    sample_size_players_moc: 5243,
    app_rate_pf: 65.4,
    app_rate_pf_e0s1: 31.48,
    app_rate_pf_e1: 30.51,
    app_rate_pf_s0: 7.69,
    avg_round_pf: 38880,
    avg_round_pf_e1: 40000,
    avg_round_pf_s0: 39029,
    sample_pf: 9175,
    sample_size_players_pf: 4973,
    app_rate_as: 63.62,
    app_rate_as_e0s1: 31.25,
    app_rate_as_e1: 29.11,
    app_rate_as_s0: 7.1,
    avg_round_as: 3518,
    avg_round_as_e1: 3640,
    avg_round_as_s0: 3463,
    sample_as: 9872,
    sample_size_players_as: 5301,
    app_0: 67.35,
    round_0_moc: 7.24,
    round_0_pf: 39349,
    round_0_as: 3547,
    app_1: 30.05,
    round_1_moc: 4.75,
    round_1_pf: 40000,
    round_1_as: 3663,
    app_2: 1.88,
    round_2_moc: 3.39,
    round_2_pf: 40000,
    round_2_as: 3712,
    app_3: 0.07,
    round_3_moc: 3.43,
    round_3_pf: 40000,
    round_3_as: 3637,
    app_4: 0.12,
    round_4_moc: 2.4,
    round_4_pf: 40000,
    round_4_as: 3828,
    app_5: 1,
    round_5_moc: 99.99,
    round_5_pf: 0,
    round_5_as: 0,
    app_6: 0.52,
    round_6_moc: 0.22,
    round_6_pf: 40000,
    round_6_as: 3882,
    cons_avg: 0.38,
    weapons_1: 'Dance! Dance! Dance!',
    weapons_1_app: 73.13,
    weapons_1_round_moc: 8.79,
    weapons_1_round_pf: 38903,
    weapons_1_round_as: 3517,
    weapons_2: 'If Time Were a Flower',
    weapons_2_app: 21.43,
    weapons_2_round_moc: 8.26,
    weapons_2_round_pf: 39653,
    weapons_2_round_as: 3545,
    weapons_3: 'Meshing Cogs',
    weapons_3_app: 1.62,
    weapons_3_round_moc: 9.05,
    weapons_3_round_pf: 37468,
    weapons_3_round_as: 3472,
    weapons_4: "But the Battle Isn't Over",
    weapons_4_app: 0.74,
    weapons_4_round_moc: 9.58,
    weapons_4_round_pf: 36981,
    weapons_4_round_as: 3473,
    weapons_5: 'Memories of the Past',
    weapons_5_app: 0.7,
    weapons_5_round_moc: 8.94,
    weapons_5_round_pf: 37969,
    weapons_5_round_as: 3478,
    weapons_6: 'Earthly Escapade',
    weapons_6_app: 0.7,
    weapons_6_round_moc: 8.67,
    weapons_6_round_pf: 37945,
    weapons_6_round_as: 3560,
    weapons_7: 'Carve the Moon, Weave the Clouds',
    weapons_7_app: 0.46,
    weapons_7_round_moc: 8.5,
    weapons_7_round_pf: 37044,
    weapons_7_round_as: 3465,
    weapons_8: 'Poised to Bloom',
    weapons_8_app: 0.34,
    weapons_8_round_moc: 9.0,
    weapons_8_round_pf: 34520,
    weapons_8_round_as: 3470,
    weapons_9: 'Planetary Rendezvous',
    weapons_9_app: 0.29,
    weapons_9_round_moc: 9.0,
    weapons_9_round_pf: 36859,
    weapons_9_round_as: 3505,
    weapons_10: 'Past Self in Mirror',
    weapons_10_app: 0.17,
    weapons_10_round_moc: 9.0,
    weapons_10_round_pf: 36184,
    weapons_10_round_as: 3457,
    artifacts_1: 'Poet of Mourning Collapse',
    artifacts_1_1: 'Poet of Mourning Collapse',
    artifacts_1_2: '',
    artifacts_1_app: 86.59,
    artifacts_1_round_moc: 8.75,
    artifacts_1_round_pf: 38942,
    artifacts_1_round_as: 3519,
    artifacts_2: 'Eagle of Twilight Line',
    artifacts_2_1: 'Eagle of Twilight Line',
    artifacts_2_2: '',
    artifacts_2_app: 7.58,
    artifacts_2_round_moc: 8.92,
    artifacts_2_round_pf: 39200,
    artifacts_2_round_as: 3528,
    artifacts_3: 'Genius of Brilliant Stars',
    artifacts_3_1: 'Genius of Brilliant Stars',
    artifacts_3_2: '',
    artifacts_3_app: 1.1,
    artifacts_3_round_moc: 9.22,
    artifacts_3_round_pf: 37876,
    artifacts_3_round_as: 3523,
    artifacts_4: 'SPD +6%, SPD +6%',
    artifacts_4_1: 'SPD +6%',
    artifacts_4_2: 'SPD +6%',
    artifacts_4_app: 0.71,
    artifacts_4_round_moc: 8.47,
    artifacts_4_round_pf: 38820,
    artifacts_4_round_as: 3469,
    artifacts_5: 'Longevous Disciple',
    artifacts_5_1: 'Longevous Disciple',
    artifacts_5_2: '',
    artifacts_5_app: 0.57,
    artifacts_5_round_moc: 6.31,
    artifacts_5_round_pf: 40000,
    artifacts_5_round_as: 3530,
    artifacts_6: 'Quan. +10%, Longevous Disciple',
    artifacts_6_1: 'Quan. +10%',
    artifacts_6_2: 'Longevous Disciple',
    artifacts_6_app: 0.44,
    artifacts_6_round_moc: 8.67,
    artifacts_6_round_pf: 35411,
    artifacts_6_round_as: 3494,
    artifacts_7: 'Longevous Disciple, Scholar Lost in Erudition',
    artifacts_7_1: 'Longevous Disciple',
    artifacts_7_2: 'Scholar Lost in Erudition',
    artifacts_7_app: 0.42,
    artifacts_7_round_moc: 7.7,
    artifacts_7_round_pf: 36095,
    artifacts_7_round_as: 3533,
    artifacts_8: 'Quan. +10%, Scholar Lost in Erudition',
    artifacts_8_1: 'Quan. +10%',
    artifacts_8_2: 'Scholar Lost in Erudition',
    artifacts_8_app: 0.38,
    artifacts_8_round_moc: 9.25,
    artifacts_8_round_pf: 37020,
    artifacts_8_round_as: 3529,
    artifacts_9: 'SPD +6%, Longevous Disciple',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'Longevous Disciple',
    artifacts_9_app: 0.3,
    artifacts_9_round_moc: 8.4,
    artifacts_9_round_pf: 38720,
    artifacts_9_round_as: 3501,
    artifacts_10: 'SPD +6%, Scholar Lost in Erudition',
    artifacts_10_1: 'SPD +6%',
    artifacts_10_2: 'Scholar Lost in Erudition',
    artifacts_10_app: 0.22,
    artifacts_10_round_moc: 8.67,
    artifacts_10_round_pf: 38128,
    artifacts_10_round_as: 3581,
    planars_1: "Bone Collection's Serene Demesne",
    planars_1_app: 74.3,
    planars_1_round_moc: 8.82,
    planars_1_round_pf: 38897,
    planars_1_round_as: 3516,
    planars_2: 'Lushaka, the Sunken Seas',
    planars_2_app: 9.4,
    planars_2_round_moc: 8.62,
    planars_2_round_pf: 39000,
    planars_2_round_as: 3518,
    planars_3: 'Sprightly Vonwacq',
    planars_3_app: 9.04,
    planars_3_round_moc: 8.91,
    planars_3_round_pf: 39173,
    planars_3_round_as: 3518,
    planars_4: 'Penacony, Land of the Dreams',
    planars_4_app: 2.55,
    planars_4_round_moc: 7.0,
    planars_4_round_pf: 39929,
    planars_4_round_as: 3595,
    planars_5: 'Broken Keel',
    planars_5_app: 1.22,
    planars_5_round_moc: 7.09,
    planars_5_round_pf: 38486,
    planars_5_round_as: 3572,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 51.38,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 43.39,
    body_stats_3: 'HP',
    body_stats_3_app: 5.06,
    feet_stats_1: 'HP',
    feet_stats_1_app: 89.32,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 10.13,
    feet_stats_3: 'ATK',
    feet_stats_3_app: 0.46,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 85.71,
    sphere_stats_2: 'Quantum DMG Boost',
    sphere_stats_2_app: 13.62,
    sphere_stats_3: 'ATK',
    sphere_stats_3_app: 0.23,
    rope_stats_1: 'Energy Regeneration Rate',
    rope_stats_1_app: 80.33,
    rope_stats_2: 'HP',
    rope_stats_2_app: 19.49,
    rope_stats_3: 'ATK',
    rope_stats_3_app: 0.13,
    char_lvl: 80.0,
    light_cone_lvl: 79.65,
    attack_lvl: 4.76,
    skill_lvl: 9.93,
    ultimate_lvl: 9.96,
    talent_lvl: 9.6,
    max_hp: 5464.61,
    atk: 1502.61,
    dfns: 1344.25,
    speed: 90.62,
    crate: 58.74,
    cdmg: 184.52,
    dmg_boost: 14.24,
    heal_boost: 1,
    energy_regen: 16.7,
    effect_res: 11.23,
    effect_rate: 8.95,
    break_effect: 12.96,
    spd_sub: 2.0,
    hp_sub: 17.08,
    atk_sub: 13.63,
    def_sub: 15.74,
    crate_sub: 27.6,
    cdmg_sub: 54.83,
    res_sub: 11.45,
    ehr_sub: 9.72,
    break_sub: 12.96
  },
  {
    char: 'mydei',
    app_rate_moc: 16.44,
    app_rate_moc_e0s1: 4.81,
    app_rate_moc_e1: 9.59,
    app_rate_moc_s0: 0.67,
    avg_round_moc: 8.47,
    avg_round_moc_e1: 6.48,
    avg_round_moc_s0: 9.12,
    sample_moc: 2476,
    sample_size_players_moc: 1666,
    app_rate_pf: 12.15,
    app_rate_pf_e0s1: 5.13,
    app_rate_pf_e1: 6.1,
    app_rate_pf_s0: 0.98,
    avg_round_pf: 30065,
    avg_round_pf_e1: 35340,
    avg_round_pf_s0: 26932,
    sample_pf: 1704,
    sample_size_players_pf: 1215,
    app_rate_as: 12.03,
    app_rate_as_e0s1: 5.25,
    app_rate_as_e1: 5.94,
    app_rate_as_s0: 0.85,
    avg_round_as: 3439,
    avg_round_as_e1: 3560,
    avg_round_as_s0: 3381,
    sample_as: 1867,
    sample_size_players_as: 1340,
    app_0: 72.34,
    round_0_moc: 7.19,
    round_0_pf: 31458,
    round_0_as: 3472,
    app_1: 15.25,
    round_1_moc: 5.95,
    round_1_pf: 37794,
    round_1_as: 3565,
    app_2: 9.02,
    round_2_moc: 3.93,
    round_2_pf: 39992,
    round_2_as: 3679,
    app_3: 0.6,
    round_3_moc: 4.77,
    round_3_pf: 38968,
    round_3_as: 3665,
    app_4: 0.35,
    round_4_moc: 5.57,
    round_4_pf: 39754,
    round_4_as: 3677,
    app_5: 0.1,
    round_5_moc: 8.0,
    round_5_pf: 39840,
    round_5_as: 3683,
    app_6: 2.35,
    round_6_moc: 1.25,
    round_6_pf: 40000,
    round_6_as: 3855,
    cons_avg: 0.51,
    weapons_1: 'Flame of Blood, Blaze My Path',
    weapons_1_app: 64.83,
    weapons_1_round_moc: 7.99,
    weapons_1_round_pf: 31455,
    weapons_1_round_as: 3469,
    weapons_2: 'Ninja Record: Sound Hunt',
    weapons_2_app: 15.64,
    weapons_2_round_moc: 8.94,
    weapons_2_round_pf: 27526,
    weapons_2_round_as: 3384,
    weapons_3: 'The Unreachable Side',
    weapons_3_app: 10.09,
    weapons_3_round_moc: 8.64,
    weapons_3_round_pf: 29315,
    weapons_3_round_as: 3425,
    weapons_4: 'A Secret Vow',
    weapons_4_app: 8.56,
    weapons_4_round_moc: 8.59,
    weapons_4_round_pf: 29100,
    weapons_4_round_as: 3415,
    weapons_5: 'Flames Afar',
    weapons_5_app: 0.31,
    weapons_5_round_moc: 9.25,
    weapons_5_round_pf: 25640,
    weapons_5_round_as: 3390,
    weapons_6: 'I Shall Be My Own Sword',
    weapons_6_app: 0.19,
    weapons_6_round_moc: 10.0,
    weapons_6_round_pf: 24000,
    weapons_6_round_as: 0,
    weapons_7: 'Dance at Sunset',
    weapons_7_app: 0.1,
    weapons_7_round_moc: 9.0,
    weapons_7_round_pf: 0,
    weapons_7_round_as: 3416,
    weapons_8: 'Something Irreplaceable',
    weapons_8_app: 0.09,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 25160,
    weapons_8_round_as: 3249,
    weapons_9: 'Brighter Than the Sun',
    weapons_9_app: 0.05,
    weapons_9_round_moc: 5.0,
    weapons_9_round_pf: 0.0,
    weapons_9_round_as: 3517,
    weapons_10: 'Under the Blue Sky',
    weapons_10_app: 0.04,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 0,
    artifacts_1: 'Scholar Lost in Erudition',
    artifacts_1_1: 'Scholar Lost in Erudition',
    artifacts_1_2: '',
    artifacts_1_app: 95.86,
    artifacts_1_round_moc: 8.44,
    artifacts_1_round_pf: 30147,
    artifacts_1_round_as: 3440,
    artifacts_2: 'Longevous Disciple',
    artifacts_2_1: 'Longevous Disciple',
    artifacts_2_2: '',
    artifacts_2_app: 2.53,
    artifacts_2_round_moc: 9.0,
    artifacts_2_round_pf: 27740,
    artifacts_2_round_as: 3399,
    artifacts_3: 'Longevous Disciple, Scholar Lost in Erudition',
    artifacts_3_1: 'Longevous Disciple',
    artifacts_3_2: 'Scholar Lost in Erudition',
    artifacts_3_app: 0.44,
    artifacts_3_round_moc: 8.0,
    artifacts_3_round_pf: 28093,
    artifacts_3_round_as: 3432,
    artifacts_4: 'Scholar Lost in Erudition, Flex',
    artifacts_4_1: 'Scholar Lost in Erudition',
    artifacts_4_2: 'Flex',
    artifacts_4_app: 0.29,
    artifacts_4_round_moc: 9.0,
    artifacts_4_round_pf: 31920,
    artifacts_4_round_as: 3420,
    artifacts_5: 'Longevous Disciple, Flex',
    artifacts_5_1: 'Longevous Disciple',
    artifacts_5_2: 'Flex',
    artifacts_5_app: 0.11,
    artifacts_5_round_moc: 9.0,
    artifacts_5_round_pf: 0,
    artifacts_5_round_as: 0,
    artifacts_6: 'SPD +6%, Longevous Disciple',
    artifacts_6_1: 'SPD +6%',
    artifacts_6_2: 'Longevous Disciple',
    artifacts_6_app: 0.1,
    artifacts_6_round_moc: 3.0,
    artifacts_6_round_pf: 0.0,
    artifacts_6_round_as: 3372,
    artifacts_7: 'Pioneer Diver of Dead Waters, Flex',
    artifacts_7_1: 'Pioneer Diver of Dead Waters',
    artifacts_7_2: 'Flex',
    artifacts_7_app: 0.09,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 31800,
    artifacts_7_round_as: 3659,
    artifacts_8: 'Longevous Disciple, Wastelander of Banditry Desert',
    artifacts_8_1: 'Longevous Disciple',
    artifacts_8_2: 'Wastelander of Banditry Desert',
    artifacts_8_app: 0.06,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0.0,
    artifacts_8_round_as: 0,
    artifacts_9: 'SPD +6%, SPD +6%',
    artifacts_9_1: 'SPD +6%',
    artifacts_9_2: 'SPD +6%',
    artifacts_9_app: 0.06,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0,
    artifacts_9_round_as: 0,
    artifacts_10: 'Hero of Triumphant Song, Scholar Lost in Erudition',
    artifacts_10_1: 'Hero of Triumphant Song',
    artifacts_10_2: 'Scholar Lost in Erudition',
    artifacts_10_app: 0.04,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 40000,
    artifacts_10_round_as: 0.0,
    planars_1: "Bone Collection's Serene Demesne",
    planars_1_app: 92.74,
    planars_1_round_moc: 8.49,
    planars_1_round_pf: 30050,
    planars_1_round_as: 3439,
    planars_2: 'Rutilant Arena',
    planars_2_app: 6.57,
    planars_2_round_moc: 8.21,
    planars_2_round_pf: 30620,
    planars_2_round_as: 3440,
    planars_3: 'Sigonia, the Unclaimed Desolation',
    planars_3_app: 0.08,
    planars_3_round_moc: 99.99,
    planars_3_round_pf: 28240,
    planars_3_round_as: 0,
    planars_4: 'Inert Salsotto',
    planars_4_app: 0.07,
    planars_4_round_moc: 10.0,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 3344,
    planars_5: '',
    planars_5_app: 0.0,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0.0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 72.05,
    body_stats_2: 'HP',
    body_stats_2_app: 24.49,
    body_stats_3: 'CRIT Rate',
    body_stats_3_app: 3.37,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 70.9,
    feet_stats_2: 'HP',
    feet_stats_2_app: 28.72,
    feet_stats_3: 'ATK',
    feet_stats_3_app: 0.26,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 60.04,
    sphere_stats_2: 'Imaginary DMG Boost',
    sphere_stats_2_app: 39.73,
    sphere_stats_3: 'Quantum DMG Boost',
    sphere_stats_3_app: 0.09,
    rope_stats_1: 'HP',
    rope_stats_1_app: 99.65,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 0.21,
    rope_stats_3: 'ATK',
    rope_stats_3_app: 0.02,
    char_lvl: 80.0,
    light_cone_lvl: 79.94,
    attack_lvl: 4.16,
    skill_lvl: 10.04,
    ultimate_lvl: 9.92,
    talent_lvl: 9.26,
    max_hp: 8281.58,
    atk: 1412.15,
    dfns: 676.26,
    speed: 134.86,
    crate: 38.52,
    cdmg: 199.98,
    dmg_boost: 15.44,
    heal_boost: 1,
    energy_regen: 0.04,
    effect_res: 8.19,
    effect_rate: 8.03,
    break_effect: 12.17,
    spd_sub: 10.99,
    hp_sub: 22.47,
    atk_sub: 10.97,
    def_sub: 10.1,
    crate_sub: 22.56,
    cdmg_sub: 66.0,
    res_sub: 8.19,
    ehr_sub: 8.03,
    break_sub: 12.17
  },
  {
    char: 'castorice',
    app_rate_moc: 44.16,
    app_rate_moc_e0s1: 9.37,
    app_rate_moc_e1: 30.03,
    app_rate_moc_s0: 0.53,
    avg_round_moc: 8.69,
    avg_round_moc_e1: 6.48,
    avg_round_moc_s0: 8.82,
    sample_moc: 6651,
    sample_size_players_moc: 4801,
    app_rate_pf: 58.51,
    app_rate_pf_e0s1: 26.54,
    app_rate_pf_e1: 28.62,
    app_rate_pf_s0: 3.35,
    avg_round_pf: 34292,
    avg_round_pf_e1: 39231,
    avg_round_pf_s0: 31475,
    sample_pf: 8208,
    sample_size_players_pf: 5856,
    app_rate_as: 64.63,
    app_rate_as_e0s1: 30.34,
    app_rate_as_e1: 31.26,
    app_rate_as_s0: 3.56,
    avg_round_as: 3513,
    avg_round_as_e1: 3642,
    avg_round_as_s0: 3434,
    sample_as: 10028,
    sample_size_players_as: 7057,
    app_0: 72.04,
    round_0_moc: 7.75,
    round_0_pf: 34563,
    round_0_as: 3538,
    app_1: 6.47,
    round_1_moc: 6.56,
    round_1_pf: 37312,
    round_1_as: 3596,
    app_2: 17.9,
    round_2_moc: 4.09,
    round_2_pf: 40000,
    round_2_as: 3765,
    app_3: 0.91,
    round_3_moc: 3.8,
    round_3_pf: 40000,
    round_3_as: 3775,
    app_4: 0.2,
    round_4_moc: 3.73,
    round_4_pf: 40000,
    round_4_as: 3748,
    app_5: 0.09,
    round_5_moc: 4.0,
    round_5_pf: 39171,
    round_5_as: 3810,
    app_6: 2.38,
    round_6_moc: 0.58,
    round_6_pf: 40000,
    round_6_as: 3863,
    cons_avg: 0.61,
    weapons_1: 'Make Farewells More Beautiful',
    weapons_1_app: 88.61,
    weapons_1_round_moc: 8.6,
    weapons_1_round_pf: 34974,
    weapons_1_round_as: 3530,
    weapons_2: 'Sweat Now, Cry Less',
    weapons_2_app: 5.12,
    weapons_2_round_moc: 8.73,
    weapons_2_round_pf: 32146,
    weapons_2_round_as: 3452,
    weapons_3: 'Time Waits for No One',
    weapons_3_app: 3.2,
    weapons_3_round_moc: 9.09,
    weapons_3_round_pf: 31855,
    weapons_3_round_as: 3452,
    weapons_4: 'Victory In a Blink',
    weapons_4_app: 1.13,
    weapons_4_round_moc: 8.87,
    weapons_4_round_pf: 29646,
    weapons_4_round_as: 3377,
    weapons_5: 'Something Irreplaceable',
    weapons_5_app: 0.49,
    weapons_5_round_moc: 9.11,
    weapons_5_round_pf: 29756,
    weapons_5_round_as: 3420,
    weapons_6: "Memory's Curtain Never Falls",
    weapons_6_app: 0.41,
    weapons_6_round_moc: 9.2,
    weapons_6_round_pf: 29925,
    weapons_6_round_as: 3419,
    weapons_7: 'Post-Op Conversation',
    weapons_7_app: 0.21,
    weapons_7_round_moc: 8.0,
    weapons_7_round_pf: 29381,
    weapons_7_round_as: 3460,
    weapons_8: 'The Unreachable Side',
    weapons_8_app: 0.1,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 32032,
    weapons_8_round_as: 3482,
    weapons_9: "But the Battle Isn't Over",
    weapons_9_app: 0.09,
    weapons_9_round_moc: 9.6,
    weapons_9_round_pf: 30680,
    weapons_9_round_as: 3456,
    weapons_10: 'Reminiscence',
    weapons_10_app: 0.06,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0.0,
    weapons_10_round_as: 3383,
    artifacts_1: 'Poet of Mourning Collapse',
    artifacts_1_1: 'Poet of Mourning Collapse',
    artifacts_1_2: '',
    artifacts_1_app: 99.26,
    artifacts_1_round_moc: 8.69,
    artifacts_1_round_pf: 34361,
    artifacts_1_round_as: 3515,
    artifacts_2: 'Quan. +10%, Flex',
    artifacts_2_1: 'Quan. +10%',
    artifacts_2_2: 'Flex',
    artifacts_2_app: 0.09,
    artifacts_2_round_moc: 8.0,
    artifacts_2_round_pf: 31224,
    artifacts_2_round_as: 3455,
    artifacts_3: 'Genius of Brilliant Stars',
    artifacts_3_1: 'Genius of Brilliant Stars',
    artifacts_3_2: '',
    artifacts_3_app: 0.07,
    artifacts_3_round_moc: 10.0,
    artifacts_3_round_pf: 33840,
    artifacts_3_round_as: 3490,
    artifacts_4: 'Hero of Triumphant Song',
    artifacts_4_1: 'Hero of Triumphant Song',
    artifacts_4_2: '',
    artifacts_4_app: 0.07,
    artifacts_4_round_moc: 10.0,
    artifacts_4_round_pf: 34260,
    artifacts_4_round_as: 3353,
    artifacts_5: 'SPD +6%, SPD +6%',
    artifacts_5_1: 'SPD +6%',
    artifacts_5_2: 'SPD +6%',
    artifacts_5_app: 0.05,
    artifacts_5_round_moc: 6.0,
    artifacts_5_round_pf: 40000,
    artifacts_5_round_as: 3510,
    artifacts_6: 'Quan. +10%, Longevous Disciple',
    artifacts_6_1: 'Quan. +10%',
    artifacts_6_2: 'Longevous Disciple',
    artifacts_6_app: 0.05,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 28093,
    artifacts_6_round_as: 3450,
    artifacts_7: 'Quan. +10%, Quan. +10%',
    artifacts_7_1: 'Quan. +10%',
    artifacts_7_2: 'Quan. +10%',
    artifacts_7_app: 0.05,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 29880,
    artifacts_7_round_as: 3356,
    artifacts_8: 'Quan. +10%, Scholar Lost in Erudition',
    artifacts_8_1: 'Quan. +10%',
    artifacts_8_2: 'Scholar Lost in Erudition',
    artifacts_8_app: 0.05,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 38240,
    artifacts_8_round_as: 3498,
    artifacts_9: 'Longevous Disciple',
    artifacts_9_1: 'Longevous Disciple',
    artifacts_9_2: '',
    artifacts_9_app: 0.04,
    artifacts_9_round_moc: 10.0,
    artifacts_9_round_pf: 0,
    artifacts_9_round_as: 3432,
    artifacts_10: 'Longevous Disciple, Scholar Lost in Erudition',
    artifacts_10_1: 'Longevous Disciple',
    artifacts_10_2: 'Scholar Lost in Erudition',
    artifacts_10_app: 0.03,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 3418,
    planars_1: "Bone Collection's Serene Demesne",
    planars_1_app: 99.34,
    planars_1_round_moc: 8.68,
    planars_1_round_pf: 34371,
    planars_1_round_as: 3515,
    planars_2: 'The Wondrous BananAmusement Park',
    planars_2_app: 0.24,
    planars_2_round_moc: 10.0,
    planars_2_round_pf: 32018,
    planars_2_round_as: 3512,
    planars_3: 'Rutilant Arena',
    planars_3_app: 0.09,
    planars_3_round_moc: 9.0,
    planars_3_round_pf: 28790,
    planars_3_round_as: 3344,
    planars_4: 'Broken Keel',
    planars_4_app: 0.02,
    planars_4_round_moc: 10.0,
    planars_4_round_pf: 0.0,
    planars_4_round_as: 3354,
    planars_5: 'Sigonia, the Unclaimed Desolation',
    planars_5_app: 0.01,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 0,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT DMG',
    body_stats_1_app: 95.42,
    body_stats_2: 'CRIT Rate',
    body_stats_2_app: 2.79,
    body_stats_3: 'HP',
    body_stats_3_app: 1.74,
    feet_stats_1: 'HP',
    feet_stats_1_app: 99.72,
    feet_stats_2: 'SPD',
    feet_stats_2_app: 0.14,
    feet_stats_3: 'ATK',
    feet_stats_3_app: 0.12,
    sphere_stats_1: 'HP',
    sphere_stats_1_app: 81.83,
    sphere_stats_2: 'Quantum DMG Boost',
    sphere_stats_2_app: 18.09,
    sphere_stats_3: 'ATK',
    sphere_stats_3_app: 0.02,
    rope_stats_1: 'HP',
    rope_stats_1_app: 99.81,
    rope_stats_2: 'ATK',
    rope_stats_2_app: 0.09,
    rope_stats_3: 'Energy Regeneration Rate',
    rope_stats_3_app: 0.08,
    char_lvl: 80.0,
    light_cone_lvl: 79.89,
    attack_lvl: 4.37,
    skill_lvl: 9.92,
    ultimate_lvl: 10.0,
    talent_lvl: 10.04,
    max_hp: 9040.76,
    atk: 1563.67,
    dfns: 1045.21,
    speed: 87.4,
    crate: 56.66,
    cdmg: 201.72,
    dmg_boost: 31.36,
    heal_boost: 0.27,
    energy_regen: 0.05,
    effect_res: 7.89,
    effect_rate: 7.78,
    break_effect: 11.66,
    spd_sub: 2.1,
    hp_sub: 16.69,
    atk_sub: 11.32,
    def_sub: 12.66,
    crate_sub: 31.58,
    cdmg_sub: 72.75,
    res_sub: 7.89,
    ehr_sub: 7.78,
    break_sub: 11.66
  },
  {
    char: 'anaxa',
    app_rate_moc: 3.88,
    app_rate_moc_e0s1: 0.62,
    app_rate_moc_e1: 2.6,
    app_rate_moc_s0: 0.05,
    avg_round_moc: 7.26,
    avg_round_moc_e1: 5.27,
    avg_round_moc_s0: 99.99,
    sample_moc: 584,
    sample_size_players_moc: 333,
    app_rate_pf: 7.77,
    app_rate_pf_e0s1: 3.43,
    app_rate_pf_e1: 3.81,
    app_rate_pf_s0: 1.05,
    avg_round_pf: 38177,
    avg_round_pf_e1: 39818,
    avg_round_pf_s0: 35619,
    sample_pf: 1090,
    sample_size_players_pf: 567,
    app_rate_as: 4.31,
    app_rate_as_e0s1: 1.74,
    app_rate_as_e1: 2.22,
    app_rate_as_s0: 0.5,
    avg_round_as: 3579,
    avg_round_as_e1: 3712,
    avg_round_as_s0: 3569,
    sample_as: 669,
    sample_size_players_as: 408,
    app_0: 84.8,
    round_0_moc: 5.48,
    round_0_pf: 39149,
    round_0_as: 3632,
    app_1: 5.91,
    round_1_moc: 4.73,
    round_1_pf: 39139,
    round_1_as: 3695,
    app_2: 6.42,
    round_2_moc: 3.34,
    round_2_pf: 40000,
    round_2_as: 3772,
    app_3: 0.39,
    round_3_moc: 5.33,
    round_3_pf: 37190,
    round_3_as: 3662,
    app_4: 0.6,
    round_4_moc: 6.8,
    round_4_pf: 40000,
    round_4_as: 3813,
    app_5: 0.13,
    round_5_moc: 4.0,
    round_5_pf: 40000,
    round_5_as: 3735,
    app_6: 1.77,
    round_6_moc: 1.14,
    round_6_pf: 40000,
    round_6_as: 3867,
    cons_avg: 0.34,
    weapons_1: 'Life Should Be Cast to Flames',
    weapons_1_app: 48.91,
    weapons_1_round_moc: 7.76,
    weapons_1_round_pf: 38557,
    weapons_1_round_as: 3572,
    weapons_2: 'The Great Cosmic Enterprise',
    weapons_2_app: 41.34,
    weapons_2_round_moc: 6.9,
    weapons_2_round_pf: 37842,
    weapons_2_round_as: 3592,
    weapons_3: 'Eternal Calculus',
    weapons_3_app: 2.58,
    weapons_3_round_moc: 7.75,
    weapons_3_round_pf: 38846,
    weapons_3_round_as: 3572,
    weapons_4: 'Night on the Milky Way',
    weapons_4_app: 1.87,
    weapons_4_round_moc: 10.0,
    weapons_4_round_pf: 31684,
    weapons_4_round_as: 3474,
    weapons_5: 'Into the Unreachable Veil',
    weapons_5_app: 1.62,
    weapons_5_round_moc: 6.0,
    weapons_5_round_pf: 38970,
    weapons_5_round_as: 3532,
    weapons_6: 'Before Dawn',
    weapons_6_app: 1.1,
    weapons_6_round_moc: 10.0,
    weapons_6_round_pf: 33168,
    weapons_6_round_as: 3564,
    weapons_7: 'Today Is Another Peaceful Day',
    weapons_7_app: 0.79,
    weapons_7_round_moc: 8.5,
    weapons_7_round_pf: 33840,
    weapons_7_round_as: 3715,
    weapons_8: 'Passkey',
    weapons_8_app: 0.46,
    weapons_8_round_moc: 99.99,
    weapons_8_round_pf: 40000,
    weapons_8_round_as: 3674,
    weapons_9: 'The Day The Cosmos Fell',
    weapons_9_app: 0.37,
    weapons_9_round_moc: 99.99,
    weapons_9_round_pf: 34453,
    weapons_9_round_as: 0,
    weapons_10: 'Make the World Clamor',
    weapons_10_app: 0.19,
    weapons_10_round_moc: 99.99,
    weapons_10_round_pf: 0,
    weapons_10_round_as: 0,
    artifacts_1: 'Eagle of Twilight Line',
    artifacts_1_1: 'Eagle of Twilight Line',
    artifacts_1_2: '',
    artifacts_1_app: 43.77,
    artifacts_1_round_moc: 7.5,
    artifacts_1_round_pf: 38919,
    artifacts_1_round_as: 3594,
    artifacts_2: 'Scholar Lost in Erudition',
    artifacts_2_1: 'Scholar Lost in Erudition',
    artifacts_2_2: '',
    artifacts_2_app: 34.84,
    artifacts_2_round_moc: 7.24,
    artifacts_2_round_pf: 37794,
    artifacts_2_round_as: 3602,
    artifacts_3: 'Genius of Brilliant Stars',
    artifacts_3_1: 'Genius of Brilliant Stars',
    artifacts_3_2: '',
    artifacts_3_app: 10.64,
    artifacts_3_round_moc: 7.6,
    artifacts_3_round_pf: 34788,
    artifacts_3_round_as: 3557,
    artifacts_4: 'Pioneer Diver of Dead Waters',
    artifacts_4_1: 'Pioneer Diver of Dead Waters',
    artifacts_4_2: '',
    artifacts_4_app: 7.84,
    artifacts_4_round_moc: 6.6,
    artifacts_4_round_pf: 35364,
    artifacts_4_round_as: 3588,
    artifacts_5: 'SPD +6%, Scholar Lost in Erudition',
    artifacts_5_1: 'SPD +6%',
    artifacts_5_2: 'Scholar Lost in Erudition',
    artifacts_5_app: 0.59,
    artifacts_5_round_moc: 99.99,
    artifacts_5_round_pf: 33400,
    artifacts_5_round_as: 3578,
    artifacts_6: 'Eagle of Twilight Line, Scholar Lost in Erudition',
    artifacts_6_1: 'Eagle of Twilight Line',
    artifacts_6_2: 'Scholar Lost in Erudition',
    artifacts_6_app: 0.28,
    artifacts_6_round_moc: 99.99,
    artifacts_6_round_pf: 36920,
    artifacts_6_round_as: 3528,
    artifacts_7: 'SPD +6%, SPD +6%',
    artifacts_7_1: 'SPD +6%',
    artifacts_7_2: 'SPD +6%',
    artifacts_7_app: 0.23,
    artifacts_7_round_moc: 99.99,
    artifacts_7_round_pf: 0,
    artifacts_7_round_as: 0,
    artifacts_8: 'ATK +12%, Eagle of Twilight Line',
    artifacts_8_1: 'ATK +12%',
    artifacts_8_2: 'Eagle of Twilight Line',
    artifacts_8_app: 0.19,
    artifacts_8_round_moc: 99.99,
    artifacts_8_round_pf: 0,
    artifacts_8_round_as: 0.0,
    artifacts_9: 'ATK +12%, ATK +12%',
    artifacts_9_1: 'ATK +12%',
    artifacts_9_2: 'ATK +12%',
    artifacts_9_app: 0.14,
    artifacts_9_round_moc: 99.99,
    artifacts_9_round_pf: 0.0,
    artifacts_9_round_as: 0.0,
    artifacts_10: 'SPD +6%, Pioneer Diver of Dead Waters',
    artifacts_10_1: 'SPD +6%',
    artifacts_10_2: 'Pioneer Diver of Dead Waters',
    artifacts_10_app: 0.13,
    artifacts_10_round_moc: 99.99,
    artifacts_10_round_pf: 0.0,
    artifacts_10_round_as: 3820,
    planars_1: 'Rutilant Arena',
    planars_1_app: 66.07,
    planars_1_round_moc: 7.17,
    planars_1_round_pf: 37254,
    planars_1_round_as: 3581,
    planars_2: 'Izumo Gensei and Takama Divine Realm',
    planars_2_app: 22.94,
    planars_2_round_moc: 7.04,
    planars_2_round_pf: 39526,
    planars_2_round_as: 3569,
    planars_3: 'Sprightly Vonwacq',
    planars_3_app: 3.08,
    planars_3_round_moc: 8.0,
    planars_3_round_pf: 40000,
    planars_3_round_as: 3610,
    planars_4: 'Lushaka, the Sunken Seas',
    planars_4_app: 2.68,
    planars_4_round_moc: 99.99,
    planars_4_round_pf: 39992,
    planars_4_round_as: 3742,
    planars_5: 'Firmament Frontline: Glamoth',
    planars_5_app: 0.94,
    planars_5_round_moc: 99.99,
    planars_5_round_pf: 37000,
    planars_5_round_as: 0.0,
    body_stats_1: 'CRIT Rate',
    body_stats_1_app: 77.53,
    body_stats_2: 'CRIT DMG',
    body_stats_2_app: 20.44,
    body_stats_3: 'ATK',
    body_stats_3_app: 1.78,
    feet_stats_1: 'SPD',
    feet_stats_1_app: 89.35,
    feet_stats_2: 'ATK',
    feet_stats_2_app: 10.48,
    feet_stats_3: '',
    feet_stats_3_app: 0.0,
    sphere_stats_1: 'ATK',
    sphere_stats_1_app: 67.02,
    sphere_stats_2: 'Wind DMG Boost',
    sphere_stats_2_app: 32.41,
    sphere_stats_3: 'HP',
    sphere_stats_3_app: 0.24,
    rope_stats_1: 'ATK',
    rope_stats_1_app: 85.24,
    rope_stats_2: 'Energy Regeneration Rate',
    rope_stats_2_app: 13.96,
    rope_stats_3: 'HP',
    rope_stats_3_app: 0.33,
    char_lvl: 79.98,
    light_cone_lvl: 79.58,
    attack_lvl: 4.93,
    skill_lvl: 9.92,
    ultimate_lvl: 9.8,
    talent_lvl: 9.62,
    max_hp: 3064.57,
    atk: 2938.5,
    dfns: 1173.27,
    speed: 135.9,
    crate: 80.23,
    cdmg: 127.75,
    dmg_boost: 38.35,
    heal_boost: 1,
    energy_regen: 2.92,
    effect_res: 7.78,
    effect_rate: 7.67,
    break_effect: 11.66,
    spd_sub: 13.84,
    hp_sub: 9.57,
    atk_sub: 15.75,
    def_sub: 10.46,
    crate_sub: 28.04,
    cdmg_sub: 64.1,
    res_sub: 7.78,
    ehr_sub: 7.67,
    break_sub: 11.57
  }
];
